import { GraphQLUpload } from "graphql-upload-minimal";
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  UUID: { input: string; output: string };
  Upload: { input: typeof GraphQLUpload; output: typeof GraphQLUpload };
};

export type AccountCredentialsInput = {
  aws?: InputMaybe<AwsCredentialsInput>;
  azure?: InputMaybe<AzureCredentialsInput>;
  gc?: InputMaybe<GoogleCloudCredentialsInput>;
};

export type Action = {
  __typename?: "Action";
  /** Change details represent when and by whom data was created or modified */
  changeDetails: ChangeDetails;
  /** Color of the action in hexadecimal numeral system e.g. #FFFFFF. Used for presentation purposes */
  color: Scalars["String"]["output"];
  /** Additional description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Action identifier */
  id: Scalars["UUID"]["output"];
  /** Action name */
  name: Scalars["String"]["output"];
  /** Defines what parameters can be defined for the action */
  parameterDefinitions: Array<ActionParameterDefinition>;
  /** Scope of the action */
  scope: ActionScope;
  /** Determines whether the action is executed in a synchronous or asynchronous way */
  synchronous: Scalars["Boolean"]["output"];
  /** Determines type of the action and which source will be used */
  type: ActionType;
  /** Content of the action respectively based on the chosen type */
  typeProperties: ActionTypeProperties;
};

export enum ActionFilterByFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Description = "DESCRIPTION",
  Id = "ID",
  Name = "NAME",
  PlanId = "PLAN_ID",
  Scope = "SCOPE",
  Type = "TYPE",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type ActionFilterByInput = {
  field: ActionFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ActionFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<ActionFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActionPage = {
  __typename?: "ActionPage";
  /** Information about returned page */
  pageInfo: PageInfo;
  /** List of actions */
  result?: Maybe<Array<Action>>;
};

export type ActionParameterDefinition = {
  __typename?: "ActionParameterDefinition";
  /** Optionally defines what values are allowed for this parameter. Values other than string are JSON-serialized to string. */
  allowedValues?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Optionally defines the default value of the parameter. Values other than string are JSON-serialized to string. */
  defaultValue?: Maybe<Scalars["String"]["output"]>;
  /** Optionally defines additional field description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Name of the parameter */
  name: Scalars["String"]["output"];
  /** Determines whether the parameter is required or not */
  required: Scalars["Boolean"]["output"];
  /** Type of the parameter */
  type: ActionParameterType;
};

export enum ActionParameterType {
  Bool = "BOOL",
  Int = "INT",
  List = "LIST",
  String = "STRING",
}

export type ActionPropertyAwsLambda = {
  __typename?: "ActionPropertyAWSLambda";
  /** ARN of the AWS Lambda function */
  lambdaArn: Scalars["String"]["output"];
};

export type ActionPropertyAzureFunction = {
  __typename?: "ActionPropertyAzureFunction";
  /** Access key ID needed for authorization to execute Azure function */
  accessKeyId: Scalars["String"]["output"];
  /** Method used by the Azure function e.g. "GET", "POST", "PUT", "PATCH", "DELETE" */
  functionMethod: AzureFunctionMethod;
  /** URL of the Azure function */
  functionUrl: Scalars["String"]["output"];
};

export type ActionPropertySsmDocument = {
  __typename?: "ActionPropertySSMDocument";
  /** ARN or name of the AWS SSM document */
  documentId: Scalars["String"]["output"];
};

export type ActionPropertyScript = {
  __typename?: "ActionPropertyScript";
  /** URL reference to a script file on the S3. Use `scriptContent` query to get content of the script. */
  s3FileUrl: Scalars["String"]["output"];
};

export type ActionPropertyWebhook = {
  __typename?: "ActionPropertyWebhook";
  /** Field that is attached header fields (additional context and metadata) to the webhook request */
  headers: Array<KeyValue>;
  /** Payload is the data used in the webhook request in stringified JSON format */
  payload: Scalars["String"]["output"];
  /** Method used to invoke webhook e.g. "GET", "POST", "PUT", "PATCH", "DELETE" */
  webhookMethod: WebhookActionMethod;
  /** URL of the Webhook */
  webhookUrl: Scalars["String"]["output"];
};

export enum ActionScope {
  Plan = "PLAN",
  Resource = "RESOURCE",
}

export enum ActionSortFields {
  Color = "COLOR",
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Name = "NAME",
  Scope = "SCOPE",
  Synchronous = "SYNCHRONOUS",
  Type = "TYPE",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type ActionSortInput = {
  /** Defines fields which can be use for sorting purpose */
  field: ActionSortFields;
  /** Order of the list of the actions */
  order?: InputMaybe<SortOrder>;
};

export enum ActionType {
  AwsLambda = "AWS_LAMBDA",
  AzureFunction = "AZURE_FUNCTION",
  Script = "SCRIPT",
  SsmDocument = "SSM_DOCUMENT",
  Webhook = "WEBHOOK",
}

/** Represents all possible action type properties */
export type ActionTypeProperties =
  | ActionPropertyAwsLambda
  | ActionPropertyAzureFunction
  | ActionPropertySsmDocument
  | ActionPropertyScript
  | ActionPropertyWebhook;

export type ActionWithMissingData = {
  __typename?: "ActionWithMissingData";
  errCode: ActionWithMissingDataErrorCode;
  eventActionId: Scalars["UUID"]["output"];
  eventId: Scalars["UUID"]["output"];
  eventName: Scalars["String"]["output"];
};

export enum ActionWithMissingDataErrorCode {
  LogsMalformed = "LOGS_MALFORMED",
  LogsNotAvailable = "LOGS_NOT_AVAILABLE",
}

export type Activation = {
  __typename?: "Activation";
  awsAccountId: Scalars["String"]["output"];
  code: Scalars["String"]["output"];
  credentialsId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
};

export type AnyResourceStatusChangedInput = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
};

export type ApiKey = {
  __typename?: "ApiKey";
  changeDetails: ChangeDetails;
  description?: Maybe<Scalars["String"]["output"]>;
  expiresAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  lastUsedAt?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  owner: Scalars["String"]["output"];
  roleBindings?: Maybe<RoleBindingsPage>;
};

export type ApiKeyRoleBindingsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<RoleBindingsSortInput>;
};

export type ApiKeysPage = {
  __typename?: "ApiKeysPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Maybe<ApiKey>>>;
};

export enum ApiKeysSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  ExpiresAt = "EXPIRES_AT",
  Id = "ID",
  Name = "NAME",
  Owner = "OWNER",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type ApiKeysSortInput = {
  field: ApiKeysSortFields;
  order?: InputMaybe<SortOrder>;
};

export type Application = {
  __typename?: "Application";
  changeDetails: ChangeDetails;
  contacts?: Maybe<Array<Scalars["String"]["output"]>>;
  description?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  environments?: Maybe<Array<EnvironmentWithResourceCount>>;
  id: Scalars["UUID"]["output"];
  metadata?: Maybe<Array<KeyValue>>;
  name: Scalars["String"]["output"];
  owner?: Maybe<Scalars["String"]["output"]>;
};

export type ApplicationEnvironmentPairInput = {
  applicationId: Scalars["UUID"]["input"];
  environmentId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type ApplicationsFilterInput = {
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type ApplicationsPage = {
  __typename?: "ApplicationsPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Application>>;
};

export enum ApplicationsSortFields {
  Name = "NAME",
}

export type ApplicationsSortInput = {
  field: ApplicationsSortFields;
  order: SortOrder;
};

export type Assignment = {
  __typename?: "Assignment";
  application: Application;
  changeDetails: ChangeDetails;
  cloudResource: CloudResource;
  environment?: Maybe<Environment>;
  id: Scalars["UUID"]["output"];
  isManual: Scalars["Boolean"]["output"];
};

export type AssignmentsFilterInput = {
  applicationId?: InputMaybe<Scalars["UUID"]["input"]>;
  cloudResourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  environmentId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type AssignmentsPage = {
  __typename?: "AssignmentsPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Assignment>>;
};

export type AuditLog = {
  __typename?: "AuditLog";
  /** Additional data related to the operation, stored as a JSON string */
  data: Scalars["String"]["output"];
  /** Time of the operation in RFC3339 format */
  datetime: Scalars["String"]["output"];
  /** Identity that performed the operation, e.g., user email, API key ID, or system identifier */
  identity: Scalars["String"]["output"];
  /** Type of the identity: USER, API_KEY, or SYSTEM */
  identityType: AuditLogIdentityType;
  /** Operation performed, e.g., "create", "update", "delete" */
  operation: Scalars["String"]["output"];
  /** Key-value pairs for filtering */
  tags: Array<KeyValue>;
  /** Target of the operation being resource type, e.g., plan, resource group */
  target: Scalars["String"]["output"];
};

export type AuditLogCount = {
  __typename?: "AuditLogCount";
  datehour: Scalars["String"]["output"];
  total: Scalars["String"]["output"];
};

export type AuditLogCountInput = {
  /** End of the time range in RFC3339 format */
  timeRangeEnd: Scalars["String"]["input"];
  /** Start of the time range in RFC3339 format */
  timeRangeStart: Scalars["String"]["input"];
};

export type AuditLogCountResponse = {
  __typename?: "AuditLogCountResponse";
  results: Array<AuditLogCount>;
};

export enum AuditLogIdentityType {
  ApiKey = "API_KEY",
  System = "SYSTEM",
  User = "USER",
}

export type AuditLogSearchFiltersInput = {
  identity?: InputMaybe<Scalars["String"]["input"]>;
  identityType?: InputMaybe<AuditLogIdentityType>;
  operation?: InputMaybe<Scalars["String"]["input"]>;
  target?: InputMaybe<Scalars["String"]["input"]>;
};

export type AuditLogSearchReportInput = {
  filters?: InputMaybe<AuditLogSearchFiltersInput>;
  /** End of the time range in RFC3339 format */
  timeRangeEnd: Scalars["String"]["input"];
  /** Start of the time range in RFC3339 format */
  timeRangeStart: Scalars["String"]["input"];
};

export type AuditLogSearchReportResponse = {
  __typename?: "AuditLogSearchReportResponse";
  url: Scalars["String"]["output"];
};

export type AuditLogsInput = {
  filters?: InputMaybe<AuditLogSearchFiltersInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Page numbers start from 0 */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /** End of the time range in RFC3339 format */
  timeRangeEnd: Scalars["String"]["input"];
  /** Start of the time range in RFC3339 format */
  timeRangeStart: Scalars["String"]["input"];
};

export type AuditLogsPage = {
  __typename?: "AuditLogsPage";
  count: Scalars["Int"]["output"];
  pages: Scalars["Int"]["output"];
  results: Array<AuditLog>;
};

export type AwsCredentialsInput = {
  rolesChain?: InputMaybe<Array<CredentialsAwsRoleInput>>;
  staticCredentials?: InputMaybe<StaticAwsCredentialsInput>;
};

export type AzureCredentialsInput = {
  appId: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  tenantId: Scalars["String"]["input"];
};

export enum AzureFunctionMethod {
  Delete = "DELETE",
  Get = "GET",
  Patch = "PATCH",
  Post = "POST",
  Put = "PUT",
}

export type BatchAction = {
  __typename?: "BatchAction";
  /** Batch action */
  action: PlanActionProperties;
  /** Batch action id */
  id: Scalars["UUID"]["output"];
  /**
   * Names and values of parameters that are passed to the action.
   * They must comply with System Action's or Custom Action's parameter definitions.
   * Values of type other than string are JSON-serialized to string.
   */
  inputParameters?: Maybe<Array<KeyValue>>;
  /** Batch action name */
  name: Scalars["String"]["output"];
  /** Batch action notification groups */
  notificationGroups?: Maybe<Array<PlanActionNotificationGroup>>;
  /** Order of the action in the batch */
  order: Scalars["Int"]["output"];
  /** Resource groups that belong to batch action */
  resourceGroups?: Maybe<Array<Group>>;
  /** Resources that belong to batch action */
  resources?: Maybe<Array<Resource>>;
};

export type BatchedEventAction = {
  __typename?: "BatchedEventAction";
  /** Action */
  action?: Maybe<EventActionProperties>;
  /** Action name */
  actionName: Scalars["String"]["output"];
  /** List of event action attempts */
  attempts: Array<EventActionAttempt>;
  /** Event action state */
  globalState?: Maybe<GlobalEventActionState>;
  /** Event action id */
  id: Scalars["UUID"]["output"];
  /**
   * Names and values of parameters that are passed to the action.
   * They must comply with System Action's or Custom Action's parameter definitions.
   * Values of type other than string are JSON-serialized to string.
   */
  inputParameters?: Maybe<Array<KeyValue>>;
  /** Event action name */
  name: Scalars["String"]["output"];
  /** Order of the event action in the batch. Must be greater or equal 0 and unique over the batch. */
  order: Scalars["Int"]["output"];
  /** Event action resource groups */
  resourceGroups?: Maybe<Array<Maybe<Group>>>;
  /** Event action merged resource statuses */
  resourceStates?: Maybe<Array<EventActionResourceState>>;
  /** Event action resources */
  resources?: Maybe<Array<Resource>>;
  /** Event action scope */
  scope: EventActionScope;
  /** Event action type */
  type: EventActionType;
};

export type BundledReportInfo = {
  __typename?: "BundledReportInfo";
  /** A message describing any error that occurred during report generation. */
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  /** Status of the report (e.g., READY, PENDING, ERROR). */
  status: BundledReportStatus;
  /** The presigned URL for downloading the report. */
  url?: Maybe<Scalars["String"]["output"]>;
};

export type BundledReportInput = {
  /** Date range for the report. */
  dateRange: DateRange;
  /** Type of report to request (e.g. CSV_EVENTS_LIST). */
  type: BundledReportType;
};

export enum BundledReportStatus {
  /** An error occurred during report generation. */
  Error = "ERROR",
  /** The report is being generated. */
  Pending = "PENDING",
  /** The report is available for download. */
  Ready = "READY",
}

export enum BundledReportType {
  /** The report in CSV format contains a list of events. */
  CsvEventsList = "CSV_EVENTS_LIST",
  /** The report in CSV format contains a list of resources with patching information. */
  CsvResourcesList = "CSV_RESOURCES_LIST",
  /** The report in JSON format contains a list of events. */
  JsonEventsList = "JSON_EVENTS_LIST",
  /** The report in JSON format contains a list of resources with patching information. */
  JsonResourcesList = "JSON_RESOURCES_LIST",
}

export enum CpuArchitecture {
  Amd64 = "AMD64",
  Arm64 = "ARM64",
  I386 = "I386",
  Ppc64Le = "PPC64LE",
  Unknown = "UNKNOWN",
}

export enum CacheControlScope {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export type ChangeDetails = {
  __typename?: "ChangeDetails";
  createdAt: Scalars["String"]["output"];
  createdBy: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  updatedBy: Scalars["String"]["output"];
};

export type ChangeResourceExecutionStatusInput = {
  annotation: Scalars["String"]["input"];
  eventActionId: Scalars["UUID"]["input"];
  eventActionResourceStateId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
  status: ResourceExecutionStatusManual;
};

export type Channel = {
  __typename?: "Channel";
  id: Scalars["UUID"]["output"];
  typeProperties: ChannelTypeProperties;
};

export type ChannelCreateInput = {
  type: ChannelType;
  /** Content of the notification channel respectively based on the chosen type */
  typeProperties: CreateChannelTypeTypePropertiesInput;
};

export enum ChannelType {
  Email = "EMAIL",
  Webhook = "WEBHOOK",
}

export type ChannelTypeProperties = EmailChannel | WebhookChannel;

export type ChannelUpdateInput = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  type?: InputMaybe<ChannelType>;
  /** Content of the notification channel respectively based on the chosen type */
  typeProperties?: InputMaybe<UpdateChannelTypePropertiesInput>;
};

export type CloudAccount = {
  __typename?: "CloudAccount";
  changeDetails: ChangeDetails;
  description?: Maybe<Scalars["String"]["output"]>;
  environment?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  lastScanEndDate?: Maybe<Scalars["String"]["output"]>;
  lastScanStartDate?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Array<KeyValue>>;
  name: Scalars["String"]["output"];
  provider: CloudAccountCloudProvider;
  providerId: Scalars["String"]["output"];
  regions: Array<Scalars["String"]["output"]>;
  regionsStatuses?: Maybe<Array<Maybe<RegionStatus>>>;
  resourceCleanerEnabled: Scalars["Boolean"]["output"];
  resourceDiscoveryEnabled: Scalars["Boolean"]["output"];
  status: CloudAccountStatus;
};

export enum CloudAccountCloudProvider {
  Aws = "AWS",
  Azure = "AZURE",
  Gc = "GC",
}

export enum CloudAccountRegionStatus {
  AccessError = "ACCESS_ERROR",
  AccessOk = "ACCESS_OK",
}

export enum CloudAccountStatus {
  AccessError = "ACCESS_ERROR",
  AccessMissing = "ACCESS_MISSING",
  AccessOk = "ACCESS_OK",
  InProgress = "IN_PROGRESS",
  RegionsUnavailable = "REGIONS_UNAVAILABLE",
}

export type CloudAccountsFilterInput = {
  field: CloudAccountsFilterableFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum CloudAccountsFilterableFields {
  CreatedAt = "CREATED_AT",
  Provider = "PROVIDER",
  Status = "STATUS",
}

export type CloudAccountsPage = {
  __typename?: "CloudAccountsPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Maybe<CloudAccount>>>;
};

export type CloudAccountsSearchInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<CloudAccountsFilterInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export enum CloudAccountsSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Name = "NAME",
  Provider = "PROVIDER",
  ResourceCleanerEnabled = "RESOURCE_CLEANER_ENABLED",
  ResourceDiscoveryEnabled = "RESOURCE_DISCOVERY_ENABLED",
  Status = "STATUS",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type CloudAccountsSortInput = {
  field: CloudAccountsSortFields;
  order?: InputMaybe<SortOrder>;
};

export type CloudResource = {
  __typename?: "CloudResource";
  changeDetails: ChangeDetails;
  cloudAccount?: Maybe<CloudAccount>;
  cloudMetadata: Array<KeyValue>;
  cloudResourceId: Scalars["String"]["output"];
  fleetControlId?: Maybe<Scalars["String"]["output"]>;
  fullCloudResourceId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  lastPatching?: Maybe<LastPatching>;
  name: Scalars["String"]["output"];
  parentId?: Maybe<Scalars["String"]["output"]>;
  provider: CloudResourceProvider;
  providerId: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
  subtype: Scalars["String"]["output"];
  tags: Array<KeyValue>;
  type: Scalars["String"]["output"];
};

export type CloudResourceFilterValues = {
  __typename?: "CloudResourceFilterValues";
  cloudServices: Array<Scalars["String"]["output"]>;
  regions: Array<Scalars["String"]["output"]>;
  resourceTypes: Array<Scalars["String"]["output"]>;
};

export enum CloudResourceProvider {
  Aws = "AWS",
  Azure = "AZURE",
  Gc = "GC",
  Ibm = "IBM",
  Other = "OTHER",
}

export type CloudResourceReport = {
  __typename?: "CloudResourceReport";
  changeDetails: ChangeDetails;
  dateGenerated?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  status: CloudResourceReportStatus;
  url?: Maybe<Scalars["String"]["output"]>;
};

export enum CloudResourceReportStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
}

export enum CloudResourceReportsFilterByFields {
  CreatedBy = "CREATED_BY",
  Status = "STATUS",
}

export type CloudResourceReportsFilterByInput = {
  field: CloudResourceReportsFilterByFields;
  /** Allowed operators are EQ and NE. */
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum CloudResourceReportsFilterByRangeFields {
  /** Filter by report date generation, allowed values are in ISO format, example "2025-01-23T00:00:00Z". */
  DateGenerated = "DATE_GENERATED",
}

export type CloudResourceReportsFilterInput = {
  filterBy?: InputMaybe<Array<CloudResourceReportsFilterByInput>>;
  phrase?: InputMaybe<Scalars["String"]["input"]>;
  rangeFilterBy?: InputMaybe<Array<CloudResourceReportsRangeFilterByInput>>;
};

export type CloudResourceReportsPage = {
  __typename?: "CloudResourceReportsPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<CloudResourceReport>>;
};

export type CloudResourceReportsRangeFilterByInput = {
  field: CloudResourceReportsFilterByRangeFields;
  from?: InputMaybe<Scalars["String"]["input"]>;
  operator: RangeFilterComparisonOperator;
  to?: InputMaybe<Scalars["String"]["input"]>;
};

export enum CloudResourceReportsSortFields {
  CreatedBy = "CREATED_BY",
  DateGenerated = "DATE_GENERATED",
}

export type CloudResourceReportsSortInput = {
  field: CloudResourceReportsSortFields;
  order: SortOrder;
};

export enum CloudResourcesFilterByFields {
  CloudAccount = "CLOUD_ACCOUNT",
  CloudService = "CLOUD_SERVICE",
  LastPatchingStatus = "LAST_PATCHING_STATUS",
  /** Filter by cloudProvider field, allowed values are from CloudResourceProvider enum. */
  Provider = "PROVIDER",
  Region = "REGION",
  ResourceType = "RESOURCE_TYPE",
}

export type CloudResourcesFilterByInput = {
  field: CloudResourcesFilterByFields;
  /** Allowed operators are EQ and NE. */
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum CloudResourcesFilterByKeyValueFields {
  Metadata = "METADATA",
  Tag = "TAG",
}

export enum CloudResourcesFilterByRangeFields {
  /** Filter by resource discovery time (createdAt field), allowed values are in ISO format, example "2025-01-23T00:00:00Z". */
  DiscoveryTime = "DISCOVERY_TIME",
  /** Filter by resource lifespan, allowed values are number value in string format, example "5". */
  ResourceLifespan = "RESOURCE_LIFESPAN",
  /** Filter by whether a resource is assigned or not to an application and/or environment. */
  Unassigned = "UNASSIGNED",
}

export type CloudResourcesFilterInput = {
  filterBy?: InputMaybe<Array<CloudResourcesFilterByInput>>;
  keyValueFilterBy?: InputMaybe<Array<CloudResourcesKeyValueFilterByInput>>;
  rangeFilterBy?: InputMaybe<Array<CloudResourcesRangeFilterByInput>>;
};

export type CloudResourcesKeyValueFilterByInput = {
  field: CloudResourcesFilterByKeyValueFields;
  operator: KeyValueFilterComparisonOperator;
  values?: InputMaybe<Array<CloudResourcesKeyValueFilterInput>>;
};

export type CloudResourcesKeyValueFilterInput = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type CloudResourcesPage = {
  __typename?: "CloudResourcesPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<CloudResource>>;
};

export type CloudResourcesRangeFilterByInput = {
  field: CloudResourcesFilterByRangeFields;
  from?: InputMaybe<Scalars["String"]["input"]>;
  operator: RangeFilterComparisonOperator;
  to?: InputMaybe<Scalars["String"]["input"]>;
};

export enum CloudResourcesSortFields {
  CloudResourceId = "CLOUD_RESOURCE_ID",
  CreatedAt = "CREATED_AT",
  Name = "NAME",
  Region = "REGION",
  Type = "TYPE",
}

export type CloudResourcesSortInput = {
  field: CloudResourcesSortFields;
  order: SortOrder;
};

export type CreateAwsLambdaInput = {
  /** ARN of the AWS Lambda function */
  lambdaArn: Scalars["String"]["input"];
};

export type CreateActionInput = {
  /** Color of action in hexadecimal numeral system e.g. #FFFFFF. Used for presentation purposes */
  color: Scalars["String"]["input"];
  /** Additional description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Action name */
  name: Scalars["String"]["input"];
  /** Defines what parameters can be defined for the action */
  parameterDefinitions: Array<CreateActionParameterDefinitionInput>;
  /** Scope of the action */
  scope: ActionScope;
  /** Determines whether the action is executed in a synchronous or asynchronous way */
  synchronous: Scalars["Boolean"]["input"];
  /** Determines type of the action and which source will be used */
  type: ActionType;
  /** Content of the action respectively based on the chosen type */
  typeProperties: CreateTypePropertiesInput;
};

export type CreateActionParameterDefinitionInput = {
  /** Optionally defines list of allowed values */
  allowedValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optionally defines the default value of the parameter */
  defaultValue?: InputMaybe<Scalars["String"]["input"]>;
  /** Optionally defines additional field description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the parameter */
  name: Scalars["String"]["input"];
  /** Determines whether the parameter is required or not */
  required: Scalars["Boolean"]["input"];
  /** Type of the parameter */
  type: ActionParameterType;
};

export type CreateApiKeyInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Valid format - ISO 8601, example: 2023-11-04T15:20:06
   * If field is not provided then the API key will expire after one year.
   */
  expiresAt?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  owner: Scalars["String"]["input"];
};

export type CreateApiKeyResult = {
  __typename?: "CreateApiKeyResult";
  /** The API key. */
  apiKey: ApiKey;
  /** The actual API key secret to be used in requests authentication. Please save it as it cannot be retrieved later. */
  apiKeySecret: Scalars["String"]["output"];
};

export type CreateApplicationInput = {
  contacts?: InputMaybe<Array<Scalars["String"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  name: Scalars["String"]["input"];
  owner?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateAssignmentsInput = {
  applicationEnvironmentPairs: Array<ApplicationEnvironmentPairInput>;
  resourceId: Scalars["UUID"]["input"];
};

export type CreateAzureFunctionInput = {
  /** Access key ID needed for authorization to execute Azure function */
  accessKeyId: Scalars["String"]["input"];
  /** Method used by the Azure function e.g. "GET", "POST", "PUT", "PATCH", "DELETE" */
  functionMethod: AzureFunctionMethod;
  /** URL of the Azure function */
  functionUrl: Scalars["String"]["input"];
};

export type CreateBatchActionInput = {
  /** Action to be used in batch action */
  action: PlanActionIdInput;
  /**
   * Names and values of parameters that are passed to the action.
   * They must comply with System Action's or Custom Action's parameter definitions.
   * Values of type other than string are JSON-serialized to string.
   */
  inputParameters?: InputMaybe<Array<KeyValueInput>>;
  /** Batch action name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Plan batch action notification groups */
  notificationGroups?: InputMaybe<
    Array<CreatePlanActionNotificationGroupInput>
  >;
  /** Order of the action in the batch */
  order: Scalars["Int"]["input"];
  /** Resource group IDs that will be added to the plan action */
  resourceGroupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Resource IDs that will be added to the plan action */
  resourceIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CreateChannelTypeTypePropertiesInput = {
  /** Content of the Email type channel */
  email?: InputMaybe<CreateEmailInput>;
  /** Content of the Webhook type channel */
  webhook?: InputMaybe<CreateWebhookInput>;
};

export type CreateCloudAccountInput = {
  credentials: AccountCredentialsInput;
  description?: InputMaybe<Scalars["String"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  name: Scalars["String"]["input"];
  provider: CloudAccountCloudProvider;
  providerId: Scalars["String"]["input"];
  regions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  resourceCleanerEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  resourceDiscoveryEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CreateCloudResourceReportInput = {
  filters?: InputMaybe<CloudResourcesFilterInput>;
  resourceIds: Array<Scalars["String"]["input"]>;
};

export type CreateEmailInput = {
  email: Scalars["String"]["input"];
};

export type CreateGroupInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  name: Scalars["String"]["input"];
  resourceSelectors: Array<CreateResourceSelectorInput>;
};

export type CreateMappingRuleInput = {
  tagName: Scalars["String"]["input"];
  type: MappingRuleType;
};

export type CreateNotificationGroupInput = {
  channels?: InputMaybe<Array<ChannelCreateInput>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type CreatePlanActionBatchInput = {
  /** Batch actions */
  batchActions?: InputMaybe<Array<CreateBatchActionInput>>;
  /** Must be set to one of the values: APPROVAL, SUCCESS_OR_APPROVAL, or ANYWAY */
  executionPolicy: ExecutionPolicy;
  /** Batch name */
  name: Scalars["String"]["input"];
  /** Must be greater than 0 */
  order: Scalars["Int"]["input"];
  /** Must be set to one of the values: ALWAYS, ON_SUCCESS, or NEVER */
  skipWindow: SkipWindowType;
  /** The windowDuration in minutes must be greater than 0 */
  windowDuration: Scalars["Int"]["input"];
};

export type CreatePlanActionInput = {
  /** Action to be used in plan action */
  action: PlanActionIdInput;
  executionPolicy: ExecutionPolicy;
  /**
   * Names and values of parameters that are passed to the action.
   * They must comply with System Action's or Custom Action's parameter definitions.
   * Values of type other than string are JSON-serialized to string.
   */
  inputParameters?: InputMaybe<Array<KeyValueInput>>;
  /** Plan action name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Plan action notification groups */
  notificationGroups?: InputMaybe<
    Array<CreatePlanActionNotificationGroupInput>
  >;
  /** Must be greater than 0 */
  order: Scalars["Int"]["input"];
  /** Resource group IDs that will be added to the plan action */
  resourceGroupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Resource IDs that will be added to the plan action */
  resourceIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** If set to true, then an action will be performed one at a time for each resource. Default value is false if not provided. */
  runInSequence?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The skipWindow property can be set to one of the values: ALWAYS, ON_SUCCESS, or NEVER */
  skipWindow: SkipWindowType;
  /** Window duration in minutes must be greater than 0 */
  windowDuration: Scalars["Int"]["input"];
};

export type CreatePlanActionNotificationGroupInput = {
  /**
   * Number of minutes that the notification should be sent in advance of the triggering event.
   * Valid only for UPCOMING and NOT_APPROVED trigger events, for which it must be set to a value greater than 0.
   */
  inAdvance?: InputMaybe<Scalars["Int"]["input"]>;
  /** ID of the notification group (notification recipient). */
  notificationGroupId: Scalars["ID"]["input"];
  /** Determines whether notifications should be sent for the action or for individual resources in the action. */
  scope: PlanActionNotificationGroupScope;
  /** Event that triggers notification. */
  triggerEvent: PlanActionNotificationTriggerType;
};

export type CreatePlanInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  enabled: Scalars["Boolean"]["input"];
  /** Metadata provided by user */
  metadata?: InputMaybe<Array<KeyValueInput>>;
  name: Scalars["String"]["input"];
  /** Plan notification groups to be added to plan */
  notificationGroups?: InputMaybe<Array<CreatePlanNotificationGroupInput>>;
  /** Batches of actions to be added to plan. */
  planActionBatches?: InputMaybe<Array<CreatePlanActionBatchInput>>;
  /** Actions to be added to plan. */
  planActions?: InputMaybe<Array<CreatePlanActionInput>>;
  /** Schedule cron e.g. 5 4 * * * */
  scheduleCron?: InputMaybe<Scalars["String"]["input"]>;
  /** Dates on which plan execution will be scheduled. When provided then `scheduleCron` and `scheduleOffset` must not be provided. */
  scheduleExecutionDates?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Schedule offset is a delay expressed in minutes that is added to cron-generated dates */
  scheduleOffset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Schedule time zone e.g. UTC. Required if `scheduleExecutionDates` or `scheduleCron` are set. */
  scheduleTimezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePlanNotificationGroupInput = {
  /**
   * Number of minutes that the notification should be sent in advance of the triggering event.
   * Valid only for UPCOMING trigger event, for which it must be set to a value greater than 0.
   */
  inAdvance?: InputMaybe<Scalars["Int"]["input"]>;
  /** ID of the notification group (notification recipient). */
  notificationGroupId: Scalars["ID"]["input"];
  /** Event that triggers notification. */
  triggerEvent: PlanNotificationTriggerType;
};

export type CreateReportEventActionInput = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
};

export type CreateReportInput = {
  eventActionInput?: InputMaybe<CreateReportEventActionInput>;
  reportType: ReportType;
  resourceListInput?: InputMaybe<CreateReportResourceListInput>;
  resourcePackagesComplianceInput?: InputMaybe<CreateReportResourcePackagesComplianceInput>;
};

export type CreateReportResourceListInput = {
  filter?: InputMaybe<Array<ResourcesFilterInput>>;
  phrase?: InputMaybe<Scalars["String"]["input"]>;
  resourceIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

export type CreateReportResourcePackagesComplianceInput = {
  endDate: Scalars["String"]["input"];
  resourceId: Scalars["UUID"]["input"];
  startDate: Scalars["String"]["input"];
};

export type CreateResourceInput = {
  /** Access needed for running commands on resource */
  access: ResourceAccessInput;
  /** Cloud resource ID e.g. instance ID for AWS, VM ID for Azure, instance ID for GC, virtual server instance ID for IBM Cloud. Field must be filled for all cloud providers excluding OTHER for which it will be filled automatically with the N/A value. */
  cloudResourceId?: InputMaybe<Scalars["String"]["input"]>;
  /** Additional description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** If set to false, it skips execution of all assigned actions to a particular resource. */
  enabled: Scalars["Boolean"]["input"];
  /** Full cloud resource ID is a full cloud identifier of a resource e.g. ARN for AWS, Resource ID for Azure, Resource Name for GC, CRN for IBM Cloud. Field must be filled for all cloud providers excluding OTHER. */
  fullCloudResourceId?: InputMaybe<Scalars["String"]["input"]>;
  /** Metadata provided by user */
  metadata?: InputMaybe<Array<KeyValueInput>>;
  /** Resource name */
  name: Scalars["String"]["input"];
  /** Resource Operating System */
  os?: InputMaybe<ResourceOsInput>;
  /** Cloud provider */
  provider: ResourceCloudProvider;
  /** Provider ID is a provider account ID (AWS account ID, Azure subscription ID, GC project ID etc.) */
  providerId: Scalars["String"]["input"];
  /** Resource region */
  region: Scalars["String"]["input"];
};

export type CreateResourceSelectorInput = {
  order: Scalars["Int"]["input"];
  resourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  tagsExpression?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateRoleBindingInput = {
  roleId: Scalars["ID"]["input"];
  /** Email for USER type or API key id for API_KEY type. */
  subject: Scalars["String"]["input"];
  type: RbacRoleBindingType;
};

export type CreateSsmDocumentInput = {
  /** ARN or name of the AWS SSM document */
  documentId: Scalars["String"]["input"];
};

export type CreateScriptInput = {
  /** File contains the script */
  file: Scalars["Upload"]["input"];
};

export type CreateTypePropertiesInput = {
  /** Content of the AWS_LAMBDA type action */
  awsLambda?: InputMaybe<CreateAwsLambdaInput>;
  /** Content of the AZURE_FUNCTION type action */
  azureFunction?: InputMaybe<CreateAzureFunctionInput>;
  /** Details of the script file */
  script?: InputMaybe<CreateScriptInput>;
  /** Content of the SSM_DOCUMENT type action */
  ssmDocument?: InputMaybe<CreateSsmDocumentInput>;
  /** Content of the WEBHOOK type action */
  webhook?: InputMaybe<CreateWebhookActionInput>;
};

export type CreateWebhookActionInput = {
  /** Field that is attached header fields (additional context and metadata) to the webhook request */
  headers: Array<KeyValueInput>;
  /** Payload is the data used in the webhook request in stringified JSON format */
  payload: Scalars["String"]["input"];
  /** Method used to invoke webhook e.g. "GET", "POST", "PUT", "PATCH", "DELETE" */
  webhookMethod: WebhookActionMethod;
  /** URL of the Webhook */
  webhookUrl: Scalars["String"]["input"];
};

export type CreateWebhookInput = {
  headers?: InputMaybe<Array<KeyValueInput>>;
  method: Scalars["String"]["input"];
  /** Payload contains request body payload in stringified JSON format */
  payload?: InputMaybe<Scalars["String"]["input"]>;
  type: WebhookChannelType;
  url: Scalars["String"]["input"];
};

export type CredentialsAwsRoleInput = {
  arn: Scalars["String"]["input"];
  externalId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CronField = {
  __typename?: "CronField";
  /** Description of field, e.g. At minute 0 */
  description: Scalars["String"]["output"];
  /** Name of expression field, e.g. Minutes */
  name: Scalars["String"]["output"];
  /** Value of expression field, e.g. 0 */
  value: Scalars["String"]["output"];
};

export type Customer = {
  __typename?: "Customer";
  customerSettings: CustomerSettings;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  organizationName: Scalars["String"]["output"];
};

export type CustomerSettings = {
  __typename?: "CustomerSettings";
  regions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type DateRange = {
  /**
   * The end date of the date range in ISO 8601 format with Coordinated Universal Time (UTC)
   * or local time zone (e.g., "2023-01-31T23:59:59Z" or "2023-01-31T23:59:59").
   */
  endDate: Scalars["String"]["input"];
  /**
   * The start date of the date range in ISO 8601 format with Coordinated Universal Time (UTC)
   * or local time zone (e.g., "2023-01-01T00:00:00Z" or "2023-01-01T00:00:00").
   */
  startDate: Scalars["String"]["input"];
};

export type DeleteApplicationInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteCloudResourceReportInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteMappingRuleInput = {
  id: Scalars["ID"]["input"];
};

export type EmailChannel = {
  __typename?: "EmailChannel";
  email: Scalars["String"]["output"];
};

export type Environment = {
  __typename?: "Environment";
  applicationId: Scalars["UUID"]["output"];
  changeDetails: ChangeDetails;
  contacts?: Maybe<Array<Scalars["String"]["output"]>>;
  description?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  metadata?: Maybe<Array<KeyValue>>;
  name: Scalars["String"]["output"];
  owner?: Maybe<Scalars["String"]["output"]>;
  type: EnvironmentType;
};

export enum EnvironmentType {
  Development = "DEVELOPMENT",
  Other = "OTHER",
  Production = "PRODUCTION",
  Staging = "STAGING",
}

export type EnvironmentWithResourceCount = {
  __typename?: "EnvironmentWithResourceCount";
  displayName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  resourceCount: Scalars["Int"]["output"];
};

export type Event = {
  __typename?: "Event";
  /** Event actions batches */
  actionBatches?: Maybe<Array<EventActionBatch>>;
  /** Event actions */
  actions?: Maybe<Array<EventAction>>;
  changeDetails: ChangeDetails;
  /** Additional description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** End time refers to the completion time of the first attempt for the final action */
  endTime?: Maybe<Scalars["String"]["output"]>;
  /** Estimated end time of the event */
  estimatedEndTime: Scalars["String"]["output"];
  /** Event id */
  id: Scalars["UUID"]["output"];
  /** Event metadata */
  metadata?: Maybe<Array<KeyValue>>;
  /** Event name */
  name: Scalars["String"]["output"];
  /** Event notifications */
  notifications?: Maybe<Array<NotificationGroup>>;
  /** Event plan. If it is set to null then the plan has been removed. */
  plan?: Maybe<Plan>;
  /** Event schedule timezone e.g. UTC */
  scheduleTimezone: Scalars["String"]["output"];
  /** Event start time */
  startTime: Scalars["String"]["output"];
  /** Event status */
  status: EventStatus;
};

export type EventAction = {
  __typename?: "EventAction";
  /** Action */
  action?: Maybe<EventActionProperties>;
  /** Action name */
  actionName: Scalars["String"]["output"];
  /** List of event action attempts */
  attempts: Array<EventActionAttempt>;
  /** Event action execution policy */
  executionPolicy: ExecutionPolicy;
  /** Event action state */
  globalState?: Maybe<GlobalEventActionState>;
  /** Event action id */
  id: Scalars["UUID"]["output"];
  /**
   * Names and values of parameters that are passed to the action.
   * They must comply with System Action's or Custom Action's parameter definitions.
   * Values of type other than string are JSON-serialized to string.
   */
  inputParameters?: Maybe<Array<KeyValue>>;
  /** Event action name */
  name: Scalars["String"]["output"];
  /** Order of the event action. Must be greater or equal 0 */
  order: Scalars["Int"]["output"];
  /** Event action resource groups */
  resourceGroups?: Maybe<Array<Maybe<Group>>>;
  /** Event action merged resource statuses */
  resourceStates?: Maybe<Array<EventActionResourceState>>;
  /** Event action resources */
  resources?: Maybe<Array<Resource>>;
  /** If set to true then an action has been performed on each resource, one at a time. */
  runInSequence: Scalars["Boolean"]["output"];
  /** Event action scope */
  scope: EventActionScope;
  /** The skipWindow property can be set to one of the values: ALWAYS, ON_SUCCESS, or NEVER */
  skipWindow: SkipWindowType;
  /**
   * Event action first attempt state
   * @deprecated Use globalState instead
   */
  state?: Maybe<EventActionState>;
  /** Event action type */
  type: EventActionType;
  /** Event action window duration in minutes. Must be greater or equal 0 */
  windowDuration: Scalars["Int"]["output"];
};

export type EventActionAttempt = {
  __typename?: "EventActionAttempt";
  /** Determines which attempt it was in turn */
  attempt: Scalars["Int"]["output"];
  /** Event action attempt id */
  id: Scalars["UUID"]["output"];
  /** Event action attempt resource statuses */
  resourceStates?: Maybe<Array<EventActionResourceState>>;
  /** Event action attempt state */
  state?: Maybe<EventActionState>;
};

export type EventActionAttemptReport = {
  __typename?: "EventActionAttemptReport";
  attempt: Scalars["Int"]["output"];
  report: EventActionReport;
};

export type EventActionBatch = {
  __typename?: "EventActionBatch";
  /** List of event actions */
  actions: Array<BatchedEventAction>;
  /** Event action batch execution policy */
  executionPolicy: ExecutionPolicy;
  /** Event action batch id */
  id: Scalars["UUID"]["output"];
  /** Event action batch name */
  name: Scalars["String"]["output"];
  /** Order of the event action batch. Must be greater or equal 0 */
  order: Scalars["Int"]["output"];
  /** The skipWindow property can be set to one of the values: ALWAYS, ON_SUCCESS, or NEVER */
  skipWindow: SkipWindowType;
  /** Start time of the entire batch action */
  startTime?: Maybe<Scalars["String"]["output"]>;
  /** Status of the entire batch */
  status: ExecutionStatus;
  /** Window duration for the entire batch in minutes. Must be greater or equal 0 */
  windowDuration: Scalars["Int"]["output"];
};

export type EventActionProperties = Action | SystemAction;

export type EventActionReport = {
  __typename?: "EventActionReport";
  /** Action name */
  actionName: Scalars["String"]["output"];
  /** Event action end time */
  endTime?: Maybe<Scalars["String"]["output"]>;
  /** Event action id */
  eventActionId: Scalars["UUID"]["output"];
  /** Event id */
  eventId: Scalars["UUID"]["output"];
  /** Event action name */
  name: Scalars["String"]["output"];
  /** Event action output, null for resource based action */
  output?: Maybe<Scalars["String"]["output"]>;
  /** Event action output URI, null for resource based action */
  outputUri?: Maybe<Scalars["String"]["output"]>;
  /** Event action resource reports */
  resources?: Maybe<Array<EventActionResourceReport>>;
  /** Event action start time */
  startTime?: Maybe<Scalars["String"]["output"]>;
  /** Event action execution status */
  status: ExecutionStatus;
};

export type EventActionResourceGroupStatus = {
  __typename?: "EventActionResourceGroupStatus";
  groupId: Scalars["UUID"]["output"];
  status: ResourceGroupStatus;
};

export type EventActionResourceReport = {
  __typename?: "EventActionResourceReport";
  /** Cloud resource id */
  cloudResourceId: Scalars["String"]["output"];
  /** Resource state error code */
  errorCode?: Maybe<ResourceExecutionErrorCode>;
  /** Full cloud resource id, for example AWS ARN */
  fullCloudResourceId: Scalars["String"]["output"];
  /** Resource name */
  name: Scalars["String"]["output"];
  /** Cloud provider */
  provider: ResourceCloudProvider;
  /** Cloud provider id */
  providerId: Scalars["String"]["output"];
  /** Resource region */
  region: Scalars["String"]["output"];
  /** Resource id */
  resourceId: Scalars["UUID"]["output"];
  /** Parsed report result */
  result: EventActionResourceReportResult;
  /** Resource execution status */
  status: ResourceExecutionStatus;
};

export type EventActionResourceReportResult = {
  __typename?: "EventActionResourceReportResult";
  /** List of available (not installed) packages */
  available?: Maybe<Array<ResourceReportPackage>>;
  /** List of packages that failed due to errors */
  failed?: Maybe<Array<ResourceReportPackage>>;
  /** List of installed packages */
  installed?: Maybe<Array<ResourceReportPackage>>;
  /** List of installed packages that require a reboot to be fully applied */
  installedPendingReboot?: Maybe<Array<ResourceReportPackage>>;
  /** Raw output for non-patching actions, null for patching action */
  output?: Maybe<Scalars["String"]["output"]>;
  /** Resource output URI for non-patching actions, null for patching action */
  outputUri?: Maybe<Scalars["String"]["output"]>;
  /** List of removed packages */
  removed?: Maybe<Array<ResourceReportPackage>>;
  /** List of updated packages */
  updated?: Maybe<Array<ResourceReportPackage>>;
};

export enum EventActionResourceReportsFilterByFields {
  /** Allowed values are ResourceExecutionErrorCode enum */
  ErrorCode = "ERROR_CODE",
  /** Allowed values are PackageTypes enum */
  PackageType = "PACKAGE_TYPE",
}

export type EventActionResourceReportsFilterByInput = {
  field: EventActionResourceReportsFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type EventActionResourceReportsFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<EventActionResourceReportsFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type EventActionResourceReportsPage = {
  __typename?: "EventActionResourceReportsPage";
  packagesCount: PackagesCount;
  pageInfo: PageInfo;
  result?: Maybe<Array<EventActionResourceReport>>;
};

export enum EventActionResourceReportsSortFields {
  Name = "NAME",
  ResourceId = "RESOURCE_ID",
}

export type EventActionResourceReportsSortInput = {
  field: EventActionResourceReportsSortFields;
  order?: InputMaybe<SortOrder>;
};

export type EventActionResourceState = {
  __typename?: "EventActionResourceState";
  /** Annotation for manual status change */
  annotation: Scalars["String"]["output"];
  changeDetails: ChangeDetails;
  /** Resource state error code */
  errorCode?: Maybe<ResourceExecutionErrorCode>;
  /** Event action id */
  eventActionId: Scalars["UUID"]["output"];
  /** Resource state id */
  id: Scalars["UUID"]["output"];
  /** Resource state order */
  order: Scalars["Int"]["output"];
  /** Resource state output */
  output?: Maybe<Array<Maybe<KeyValue>>>;
  /** Resource state output URI */
  outputUri?: Maybe<Scalars["String"]["output"]>;
  /** Resource state resource */
  resource?: Maybe<Resource>;
  /** Resource state resource group */
  resourceGroup?: Maybe<Group>;
  /** Resource group id */
  resourceGroupId?: Maybe<Scalars["UUID"]["output"]>;
  /** Resource id */
  resourceId: Scalars["UUID"]["output"];
  /** Resource state status */
  status: ResourceExecutionStatus;
};

/** Individual resource state change for idempotent UI counting */
export type EventActionResourceStateChange = {
  __typename?: "EventActionResourceStateChange";
  eventActionId: Scalars["UUID"]["output"];
  resourceStateId: Scalars["UUID"]["output"];
  status: ResourceExecutionStatus;
};

/**
 * Input for subscribing to event action resource state changes.
 * If eventActionId is provided, subscribes to a specific action.
 * If eventActionId is omitted, subscribes to all actions in the event.
 */
export type EventActionResourceStateChangedInput = {
  eventActionId?: InputMaybe<Scalars["UUID"]["input"]>;
  eventId: Scalars["UUID"]["input"];
};

export type EventActionResourceStateSearchItem = {
  __typename?: "EventActionResourceStateSearchItem";
  /** Resource state resource group */
  resourceGroup?: Maybe<Group>;
  /** Resource group id */
  resourceGroupId?: Maybe<Scalars["UUID"]["output"]>;
  /** Resource group status */
  resourceGroupStatus?: Maybe<ResourceGroupStatus>;
  /** List of event action resource states of resources belonging to the group */
  resourceStates?: Maybe<Array<EventActionResourceStateWithoutGroup>>;
};

export type EventActionResourceStateSearchPage = {
  __typename?: "EventActionResourceStateSearchPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<EventActionResourceStateSearchItem>>;
};

export enum EventActionResourceStateSortFields {
  Order = "ORDER",
  ResourceGroupName = "RESOURCE_GROUP_NAME",
  Status = "STATUS",
}

export type EventActionResourceStateSortInput = {
  field: EventActionResourceStateSortFields;
  order?: InputMaybe<SortOrder>;
};

export type EventActionResourceStateWithoutGroup = {
  __typename?: "EventActionResourceStateWithoutGroup";
  /** Annotation for manual status change */
  annotation: Scalars["String"]["output"];
  changeDetails: ChangeDetails;
  /** Resource state error code */
  errorCode?: Maybe<ResourceExecutionErrorCode>;
  /** Resource state id */
  id: Scalars["UUID"]["output"];
  /** Resource state order */
  order: Scalars["Int"]["output"];
  /** Resource state output */
  output?: Maybe<Array<Maybe<KeyValue>>>;
  /** Resource state output URI */
  outputUri?: Maybe<Scalars["String"]["output"]>;
  /** Resource state resource */
  resource?: Maybe<Resource>;
  /** Resource id */
  resourceId: Scalars["UUID"]["output"];
  /** Resource state status */
  status: ResourceExecutionStatus;
};

export enum EventActionResourceStatesFilterByFields {
  GroupId = "GROUP_ID",
  ResourceId = "RESOURCE_ID",
  Status = "STATUS",
}

export type EventActionResourceStatesFilterByInput = {
  field: EventActionResourceStatesFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type EventActionResourceStatesFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<EventActionResourceStatesFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export enum EventActionScope {
  Plan = "PLAN",
  Resource = "RESOURCE",
}

export type EventActionState = {
  __typename?: "EventActionState";
  approvedAt?: Maybe<Scalars["String"]["output"]>;
  /** Event action approval */
  approvedBy?: Maybe<Scalars["String"]["output"]>;
  changeDetails: ChangeDetails;
  /** Event action end time */
  endTime?: Maybe<Scalars["String"]["output"]>;
  /** Event action estimated start time */
  estimatedStartTime: Scalars["String"]["output"];
  /** Event action id */
  eventActionId: Scalars["UUID"]["output"];
  /** Event id */
  eventId: Scalars["UUID"]["output"];
  /** Event action output */
  output?: Maybe<Array<Maybe<KeyValue>>>;
  /** Event action output URI */
  outputUri?: Maybe<Scalars["String"]["output"]>;
  /** Event action start time */
  startTime?: Maybe<Scalars["String"]["output"]>;
  /** Event action execution status */
  status: ExecutionStatus;
};

export enum EventActionType {
  Custom = "CUSTOM",
  System = "SYSTEM",
}

export type EventReport = {
  __typename?: "EventReport";
  /** Event actions reports */
  actions?: Maybe<Array<EventActionReport>>;
  /** Event end time */
  endTime?: Maybe<Scalars["String"]["output"]>;
  /** Event id */
  eventId: Scalars["UUID"]["output"];
  /** Event name */
  name: Scalars["String"]["output"];
  /** Event start time */
  startTime?: Maybe<Scalars["String"]["output"]>;
  /** Event status */
  status: EventStatus;
};

export enum EventStatus {
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  PartialSuccess = "PARTIAL_SUCCESS",
  Success = "SUCCESS",
  WaitingForApproval = "WAITING_FOR_APPROVAL",
}

export type EventView = {
  __typename?: "EventView";
  actionBatches?: Maybe<Array<EventViewActionBatch>>;
  actions?: Maybe<Array<EventViewAction>>;
  changeDetails?: Maybe<ChangeDetails>;
  description?: Maybe<Scalars["String"]["output"]>;
  endTime?: Maybe<Scalars["String"]["output"]>;
  errorCodeCounts: Array<ResourceExecutionErrorCodeCount>;
  estimatedEndTime: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  metadata?: Maybe<Array<KeyValue>>;
  name: Scalars["String"]["output"];
  notifications?: Maybe<Array<NotificationGroup>>;
  plan?: Maybe<Plan>;
  scheduleTimezone: Scalars["String"]["output"];
  startTime: Scalars["String"]["output"];
  status: EventStatus;
};

export type EventViewAction = {
  __typename?: "EventViewAction";
  action?: Maybe<EventActionProperties>;
  actionName: Scalars["String"]["output"];
  attempts: Array<EventActionAttempt>;
  errorCodeCounts: Array<ResourceExecutionErrorCodeCount>;
  executionPolicy: ExecutionPolicy;
  globalState?: Maybe<GlobalEventActionState>;
  id: Scalars["UUID"]["output"];
  inputParameters?: Maybe<Array<KeyValue>>;
  name: Scalars["String"]["output"];
  order: Scalars["Int"]["output"];
  resourceGroups?: Maybe<Array<Maybe<Group>>>;
  resources?: Maybe<Array<Resource>>;
  resourcesFailed: Scalars["Int"]["output"];
  resourcesNotCompleted: Scalars["Int"]["output"];
  resourcesSucceeded: Scalars["Int"]["output"];
  runInSequence: Scalars["Boolean"]["output"];
  scope: EventActionScope;
  skipWindow: SkipWindowType;
  type: EventActionType;
  windowDuration?: Maybe<Scalars["Int"]["output"]>;
};

export type EventViewActionBatch = {
  __typename?: "EventViewActionBatch";
  actions: Array<EventViewAction>;
  executionPolicy: ExecutionPolicy;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  order: Scalars["Int"]["output"];
  skipWindow: SkipWindowType;
  startTime?: Maybe<Scalars["String"]["output"]>;
  status: ExecutionStatus;
  windowDuration: Scalars["Int"]["output"];
};

export enum EventsFilterByFields {
  ActionId = "ACTION_ID",
  ErrorCode = "ERROR_CODE",
  PlanId = "PLAN_ID",
  StartTime = "START_TIME",
  Status = "STATUS",
}

export type EventsFilterByInput = {
  field: EventsFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type EventsFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<EventsFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type EventsPage = {
  __typename?: "EventsPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Event>>;
};

export enum EventsSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  EstimatedEndTime = "ESTIMATED_END_TIME",
  Name = "NAME",
  StartTime = "START_TIME",
  Status = "STATUS",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type EventsSortInput = {
  field: EventsSortFields;
  order?: InputMaybe<SortOrder>;
};

export type EventsViewPage = {
  __typename?: "EventsViewPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<EventView>>;
};

export enum ExecutionPolicy {
  Anyway = "ANYWAY",
  Approval = "APPROVAL",
  SuccessOrApproval = "SUCCESS_OR_APPROVAL",
}

export enum ExecutionStatus {
  ApprovalRequired = "APPROVAL_REQUIRED",
  ApprovalTimeout = "APPROVAL_TIMEOUT",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  PartialSuccess = "PARTIAL_SUCCESS",
  Success = "SUCCESS",
  Timeout = "TIMEOUT",
  Upcoming = "UPCOMING",
}

export enum FilterComparisonOperator {
  Eq = "EQ",
  Ge = "GE",
  Gt = "GT",
  Le = "LE",
  Lt = "LT",
  Ne = "NE",
}

export type FutureActionForResource = {
  __typename?: "FutureActionForResource";
  actionName: Scalars["String"]["output"];
  actionType: PlanActionType;
  eventId: Scalars["UUID"]["output"];
  eventName: Scalars["String"]["output"];
  planId: Scalars["UUID"]["output"];
  resourceGroupId?: Maybe<Scalars["UUID"]["output"]>;
  resourceGroupName?: Maybe<Scalars["String"]["output"]>;
  scheduleTimezone: Scalars["String"]["output"];
  startTime: Scalars["String"]["output"];
};

export enum FutureActionsForResourceFilterByFields {
  ActionName = "ACTION_NAME",
  ActionType = "ACTION_TYPE",
  EventName = "EVENT_NAME",
  ResourceGroupName = "RESOURCE_GROUP_NAME",
  StartTime = "START_TIME",
  Timezone = "TIMEZONE",
}

export type FutureActionsForResourceFilterByInput = {
  field: FutureActionsForResourceFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type FutureActionsForResourceFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<FutureActionsForResourceFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type FutureActionsForResourcePage = {
  __typename?: "FutureActionsForResourcePage";
  pageInfo: PageInfo;
  result: Array<FutureActionForResource>;
};

export enum FutureActionsForResourceSortFields {
  ActionName = "ACTION_NAME",
  EventName = "EVENT_NAME",
  ResourceGroupName = "RESOURCE_GROUP_NAME",
  StartTime = "START_TIME",
}

export type FutureActionsForResourceSortInput = {
  field: FutureActionsForResourceSortFields;
  order?: InputMaybe<SortOrder>;
};

export type GenerateCronFromPhraseInput = {
  /** Phrase that describes schedule, e.g. 3rd Friday of every 3 months at 8 AM */
  phrase: Scalars["String"]["input"];
};

export type GenerateCronFromPhraseResult = {
  __typename?: "GenerateCronFromPhraseResult";
  /** Any error encountered during generation */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Generated cron expression */
  expression: Scalars["String"]["output"];
  /** Expression fields with values and descriptions */
  fields: Array<CronField>;
};

export type GenerateDatesFromCronInput = {
  /** Optionally defines how many dates should be generated. Allowed range 1 - 100. Default: 3. */
  countLimit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Defines the cron expression as the basis for date generation. */
  cronExpression: Scalars["String"]["input"];
  /** Defines the timezone in which the dates are generated. The timezone must be a valid IANA timezone identifier. */
  location: Scalars["String"]["input"];
  /** Optionally defines the number of minutes (positive or negative) added to or subtracted from each generated date. */
  offsetInMinutes?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GenerateDatesFromCronResult = {
  __typename?: "GenerateDatesFromCronResult";
  /** List of generated dates in ISO 8601 format. */
  dates?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Any error encountered during the dates generation process. */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Message displayed when generated dates do not comply with Fleet Control rules. */
  validationMsg?: Maybe<Scalars["String"]["output"]>;
};

export type GlobalEventActionState = {
  __typename?: "GlobalEventActionState";
  /** Event action end time */
  endTime?: Maybe<Scalars["String"]["output"]>;
  /** Event action estimated start time */
  estimatedStartTime: Scalars["String"]["output"];
  /** Event action output URI */
  outputUri?: Maybe<Scalars["String"]["output"]>;
  /** Event action start time */
  startTime?: Maybe<Scalars["String"]["output"]>;
  /** Event action execution status */
  status: ExecutionStatus;
};

export type GoogleCloudCredentialsInput = {
  keyFile: Scalars["String"]["input"];
};

export type Group = {
  __typename?: "Group";
  changeDetails: ChangeDetails;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  metadata?: Maybe<Array<KeyValue>>;
  name: Scalars["String"]["output"];
  plans?: Maybe<Array<Maybe<Plan>>>;
  resourceSelectors?: Maybe<Array<ResourceSelector>>;
  resourcesCounts?: Maybe<ResourcesCounts>;
  type?: Maybe<GroupTypes>;
};

export type GroupForResource = {
  __typename?: "GroupForResource";
  createdAt: Scalars["String"]["output"];
  createdBy: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  plans?: Maybe<Array<Plan>>;
  resourceSelector: ResourceSelector;
  updatedAt: Scalars["String"]["output"];
};

export type GroupIdentifiers = {
  __typename?: "GroupIdentifiers";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
};

export enum GroupTypes {
  Dynamic = "DYNAMIC",
  Empty = "EMPTY",
  Manual = "MANUAL",
  Mixed = "MIXED",
}

export type GroupUniqueAttributes = {
  __typename?: "GroupUniqueAttributes";
  createdBy: Array<Scalars["String"]["output"]>;
};

export enum GroupsFilterByFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Description = "DESCRIPTION",
  Name = "NAME",
  Type = "TYPE",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type GroupsFilterByInput = {
  field: GroupsFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GroupsFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<GroupsFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export enum GroupsForResourceFilterByFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Name = "NAME",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type GroupsForResourceFilterByInput = {
  field: GroupsForResourceFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GroupsForResourceFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<GroupsForResourceFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type GroupsForResourcePage = {
  __typename?: "GroupsForResourcePage";
  pageInfo: PageInfo;
  result: Array<GroupForResource>;
};

export enum GroupsForResourceSortFields {
  CreatedAt = "CREATED_AT",
  Name = "NAME",
  UpdatedAt = "UPDATED_AT",
}

export type GroupsForResourceSortInput = {
  field: GroupsForResourceSortFields;
  order?: InputMaybe<SortOrder>;
};

export type GroupsPage = {
  __typename?: "GroupsPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Group>>;
};

export enum GroupsSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Name = "NAME",
  OfflineResourcesCount = "OFFLINE_RESOURCES_COUNT",
  OnlineResourcesCount = "ONLINE_RESOURCES_COUNT",
  TotalResourcesCount = "TOTAL_RESOURCES_COUNT",
  Type = "TYPE",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type GroupsSortInput = {
  field: GroupsSortFields;
  order?: InputMaybe<SortOrder>;
};

export type HostAccessInput = {
  credentialsId: Scalars["String"]["input"];
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  ssmAccess: HostSsmAccessInput;
  type: ResourceAccessType;
};

export type HostInput = {
  access?: InputMaybe<HostAccessInput>;
  cloudHostId: Scalars["String"]["input"];
  cloudMetadata: Array<KeyValueInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fullCloudResourceId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  os?: InputMaybe<ResourceOsInput>;
  provider: ResourceCloudProvider;
  providerId: Scalars["String"]["input"];
  region: Scalars["String"]["input"];
  tags: Array<KeyValueInput>;
};

export type HostSsmAccessInput = {
  instanceId: Scalars["String"]["input"];
  region: Scalars["String"]["input"];
};

export type IncomingEvent = {
  __typename?: "IncomingEvent";
  changeDetails: ChangeDetails;
  /** Estimated end time of the event */
  estimatedEndTime: Scalars["String"]["output"];
  /** Incoming event id */
  id: Scalars["UUID"]["output"];
  /** Event metadata */
  metadata?: Maybe<Array<KeyValue>>;
  /** Event name */
  name: Scalars["String"]["output"];
  /** Event plan. If it is set to null then the plan has been removed. */
  plan?: Maybe<Plan>;
  /** Event schedule timezone e.g. UTC */
  scheduleTimezone: Scalars["String"]["output"];
  /** Start time of the event */
  startTime: Scalars["String"]["output"];
  /** Event status */
  status: IncomingEventStatus;
};

export type IncomingEventPage = {
  __typename?: "IncomingEventPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<IncomingEvent>>;
};

export enum IncomingEventStatus {
  Revoked = "REVOKED",
  Upcoming = "UPCOMING",
}

export enum IncomingEventsFilterByFields {
  ActionId = "ACTION_ID",
  PlanId = "PLAN_ID",
  StartTime = "START_TIME",
  Status = "STATUS",
}

export type IncomingEventsFilterByInput = {
  field: IncomingEventsFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type IncomingEventsFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<IncomingEventsFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export enum IncomingEventsSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  EstimatedEndTime = "ESTIMATED_END_TIME",
  StartTime = "START_TIME",
  Status = "STATUS",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type IncomingEventsSortInput = {
  field: IncomingEventsSortFields;
  order?: InputMaybe<SortOrder>;
};

export enum InventoryStatus {
  Error = "ERROR",
  Success = "SUCCESS",
}

export type KeyValue = {
  __typename?: "KeyValue";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export enum KeyValueFilterComparisonOperator {
  Eq = "EQ",
  Ne = "NE",
}

export type KeyValueInput = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type LastPatching = {
  __typename?: "LastPatching";
  date: Scalars["String"]["output"];
  status: PatchingStatus;
};

export type MappingRule = {
  __typename?: "MappingRule";
  changeDetails: ChangeDetails;
  id: Scalars["ID"]["output"];
  tagName: Scalars["String"]["output"];
  type: MappingRuleType;
};

export enum MappingRuleType {
  Application = "APPLICATION",
  Environment = "ENVIRONMENT",
}

export type MappingRulesFilterInput = {
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type MappingRulesPage = {
  __typename?: "MappingRulesPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<MappingRule>>;
};

export enum MappingRulesSortFields {
  TagName = "TAG_NAME",
  Type = "TYPE",
}

export type MappingRulesSortInput = {
  field: MappingRulesSortFields;
  order: SortOrder;
};

export type Mutation = {
  __typename?: "Mutation";
  /** This mutation approves event action */
  approveEventAction: Scalars["Boolean"]["output"];
  /** This mutation approves event action batch */
  approveEventActionBatch: Scalars["Boolean"]["output"];
  /** This mutation allows to change resource execution status with annotation */
  changeResourceExecutionStatus: Scalars["Boolean"]["output"];
  /** The mutation creates action */
  createAction: Action;
  /** The mutation creates a new API key for any entity. */
  createApiKey: CreateApiKeyResult;
  createApplication: Application;
  createAssignments: Array<Assignment>;
  /** This mutation creates cloud account */
  createCloudAccount: CloudAccount;
  createCloudResourceReport: Scalars["Boolean"]["output"];
  /** The mutation creates group. */
  createGroup: Group;
  createMappingRule: MappingRule;
  /** The mutation creates a notification group */
  createNotificationGroup: NotificationGroup;
  /** The mutation creates plan */
  createPlan: Plan;
  createReport: Report;
  /** Creates new resource. Returns newly created resource */
  createResource: Resource;
  /** The mutation creates new RBAC role */
  createRole: Role;
  /** The mutation creates Role Binding. */
  createRoleBinding: RoleBinding;
  deleteApplication: Scalars["Boolean"]["output"];
  /** Delete the report or cancel the report generation process. */
  deleteCloudResourceReport: Scalars["Boolean"]["output"];
  deleteMappingRule: Scalars["Boolean"]["output"];
  /** The mutation generates cron expression based on phrase. */
  generateCronFromPhrase: GenerateCronFromPhraseResult;
  /** The mutation generates dates based on cron expression. */
  generateDatesFromCron: GenerateDatesFromCronResult;
  /** Ping resource based on provided identifier */
  pingResource?: Maybe<Scalars["Boolean"]["output"]>;
  /** The mutation removes action */
  removeAction: Scalars["Boolean"]["output"];
  /** The mutation removes the API key. */
  removeApiKey: Scalars["Boolean"]["output"];
  /** This mutation removes cloud account */
  removeCloudAccount: Scalars["Boolean"]["output"];
  /** The mutation removes group. */
  removeGroup: Scalars["Boolean"]["output"];
  /** The mutation removes a notification group */
  removeNotificationGroup: Scalars["Boolean"]["output"];
  /** The mutation removes plan */
  removePlan: Scalars["Boolean"]["output"];
  removeReport: Scalars["Boolean"]["output"];
  /** Remove resource based on provided identifier */
  removeResource?: Maybe<Scalars["Boolean"]["output"]>;
  /** The mutation removes RBAC role based on provided identifier */
  removeRole: Scalars["Boolean"]["output"];
  /** The mutation removes Role Binding. */
  removeRoleBinding: Scalars["Boolean"]["output"];
  /**
   * The mutation removes the User.
   * This user entity is used only to store last login date.
   */
  removeUser: Scalars["Boolean"]["output"];
  /**
   * This mutation invokes the SSM activation create request for the given region.
   * If the activation already exists, the creation will be skipped.
   */
  requestSsmActivation: Activation;
  /** Rerun the report generation with the same filters and resource IDs. It is possible only for reports with status FAILED. */
  rerunCloudResourceReport: Scalars["Boolean"]["output"];
  /** This mutation reruns failed event action */
  rerunEventAction: Scalars["Boolean"]["output"];
  /** This mutation sets REVOKED status for the incoming event */
  revokeIncomingEvent: Scalars["Boolean"]["output"];
  /** This mutation invokes a synchronous account scan */
  scanCloudAccount: Scalars["Boolean"]["output"];
  /** The mutation triggers plan */
  triggerPlan: Event;
  /** The mutation updates action */
  updateAction: Action;
  /** The mutation updates API key */
  updateApiKey: ApiKey;
  updateApplication: Application;
  /** This mutation updates cloud account */
  updateCloudAccount: CloudAccount;
  /** The mutation updates group. */
  updateGroup: Group;
  /** The mutation updates a notification group */
  updateNotificationGroup: NotificationGroup;
  /** The mutation updates plan */
  updatePlan: Plan;
  /** Updates resource. Returns updated resource. */
  updateResource: Resource;
  /** The mutation updates RBAC role */
  updateRole: Role;
  /** This query creates if not exist or updates if exists a host using the host installer */
  upsertHost: Scalars["Boolean"]["output"];
};

export type MutationApproveEventActionArgs = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
};

export type MutationApproveEventActionBatchArgs = {
  eventActionBatchId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
};

export type MutationChangeResourceExecutionStatusArgs = {
  input: ChangeResourceExecutionStatusInput;
};

export type MutationCreateActionArgs = {
  input: CreateActionInput;
};

export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};

export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};

export type MutationCreateAssignmentsArgs = {
  input: CreateAssignmentsInput;
};

export type MutationCreateCloudAccountArgs = {
  input: CreateCloudAccountInput;
};

export type MutationCreateCloudResourceReportArgs = {
  input: CreateCloudResourceReportInput;
};

export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};

export type MutationCreateMappingRuleArgs = {
  input: CreateMappingRuleInput;
};

export type MutationCreateNotificationGroupArgs = {
  input: CreateNotificationGroupInput;
};

export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};

export type MutationCreateReportArgs = {
  input: CreateReportInput;
};

export type MutationCreateResourceArgs = {
  input: CreateResourceInput;
};

export type MutationCreateRoleArgs = {
  input: RoleInput;
};

export type MutationCreateRoleBindingArgs = {
  input: CreateRoleBindingInput;
};

export type MutationDeleteApplicationArgs = {
  input: DeleteApplicationInput;
};

export type MutationDeleteCloudResourceReportArgs = {
  input: DeleteCloudResourceReportInput;
};

export type MutationDeleteMappingRuleArgs = {
  input: DeleteMappingRuleInput;
};

export type MutationGenerateCronFromPhraseArgs = {
  input: GenerateCronFromPhraseInput;
};

export type MutationGenerateDatesFromCronArgs = {
  input: GenerateDatesFromCronInput;
};

export type MutationPingResourceArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveActionArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveApiKeyArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveCloudAccountArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveGroupArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveNotificationGroupArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemovePlanArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveReportArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveResourceArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveRoleArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationRemoveRoleBindingArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationRemoveUserArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRequestSsmActivationArgs = {
  region: Scalars["String"]["input"];
};

export type MutationRerunCloudResourceReportArgs = {
  input: RerunCloudResourceReportInput;
};

export type MutationRerunEventActionArgs = {
  input: RerunEventActionInput;
};

export type MutationRevokeIncomingEventArgs = {
  eventId: Scalars["UUID"]["input"];
};

export type MutationScanCloudAccountArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationTriggerPlanArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationUpdateActionArgs = {
  input: UpdateActionInput;
};

export type MutationUpdateApiKeyArgs = {
  input: UpdateApiKeyInput;
};

export type MutationUpdateApplicationArgs = {
  input: UpdateApplicationInput;
};

export type MutationUpdateCloudAccountArgs = {
  input: UpdateCloudAccountInput;
};

export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};

export type MutationUpdateNotificationGroupArgs = {
  input: UpdateNotificationGroupInput;
};

export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};

export type MutationUpdateResourceArgs = {
  input: UpdateResourceInput;
};

export type MutationUpdateRoleArgs = {
  input: RoleUpdateInput;
};

export type MutationUpsertHostArgs = {
  input: UpsertHostInput;
};

export type NextPatchingActionForResource = {
  __typename?: "NextPatchingActionForResource";
  eventId: Scalars["UUID"]["output"];
  planActionId: Scalars["UUID"]["output"];
  planId: Scalars["UUID"]["output"];
  scheduleTimezone: Scalars["String"]["output"];
  startTime: Scalars["String"]["output"];
};

export type NotificationGroup = {
  __typename?: "NotificationGroup";
  changeDetails: ChangeDetails;
  channels?: Maybe<Array<Channel>>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  plans?: Maybe<Array<Plan>>;
};

export type NotificationGroupPage = {
  __typename?: "NotificationGroupPage";
  /** Information about returned page */
  pageInfo: PageInfo;
  /** List of notification groups */
  result?: Maybe<Array<NotificationGroup>>;
};

export enum NotificationGroupSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Name = "NAME",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type NotificationGroupSortInput = {
  field: NotificationGroupSortFields;
  order?: InputMaybe<SortOrder>;
};

export enum OsSubType {
  Amazon = "AMAZON",
  Centos = "CENTOS",
  Debian = "DEBIAN",
  OracleLinux = "ORACLE_LINUX",
  Redhat = "REDHAT",
  Suse = "SUSE",
  Ubuntu = "UBUNTU",
  WindowsServer = "WINDOWS_SERVER",
}

export enum OsType {
  Linux = "LINUX",
  Windows = "WINDOWS",
}

export enum PackageType {
  Available = "AVAILABLE",
  Failed = "FAILED",
  Installed = "INSTALLED",
  InstalledPendingReboot = "INSTALLED_PENDING_REBOOT",
  Packages = "PACKAGES",
  Removed = "REMOVED",
  Updated = "UPDATED",
}

export type PackagesCount = {
  __typename?: "PackagesCount";
  available: Scalars["Int"]["output"];
  failed: Scalars["Int"]["output"];
  installed: Scalars["Int"]["output"];
  installedPendingReboot: Scalars["Int"]["output"];
  packages: Scalars["Int"]["output"];
  removed: Scalars["Int"]["output"];
  updated: Scalars["Int"]["output"];
};

export type PageInfo = {
  __typename?: "PageInfo";
  count: Scalars["Int"]["output"];
  pages: Scalars["Int"]["output"];
};

export type PastActionForResource = {
  __typename?: "PastActionForResource";
  actionName: Scalars["String"]["output"];
  actionType: EventActionType;
  annotation?: Maybe<Scalars["String"]["output"]>;
  endTime?: Maybe<Scalars["String"]["output"]>;
  errorCode?: Maybe<ResourceExecutionErrorCode>;
  eventActionId: Scalars["UUID"]["output"];
  eventId: Scalars["UUID"]["output"];
  eventName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  outputUri?: Maybe<Scalars["String"]["output"]>;
  planId: Scalars["UUID"]["output"];
  resourceGroupId?: Maybe<Scalars["UUID"]["output"]>;
  resourceGroupName?: Maybe<Scalars["String"]["output"]>;
  scheduleTimezone: Scalars["String"]["output"];
  status: ResourceExecutionStatus;
  updatedBy: Scalars["String"]["output"];
};

export enum PastActionsForResourceFilterByFields {
  ActionName = "ACTION_NAME",
  ActionType = "ACTION_TYPE",
  ErrorCode = "ERROR_CODE",
  Status = "STATUS",
}

export type PastActionsForResourceFilterByInput = {
  field: PastActionsForResourceFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PastActionsForResourceFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<PastActionsForResourceFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type PastActionsForResourcePage = {
  __typename?: "PastActionsForResourcePage";
  pageInfo: PageInfo;
  result: Array<PastActionForResource>;
};

export enum PastActionsForResourceSortFields {
  ActionName = "ACTION_NAME",
  EndTime = "END_TIME",
  EventName = "EVENT_NAME",
  ResourceGroupName = "RESOURCE_GROUP_NAME",
  Status = "STATUS",
}

export type PastActionsForResourceSortInput = {
  field: PastActionsForResourceSortFields;
  order?: InputMaybe<SortOrder>;
};

export enum PatchingStatus {
  Error = "ERROR",
  Failed = "FAILED",
  NotInTimeWindow = "NOT_IN_TIME_WINDOW",
  Success = "SUCCESS",
  Timeout = "TIMEOUT",
}

export type Plan = {
  __typename?: "Plan";
  changeDetails: ChangeDetails;
  description?: Maybe<Scalars["String"]["output"]>;
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** Metadata provided by user */
  metadata?: Maybe<Array<KeyValue>>;
  name: Scalars["String"]["output"];
  /** Plan next three execution dates */
  nextExecutionDates?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Plan notification groups */
  notificationGroups?: Maybe<Array<PlanNotificationGroup>>;
  /** Plan action batches */
  planActionBatches?: Maybe<Array<PlanActionBatch>>;
  /** Plan actions */
  planActions?: Maybe<Array<PlanAction>>;
  /** Schedule cron e.g. 5 4 * * * */
  scheduleCron?: Maybe<Scalars["String"]["output"]>;
  /** Dates on which plan execution will be scheduled. */
  scheduleExecutionDates?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Schedule offset is a delay expressed in minutes that is added to cron-generated dates */
  scheduleOffset: Scalars["Int"]["output"];
  scheduleOption: PlanScheduleOptions;
  /** Schedule time zone e.g. UTC */
  scheduleTimezone?: Maybe<Scalars["String"]["output"]>;
  status: PlanStatuses;
};

export type PlanAction = {
  __typename?: "PlanAction";
  action: PlanActionProperties;
  /** Execution policy provided by user */
  executionPolicy: ExecutionPolicy;
  /** Plan action id */
  id: Scalars["UUID"]["output"];
  /**
   * Names and values of parameters that are passed to the action.
   * They must comply with System Action's or Custom Action's parameter definitions.
   * Values of type other than string are JSON-serialized to string.
   */
  inputParameters?: Maybe<Array<KeyValue>>;
  /** Plan action name */
  name: Scalars["String"]["output"];
  /** Plan action notification groups */
  notificationGroups?: Maybe<Array<PlanActionNotificationGroup>>;
  /** Must be greater than 0 */
  order: Scalars["Int"]["output"];
  /** Resource groups that belong to plan action */
  resourceGroups?: Maybe<Array<Group>>;
  /** Resources that belong to plan action */
  resources?: Maybe<Array<Resource>>;
  /** If set to true, then an action will be performed one at a time for each resource. */
  runInSequence: Scalars["Boolean"]["output"];
  /** The skipWindow property can be set to one of the values: ALWAYS, ON_SUCCESS, or NEVER */
  skipWindow: SkipWindowType;
  /** Window duration in minutes must be greater than 0 */
  windowDuration: Scalars["Int"]["output"];
};

export type PlanActionBatch = {
  __typename?: "PlanActionBatch";
  /** Batch actions */
  batchActions?: Maybe<Array<BatchAction>>;
  /** Must be set to one of the values: APPROVAL, SUCCESS_OR_APPROVAL, or ANYWAY */
  executionPolicy: ExecutionPolicy;
  /** Batch id */
  id: Scalars["UUID"]["output"];
  /** Batch name */
  name: Scalars["String"]["output"];
  /** Must be greater than 0 */
  order: Scalars["Int"]["output"];
  /** Must be set to one of the values: ALWAYS, ON_SUCCESS, or NEVER */
  skipWindow: SkipWindowType;
  /** The windowDuration in minutes must be greater than 0 */
  windowDuration: Scalars["Int"]["output"];
};

export type PlanActionIdInput = {
  /** Action id */
  actionId: Scalars["UUID"]["input"];
  /** Action type */
  actionType: PlanActionType;
};

export type PlanActionNotificationGroup = {
  __typename?: "PlanActionNotificationGroup";
  id: Scalars["ID"]["output"];
  inAdvance?: Maybe<Scalars["Int"]["output"]>;
  notificationGroup: NotificationGroup;
  scope: PlanActionNotificationGroupScope;
  triggerEvent: PlanActionNotificationTriggerType;
};

export enum PlanActionNotificationGroupScope {
  Action = "ACTION",
  Resource = "RESOURCE",
}

export enum PlanActionNotificationTriggerType {
  /** @deprecated Use FAILED instead */
  EventActionsFailed = "EVENT_ACTIONS_FAILED",
  /** @deprecated Use SUCCESSFUL instead */
  EventActionsFinished = "EVENT_ACTIONS_FINISHED",
  /** @deprecated Use UPCOMING instead */
  EventActionsIncoming = "EVENT_ACTIONS_INCOMING",
  /** @deprecated Use NOT_APPROVED instead */
  EventActionsNotApproved = "EVENT_ACTIONS_NOT_APPROVED",
  /** @deprecated Use PARTIALLY_SUCCESSFUL instead */
  EventActionsPartiallySucceeded = "EVENT_ACTIONS_PARTIALLY_SUCCEEDED",
  /** @deprecated Use START instead */
  EventActionsStarted = "EVENT_ACTIONS_STARTED",
  /** @deprecated Use SUCCESSFUL instead */
  EventActionsSucceeded = "EVENT_ACTIONS_SUCCEEDED",
  /** @deprecated Use RESOURCES_ERROR instead */
  EventActionResourcesError = "EVENT_ACTION_RESOURCES_ERROR",
  /** @deprecated Use RESOURCES_FAILED instead */
  EventActionResourcesFailed = "EVENT_ACTION_RESOURCES_FAILED",
  /** @deprecated Use RESOURCES_SUCCESSFUL instead */
  EventActionResourcesFinished = "EVENT_ACTION_RESOURCES_FINISHED",
  /** @deprecated Use RESOURCES_NOT_IN_TIME_WINDOW instead */
  EventActionResourcesNotInTimeWindow = "EVENT_ACTION_RESOURCES_NOT_IN_TIME_WINDOW",
  /** @deprecated Use RESOURCES_START instead */
  EventActionResourcesStarted = "EVENT_ACTION_RESOURCES_STARTED",
  /** @deprecated Use RESOURCES_SUCCESSFUL instead */
  EventActionResourcesSucceeded = "EVENT_ACTION_RESOURCES_SUCCEEDED",
  /** @deprecated Use RESOURCES_TIMEOUT instead */
  EventActionResourcesTimeout = "EVENT_ACTION_RESOURCES_TIMEOUT",
  Failed = "FAILED",
  NotApproved = "NOT_APPROVED",
  PartiallySuccessful = "PARTIALLY_SUCCESSFUL",
  ResourcesError = "RESOURCES_ERROR",
  ResourcesFailed = "RESOURCES_FAILED",
  ResourcesNotInTimeWindow = "RESOURCES_NOT_IN_TIME_WINDOW",
  ResourcesStart = "RESOURCES_START",
  ResourcesSuccessful = "RESOURCES_SUCCESSFUL",
  ResourcesTimeout = "RESOURCES_TIMEOUT",
  Start = "START",
  Successful = "SUCCESSFUL",
  Upcoming = "UPCOMING",
}

export type PlanActionProperties = Action | SystemAction;

export enum PlanActionType {
  Custom = "CUSTOM",
  System = "SYSTEM",
}

export type PlanNotificationGroup = {
  __typename?: "PlanNotificationGroup";
  id: Scalars["ID"]["output"];
  inAdvance?: Maybe<Scalars["Int"]["output"]>;
  notificationGroup: NotificationGroup;
  triggerEvent: PlanNotificationTriggerType;
};

export enum PlanNotificationTriggerType {
  Created = "CREATED",
  Deleted = "DELETED",
  /** @deprecated Use FAILED instead */
  EventsFailed = "EVENTS_FAILED",
  /** @deprecated Use FINISHED instead */
  EventsFinished = "EVENTS_FINISHED",
  /** @deprecated Use INCOMING instead */
  EventsIncoming = "EVENTS_INCOMING",
  /** @deprecated Use PARTIALLY_SUCCESSFUL instead */
  EventsPartiallySucceeded = "EVENTS_PARTIALLY_SUCCEEDED",
  /** @deprecated Use START instead */
  EventsStarted = "EVENTS_STARTED",
  /** @deprecated Use SUCCESSFUL instead */
  EventsSucceeded = "EVENTS_SUCCEEDED",
  Failed = "FAILED",
  Finished = "FINISHED",
  PartiallySuccessful = "PARTIALLY_SUCCESSFUL",
  /** @deprecated Use CREATED instead */
  PlansCreated = "PLANS_CREATED",
  /** @deprecated Use DELETED instead */
  PlansDeleted = "PLANS_DELETED",
  /** @deprecated Use UPDATED instead */
  PlansUpdated = "PLANS_UPDATED",
  Start = "START",
  Successful = "SUCCESSFUL",
  Upcoming = "UPCOMING",
  Updated = "UPDATED",
}

export type PlanPage = {
  __typename?: "PlanPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Plan>>;
};

export enum PlanScheduleOptions {
  OnDemand = "ON_DEMAND",
  Recurring = "RECURRING",
  SpecifiedDates = "SPECIFIED_DATES",
}

export enum PlanSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Enabled = "ENABLED",
  Name = "NAME",
  ScheduleCron = "SCHEDULE_CRON",
  ScheduleTimezone = "SCHEDULE_TIMEZONE",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type PlanSortInput = {
  field: PlanSortFields;
  order?: InputMaybe<SortOrder>;
};

export enum PlanStatuses {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  OnDemand = "ON_DEMAND",
}

export enum PlansFilterByFields {
  ActionId = "ACTION_ID",
  CreatedAt = "CREATED_AT",
  ResourceGroupId = "RESOURCE_GROUP_ID",
  ScheduleOption = "SCHEDULE_OPTION",
  Status = "STATUS",
}

export type PlansFilterByInput = {
  field: PlansFilterByFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PlansFilterInput = {
  /** Can be provided with phrase to narrow down search results. */
  filterBy?: InputMaybe<Array<PlansFilterByInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query = {
  __typename?: "Query";
  /** The query returns a specified action. */
  action?: Maybe<Action>;
  /** The query returns actions with pagination. */
  actions: ActionPage;
  /**
   * This query returns existing activation or creates new if the activation limit is exceeded.
   * It is optional to specify one region where the activation will be searched or created.
   * When there is a need to create a new customer account exception is thrown.
   * @deprecated Use ssmActivation instead
   */
  activation: Activation;
  /** The query returns API key. */
  apiKey?: Maybe<ApiKey>;
  /** The query returns paginated list of API key. */
  apiKeys: ApiKeysPage;
  application: Application;
  applicationEnvironments: Array<Environment>;
  applications: ApplicationsPage;
  assignments: AssignmentsPage;
  auditLogCount: AuditLogCountResponse;
  auditLogSearchReport: AuditLogSearchReportResponse;
  auditLogs: AuditLogsPage;
  /** This query returns the list of unique event action names. It is used for filtering purposes. */
  availableEventActionNames: Array<Scalars["String"]["output"]>;
  /** This query returns the list of unique plan action names. It is used for filtering purposes. */
  availablePlanActionNames: Array<Scalars["String"]["output"]>;
  /** This query returns CFN template that can be used for AWS Cloud Account onboarding */
  awsOnboardingTemplate: Scalars["String"]["output"];
  /** This query returns Bash script that can be used for Azure Cloud Account onboarding */
  azureOnboardingScript: Scalars["String"]["output"];
  /** This query initiates bundled report generation for each unique date range and retrieves bundled report info. */
  bundledReport?: Maybe<BundledReportInfo>;
  /** This query returns specified cloud account */
  cloudAccount?: Maybe<CloudAccount>;
  /** This query returns customer cloud accounts with pagination */
  cloudAccounts: CloudAccountsPage;
  cloudResource?: Maybe<CloudResource>;
  cloudResourceFilterValues: CloudResourceFilterValues;
  cloudResourceReports: CloudResourceReportsPage;
  cloudResources: CloudResourcesPage;
  /** The query returns a list of customers to which the user or API key has an access. */
  customers: Array<Customer>;
  /**
   * This query returns specified event
   * @deprecated Use eventView instead
   */
  event?: Maybe<Event>;
  /** This query returns report for single event action */
  eventActionReport?: Maybe<EventActionReport>;
  /** This query returns reports for all event action attempts */
  eventActionReports?: Maybe<Array<EventActionAttemptReport>>;
  /** This query returns resource group statuses for the given event action */
  eventActionResourceGroupStatuses?: Maybe<
    Array<EventActionResourceGroupStatus>
  >;
  /** This query returns report for single event action resource */
  eventActionResourceReport: EventActionResourceReport;
  eventActionResourceReports: EventActionResourceReportsPage;
  /** This query returns list of event actions resource states with filters and pagination */
  eventActionResourceStateSearch: EventActionResourceStateSearchPage;
  /** This query returns report for the whole event including all actions and resources */
  eventReport?: Maybe<EventReport>;
  /**
   * This query returns specified event view with all actions but without resource states.
   * It is used for UI event detail view.
   */
  eventView?: Maybe<EventView>;
  /**
   * This query returns events with pagination
   * @deprecated Use eventsView instead
   */
  events: EventsPage;
  /**
   * This query fetches only the necessary event fields required to render the event list,
   * omitting redundant data to improve loading performance. Pagination is applied.
   */
  eventsView: EventsViewPage;
  futureActionsForResource: FutureActionsForResourcePage;
  /**
   * This query returns merged resource states from all attempts of an event action,
   * automatically concatenating resource states from newest to oldest attempts
   */
  globalEventActionResourceState: EventActionResourceStateSearchPage;
  /** The query returns a specified group. */
  group?: Maybe<Group>;
  /** The query returns unique attributes for groups to be used in filters. */
  groupUniqueAttributes: GroupUniqueAttributes;
  /** The query returns groups with pagination. */
  groups: GroupsPage;
  /** The query returns groups that a resource belongs to. */
  groupsForResource: GroupsForResourcePage;
  /** This query returns specified incoming event */
  incomingEvent?: Maybe<IncomingEvent>;
  /** This query returns incoming events with pagination */
  incomingEvents: IncomingEventPage;
  mappingRules: MappingRulesPage;
  /** The query returns a specified notification group. */
  notificationGroup?: Maybe<NotificationGroup>;
  /** The query returns notification groups with pagination. */
  notificationGroups: NotificationGroupPage;
  pastActionsForResource: PastActionsForResourcePage;
  /** The query returns a specified plan. */
  plan?: Maybe<Plan>;
  /** The query returns plans with pagination. */
  plans: PlanPage;
  /** This query returns presigned URL for given event action and event action resource output URL */
  presignedEventActionOutputUrl?: Maybe<Scalars["String"]["output"]>;
  /** This registration query verifies if the registration exists for the given managed node id. */
  registration: Registration;
  reports: ReportsPage;
  /** Returns single resource based on provided identifier */
  resource?: Maybe<Resource>;
  /** Returns cloud regions available for resources grouped by cloud providers. */
  resourceCloudRegions: ResourceCloudRegions;
  resourceComplianceReportForUI?: Maybe<ResourceComplianceReportForUiInfo>;
  resourceComplianceStatusForUI?: Maybe<ResourceComplianceStatusForUiInfo>;
  /** Returns a list of past events which contained a resource given by `id` in their actions */
  resourceEvents?: Maybe<EventsPage>;
  /**
   * Returns a list of future events which contain a resource given by `id` in their actions. This includes only resources which are
   * statically assigned to resource groups, and doesn't include resources which would be included via tags/mapping rules.
   */
  resourceIncomingEvents?: Maybe<IncomingEventPage>;
  /** Return the last event that contained a resource given by `id` in its actions */
  resourceLastEvent?: Maybe<Event>;
  /** Return the next future/incoming event which contains a resource given by `id` in its actions. This includes only resources which are statically assigned to resource groups, and doesn't include resources which would be included via tags/mapping rules. */
  resourceNextIncomingEvent?: Maybe<IncomingEvent>;
  /** Returns list of resources */
  resources?: Maybe<ResourcesPage>;
  /** Returns list of resources by provided tags expression */
  resourcesByTags?: Maybe<ResourcesPage>;
  /** Returns list of resources by provided search expression */
  resourcesSearch?: Maybe<ResourcesPage>;
  /** The query returns single role based on provided identifier */
  role?: Maybe<Role>;
  /** The query returns Role Binding. */
  roleBinding?: Maybe<RoleBinding>;
  /** The query returns paginated list of Role Bindings. */
  roleBindings?: Maybe<RoleBindingsPage>;
  /** The query returns paginated list of Role Bindings grouped by Users. */
  roleBindingsByUsers?: Maybe<RoleBindingsByUsersPage>;
  /** The query returns list of roles */
  roles: RolesPage;
  /** The query returns a script content for a specified action. */
  scriptContent: Scalars["String"]["output"];
  /** This query returns usable SSM activation. */
  ssmActivation: Activation;
  /** This query returns all SSM activation regions enabled for the customer. */
  ssmActivationRegions: Array<Maybe<Scalars["String"]["output"]>>;
  /** The query returns a specified system action. */
  systemAction?: Maybe<SystemAction>;
  /** The query returns system actions with pagination. */
  systemActions: SystemActionPage;
  /** Returns update status for the provided list of resource IDs. Each status includes information about pending updates, current update state, and details about the event/action/resource state used to determine the status. */
  updateStatusForResources?: Maybe<Array<UpdateStatusForResource>>;
  /** Returns update status resource statistics counts. */
  updateStatusResourceStatisticsCounts?: Maybe<
    Array<UpdateStatusResourceStatisticsCounts>
  >;
};

export type QueryActionArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryActionsArgs = {
  filter?: InputMaybe<ActionFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ActionSortInput>;
};

export type QueryActivationArgs = {
  region?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryApiKeyArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApiKeysArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ApiKeysSortInput>;
};

export type QueryApplicationArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApplicationEnvironmentsArgs = {
  applicationId: Scalars["UUID"]["input"];
};

export type QueryApplicationsArgs = {
  filter?: InputMaybe<ApplicationsFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ApplicationsSortInput>;
};

export type QueryAssignmentsArgs = {
  filter?: InputMaybe<AssignmentsFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAuditLogCountArgs = {
  input: AuditLogCountInput;
};

export type QueryAuditLogSearchReportArgs = {
  input: AuditLogSearchReportInput;
};

export type QueryAuditLogsArgs = {
  input: AuditLogsInput;
};

export type QueryAzureOnboardingScriptArgs = {
  subscriptionId: Scalars["UUID"]["input"];
};

export type QueryBundledReportArgs = {
  input: BundledReportInput;
};

export type QueryCloudAccountArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryCloudAccountsArgs = {
  filter?: InputMaybe<CloudAccountsSearchInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<CloudAccountsSortInput>;
};

export type QueryCloudResourceArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryCloudResourceReportsArgs = {
  filter?: InputMaybe<CloudResourceReportsFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<CloudResourceReportsSortInput>;
};

export type QueryCloudResourcesArgs = {
  filter?: InputMaybe<CloudResourcesFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<CloudResourcesSortInput>;
};

export type QueryEventArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryEventActionReportArgs = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
};

export type QueryEventActionReportsArgs = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
};

export type QueryEventActionResourceGroupStatusesArgs = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
  groupIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  merged?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryEventActionResourceReportArgs = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
  resourceId: Scalars["UUID"]["input"];
};

export type QueryEventActionResourceReportsArgs = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
  filter?: InputMaybe<EventActionResourceReportsFilterInput>;
  includeAttempts?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<EventActionResourceReportsSortInput>;
};

export type QueryEventActionResourceStateSearchArgs = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
  filter?: InputMaybe<EventActionResourceStatesFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<EventActionResourceStateSortInput>;
};

export type QueryEventReportArgs = {
  eventId: Scalars["UUID"]["input"];
};

export type QueryEventViewArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryEventsArgs = {
  filter?: InputMaybe<EventsFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<EventsSortInput>;
};

export type QueryEventsViewArgs = {
  filter?: InputMaybe<EventsFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<EventsSortInput>;
};

export type QueryFutureActionsForResourceArgs = {
  filter?: InputMaybe<FutureActionsForResourceFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  resourceId: Scalars["UUID"]["input"];
  sort?: InputMaybe<FutureActionsForResourceSortInput>;
};

export type QueryGlobalEventActionResourceStateArgs = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
  filter?: InputMaybe<EventActionResourceStatesFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<EventActionResourceStateSortInput>;
};

export type QueryGroupArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryGroupsArgs = {
  filter?: InputMaybe<GroupsFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<GroupsSortInput>;
};

export type QueryGroupsForResourceArgs = {
  filter?: InputMaybe<GroupsForResourceFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  resourceId: Scalars["UUID"]["input"];
  sort?: InputMaybe<GroupsForResourceSortInput>;
};

export type QueryIncomingEventArgs = {
  eventId: Scalars["UUID"]["input"];
};

export type QueryIncomingEventsArgs = {
  filter?: InputMaybe<IncomingEventsFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<IncomingEventsSortInput>;
};

export type QueryMappingRulesArgs = {
  filter?: InputMaybe<MappingRulesFilterInput>;
  sort?: InputMaybe<MappingRulesSortInput>;
};

export type QueryNotificationGroupArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryNotificationGroupsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<NotificationGroupSortInput>;
};

export type QueryPastActionsForResourceArgs = {
  filter?: InputMaybe<PastActionsForResourceFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  resourceId: Scalars["UUID"]["input"];
  sort?: InputMaybe<PastActionsForResourceSortInput>;
};

export type QueryPlanArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryPlansArgs = {
  filter?: InputMaybe<PlansFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<PlanSortInput>;
};

export type QueryPresignedEventActionOutputUrlArgs = {
  url: Scalars["String"]["input"];
};

export type QueryRegistrationArgs = {
  input: RegistrationInput;
};

export type QueryReportsArgs = {
  filter?: InputMaybe<ReportsFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ReportsSortInput>;
};

export type QueryResourceArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryResourceComplianceReportForUiArgs = {
  input: ResourceComplianceReportForUiInput;
};

export type QueryResourceComplianceStatusForUiArgs = {
  input: ResourceComplianceStatusForUiInput;
};

export type QueryResourceEventsArgs = {
  filters: ResourceEventsFilterInput;
  id: Scalars["UUID"]["input"];
};

export type QueryResourceIncomingEventsArgs = {
  filters: ResourceEventsFilterInput;
  id: Scalars["UUID"]["input"];
};

export type QueryResourceLastEventArgs = {
  filters: ResourceEventFiltersInput;
  id: Scalars["UUID"]["input"];
};

export type QueryResourceNextIncomingEventArgs = {
  filters: ResourceEventFiltersInput;
  id: Scalars["UUID"]["input"];
};

export type QueryResourcesArgs = {
  filter?: InputMaybe<ResourceFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ResourcesSortInput>;
};

export type QueryResourcesByTagsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  tagsExpression: Scalars["String"]["input"];
};

export type QueryResourcesSearchArgs = {
  input?: InputMaybe<ResourcesSearchInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ResourcesSortInput>;
};

export type QueryRoleArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryRoleBindingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRoleBindingsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<RoleBindingsSortInput>;
};

export type QueryRoleBindingsByUsersArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<RoleBindingsByUsersSortInput>;
};

export type QueryRolesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<RolesSortInput>;
};

export type QueryScriptContentArgs = {
  actionId: Scalars["UUID"]["input"];
};

export type QuerySsmActivationArgs = {
  region: Scalars["String"]["input"];
};

export type QuerySystemActionArgs = {
  id: Scalars["UUID"]["input"];
};

export type QuerySystemActionsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<SystemActionsSortInput>;
};

export type QueryUpdateStatusForResourcesArgs = {
  resourceIds: Array<Scalars["UUID"]["input"]>;
};

export enum RangeFilterComparisonOperator {
  Eq = "EQ",
  Ne = "NE",
}

/** All available actions on FleetControl resources. Choose ANY to allow the use of all actions. */
export enum RbacAction {
  Any = "ANY",
  Create = "CREATE",
  Delete = "DELETE",
  Execute = "EXECUTE",
  Update = "UPDATE",
  View = "VIEW",
}

/** All available FleetControl resources. Choose ANY to grant access to all resources. */
export enum RbacResource {
  Action = "ACTION",
  Activation = "ACTIVATION",
  Any = "ANY",
  ApiKey = "API_KEY",
  Application = "APPLICATION",
  Assignment = "ASSIGNMENT",
  CloudAccount = "CLOUD_ACCOUNT",
  Environment = "ENVIRONMENT",
  Event = "EVENT",
  MappingRule = "MAPPING_RULE",
  NotificationGroup = "NOTIFICATION_GROUP",
  Plan = "PLAN",
  Report = "REPORT",
  Resource = "RESOURCE",
  ResourceGroup = "RESOURCE_GROUP",
  Role = "ROLE",
  RoleBinding = "ROLE_BINDING",
}

export enum RbacRoleBindingType {
  ApiKey = "API_KEY",
  User = "USER",
}

export type RegionStatus = {
  __typename?: "RegionStatus";
  details?: Maybe<Scalars["String"]["output"]>;
  region: Scalars["String"]["output"];
  status: CloudAccountRegionStatus;
};

export type Registration = {
  __typename?: "Registration";
  awsAccountId?: Maybe<Scalars["String"]["output"]>;
  /** The credentials ID for the customer account that has the managed node registered in SSM. */
  credentialsId?: Maybe<Scalars["String"]["output"]>;
};

export type RegistrationInput = {
  /**
   * The AWS account ID where the managed node is already registered.
   * This account must be on-boarded to Fleet Control.
   * If omitted, dedicated customer accounts will be checked.
   */
  customerAwsAccountId?: InputMaybe<Scalars["String"]["input"]>;
  /** The manged node id is the the machine identifier in AWS Systems Manager. */
  managedNodeId: Scalars["String"]["input"];
  /** The region is the AWS region where the managed node is located. */
  region: Scalars["String"]["input"];
};

export type Report = {
  __typename?: "Report";
  changeDetails: ChangeDetails;
  dateGenerated?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  status: ReportStatus;
  type: ReportType;
  url?: Maybe<Scalars["String"]["output"]>;
};

export enum ReportStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
}

export enum ReportType {
  EventActionReportCsvExport = "EVENT_ACTION_REPORT_CSV_EXPORT",
  ResourceListCsvExport = "RESOURCE_LIST_CSV_EXPORT",
  ResourcePackagesComplianceCsvExport = "RESOURCE_PACKAGES_COMPLIANCE_CSV_EXPORT",
}

export enum ReportsFilterByFields {
  CreatedBy = "CREATED_BY",
  DateGenerated = "DATE_GENERATED",
  ReportType = "REPORT_TYPE",
  Status = "STATUS",
}

export type ReportsFilterByInput = {
  field: ReportsFilterByFields;
  /** Allowed operators are EQ and NE. */
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ReportsFilterInput = {
  filterBy?: InputMaybe<Array<ReportsFilterByInput>>;
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export type ReportsPage = {
  __typename?: "ReportsPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Report>>;
};

export enum ReportsSortFields {
  CreatedBy = "CREATED_BY",
  DateGenerated = "DATE_GENERATED",
}

export type ReportsSortInput = {
  field: ReportsSortFields;
  order: SortOrder;
};

export type RerunCloudResourceReportInput = {
  id: Scalars["UUID"]["input"];
};

export type RerunEventActionInput = {
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
};

export type Resource = {
  __typename?: "Resource";
  /** Access needed for running commands on resource */
  access?: Maybe<ResourceAccess>;
  /** Determines whether resource has been discovered automatically by Klarity FleetControl or has been added manually by user */
  autoDiscovery: Scalars["Boolean"]["output"];
  /** Change details represent when and by whom data was created or modified */
  changeDetails: ChangeDetails;
  /** Cloud account this resource belongs to */
  cloudAccount?: Maybe<CloudAccount>;
  /** Additional metadata fetched from cloud provider */
  cloudMetadata?: Maybe<Array<KeyValue>>;
  /** Cloud resource ID e.g. instance ID for AWS, VM ID for Azure, instance ID for GC, virtual server instance ID for IBM Cloud and N/A for OTHER. */
  cloudResourceId: Scalars["String"]["output"];
  /** Additional description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** If set to false, it skips execution of all assigned actions to a particular resource. */
  enabled: Scalars["Boolean"]["output"];
  /** Full cloud resource ID is a full cloud identifier of a resource e.g. ARN for AWS, Resource ID for Azure, Resource Name for GC, CRN for IBM Cloud and N/A for OTHER. */
  fullCloudResourceId: Scalars["String"]["output"];
  /**
   * List of future patching actions for this resource.
   * There would be only next patching action.
   * In case of overlapping actions (interval between their estimatedStartTime less than 5min) there would be multiple actions listed.
   */
  futurePatchingActions?: Maybe<Array<NextPatchingActionForResource>>;
  /** Identifiers of the groups this resource belongs to */
  groupIdentifiers?: Maybe<Array<GroupIdentifiers>>;
  /** Resource identifier */
  id: Scalars["String"]["output"];
  /** Latest available update */
  latestInventory?: Maybe<ResourceInventory>;
  /** Metadata provided by user */
  metadata?: Maybe<Array<KeyValue>>;
  /** Resource name */
  name: Scalars["String"]["output"];
  /** Resource Operating System */
  os?: Maybe<ResourceOs>;
  /** Cloud provider */
  provider: ResourceCloudProvider;
  /** Provider ID is a provider account ID (AWS account ID, Azure subscription ID, GC project ID etc.) */
  providerId: Scalars["String"]["output"];
  /** Resource region */
  region: Scalars["String"]["output"];
  /** Indicates if resource is scanned from Cloud Account or manually onboarded */
  scanned: Scalars["Boolean"]["output"];
  /** Resource state - connection status and other information */
  state?: Maybe<ResourceState>;
  /** Resource tags from cloud provider */
  tags?: Maybe<Array<KeyValue>>;
};

/** Represents access to resource */
export type ResourceAccess = SsmAccess;

export type ResourceAccessInput = {
  /** Access to resource using AWS SSM service */
  ssmAccess: SsmAccessInput;
  /** Type of resource access. It determines which field have to be filled, */
  type: ResourceAccessType;
};

export enum ResourceAccessType {
  Ssm = "SSM",
}

export type ResourceAccessUpdateInput = {
  /** Access to resource using AWS SSM service */
  ssmAccess: SsmAccessUpdateInput;
  /** Type of resource access. It determines which field have to be filled, */
  type: ResourceAccessType;
};

export enum ResourceCloudProvider {
  Aws = "AWS",
  Azure = "AZURE",
  Gc = "GC",
  Ibm = "IBM",
  Other = "OTHER",
}

export type ResourceCloudRegions = {
  __typename?: "ResourceCloudRegions";
  aws: Array<Scalars["String"]["output"]>;
  azure: Array<Scalars["String"]["output"]>;
  gc: Array<Scalars["String"]["output"]>;
  ibm: Array<Scalars["String"]["output"]>;
};

export type ResourceComplianceReportForUiInfo = {
  __typename?: "ResourceComplianceReportForUIInfo";
  /** List of actions with missing logs data which could not be evaluated for compliance. */
  actionsWithMissingData?: Maybe<Array<ActionWithMissingData>>;
  /** List of packages with compliance info. */
  packages?: Maybe<Array<ResourceComplianceReportPackageInfo>>;
  /** Status of the report (e.g., COMPLETED, IN_PROGRESS, FAILED). */
  status: ReportStatus;
};

export type ResourceComplianceReportForUiInput = {
  dateRange: DateRange;
  resourceId: Scalars["String"]["input"];
};

export type ResourceComplianceReportPackageInfo = {
  __typename?: "ResourceComplianceReportPackageInfo";
  category: Scalars["String"]["output"];
  eventActionId: Scalars["UUID"]["output"];
  eventId: Scalars["UUID"]["output"];
  patchPolicy: Scalars["String"]["output"];
  rebootAllowed: Scalars["String"]["output"];
  releaseDate: Scalars["String"]["output"];
  time: Scalars["String"]["output"];
  updateName: Scalars["String"]["output"];
  updateStatus: Scalars["String"]["output"];
};

export enum ResourceComplianceStatus {
  Compliant = "COMPLIANT",
  NonCompliant = "NON_COMPLIANT",
}

export type ResourceComplianceStatusForUiInfo = {
  __typename?: "ResourceComplianceStatusForUIInfo";
  /** List of resources with compliance status. */
  complianceStatuses?: Maybe<Array<ResourceComplianceStatusInfo>>;
  /** Status of the report (e.g., COMPLETED, IN_PROGRESS, FAILED). */
  status: ReportStatus;
};

export type ResourceComplianceStatusForUiInput = {
  dateRange: DateRange;
  resourceIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ResourceComplianceStatusInfo = {
  __typename?: "ResourceComplianceStatusInfo";
  resourceId: Scalars["String"]["output"];
  status: ResourceComplianceStatus;
};

export type ResourceEventFiltersInput = {
  /**
   * Optional: filter by actions type.
   *
   * This means that you can provide either/or `SCAN` and `PATCH` as values for the filter. If you provide these, the events
   * will be filtered to only events that have a system `SCAN/PATCH` action that contains the resource selected within the query.
   */
  actionTypes?: InputMaybe<Array<ResourceEventsActionType>>;
};

export enum ResourceEventsActionType {
  Patch = "PATCH",
  Scan = "SCAN",
}

export type ResourceEventsFilterInput = {
  /**
   * Optional: filter by actions type.
   *
   * This means that you can provide either/or `SCAN` and `PATCH` as values for the filter. If you provide these, the events
   * will be filtered to only events that have a system `SCAN/PATCH` action that contains the resource selected within the query.
   */
  actionTypes?: InputMaybe<Array<ResourceEventsActionType>>;
  /** Optional: maximum number of resources to return */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Optional: page number, 1-indexed */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /** Earliest start time for the event, equivalent to event.startTime > startTimeAfter */
  startTimeAfter: Scalars["String"]["input"];
  /** Latest start time for the event, equivalent to event.startTime <= startTimeBefore */
  startTimeBefore: Scalars["String"]["input"];
};

export enum ResourceExecutionErrorCode {
  InternalError = "INTERNAL_ERROR",
  LogsMalformed = "LOGS_MALFORMED",
  LogsNotAvailable = "LOGS_NOT_AVAILABLE",
  MissingAccess = "MISSING_ACCESS",
  Unknown = "UNKNOWN",
  VmInvalidState = "VM_INVALID_STATE",
  VmNotFound = "VM_NOT_FOUND",
}

export type ResourceExecutionErrorCodeCount = {
  __typename?: "ResourceExecutionErrorCodeCount";
  count: Scalars["Int"]["output"];
  errorCode: ResourceExecutionErrorCode;
};

export enum ResourceExecutionStatus {
  Error = "ERROR",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  ManualSuccess = "MANUAL_SUCCESS",
  NotInTimeWindow = "NOT_IN_TIME_WINDOW",
  Pending = "PENDING",
  Success = "SUCCESS",
  Timeout = "TIMEOUT",
}

export enum ResourceExecutionStatusManual {
  ManualSuccess = "MANUAL_SUCCESS",
}

export type ResourceFilterInput = {
  cloudResourceId?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ResourceGroupStatus {
  Error = "ERROR",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  ManualSuccess = "MANUAL_SUCCESS",
  NotInTimeWindow = "NOT_IN_TIME_WINDOW",
  PartialSuccess = "PARTIAL_SUCCESS",
  Pending = "PENDING",
  Success = "SUCCESS",
  Timeout = "TIMEOUT",
}

export type ResourceInventory = {
  __typename?: "ResourceInventory";
  availablePackagesUri?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["String"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  inventoryUri?: Maybe<Scalars["String"]["output"]>;
  status: InventoryStatus;
};

/** Operating system details */
export type ResourceOs = {
  __typename?: "ResourceOS";
  /** Architecture of CPU */
  architecture: CpuArchitecture;
  /** Subtype of operating system */
  subType?: Maybe<OsSubType>;
  /** Resource operating system type, e.g Windows, Linux */
  type: OsType;
  /** Version of operating system */
  version?: Maybe<Scalars["String"]["output"]>;
};

/** Operating system details */
export type ResourceOsInput = {
  /** Architecture of CPU */
  architecture: CpuArchitecture;
  /** Subtype of operating system */
  subType?: InputMaybe<OsSubType>;
  /** Resource operating system type, e.g Windows, Linux */
  type: OsType;
  /** Version of operating system */
  version?: InputMaybe<Scalars["String"]["input"]>;
};

/** Operating system details */
export type ResourceOsUpdateInput = {
  /** Version of operating system */
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResourceReportPackage = {
  __typename?: "ResourceReportPackage";
  /** Error message */
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  /** Package ID */
  id: Scalars["String"]["output"];
  /** Package name */
  name: Scalars["String"]["output"];
  /** Package previous version */
  previousVersion?: Maybe<Scalars["String"]["output"]>;
  /** Package version */
  version?: Maybe<Scalars["String"]["output"]>;
};

export type ResourceSelector = {
  __typename?: "ResourceSelector";
  dynamicResources?: Maybe<Array<Resource>>;
  id: Scalars["UUID"]["output"];
  order: Scalars["Int"]["output"];
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars["String"]["output"]>;
  tagsExpression?: Maybe<Scalars["String"]["output"]>;
};

export type ResourceState = {
  __typename?: "ResourceState";
  /** Error message */
  error?: Maybe<Scalars["String"]["output"]>;
  /** SSM metadata */
  ssmMetadata?: Maybe<Array<KeyValue>>;
  /** Connection status between resource and FleetControl */
  status: ResourceStatus;
  /** Date of state change */
  updatedAt: Scalars["String"]["output"];
};

export enum ResourceStatus {
  ConnectionLost = "CONNECTION_LOST",
  Online = "ONLINE",
}

export enum ResourceUpdateStatus {
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  NoPendingUpdates = "NO_PENDING_UPDATES",
  NoUpdatesData = "NO_UPDATES_DATA",
  PendingUpdates = "PENDING_UPDATES",
}

export type ResourceUpdateStatusBasedOn = {
  __typename?: "ResourceUpdateStatusBasedOn";
  /** Identifier of the specific action within the event. */
  eventActionId: Scalars["String"]["output"];
  /** The actual event action resource state object. */
  eventActionResourceState?: Maybe<EventActionResourceState>;
  /** Identifier of the resource state associated with the event action. */
  eventActionResourceStateId: Scalars["String"]["output"];
  /** Identifier of the event related to the resource update status. */
  eventId: Scalars["String"]["output"];
};

export type ResourcesCounts = {
  __typename?: "ResourcesCounts";
  disconnectedCount: Scalars["Int"]["output"];
  onlineCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type ResourcesFilterInput = {
  field: ResourcesFilterableFields;
  operator: FilterComparisonOperator;
  values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum ResourcesFilterableFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  OsSubtype = "OS_SUBTYPE",
  OsType = "OS_TYPE",
  PingStatus = "PING_STATUS",
  PlanId = "PLAN_ID",
  Provider = "PROVIDER",
  ProviderId = "PROVIDER_ID",
  Region = "REGION",
  ResourceGroupId = "RESOURCE_GROUP_ID",
  ResourceUpdateStatus = "RESOURCE_UPDATE_STATUS",
  /**
   * Use the `TAGS` filter by passing a JSON object as a single string in `values`. Keys are tag keys, and each value is a list of allowed tag values:
   * `{"env": ["production"], "role": ["webserver"]}` selects resources that have *both* tags: `env=production` and `role=webserver`.
   * `{"env": ["production", "development"], "role": ["webserver"]}` selects resources that have `role=webserver` and either `env=production` or `env=development`.
   * `{"priority": []}` selects resources that have the `priority` tag key present, regardless of its value.
   */
  Tags = "TAGS",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type ResourcesPage = {
  __typename?: "ResourcesPage";
  /** Information about returned page */
  pageInfo: PageInfo;
  /** List of resources */
  result?: Maybe<Array<Maybe<Resource>>>;
};

export type ResourcesSearchInput = {
  /** Can be provided with phrase to narrow down search results. */
  filter?: InputMaybe<Array<ResourcesFilterInput>>;
  /**
   * Used to match phrase on multiple fields by the prefix.
   * Multiple keywords can be provided separated by the space and they are considered as combined by AND statement.
   */
  phrase?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ResourcesSortFields {
  AutoDiscovery = "AUTO_DISCOVERY",
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Enabled = "ENABLED",
  Name = "NAME",
  Provider = "PROVIDER",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type ResourcesSortInput = {
  field: ResourcesSortFields;
  order?: InputMaybe<SortOrder>;
};

/** Role contains permissions and can be attached to the user/API key. */
export type Role = {
  __typename?: "Role";
  /** Change details represent when and by whom data was created or modified */
  changeDetails: ChangeDetails;
  /** Additional role description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Role identifier */
  id: Scalars["UUID"]["output"];
  /** Friendly role name */
  name: Scalars["String"]["output"];
  /** Rules allow to control access to FleetControl resources */
  rules: Array<RoleRule>;
};

export type RoleBinding = {
  __typename?: "RoleBinding";
  changeDetails: ChangeDetails;
  id: Scalars["ID"]["output"];
  role: Role;
  /** Email for USER type or API key id for API_KEY type. */
  subject: Scalars["String"]["output"];
  type: RbacRoleBindingType;
};

export type RoleBindingByUser = {
  __typename?: "RoleBindingByUser";
  /** Aggregated change details for all roles bindings, including the latest update and the earliest creation. */
  changeDetails: ChangeDetails;
  customerId: Scalars["UUID"]["output"];
  lastLoggedInAt?: Maybe<Scalars["String"]["output"]>;
  roles: Array<Role>;
  /** Email for USER type or API key id for API_KEY type. */
  subject: Scalars["String"]["output"];
  type: RbacRoleBindingType;
};

export type RoleBindingsByUsersPage = {
  __typename?: "RoleBindingsByUsersPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Maybe<RoleBindingByUser>>>;
};

export enum RoleBindingsByUsersSortFields {
  LastLoggedInAt = "LAST_LOGGED_IN_AT",
  Subject = "SUBJECT",
}

export type RoleBindingsByUsersSortInput = {
  field: RoleBindingsByUsersSortFields;
  order?: InputMaybe<SortOrder>;
};

export type RoleBindingsPage = {
  __typename?: "RoleBindingsPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<Maybe<RoleBinding>>>;
};

export enum RoleBindingsSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Id = "ID",
  RoleId = "ROLE_ID",
  Subject = "SUBJECT",
  Type = "TYPE",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type RoleBindingsSortInput = {
  field: RoleBindingsSortFields;
  order?: InputMaybe<SortOrder>;
};

/** Role contains permissions and can be attached to the user/API key. */
export type RoleInput = {
  /** Additional role description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Friendly role name */
  name: Scalars["String"]["input"];
  /** Rules allow to control access to FleetControl resources */
  rules: Array<RoleRuleInput>;
};

/** RoleRule allows to control access to FleetControl resources */
export type RoleRule = {
  __typename?: "RoleRule";
  /** List of actions that can be performed by the role */
  actions: Array<RbacAction>;
  /** List of resources that role has access */
  resources: Array<RbacResource>;
};

/** RoleRule allows to control access to FleetControl resources */
export type RoleRuleInput = {
  /** List of actions that can be performed by the role */
  actions: Array<RbacAction>;
  /** List of resources that role has access */
  resources: Array<RbacResource>;
};

export type RoleUpdateInput = {
  /** Additional role description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Role identifier */
  id: Scalars["UUID"]["input"];
  /** Friendly role name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Rules allow to control access to FleetControl resources */
  rules?: InputMaybe<Array<RoleRuleInput>>;
};

export type RolesPage = {
  __typename?: "RolesPage";
  /** Page details */
  pageInfo: PageInfo;
  /** List of roles */
  result?: Maybe<Array<Maybe<Role>>>;
};

export enum RolesSortFields {
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Name = "NAME",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
}

export type RolesSortInput = {
  field: RolesSortFields;
  order?: InputMaybe<SortOrder>;
};

/** Access to resource using AWS SSM service */
export type SsmAccess = {
  __typename?: "SSMAccess";
  /** Resource ID in SSM service */
  instanceId: Scalars["String"]["output"];
  /** Region where instance has been registered */
  region: Scalars["String"]["output"];
};

/** Access to resource using AWS SSM service */
export type SsmAccessInput = {
  credentials: AwsCredentialsInput;
  /** Resource ID in SSM service */
  instanceId: Scalars["String"]["input"];
  /** Region where instance has been registered */
  region: Scalars["String"]["input"];
};

/** Access to resource using AWS SSM service */
export type SsmAccessUpdateInput = {
  credentials?: InputMaybe<AwsCredentialsInput>;
  /** Resource ID in SSM service */
  instanceId?: InputMaybe<Scalars["String"]["input"]>;
  /** Region where instance has been registered */
  region?: InputMaybe<Scalars["String"]["input"]>;
};

export enum SkipWindowType {
  Always = "ALWAYS",
  Never = "NEVER",
  OnSuccess = "ON_SUCCESS",
}

export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type StaticAwsCredentialsInput = {
  accessKeyId: Scalars["String"]["input"];
  secretAccessKey: Scalars["String"]["input"];
};

export type StatusChangedInput = {
  id: Scalars["UUID"]["input"];
};

export type Subscription = {
  __typename?: "Subscription";
  /** This subscription allows to get the newest any event resource status based on eventId and eventActionId */
  anyEventResourceStatusChanged: ResourceExecutionStatus;
  /** This subscription allows to get the newest event action batch status */
  eventActionBatchStatusChanged: ExecutionStatus;
  /** This subscription allows to get individual resource state changes with resourceStateId for idempotent counting */
  eventActionResourceStateChanged: EventActionResourceStateChange;
  /** This subscription allows to get the newest event action status */
  eventActionStatusChanged: ExecutionStatus;
  /** This subscription allows to get the newest event resource status based on resourceStateId */
  eventResourceStatusChanged: ResourceExecutionStatus;
  /** This subscription allows to get the newest event status */
  eventStatusChanged: EventStatus;
};

export type SubscriptionAnyEventResourceStatusChangedArgs = {
  input: AnyResourceStatusChangedInput;
};

export type SubscriptionEventActionBatchStatusChangedArgs = {
  input: StatusChangedInput;
};

export type SubscriptionEventActionResourceStateChangedArgs = {
  input: EventActionResourceStateChangedInput;
};

export type SubscriptionEventActionStatusChangedArgs = {
  input: StatusChangedInput;
};

export type SubscriptionEventResourceStatusChangedArgs = {
  input: StatusChangedInput;
};

export type SubscriptionEventStatusChangedArgs = {
  input: StatusChangedInput;
};

export type SystemAction = {
  __typename?: "SystemAction";
  /** Change details represent when and by whom data was created or modified */
  changeDetails: ChangeDetails;
  /** Color of the action in hexadecimal numeral system e.g. #FFFFFF. Used for presentation purposes */
  color: Scalars["String"]["output"];
  /** Additional description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Action identifier */
  id: Scalars["UUID"]["output"];
  /** Action name */
  name: Scalars["String"]["output"];
  /** Describes the possible parameters of the action */
  parameterDefinitions: Array<ActionParameterDefinition>;
  /** Scope of the action */
  scope: ActionScope;
  /** Version of action */
  version: Scalars["String"]["output"];
};

export type SystemActionPage = {
  __typename?: "SystemActionPage";
  pageInfo: PageInfo;
  result?: Maybe<Array<SystemAction>>;
};

export enum SystemActionsSortFields {
  Color = "COLOR",
  CreatedAt = "CREATED_AT",
  CreatedBy = "CREATED_BY",
  Name = "NAME",
  UpdatedAt = "UPDATED_AT",
  UpdatedBy = "UPDATED_BY",
  Version = "VERSION",
}

export type SystemActionsSortInput = {
  field: SystemActionsSortFields;
  order?: InputMaybe<SortOrder>;
};

export type UpdateAwsLambdaInput = {
  /** ARN of the AWS lambda function */
  lambdaArn: Scalars["String"]["input"];
};

export type UpdateActionInput = {
  /** Color of action in hexadecimal numeral system e.g. #FFFFFF. Used for presentation purposes */
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Additional description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Action identifier */
  id: Scalars["UUID"]["input"];
  /** Action name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Defines what parameters can be defined for the action */
  parameterDefinitions?: InputMaybe<
    Array<UpdateActionParameterDefinitionInput>
  >;
  /** Scope of the action */
  scope?: InputMaybe<ActionScope>;
  /** Determines whether the action is executed in a synchronous or asynchronous way */
  synchronous?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Determines type of the action and which source will be used, must be set in case updating the `typeProperties` */
  type?: InputMaybe<ActionType>;
  /** Content of the action respectively based on the chosen type */
  typeProperties?: InputMaybe<UpdateTypePropertiesInput>;
};

export type UpdateActionParameterDefinitionInput = {
  /** Optionally defines list of allowed values */
  allowedValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optionally defines the default value of the parameter */
  defaultValue?: InputMaybe<Scalars["String"]["input"]>;
  /** Optionally defines additional field description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the parameter */
  name: Scalars["String"]["input"];
  /** Determines whether the parameter is required or not */
  required: Scalars["Boolean"]["input"];
  /** Type of the parameter */
  type: ActionParameterType;
};

export type UpdateApiKeyInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  owner?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateApplicationInput = {
  contacts?: InputMaybe<Array<Scalars["String"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  metadata?: InputMaybe<Array<KeyValueInput>>;
  owner?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAzureFunctionInput = {
  /** Access key ID needed for authorization to execute Azure function */
  accessKeyId: Scalars["String"]["input"];
  /** Method used by the azure function e.g. GET, POST, PUT, PATCH, DELETE */
  functionMethod: AzureFunctionMethod;
  /** URL of the Azure function */
  functionUrl: Scalars["String"]["input"];
};

export type UpdateBatchActionInput = {
  /** Action to be used in batch action */
  action?: InputMaybe<PlanActionIdInput>;
  /** Batch action id. If id is not set then action will be added to the batch otherwise corresponding action will be updated in batch. */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   * Names and values of parameters that are passed to the action.
   * They must comply with System Action's or Custom Action's parameter definitions.
   * Values of type other than string are JSON-serialized to string.
   */
  inputParameters?: InputMaybe<Array<KeyValueInput>>;
  /** Batch action name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Notification groups to be added or updated */
  notificationGroups?: InputMaybe<
    Array<UpdatePlanActionNotificationGroupInput>
  >;
  /** Ids of notification groups to be removed from plan action */
  notificationGroupsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Order of the action in the batch */
  order?: InputMaybe<Scalars["Int"]["input"]>;
  /** Resource group IDs that will be added to the plan action */
  resourceGroupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Resource group IDs that will be removed from the plan action */
  resourceGroupIdsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Resource IDs that will be added to the plan action */
  resourceIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Resource IDs that will be removed from the plan action */
  resourceIdsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UpdateChannelTypePropertiesInput = {
  /** Content of the Email type channel */
  email?: InputMaybe<UpdateEmailInput>;
  /** Content of the Webhook type channel */
  webhook?: InputMaybe<UpdateWebhookInput>;
};

export type UpdateCloudAccountInput = {
  credentials?: InputMaybe<AccountCredentialsInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  metadata?: InputMaybe<Array<KeyValueInput>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  regions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  resourceCleanerEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  resourceDiscoveryEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateEmailInput = {
  email: Scalars["String"]["input"];
};

export type UpdateGroupInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  metadata?: InputMaybe<Array<KeyValueInput>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  resourceSelectors?: InputMaybe<Array<UpdateResourceSelectorInput>>;
  resourceSelectorsToDelete?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

export type UpdateNotificationGroupInput = {
  channels?: InputMaybe<Array<ChannelUpdateInput>>;
  channelsToDelete?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePlanActionBatchInput = {
  /** Batch actions to be added or updated */
  batchActions?: InputMaybe<Array<UpdateBatchActionInput>>;
  /** Ids of batch actions to be removed from plan action batch */
  batchActionsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Must be one of the values: APPROVAL, SUCCESS_OR_APPROVAL, or ANYWAY */
  executionPolicy?: InputMaybe<ExecutionPolicy>;
  /** Plan action batch id. If id is not set then batch will be added to the plan otherwise corresponding batch will be updated in plan. */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /** Batch name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Must be greater than 0 */
  order?: InputMaybe<Scalars["Int"]["input"]>;
  /** Must be one of the values: ALWAYS, ON_SUCCESS, or NEVER */
  skipWindow?: InputMaybe<SkipWindowType>;
  /** The windowDuration in minutes must be greater than 0 */
  windowDuration?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdatePlanActionInput = {
  /** Action to be used in plan action */
  action?: InputMaybe<PlanActionIdInput>;
  /** Execution policy provided by user */
  executionPolicy?: InputMaybe<ExecutionPolicy>;
  /** Plan action id. If id is not set then action will be added to the plan otherwise corresponding action will be updated in plan. */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   * Names and values of parameters that are passed to the action.
   * They must comply with System Action's or Custom Action's parameter definitions.
   * Values of type other than string are JSON-serialized to string.
   */
  inputParameters?: InputMaybe<Array<KeyValueInput>>;
  /** Plan action name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Notification groups to be added or updated */
  notificationGroups?: InputMaybe<
    Array<UpdatePlanActionNotificationGroupInput>
  >;
  /** Ids of notification groups to be removed from plan action */
  notificationGroupsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Must be greater than 0 */
  order?: InputMaybe<Scalars["Int"]["input"]>;
  /** Resource group IDs that will be added to the plan action */
  resourceGroupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Resource group IDs that will be removed from the plan action */
  resourceGroupIdsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Resource IDs that will be added to the plan action */
  resourceIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Resource IDs that will be removed from the plan action */
  resourceIdsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** If set to true, then an action will be performed one at a time for each resource. */
  runInSequence?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The skipWindow property can be set to one of the values: ALWAYS, ON_SUCCESS, or NEVER */
  skipWindow?: InputMaybe<SkipWindowType>;
  /** Window duration in minutes must be greater than 0 */
  windowDuration?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdatePlanActionNotificationGroupInput = {
  /**
   * ID of the plan action notification configuration.
   * If it is unset, then new notification configuration will be added to the plan action,
   * otherwise the specified notification configuration will be updated in the plan action.
   */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   * Number of minutes that the notification should be sent in advance of the triggering event.
   * Valid only for UPCOMING and NOT_APPROVED trigger events, for which it must be set to a value greater than 0.
   */
  inAdvance?: InputMaybe<Scalars["Int"]["input"]>;
  /** ID of the notification group (notification recipient). */
  notificationGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Determines whether notifications should be sent for the action or for individual resources in the action. */
  scope?: InputMaybe<PlanActionNotificationGroupScope>;
  /** Event that triggers notification. */
  triggerEvent: PlanActionNotificationTriggerType;
};

export type UpdatePlanInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** Metadata provided by user */
  metadata?: InputMaybe<Array<KeyValueInput>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Notification groups to be added or updated */
  notificationGroups?: InputMaybe<Array<UpdatePlanNotificationGroupInput>>;
  /** Ids of notification groups to be removed from plan */
  notificationGroupsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Batches of actions to be added or updated */
  planActionBatches?: InputMaybe<Array<UpdatePlanActionBatchInput>>;
  /** Ids of batches to be removed from plan */
  planActionBatchesToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Actions to be added or updated */
  planActions?: InputMaybe<Array<UpdatePlanActionInput>>;
  /** Ids of actions to be removed from plan */
  planActionsToDelete?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Schedule cron e.g. 5 4 * * * */
  scheduleCron?: InputMaybe<Scalars["String"]["input"]>;
  /** Dates on which plan execution will be scheduled. When provided then `scheduleCron` and `scheduleOffset` must not be provided. */
  scheduleExecutionDates?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Schedule offset is a delay expressed in minutes that is added to cron-generated dates */
  scheduleOffset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Schedule time zone e.g. UTC. Required if `scheduleExecutionDates` or `scheduleCron` are set. */
  scheduleTimezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePlanNotificationGroupInput = {
  /**
   * ID of the plan notification configuration. If it is unset, then new notification configuration will be added to the plan,
   * otherwise the specified notification configuration will be updated in the plan.
   */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   * Number of minutes that the notification should be sent in advance of the triggering event.
   * Valid only for UPCOMING trigger event, for which it must be set to a value greater than 0.
   */
  inAdvance?: InputMaybe<Scalars["Int"]["input"]>;
  /** ID of the notification group (notification recipient). */
  notificationGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Event that triggers notification. */
  triggerEvent?: InputMaybe<PlanNotificationTriggerType>;
};

export type UpdateResourceInput = {
  /** Access needed for running commands on resource */
  access?: InputMaybe<ResourceAccessUpdateInput>;
  /** Additional description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** If set to false, it skips execution of all assigned actions to a particular resource. */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Resource identifier which will be modified */
  id: Scalars["UUID"]["input"];
  /** Metadata provided by user */
  metadata?: InputMaybe<Array<KeyValueInput>>;
  /** Resource name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Resource Operating System */
  os?: InputMaybe<ResourceOsUpdateInput>;
  /** Resource region */
  region?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateResourceSelectorInput = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  order: Scalars["Int"]["input"];
  resourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  tagsExpression?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateSsmDocumentInput = {
  /** ARN or name of the AWS SSM document */
  documentId: Scalars["String"]["input"];
};

export type UpdateScriptInput = {
  /** File contains the script, which will be uploaded to S3 */
  file: Scalars["Upload"]["input"];
};

export type UpdateStatusForResource = {
  __typename?: "UpdateStatusForResource";
  /** Details about the event, action, and resource state used to determine the update status. */
  basedOn?: Maybe<ResourceUpdateStatusBasedOn>;
  /** Number of updates that are pending for this resource. */
  pendingUpdateCount?: Maybe<Scalars["Int"]["output"]>;
  /** Resource identifier for which the update status is reported. */
  resourceId: Scalars["String"]["output"];
  /** Current update status of the resource (e.g. pending updates, in progress, failed). */
  updateStatus: ResourceUpdateStatus;
};

export type UpdateStatusResourceStatisticsCounts = {
  __typename?: "UpdateStatusResourceStatisticsCounts";
  /** Count of resources in this update status. */
  count: Scalars["Int"]["output"];
  /** Current update status of the resources (e.g. pending updates, in progress, failed). */
  updateStatus: ResourceUpdateStatus;
};

export type UpdateTypePropertiesInput = {
  /** Content of the AWS_LAMBDA type action */
  awsLambda?: InputMaybe<UpdateAwsLambdaInput>;
  /** Content of the AZURE_FUNCTION type action */
  azureFunction?: InputMaybe<UpdateAzureFunctionInput>;
  /** Details of the script file */
  script?: InputMaybe<UpdateScriptInput>;
  /** Content of the SSM_DOCUMENT type action */
  ssmDocument?: InputMaybe<UpdateSsmDocumentInput>;
  /** Content of the WEBHOOK type action */
  webhook?: InputMaybe<UpdateWebhookActionInput>;
};

export type UpdateWebhookActionInput = {
  /** Field that is attached header fields (additional context and metadata) to the webhook request */
  headers: Array<KeyValueInput>;
  /** Payload is the data used in the webhook request in stringified JSON format */
  payload: Scalars["String"]["input"];
  /** Method used to invoke webhook e.g. "GET", "POST", "PUT", "PATCH", "DELETE" */
  webhookMethod: WebhookActionMethod;
  /** URL of the Webhook */
  webhookUrl: Scalars["String"]["input"];
};

export type UpdateWebhookInput = {
  headers?: InputMaybe<Array<KeyValueInput>>;
  method: Scalars["String"]["input"];
  /** Payload contains request body payload in stringified JSON format */
  payload?: InputMaybe<Scalars["String"]["input"]>;
  type: WebhookChannelType;
  url: Scalars["String"]["input"];
};

export type UpsertHostInput = {
  host: HostInput;
  hostGroups?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum WebhookActionMethod {
  Delete = "DELETE",
  Get = "GET",
  Patch = "PATCH",
  Post = "POST",
  Put = "PUT",
}

export type WebhookChannel = {
  __typename?: "WebhookChannel";
  headers?: Maybe<Array<KeyValue>>;
  method: Scalars["String"]["output"];
  /** Payload contains request body payload in stringified JSON format */
  payload?: Maybe<Scalars["String"]["output"]>;
  type: WebhookChannelType;
  url: Scalars["String"]["output"];
};

export enum WebhookChannelType {
  Custom = "CUSTOM",
  PagerDuty = "PAGER_DUTY",
  Slack = "SLACK",
}

export type CustomerQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerQuery = {
  __typename?: "Query";
  customers: Array<{
    __typename?: "Customer";
    id: string;
    name: string;
    organizationName: string;
  }>;
};

export type GetAvailableEventActionNamesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAvailableEventActionNamesQuery = {
  __typename?: "Query";
  availableEventActionNames: Array<string>;
};

export type GetAvailablePlanActionNamesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAvailablePlanActionNamesQuery = {
  __typename?: "Query";
  availablePlanActionNames: Array<string>;
};

export type AwsOnboardingTemplateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AwsOnboardingTemplateQuery = {
  __typename?: "Query";
  awsOnboardingTemplate: string;
};

export type AzureOnboardingScriptQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
}>;

export type AzureOnboardingScriptQuery = {
  __typename?: "Query";
  azureOnboardingScript: string;
};

export type CreateCloudAccountMutationVariables = Exact<{
  input: CreateCloudAccountInput;
}>;

export type CreateCloudAccountMutation = {
  __typename?: "Mutation";
  createCloudAccount: { __typename?: "CloudAccount"; id: string };
};

export type DeleteCloudAccountMutationVariables = Exact<{
  removeCloudAccountId: Scalars["UUID"]["input"];
}>;

export type DeleteCloudAccountMutation = {
  __typename?: "Mutation";
  removeCloudAccount: boolean;
};

export type GetCloudAccountQueryVariables = Exact<{
  cloudAccountId: Scalars["UUID"]["input"];
}>;

export type GetCloudAccountQuery = {
  __typename?: "Query";
  cloudAccount?: {
    __typename?: "CloudAccount";
    id: string;
    name: string;
    description?: string | null;
    provider: CloudAccountCloudProvider;
    providerId: string;
    environment?: string | null;
    status: CloudAccountStatus;
    lastScanStartDate?: string | null;
    lastScanEndDate?: string | null;
    regions: Array<string>;
    resourceDiscoveryEnabled: boolean;
    resourceCleanerEnabled: boolean;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    regionsStatuses?: Array<{
      __typename?: "RegionStatus";
      region: string;
      status: CloudAccountRegionStatus;
      details?: string | null;
    } | null> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  } | null;
};

export type GetCloudAccountsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  sort?: InputMaybe<CloudAccountsSortInput>;
  filter?: InputMaybe<CloudAccountsSearchInput>;
}>;

export type GetCloudAccountsQuery = {
  __typename?: "Query";
  cloudAccounts: {
    __typename?: "CloudAccountsPage";
    result?: Array<{
      __typename?: "CloudAccount";
      name: string;
      id: string;
      provider: CloudAccountCloudProvider;
      environment?: string | null;
      status: CloudAccountStatus;
      providerId: string;
      changeDetails: { __typename?: "ChangeDetails"; createdAt: string };
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type ScanCloudAccountMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type ScanCloudAccountMutation = {
  __typename?: "Mutation";
  scanCloudAccount: boolean;
};

export type UpdateCloudAccountMutationVariables = Exact<{
  input: UpdateCloudAccountInput;
}>;

export type UpdateCloudAccountMutation = {
  __typename?: "Mutation";
  updateCloudAccount: {
    __typename?: "CloudAccount";
    id: string;
    name: string;
    description?: string | null;
    environment?: string | null;
    regionsStatuses?: Array<{
      __typename?: "RegionStatus";
      region: string;
      status: CloudAccountRegionStatus;
      details?: string | null;
    } | null> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type CreateApplicationMutationVariables = Exact<{
  input: CreateApplicationInput;
}>;

export type CreateApplicationMutation = {
  __typename?: "Mutation";
  createApplication: {
    __typename?: "Application";
    id: string;
    name: string;
    displayName?: string | null;
    description?: string | null;
    owner?: string | null;
    contacts?: Array<string> | null;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type DeleteApplicationMutationVariables = Exact<{
  input: DeleteApplicationInput;
}>;

export type DeleteApplicationMutation = {
  __typename?: "Mutation";
  deleteApplication: boolean;
};

export type GetApplicationQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetApplicationQuery = {
  __typename?: "Query";
  application: {
    __typename?: "Application";
    id: string;
    name: string;
    displayName?: string | null;
    description?: string | null;
    owner?: string | null;
    contacts?: Array<string> | null;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type GetApplicationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ApplicationsSortInput>;
  filter?: InputMaybe<ApplicationsFilterInput>;
}>;

export type GetApplicationsQuery = {
  __typename?: "Query";
  applications: {
    __typename?: "ApplicationsPage";
    pageInfo: { __typename?: "PageInfo"; count: number; pages: number };
    result?: Array<{
      __typename?: "Application";
      id: string;
      name: string;
      displayName?: string | null;
      description?: string | null;
      owner?: string | null;
      contacts?: Array<string> | null;
      metadata?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
      environments?: Array<{
        __typename?: "EnvironmentWithResourceCount";
        id: string;
        name: string;
        displayName?: string | null;
        resourceCount: number;
      }> | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
    }> | null;
  };
};

export type UpdateApplicationMutationVariables = Exact<{
  input: UpdateApplicationInput;
}>;

export type UpdateApplicationMutation = {
  __typename?: "Mutation";
  updateApplication: {
    __typename?: "Application";
    id: string;
    name: string;
    displayName?: string | null;
    description?: string | null;
    owner?: string | null;
    contacts?: Array<string> | null;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type CreateCustomActionMutationVariables = Exact<{
  input: CreateActionInput;
}>;

export type CreateCustomActionMutation = {
  __typename?: "Mutation";
  createAction: {
    __typename?: "Action";
    id: string;
    name: string;
    description?: string | null;
    color: string;
    type: ActionType;
    scope: ActionScope;
  };
};

export type DeleteCustomActionMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteCustomActionMutation = {
  __typename?: "Mutation";
  removeAction: boolean;
};

export type GetCustomActionQueryVariables = Exact<{
  customActionId: Scalars["UUID"]["input"];
}>;

export type GetCustomActionQuery = {
  __typename?: "Query";
  action?: {
    __typename?: "Action";
    id: string;
    name: string;
    description?: string | null;
    color: string;
    type: ActionType;
    scope: ActionScope;
    typeProperties:
      | { __typename: "ActionPropertyAWSLambda"; lambdaArn: string }
      | {
          __typename: "ActionPropertyAzureFunction";
          accessKeyId: string;
          functionMethod: AzureFunctionMethod;
          functionUrl: string;
        }
      | { __typename: "ActionPropertySSMDocument"; documentId: string }
      | { __typename: "ActionPropertyScript"; s3FileUrl: string }
      | {
          __typename: "ActionPropertyWebhook";
          webhookUrl: string;
          webhookMethod: WebhookActionMethod;
          payload: string;
          headers: Array<{
            __typename?: "KeyValue";
            key: string;
            value: string;
          }>;
        };
  } | null;
};

export type GetCustomActionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ActionSortInput>;
  filter?: InputMaybe<ActionFilterInput>;
}>;

export type GetCustomActionsQuery = {
  __typename?: "Query";
  actions: {
    __typename?: "ActionPage";
    result?: Array<{
      __typename?: "Action";
      id: string;
      name: string;
      color: string;
      description?: string | null;
      scope: ActionScope;
      type: ActionType;
      synchronous: boolean;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        updatedAt: string;
        updatedBy: string;
        createdBy: string;
      };
      parameterDefinitions: Array<{
        __typename?: "ActionParameterDefinition";
        name: string;
        required: boolean;
        description?: string | null;
        allowedValues?: Array<string> | null;
        defaultValue?: string | null;
        type: ActionParameterType;
      }>;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetCustomActionPlansQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<PlanSortInput>;
}>;

export type GetCustomActionPlansQuery = {
  __typename?: "Query";
  plans: {
    __typename?: "PlanPage";
    result?: Array<{
      __typename?: "Plan";
      name: string;
      planActions?: Array<{
        __typename?: "PlanAction";
        action:
          | { __typename?: "Action"; name: string; id: string }
          | { __typename?: "SystemAction" };
      }> | null;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetScriptContentQueryVariables = Exact<{
  actionId: Scalars["UUID"]["input"];
}>;

export type GetScriptContentQuery = {
  __typename?: "Query";
  scriptContent: string;
};

export type UpdateCustomActionMutationVariables = Exact<{
  input: UpdateActionInput;
}>;

export type UpdateCustomActionMutation = {
  __typename?: "Mutation";
  updateAction: {
    __typename?: "Action";
    id: string;
    name: string;
    description?: string | null;
    type: ActionType;
    scope: ActionScope;
    typeProperties:
      | { __typename: "ActionPropertyAWSLambda"; lambdaArn: string }
      | {
          __typename: "ActionPropertyAzureFunction";
          accessKeyId: string;
          functionUrl: string;
          functionMethod: AzureFunctionMethod;
        }
      | { __typename: "ActionPropertySSMDocument"; documentId: string }
      | { __typename: "ActionPropertyScript"; s3FileUrl: string }
      | {
          __typename: "ActionPropertyWebhook";
          webhookUrl: string;
          webhookMethod: WebhookActionMethod;
          payload: string;
          headers: Array<{
            __typename?: "KeyValue";
            key: string;
            value: string;
          }>;
        };
  };
};

export type GetEventActionReportQueryVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
  eventActionId: Scalars["UUID"]["input"];
}>;

export type GetEventActionReportQuery = {
  __typename?: "Query";
  eventActionReport?: {
    __typename?: "EventActionReport";
    eventId: string;
    eventActionId: string;
    name: string;
    actionName: string;
    status: ExecutionStatus;
    startTime?: string | null;
    endTime?: string | null;
    output?: string | null;
    resources?: Array<{
      __typename?: "EventActionResourceReport";
      resourceId: string;
      name: string;
      status: ResourceExecutionStatus;
      result: {
        __typename?: "EventActionResourceReportResult";
        output?: string | null;
        outputUri?: string | null;
        installed?: Array<{
          __typename?: "ResourceReportPackage";
          name: string;
          id: string;
          version?: string | null;
        }> | null;
        updated?: Array<{
          __typename?: "ResourceReportPackage";
          name: string;
          id: string;
          version?: string | null;
        }> | null;
        removed?: Array<{
          __typename?: "ResourceReportPackage";
          name: string;
          id: string;
          version?: string | null;
        }> | null;
        available?: Array<{
          __typename?: "ResourceReportPackage";
          name: string;
          id: string;
          version?: string | null;
        }> | null;
        failed?: Array<{
          __typename?: "ResourceReportPackage";
          name: string;
          id: string;
          version?: string | null;
        }> | null;
      };
    }> | null;
  } | null;
};

export type GetEventActionReportsQueryVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
  eventActionId: Scalars["UUID"]["input"];
}>;

export type GetEventActionReportsQuery = {
  __typename?: "Query";
  eventActionReports?: Array<{
    __typename?: "EventActionAttemptReport";
    attempt: number;
    report: {
      __typename?: "EventActionReport";
      eventId: string;
      eventActionId: string;
      name: string;
      actionName: string;
      status: ExecutionStatus;
      startTime?: string | null;
      endTime?: string | null;
      output?: string | null;
      resources?: Array<{
        __typename?: "EventActionResourceReport";
        resourceId: string;
        name: string;
        cloudResourceId: string;
        fullCloudResourceId: string;
        provider: ResourceCloudProvider;
        providerId: string;
        region: string;
        status: ResourceExecutionStatus;
        result: {
          __typename?: "EventActionResourceReportResult";
          output?: string | null;
          outputUri?: string | null;
          installed?: Array<{
            __typename?: "ResourceReportPackage";
            name: string;
            id: string;
            version?: string | null;
          }> | null;
          installedPendingReboot?: Array<{
            __typename?: "ResourceReportPackage";
            name: string;
            id: string;
            version?: string | null;
            previousVersion?: string | null;
          }> | null;
          updated?: Array<{
            __typename?: "ResourceReportPackage";
            name: string;
            id: string;
            version?: string | null;
            previousVersion?: string | null;
          }> | null;
          removed?: Array<{
            __typename?: "ResourceReportPackage";
            name: string;
            id: string;
            version?: string | null;
          }> | null;
          available?: Array<{
            __typename?: "ResourceReportPackage";
            name: string;
            id: string;
            version?: string | null;
          }> | null;
          failed?: Array<{
            __typename?: "ResourceReportPackage";
            name: string;
            id: string;
            version?: string | null;
          }> | null;
        };
      }> | null;
    };
  }> | null;
};

export type AnyEventResourceStatusChangedSubscriptionVariables = Exact<{
  input: AnyResourceStatusChangedInput;
}>;

export type AnyEventResourceStatusChangedSubscription = {
  __typename?: "Subscription";
  anyEventResourceStatusChanged: ResourceExecutionStatus;
};

export type EventActionBatchStatusChangedSubscriptionVariables = Exact<{
  input: StatusChangedInput;
}>;

export type EventActionBatchStatusChangedSubscription = {
  __typename?: "Subscription";
  eventActionBatchStatusChanged: ExecutionStatus;
};

export type EventResourceStatusChangedSubscriptionVariables = Exact<{
  input: StatusChangedInput;
}>;

export type EventResourceStatusChangedSubscription = {
  __typename?: "Subscription";
  eventResourceStatusChanged: ResourceExecutionStatus;
};

export type EventActionStatusChangedSubscriptionVariables = Exact<{
  input: StatusChangedInput;
}>;

export type EventActionStatusChangedSubscription = {
  __typename?: "Subscription";
  eventActionStatusChanged: ExecutionStatus;
};

export type EventStatusChangedSubscriptionVariables = Exact<{
  input: StatusChangedInput;
}>;

export type EventStatusChangedSubscription = {
  __typename?: "Subscription";
  eventStatusChanged: EventStatus;
};

export type ApproveEventActionMutationVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
  actionId: Scalars["UUID"]["input"];
}>;

export type ApproveEventActionMutation = {
  __typename?: "Mutation";
  approveEventAction: boolean;
};

export type ApproveEventActionBatchMutationVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
  actionBatchId: Scalars["UUID"]["input"];
}>;

export type ApproveEventActionBatchMutation = {
  __typename?: "Mutation";
  approveEventActionBatch: boolean;
};

export type ChangeResourceExecutionStatusMutationVariables = Exact<{
  input: ChangeResourceExecutionStatusInput;
}>;

export type ChangeResourceExecutionStatusMutation = {
  __typename?: "Mutation";
  changeResourceExecutionStatus: boolean;
};

export type EventActionResourceStateChangedSubscriptionVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
}>;

export type EventActionResourceStateChangedSubscription = {
  __typename?: "Subscription";
  eventActionResourceStateChanged: {
    __typename?: "EventActionResourceStateChange";
    resourceStateId: string;
    eventActionId: string;
    status: ResourceExecutionStatus;
  };
};

export type GetEventActionResourceStateSearchQueryVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
  eventActionId: Scalars["UUID"]["input"];
  sort?: InputMaybe<EventActionResourceStateSortInput>;
  filter?: InputMaybe<EventActionResourceStatesFilterInput>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  excludeGroupStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetEventActionResourceStateSearchQuery = {
  __typename?: "Query";
  eventActionResourceStateSearch: {
    __typename?: "EventActionResourceStateSearchPage";
    result?: Array<{
      __typename?: "EventActionResourceStateSearchItem";
      resourceGroupId?: string | null;
      resourceGroupStatus?: ResourceGroupStatus | null;
      resourceGroup?: {
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        resourcesCounts?: {
          __typename?: "ResourcesCounts";
          totalCount: number;
          disconnectedCount: number;
          onlineCount: number;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      } | null;
      resourceStates?: Array<{
        __typename?: "EventActionResourceStateWithoutGroup";
        id: string;
        resourceId: string;
        order: number;
        status: ResourceExecutionStatus;
        outputUri?: string | null;
        annotation: string;
        errorCode?: ResourceExecutionErrorCode | null;
        resource?: {
          __typename?: "Resource";
          id: string;
          name: string;
          description?: string | null;
          autoDiscovery: boolean;
          cloudResourceId: string;
          fullCloudResourceId: string;
          enabled: boolean;
          provider: ResourceCloudProvider;
          providerId: string;
          region: string;
          scanned: boolean;
          os?: {
            __typename?: "ResourceOS";
            type: OsType;
            subType?: OsSubType | null;
          } | null;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        } | null;
        output?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        } | null> | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdBy: string;
          createdAt: string;
          updatedBy: string;
          updatedAt: string;
        };
      }> | null;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; count: number; pages: number };
  };
};

export type ActionPropertiesFragment = {
  __typename?: "Action";
  id: string;
  name: string;
  color: string;
  synchronous: boolean;
  type: ActionType;
  scope: ActionScope;
  typeProperties:
    | { __typename?: "ActionPropertyAWSLambda"; lambdaArn: string }
    | {
        __typename?: "ActionPropertyAzureFunction";
        accessKeyId: string;
        functionMethod: AzureFunctionMethod;
        functionUrl: string;
      }
    | { __typename?: "ActionPropertySSMDocument"; documentId: string }
    | { __typename?: "ActionPropertyScript"; s3FileUrl: string }
    | {
        __typename?: "ActionPropertyWebhook";
        webhookUrl: string;
        webhookMethod: WebhookActionMethod;
        payload: string;
        headers: Array<{ __typename?: "KeyValue"; key: string; value: string }>;
      };
  parameterDefinitions: Array<{
    __typename?: "ActionParameterDefinition";
    name: string;
    required: boolean;
    type: ActionParameterType;
  }>;
  changeDetails: {
    __typename?: "ChangeDetails";
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
  };
};

export type EventActionAttemptResourceStatesFragment = {
  __typename?: "EventActionAttempt";
  resourceStates?: Array<{
    __typename?: "EventActionResourceState";
    id: string;
    eventActionId: string;
    resourceId: string;
    resourceGroupId?: string | null;
    order: number;
    status: ResourceExecutionStatus;
    outputUri?: string | null;
    annotation: string;
    errorCode?: ResourceExecutionErrorCode | null;
    resource?: {
      __typename?: "Resource";
      id: string;
      name: string;
      description?: string | null;
      autoDiscovery: boolean;
      cloudResourceId: string;
      fullCloudResourceId: string;
      enabled: boolean;
      provider: ResourceCloudProvider;
      providerId: string;
      region: string;
      scanned: boolean;
      os?: {
        __typename?: "ResourceOS";
        type: OsType;
        subType?: OsSubType | null;
      } | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
    } | null;
    resourceGroup?: {
      __typename?: "Group";
      id: string;
      name: string;
      description?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        totalCount: number;
        disconnectedCount: number;
        onlineCount: number;
      } | null;
    } | null;
    output?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    } | null> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdBy: string;
      createdAt: string;
      updatedBy: string;
      updatedAt: string;
    };
  }> | null;
};

export type EventActionResourceStatesFragment = {
  __typename?: "EventAction";
  resourceStates?: Array<{
    __typename?: "EventActionResourceState";
    id: string;
    eventActionId: string;
    resourceId: string;
    resourceGroupId?: string | null;
    order: number;
    status: ResourceExecutionStatus;
    outputUri?: string | null;
    annotation: string;
    errorCode?: ResourceExecutionErrorCode | null;
    resource?: {
      __typename?: "Resource";
      id: string;
      name: string;
      description?: string | null;
      autoDiscovery: boolean;
      cloudResourceId: string;
      fullCloudResourceId: string;
      enabled: boolean;
      provider: ResourceCloudProvider;
      providerId: string;
      region: string;
      scanned: boolean;
      os?: {
        __typename?: "ResourceOS";
        type: OsType;
        subType?: OsSubType | null;
      } | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
    } | null;
    resourceGroup?: {
      __typename?: "Group";
      id: string;
      name: string;
      description?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        totalCount: number;
        disconnectedCount: number;
        onlineCount: number;
      } | null;
    } | null;
    output?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    } | null> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdBy: string;
      createdAt: string;
      updatedBy: string;
      updatedAt: string;
    };
  }> | null;
};

export type EventDetailsFragment = {
  __typename?: "EventView";
  id: string;
  name: string;
  description?: string | null;
  scheduleTimezone: string;
  estimatedEndTime: string;
  status: EventStatus;
  startTime: string;
  endTime?: string | null;
  metadata?: Array<{
    __typename?: "KeyValue";
    key: string;
    value: string;
  }> | null;
  plan?: {
    __typename?: "Plan";
    id: string;
    name: string;
    scheduleCron?: string | null;
    scheduleOffset: number;
    scheduleTimezone?: string | null;
    enabled: boolean;
    planActions?: Array<{
      __typename?: "PlanAction";
      id: string;
      runInSequence: boolean;
      executionPolicy: ExecutionPolicy;
      order: number;
      skipWindow: SkipWindowType;
      windowDuration: number;
      action:
        | {
            __typename?: "Action";
            id: string;
            name: string;
            color: string;
            synchronous: boolean;
            type: ActionType;
            scope: ActionScope;
            typeProperties:
              | { __typename?: "ActionPropertyAWSLambda"; lambdaArn: string }
              | {
                  __typename?: "ActionPropertyAzureFunction";
                  accessKeyId: string;
                  functionMethod: AzureFunctionMethod;
                  functionUrl: string;
                }
              | { __typename?: "ActionPropertySSMDocument"; documentId: string }
              | { __typename?: "ActionPropertyScript"; s3FileUrl: string }
              | {
                  __typename?: "ActionPropertyWebhook";
                  webhookUrl: string;
                  webhookMethod: WebhookActionMethod;
                  payload: string;
                  headers: Array<{
                    __typename?: "KeyValue";
                    key: string;
                    value: string;
                  }>;
                };
            parameterDefinitions: Array<{
              __typename?: "ActionParameterDefinition";
              name: string;
              required: boolean;
              type: ActionParameterType;
            }>;
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
          }
        | {
            __typename?: "SystemAction";
            id: string;
            name: string;
            scope: ActionScope;
            color: string;
            version: string;
            parameterDefinitions: Array<{
              __typename?: "ActionParameterDefinition";
              name: string;
              required: boolean;
              type: ActionParameterType;
            }>;
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
          };
      resourceGroups?: Array<{
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      }> | null;
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  } | null;
  actions?: Array<{
    __typename?: "EventViewAction";
    id: string;
    actionName: string;
    name: string;
    type: EventActionType;
    scope: EventActionScope;
    order: number;
    windowDuration?: number | null;
    skipWindow: SkipWindowType;
    executionPolicy: ExecutionPolicy;
    runInSequence: boolean;
    resourcesFailed: number;
    resourcesNotCompleted: number;
    resourcesSucceeded: number;
    globalState?: {
      __typename?: "GlobalEventActionState";
      status: ExecutionStatus;
      outputUri?: string | null;
      estimatedStartTime: string;
      startTime?: string | null;
      endTime?: string | null;
    } | null;
    attempts: Array<{
      __typename?: "EventActionAttempt";
      id: string;
      attempt: number;
      state?: {
        __typename?: "EventActionState";
        eventId: string;
        eventActionId: string;
        status: ExecutionStatus;
        outputUri?: string | null;
        estimatedStartTime: string;
        startTime?: string | null;
        endTime?: string | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      } | null;
    }>;
    inputParameters?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    action?:
      | {
          __typename?: "Action";
          id: string;
          name: string;
          color: string;
          synchronous: boolean;
          type: ActionType;
          scope: ActionScope;
          typeProperties:
            | { __typename?: "ActionPropertyAWSLambda"; lambdaArn: string }
            | {
                __typename?: "ActionPropertyAzureFunction";
                accessKeyId: string;
                functionMethod: AzureFunctionMethod;
                functionUrl: string;
              }
            | { __typename?: "ActionPropertySSMDocument"; documentId: string }
            | { __typename?: "ActionPropertyScript"; s3FileUrl: string }
            | {
                __typename?: "ActionPropertyWebhook";
                webhookUrl: string;
                webhookMethod: WebhookActionMethod;
                payload: string;
                headers: Array<{
                  __typename?: "KeyValue";
                  key: string;
                  value: string;
                }>;
              };
          parameterDefinitions: Array<{
            __typename?: "ActionParameterDefinition";
            name: string;
            required: boolean;
            type: ActionParameterType;
          }>;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        }
      | {
          __typename?: "SystemAction";
          id: string;
          name: string;
          scope: ActionScope;
          color: string;
          version: string;
          parameterDefinitions: Array<{
            __typename?: "ActionParameterDefinition";
            name: string;
            required: boolean;
            type: ActionParameterType;
          }>;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        }
      | null;
    errorCodeCounts: Array<{
      __typename?: "ResourceExecutionErrorCodeCount";
      errorCode: ResourceExecutionErrorCode;
      count: number;
    }>;
    resourceGroups?: Array<{
      __typename?: "Group";
      id: string;
      name: string;
      description?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        totalCount: number;
        disconnectedCount: number;
        onlineCount: number;
      } | null;
    } | null> | null;
    resources?: Array<{ __typename?: "Resource"; id: string }> | null;
  }> | null;
  actionBatches?: Array<{
    __typename?: "EventViewActionBatch";
    id: string;
    name: string;
    order: number;
    windowDuration: number;
    skipWindow: SkipWindowType;
    executionPolicy: ExecutionPolicy;
    startTime?: string | null;
    status: ExecutionStatus;
    actions: Array<{
      __typename?: "EventViewAction";
      id: string;
      name: string;
      actionName: string;
      type: EventActionType;
      order: number;
      scope: EventActionScope;
      executionPolicy: ExecutionPolicy;
      windowDuration?: number | null;
      skipWindow: SkipWindowType;
      runInSequence: boolean;
      resourcesFailed: number;
      resourcesNotCompleted: number;
      resourcesSucceeded: number;
      action?:
        | {
            __typename?: "Action";
            id: string;
            name: string;
            type: ActionType;
            color: string;
          }
        | {
            __typename?: "SystemAction";
            id: string;
            name: string;
            version: string;
            color: string;
          }
        | null;
      inputParameters?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
      errorCodeCounts: Array<{
        __typename?: "ResourceExecutionErrorCodeCount";
        errorCode: ResourceExecutionErrorCode;
        count: number;
      }>;
      resourceGroups?: Array<{
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        resourcesCounts?: {
          __typename?: "ResourcesCounts";
          totalCount: number;
          disconnectedCount: number;
          onlineCount: number;
        } | null;
      } | null> | null;
      resources?: Array<{ __typename?: "Resource"; id: string }> | null;
      globalState?: {
        __typename?: "GlobalEventActionState";
        status: ExecutionStatus;
        estimatedStartTime: string;
        startTime?: string | null;
        endTime?: string | null;
        outputUri?: string | null;
      } | null;
      attempts: Array<{
        __typename?: "EventActionAttempt";
        id: string;
        attempt: number;
        state?: {
          __typename?: "EventActionState";
          eventId: string;
          eventActionId: string;
          status: ExecutionStatus;
          outputUri?: string | null;
          estimatedStartTime: string;
          startTime?: string | null;
          endTime?: string | null;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        } | null;
      }>;
    }>;
  }> | null;
  changeDetails?: {
    __typename?: "ChangeDetails";
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
  } | null;
};

export type SystemActionPropertiesFragment = {
  __typename?: "SystemAction";
  id: string;
  name: string;
  scope: ActionScope;
  color: string;
  version: string;
  parameterDefinitions: Array<{
    __typename?: "ActionParameterDefinition";
    name: string;
    required: boolean;
    type: ActionParameterType;
  }>;
  changeDetails: {
    __typename?: "ChangeDetails";
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
  };
};

export type GetEventViewQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetEventViewQuery = {
  __typename?: "Query";
  eventView?: {
    __typename?: "EventView";
    id: string;
    name: string;
    description?: string | null;
    scheduleTimezone: string;
    estimatedEndTime: string;
    status: EventStatus;
    startTime: string;
    endTime?: string | null;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    plan?: {
      __typename?: "Plan";
      id: string;
      name: string;
      scheduleCron?: string | null;
      scheduleOffset: number;
      scheduleTimezone?: string | null;
      enabled: boolean;
      planActions?: Array<{
        __typename?: "PlanAction";
        id: string;
        runInSequence: boolean;
        executionPolicy: ExecutionPolicy;
        order: number;
        skipWindow: SkipWindowType;
        windowDuration: number;
        action:
          | {
              __typename?: "Action";
              id: string;
              name: string;
              color: string;
              synchronous: boolean;
              type: ActionType;
              scope: ActionScope;
              typeProperties:
                | { __typename?: "ActionPropertyAWSLambda"; lambdaArn: string }
                | {
                    __typename?: "ActionPropertyAzureFunction";
                    accessKeyId: string;
                    functionMethod: AzureFunctionMethod;
                    functionUrl: string;
                  }
                | {
                    __typename?: "ActionPropertySSMDocument";
                    documentId: string;
                  }
                | { __typename?: "ActionPropertyScript"; s3FileUrl: string }
                | {
                    __typename?: "ActionPropertyWebhook";
                    webhookUrl: string;
                    webhookMethod: WebhookActionMethod;
                    payload: string;
                    headers: Array<{
                      __typename?: "KeyValue";
                      key: string;
                      value: string;
                    }>;
                  };
              parameterDefinitions: Array<{
                __typename?: "ActionParameterDefinition";
                name: string;
                required: boolean;
                type: ActionParameterType;
              }>;
              changeDetails: {
                __typename?: "ChangeDetails";
                createdAt: string;
                createdBy: string;
                updatedAt: string;
                updatedBy: string;
              };
            }
          | {
              __typename?: "SystemAction";
              id: string;
              name: string;
              scope: ActionScope;
              color: string;
              version: string;
              parameterDefinitions: Array<{
                __typename?: "ActionParameterDefinition";
                name: string;
                required: boolean;
                type: ActionParameterType;
              }>;
              changeDetails: {
                __typename?: "ChangeDetails";
                createdAt: string;
                createdBy: string;
                updatedAt: string;
                updatedBy: string;
              };
            };
        resourceGroups?: Array<{
          __typename?: "Group";
          id: string;
          name: string;
          description?: string | null;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        }> | null;
      }> | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
    } | null;
    actions?: Array<{
      __typename?: "EventViewAction";
      id: string;
      actionName: string;
      name: string;
      type: EventActionType;
      scope: EventActionScope;
      order: number;
      windowDuration?: number | null;
      skipWindow: SkipWindowType;
      executionPolicy: ExecutionPolicy;
      runInSequence: boolean;
      resourcesFailed: number;
      resourcesNotCompleted: number;
      resourcesSucceeded: number;
      globalState?: {
        __typename?: "GlobalEventActionState";
        status: ExecutionStatus;
        outputUri?: string | null;
        estimatedStartTime: string;
        startTime?: string | null;
        endTime?: string | null;
      } | null;
      attempts: Array<{
        __typename?: "EventActionAttempt";
        id: string;
        attempt: number;
        state?: {
          __typename?: "EventActionState";
          eventId: string;
          eventActionId: string;
          status: ExecutionStatus;
          outputUri?: string | null;
          estimatedStartTime: string;
          startTime?: string | null;
          endTime?: string | null;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        } | null;
      }>;
      inputParameters?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
      action?:
        | {
            __typename?: "Action";
            id: string;
            name: string;
            color: string;
            synchronous: boolean;
            type: ActionType;
            scope: ActionScope;
            typeProperties:
              | { __typename?: "ActionPropertyAWSLambda"; lambdaArn: string }
              | {
                  __typename?: "ActionPropertyAzureFunction";
                  accessKeyId: string;
                  functionMethod: AzureFunctionMethod;
                  functionUrl: string;
                }
              | { __typename?: "ActionPropertySSMDocument"; documentId: string }
              | { __typename?: "ActionPropertyScript"; s3FileUrl: string }
              | {
                  __typename?: "ActionPropertyWebhook";
                  webhookUrl: string;
                  webhookMethod: WebhookActionMethod;
                  payload: string;
                  headers: Array<{
                    __typename?: "KeyValue";
                    key: string;
                    value: string;
                  }>;
                };
            parameterDefinitions: Array<{
              __typename?: "ActionParameterDefinition";
              name: string;
              required: boolean;
              type: ActionParameterType;
            }>;
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
          }
        | {
            __typename?: "SystemAction";
            id: string;
            name: string;
            scope: ActionScope;
            color: string;
            version: string;
            parameterDefinitions: Array<{
              __typename?: "ActionParameterDefinition";
              name: string;
              required: boolean;
              type: ActionParameterType;
            }>;
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
          }
        | null;
      errorCodeCounts: Array<{
        __typename?: "ResourceExecutionErrorCodeCount";
        errorCode: ResourceExecutionErrorCode;
        count: number;
      }>;
      resourceGroups?: Array<{
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
        resourcesCounts?: {
          __typename?: "ResourcesCounts";
          totalCount: number;
          disconnectedCount: number;
          onlineCount: number;
        } | null;
      } | null> | null;
      resources?: Array<{ __typename?: "Resource"; id: string }> | null;
    }> | null;
    actionBatches?: Array<{
      __typename?: "EventViewActionBatch";
      id: string;
      name: string;
      order: number;
      windowDuration: number;
      skipWindow: SkipWindowType;
      executionPolicy: ExecutionPolicy;
      startTime?: string | null;
      status: ExecutionStatus;
      actions: Array<{
        __typename?: "EventViewAction";
        id: string;
        name: string;
        actionName: string;
        type: EventActionType;
        order: number;
        scope: EventActionScope;
        executionPolicy: ExecutionPolicy;
        windowDuration?: number | null;
        skipWindow: SkipWindowType;
        runInSequence: boolean;
        resourcesFailed: number;
        resourcesNotCompleted: number;
        resourcesSucceeded: number;
        action?:
          | {
              __typename?: "Action";
              id: string;
              name: string;
              type: ActionType;
              color: string;
            }
          | {
              __typename?: "SystemAction";
              id: string;
              name: string;
              version: string;
              color: string;
            }
          | null;
        inputParameters?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        }> | null;
        errorCodeCounts: Array<{
          __typename?: "ResourceExecutionErrorCodeCount";
          errorCode: ResourceExecutionErrorCode;
          count: number;
        }>;
        resourceGroups?: Array<{
          __typename?: "Group";
          id: string;
          name: string;
          description?: string | null;
          resourcesCounts?: {
            __typename?: "ResourcesCounts";
            totalCount: number;
            disconnectedCount: number;
            onlineCount: number;
          } | null;
        } | null> | null;
        resources?: Array<{ __typename?: "Resource"; id: string }> | null;
        globalState?: {
          __typename?: "GlobalEventActionState";
          status: ExecutionStatus;
          estimatedStartTime: string;
          startTime?: string | null;
          endTime?: string | null;
          outputUri?: string | null;
        } | null;
        attempts: Array<{
          __typename?: "EventActionAttempt";
          id: string;
          attempt: number;
          state?: {
            __typename?: "EventActionState";
            eventId: string;
            eventActionId: string;
            status: ExecutionStatus;
            outputUri?: string | null;
            estimatedStartTime: string;
            startTime?: string | null;
            endTime?: string | null;
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
          } | null;
        }>;
      }>;
    }> | null;
    changeDetails?: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    } | null;
  } | null;
};

export type GetEventActionResourceReportsQueryVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
  eventActionId: Scalars["UUID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<EventActionResourceReportsFilterInput>;
  includeAttempts?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetEventActionResourceReportsQuery = {
  __typename?: "Query";
  eventActionResourceReports: {
    __typename?: "EventActionResourceReportsPage";
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
    packagesCount: {
      __typename?: "PackagesCount";
      installed: number;
      installedPendingReboot: number;
      updated: number;
      available: number;
      removed: number;
      failed: number;
    };
    result?: Array<{
      __typename?: "EventActionResourceReport";
      resourceId: string;
      cloudResourceId: string;
      fullCloudResourceId: string;
      provider: ResourceCloudProvider;
      providerId: string;
      name: string;
      region: string;
      status: ResourceExecutionStatus;
      errorCode?: ResourceExecutionErrorCode | null;
      result: {
        __typename?: "EventActionResourceReportResult";
        output?: string | null;
        outputUri?: string | null;
        installed?: Array<{
          __typename?: "ResourceReportPackage";
          id: string;
          name: string;
          version?: string | null;
          previousVersion?: string | null;
          errorMessage?: string | null;
        }> | null;
        installedPendingReboot?: Array<{
          __typename?: "ResourceReportPackage";
          id: string;
          name: string;
          version?: string | null;
          previousVersion?: string | null;
          errorMessage?: string | null;
        }> | null;
        updated?: Array<{
          __typename?: "ResourceReportPackage";
          id: string;
          name: string;
          version?: string | null;
          previousVersion?: string | null;
          errorMessage?: string | null;
        }> | null;
        removed?: Array<{
          __typename?: "ResourceReportPackage";
          id: string;
          name: string;
          version?: string | null;
          previousVersion?: string | null;
          errorMessage?: string | null;
        }> | null;
        available?: Array<{
          __typename?: "ResourceReportPackage";
          id: string;
          name: string;
          version?: string | null;
          previousVersion?: string | null;
          errorMessage?: string | null;
        }> | null;
        failed?: Array<{
          __typename?: "ResourceReportPackage";
          id: string;
          name: string;
          version?: string | null;
          previousVersion?: string | null;
          errorMessage?: string | null;
        }> | null;
      };
    }> | null;
  };
};

export type ActionBatchesFragment = {
  __typename?: "Event";
  actionBatches?: Array<{
    __typename?: "EventActionBatch";
    id: string;
    name: string;
    order: number;
    windowDuration: number;
    skipWindow: SkipWindowType;
    executionPolicy: ExecutionPolicy;
    startTime?: string | null;
    status: ExecutionStatus;
    actions: Array<{
      __typename?: "BatchedEventAction";
      id: string;
      name: string;
      actionName: string;
      type: EventActionType;
      order: number;
      action?:
        | {
            __typename?: "Action";
            id: string;
            name: string;
            type: ActionType;
            color: string;
          }
        | {
            __typename?: "SystemAction";
            id: string;
            name: string;
            version: string;
            color: string;
          }
        | null;
      inputParameters?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
      resourceGroups?: Array<{
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        resourcesCounts?: {
          __typename?: "ResourcesCounts";
          totalCount: number;
          disconnectedCount: number;
          onlineCount: number;
        } | null;
      } | null> | null;
      resources?: Array<{ __typename?: "Resource"; id: string }> | null;
      globalState?: {
        __typename?: "GlobalEventActionState";
        status: ExecutionStatus;
        estimatedStartTime: string;
        startTime?: string | null;
        endTime?: string | null;
        outputUri?: string | null;
      } | null;
      resourceStates?: Array<{
        __typename?: "EventActionResourceState";
        id: string;
        eventActionId: string;
        resourceId: string;
        resourceGroupId?: string | null;
        order: number;
        status: ResourceExecutionStatus;
        outputUri?: string | null;
        annotation: string;
        resource?: {
          __typename?: "Resource";
          id: string;
          name: string;
          description?: string | null;
          autoDiscovery: boolean;
          cloudResourceId: string;
          fullCloudResourceId: string;
          enabled: boolean;
          provider: ResourceCloudProvider;
          providerId: string;
          region: string;
          scanned: boolean;
          os?: {
            __typename?: "ResourceOS";
            type: OsType;
            subType?: OsSubType | null;
          } | null;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        } | null;
        resourceGroup?: {
          __typename?: "Group";
          id: string;
          name: string;
          description?: string | null;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
          resourcesCounts?: {
            __typename?: "ResourcesCounts";
            totalCount: number;
            disconnectedCount: number;
            onlineCount: number;
          } | null;
        } | null;
        output?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        } | null> | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdBy: string;
          createdAt: string;
          updatedBy: string;
          updatedAt: string;
        };
      }> | null;
    }>;
  }> | null;
};

export type BatchActionFragment = {
  __typename?: "BatchedEventAction";
  id: string;
  name: string;
  actionName: string;
  type: EventActionType;
  order: number;
  action?:
    | {
        __typename?: "Action";
        id: string;
        name: string;
        type: ActionType;
        color: string;
      }
    | {
        __typename?: "SystemAction";
        id: string;
        name: string;
        version: string;
        color: string;
      }
    | null;
  inputParameters?: Array<{
    __typename?: "KeyValue";
    key: string;
    value: string;
  }> | null;
  resourceGroups?: Array<{
    __typename?: "Group";
    id: string;
    name: string;
    description?: string | null;
    resourcesCounts?: {
      __typename?: "ResourcesCounts";
      totalCount: number;
      disconnectedCount: number;
      onlineCount: number;
    } | null;
  } | null> | null;
  resources?: Array<{ __typename?: "Resource"; id: string }> | null;
  globalState?: {
    __typename?: "GlobalEventActionState";
    status: ExecutionStatus;
    estimatedStartTime: string;
    startTime?: string | null;
    endTime?: string | null;
    outputUri?: string | null;
  } | null;
  resourceStates?: Array<{
    __typename?: "EventActionResourceState";
    id: string;
    eventActionId: string;
    resourceId: string;
    resourceGroupId?: string | null;
    order: number;
    status: ResourceExecutionStatus;
    outputUri?: string | null;
    annotation: string;
    resource?: {
      __typename?: "Resource";
      id: string;
      name: string;
      description?: string | null;
      autoDiscovery: boolean;
      cloudResourceId: string;
      fullCloudResourceId: string;
      enabled: boolean;
      provider: ResourceCloudProvider;
      providerId: string;
      region: string;
      scanned: boolean;
      os?: {
        __typename?: "ResourceOS";
        type: OsType;
        subType?: OsSubType | null;
      } | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
    } | null;
    resourceGroup?: {
      __typename?: "Group";
      id: string;
      name: string;
      description?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        totalCount: number;
        disconnectedCount: number;
        onlineCount: number;
      } | null;
    } | null;
    output?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    } | null> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdBy: string;
      createdAt: string;
      updatedBy: string;
      updatedAt: string;
    };
  }> | null;
};

export type BatchActionsFragment = {
  __typename?: "EventActionBatch";
  actions: Array<{
    __typename?: "BatchedEventAction";
    id: string;
    name: string;
    actionName: string;
    type: EventActionType;
    order: number;
    action?:
      | {
          __typename?: "Action";
          id: string;
          name: string;
          type: ActionType;
          color: string;
        }
      | {
          __typename?: "SystemAction";
          id: string;
          name: string;
          version: string;
          color: string;
        }
      | null;
    inputParameters?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    resourceGroups?: Array<{
      __typename?: "Group";
      id: string;
      name: string;
      description?: string | null;
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        totalCount: number;
        disconnectedCount: number;
        onlineCount: number;
      } | null;
    } | null> | null;
    resources?: Array<{ __typename?: "Resource"; id: string }> | null;
    globalState?: {
      __typename?: "GlobalEventActionState";
      status: ExecutionStatus;
      estimatedStartTime: string;
      startTime?: string | null;
      endTime?: string | null;
      outputUri?: string | null;
    } | null;
    resourceStates?: Array<{
      __typename?: "EventActionResourceState";
      id: string;
      eventActionId: string;
      resourceId: string;
      resourceGroupId?: string | null;
      order: number;
      status: ResourceExecutionStatus;
      outputUri?: string | null;
      annotation: string;
      resource?: {
        __typename?: "Resource";
        id: string;
        name: string;
        description?: string | null;
        autoDiscovery: boolean;
        cloudResourceId: string;
        fullCloudResourceId: string;
        enabled: boolean;
        provider: ResourceCloudProvider;
        providerId: string;
        region: string;
        scanned: boolean;
        os?: {
          __typename?: "ResourceOS";
          type: OsType;
          subType?: OsSubType | null;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      } | null;
      resourceGroup?: {
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
        resourcesCounts?: {
          __typename?: "ResourcesCounts";
          totalCount: number;
          disconnectedCount: number;
          onlineCount: number;
        } | null;
      } | null;
      output?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      } | null> | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdBy: string;
        createdAt: string;
        updatedBy: string;
        updatedAt: string;
      };
    }> | null;
  }>;
};

export type EventActionFragment = {
  __typename?: "EventAction";
  id: string;
  name: string;
  type: EventActionType;
  scope: EventActionScope;
  order: number;
  windowDuration: number;
  skipWindow: SkipWindowType;
  executionPolicy: ExecutionPolicy;
  action?:
    | {
        __typename?: "Action";
        id: string;
        name: string;
        type: ActionType;
        color: string;
        description?: string | null;
      }
    | {
        __typename?: "SystemAction";
        id: string;
        name: string;
        version: string;
        color: string;
        description?: string | null;
      }
    | null;
  resourceGroups?: Array<{
    __typename?: "Group";
    id: string;
    name: string;
    description?: string | null;
    resourcesCounts?: {
      __typename?: "ResourcesCounts";
      totalCount: number;
      disconnectedCount: number;
      onlineCount: number;
    } | null;
  } | null> | null;
  resources?: Array<{ __typename?: "Resource"; id: string }> | null;
  globalState?: {
    __typename?: "GlobalEventActionState";
    status: ExecutionStatus;
    estimatedStartTime: string;
    startTime?: string | null;
    endTime?: string | null;
    outputUri?: string | null;
  } | null;
  resourceStates?: Array<{
    __typename?: "EventActionResourceState";
    id: string;
    resourceGroupId?: string | null;
    order: number;
    status: ResourceExecutionStatus;
    outputUri?: string | null;
    resource?: { __typename?: "Resource"; id: string; name: string } | null;
    resourceGroup?: { __typename?: "Group"; id: string; name: string } | null;
    output?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    } | null> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdBy: string;
      createdAt: string;
      updatedBy: string;
      updatedAt: string;
    };
  }> | null;
};

export type EventActionBatchFragment = {
  __typename?: "EventActionBatch";
  id: string;
  name: string;
  order: number;
  windowDuration: number;
  skipWindow: SkipWindowType;
  executionPolicy: ExecutionPolicy;
  startTime?: string | null;
  status: ExecutionStatus;
  actions: Array<{
    __typename?: "BatchedEventAction";
    id: string;
    name: string;
    actionName: string;
    type: EventActionType;
    order: number;
    action?:
      | {
          __typename?: "Action";
          id: string;
          name: string;
          type: ActionType;
          color: string;
        }
      | {
          __typename?: "SystemAction";
          id: string;
          name: string;
          version: string;
          color: string;
        }
      | null;
    inputParameters?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    resourceGroups?: Array<{
      __typename?: "Group";
      id: string;
      name: string;
      description?: string | null;
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        totalCount: number;
        disconnectedCount: number;
        onlineCount: number;
      } | null;
    } | null> | null;
    resources?: Array<{ __typename?: "Resource"; id: string }> | null;
    globalState?: {
      __typename?: "GlobalEventActionState";
      status: ExecutionStatus;
      estimatedStartTime: string;
      startTime?: string | null;
      endTime?: string | null;
      outputUri?: string | null;
    } | null;
    resourceStates?: Array<{
      __typename?: "EventActionResourceState";
      id: string;
      eventActionId: string;
      resourceId: string;
      resourceGroupId?: string | null;
      order: number;
      status: ResourceExecutionStatus;
      outputUri?: string | null;
      annotation: string;
      resource?: {
        __typename?: "Resource";
        id: string;
        name: string;
        description?: string | null;
        autoDiscovery: boolean;
        cloudResourceId: string;
        fullCloudResourceId: string;
        enabled: boolean;
        provider: ResourceCloudProvider;
        providerId: string;
        region: string;
        scanned: boolean;
        os?: {
          __typename?: "ResourceOS";
          type: OsType;
          subType?: OsSubType | null;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      } | null;
      resourceGroup?: {
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
        resourcesCounts?: {
          __typename?: "ResourcesCounts";
          totalCount: number;
          disconnectedCount: number;
          onlineCount: number;
        } | null;
      } | null;
      output?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      } | null> | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdBy: string;
        createdAt: string;
        updatedBy: string;
        updatedAt: string;
      };
    }> | null;
  }>;
};

export type EventActionsFragment = {
  __typename?: "Event";
  actions?: Array<{
    __typename?: "EventAction";
    id: string;
    name: string;
    type: EventActionType;
    scope: EventActionScope;
    order: number;
    windowDuration: number;
    skipWindow: SkipWindowType;
    executionPolicy: ExecutionPolicy;
    action?:
      | {
          __typename?: "Action";
          id: string;
          name: string;
          type: ActionType;
          color: string;
          description?: string | null;
        }
      | {
          __typename?: "SystemAction";
          id: string;
          name: string;
          version: string;
          color: string;
          description?: string | null;
        }
      | null;
    resourceGroups?: Array<{
      __typename?: "Group";
      id: string;
      name: string;
      description?: string | null;
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        totalCount: number;
        disconnectedCount: number;
        onlineCount: number;
      } | null;
    } | null> | null;
    resources?: Array<{ __typename?: "Resource"; id: string }> | null;
    globalState?: {
      __typename?: "GlobalEventActionState";
      status: ExecutionStatus;
      estimatedStartTime: string;
      startTime?: string | null;
      endTime?: string | null;
      outputUri?: string | null;
    } | null;
    resourceStates?: Array<{
      __typename?: "EventActionResourceState";
      id: string;
      resourceGroupId?: string | null;
      order: number;
      status: ResourceExecutionStatus;
      outputUri?: string | null;
      resource?: { __typename?: "Resource"; id: string; name: string } | null;
      resourceGroup?: { __typename?: "Group"; id: string; name: string } | null;
      output?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      } | null> | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdBy: string;
        createdAt: string;
        updatedBy: string;
        updatedAt: string;
      };
    }> | null;
  }> | null;
};

export type GetEventsViewQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<EventsSortInput>;
  filter?: InputMaybe<EventsFilterInput>;
}>;

export type GetEventsViewQuery = {
  __typename?: "Query";
  eventsView: {
    __typename?: "EventsViewPage";
    result?: Array<{
      __typename?: "EventView";
      id: string;
      startTime: string;
      endTime?: string | null;
      status: EventStatus;
      name: string;
      scheduleTimezone: string;
      estimatedEndTime: string;
      actions?: Array<{
        __typename?: "EventViewAction";
        scope: EventActionScope;
        id: string;
        name: string;
        order: number;
        resourcesFailed: number;
        resourcesSucceeded: number;
        resourcesNotCompleted: number;
        globalState?: {
          __typename?: "GlobalEventActionState";
          status: ExecutionStatus;
        } | null;
        errorCodeCounts: Array<{
          __typename?: "ResourceExecutionErrorCodeCount";
          errorCode: ResourceExecutionErrorCode;
          count: number;
        }>;
      }> | null;
      actionBatches?: Array<{
        __typename?: "EventViewActionBatch";
        id: string;
        name: string;
        order: number;
        status: ExecutionStatus;
        actions: Array<{
          __typename?: "EventViewAction";
          id: string;
          name: string;
          order: number;
          resourcesFailed: number;
          resourcesSucceeded: number;
          resourcesNotCompleted: number;
          scope: EventActionScope;
          globalState?: {
            __typename?: "GlobalEventActionState";
            status: ExecutionStatus;
          } | null;
          errorCodeCounts: Array<{
            __typename?: "ResourceExecutionErrorCodeCount";
            errorCode: ResourceExecutionErrorCode;
            count: number;
          }>;
        }>;
      }> | null;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type EventActionDefinitionFragment = {
  __typename?: "Action";
  id: string;
  name: string;
  color: string;
  type: ActionType;
  scope: ActionScope;
  description?: string | null;
};

export type EventDetailResourceFragment = {
  __typename?: "Resource";
  id: string;
  name: string;
  os?: {
    __typename?: "ResourceOS";
    type: OsType;
    subType?: OsSubType | null;
  } | null;
};

export type EventDetailResourceGroupFragment = {
  __typename?: "Group";
  id: string;
  name: string;
};

export type EventSystemActionDefinitionFragment = {
  __typename?: "SystemAction";
  id: string;
  name: string;
  color: string;
  scope: ActionScope;
  description?: string | null;
  version: string;
};

export type IncomingEventDetailPlanActionBatchFragment = {
  __typename: "PlanActionBatch";
  id: string;
  name: string;
  order: number;
  windowDuration: number;
  skipWindow: SkipWindowType;
  executionPolicy: ExecutionPolicy;
  batchActions?: Array<{
    __typename: "BatchAction";
    id: string;
    name: string;
    order: number;
    resourceGroups?: Array<{
      __typename?: "Group";
      id: string;
      name: string;
    }> | null;
    action:
      | {
          __typename?: "Action";
          id: string;
          name: string;
          color: string;
          type: ActionType;
          scope: ActionScope;
          description?: string | null;
        }
      | {
          __typename?: "SystemAction";
          id: string;
          name: string;
          color: string;
          scope: ActionScope;
          description?: string | null;
          version: string;
        };
    resources?: Array<{
      __typename?: "Resource";
      id: string;
      name: string;
      os?: {
        __typename?: "ResourceOS";
        type: OsType;
        subType?: OsSubType | null;
      } | null;
    }> | null;
    inputParameters?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
  }> | null;
};

export type IncomingEventDetailPlanBatchActionFragment = {
  __typename: "BatchAction";
  id: string;
  name: string;
  order: number;
  resourceGroups?: Array<{
    __typename?: "Group";
    id: string;
    name: string;
  }> | null;
  action:
    | {
        __typename?: "Action";
        id: string;
        name: string;
        color: string;
        type: ActionType;
        scope: ActionScope;
        description?: string | null;
      }
    | {
        __typename?: "SystemAction";
        id: string;
        name: string;
        color: string;
        scope: ActionScope;
        description?: string | null;
        version: string;
      };
  resources?: Array<{
    __typename?: "Resource";
    id: string;
    name: string;
    os?: {
      __typename?: "ResourceOS";
      type: OsType;
      subType?: OsSubType | null;
    } | null;
  }> | null;
  inputParameters?: Array<{
    __typename?: "KeyValue";
    key: string;
    value: string;
  }> | null;
};

export type GetIncomingEventQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetIncomingEventQuery = {
  __typename?: "Query";
  incomingEvent?: {
    __typename?: "IncomingEvent";
    id: string;
    name: string;
    scheduleTimezone: string;
    estimatedEndTime: string;
    status: IncomingEventStatus;
    startTime: string;
    plan?: {
      __typename?: "Plan";
      id: string;
      name: string;
      description?: string | null;
      scheduleCron?: string | null;
      scheduleOffset: number;
      scheduleTimezone?: string | null;
      enabled: boolean;
      planActions?: Array<{
        __typename?: "PlanAction";
        id: string;
        name: string;
        runInSequence: boolean;
        executionPolicy: ExecutionPolicy;
        order: number;
        skipWindow: SkipWindowType;
        windowDuration: number;
        action:
          | {
              __typename?: "Action";
              id: string;
              name: string;
              color: string;
              type: ActionType;
              scope: ActionScope;
              description?: string | null;
            }
          | {
              __typename?: "SystemAction";
              id: string;
              name: string;
              color: string;
              scope: ActionScope;
              description?: string | null;
              version: string;
            };
        resourceGroups?: Array<{
          __typename?: "Group";
          id: string;
          name: string;
        }> | null;
        resources?: Array<{
          __typename?: "Resource";
          id: string;
          name: string;
          os?: {
            __typename?: "ResourceOS";
            type: OsType;
            subType?: OsSubType | null;
          } | null;
        }> | null;
        inputParameters?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        }> | null;
      }> | null;
      planActionBatches?: Array<{
        __typename: "PlanActionBatch";
        id: string;
        name: string;
        order: number;
        windowDuration: number;
        skipWindow: SkipWindowType;
        executionPolicy: ExecutionPolicy;
        batchActions?: Array<{
          __typename: "BatchAction";
          id: string;
          name: string;
          order: number;
          resourceGroups?: Array<{
            __typename?: "Group";
            id: string;
            name: string;
          }> | null;
          action:
            | {
                __typename?: "Action";
                id: string;
                name: string;
                color: string;
                type: ActionType;
                scope: ActionScope;
                description?: string | null;
              }
            | {
                __typename?: "SystemAction";
                id: string;
                name: string;
                color: string;
                scope: ActionScope;
                description?: string | null;
                version: string;
              };
          resources?: Array<{
            __typename?: "Resource";
            id: string;
            name: string;
            os?: {
              __typename?: "ResourceOS";
              type: OsType;
              subType?: OsSubType | null;
            } | null;
          }> | null;
          inputParameters?: Array<{
            __typename?: "KeyValue";
            key: string;
            value: string;
          }> | null;
        }> | null;
      }> | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
    } | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
  } | null;
};

export type IncomingEventsListBatchActionFragment = {
  __typename?: "BatchAction";
  id: string;
  order: number;
  name: string;
  resourceGroups?: Array<{
    __typename?: "Group";
    resourcesCounts?: {
      __typename?: "ResourcesCounts";
      totalCount: number;
      disconnectedCount: number;
      onlineCount: number;
    } | null;
  }> | null;
  resources?: Array<{ __typename?: "Resource"; id: string }> | null;
  action:
    | { __typename?: "Action"; name: string }
    | { __typename?: "SystemAction"; name: string };
};

export type IncomingEventsListPlanActionFragment = {
  __typename?: "PlanAction";
  id: string;
  name: string;
  order: number;
  resourceGroups?: Array<{
    __typename?: "Group";
    resourcesCounts?: {
      __typename?: "ResourcesCounts";
      totalCount: number;
      disconnectedCount: number;
      onlineCount: number;
    } | null;
  }> | null;
  action:
    | { __typename?: "Action"; name: string }
    | { __typename?: "SystemAction"; name: string };
};

export type IncomingEventsListPlanActionBatchFragment = {
  __typename?: "PlanActionBatch";
  name: string;
  order: number;
  batchActions?: Array<{
    __typename?: "BatchAction";
    id: string;
    order: number;
    name: string;
    resourceGroups?: Array<{
      __typename?: "Group";
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        totalCount: number;
        disconnectedCount: number;
        onlineCount: number;
      } | null;
    }> | null;
    resources?: Array<{ __typename?: "Resource"; id: string }> | null;
    action:
      | { __typename?: "Action"; name: string }
      | { __typename?: "SystemAction"; name: string };
  }> | null;
};

export type GetIncomingEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<IncomingEventsSortInput>;
  filter?: InputMaybe<IncomingEventsFilterInput>;
}>;

export type GetIncomingEventsQuery = {
  __typename?: "Query";
  incomingEvents: {
    __typename?: "IncomingEventPage";
    result?: Array<{
      __typename?: "IncomingEvent";
      id: string;
      name: string;
      status: IncomingEventStatus;
      scheduleTimezone: string;
      estimatedEndTime: string;
      startTime: string;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdBy: string;
        createdAt: string;
        updatedBy: string;
        updatedAt: string;
      };
      plan?: {
        __typename?: "Plan";
        id: string;
        planActions?: Array<{
          __typename?: "PlanAction";
          id: string;
          name: string;
          order: number;
          resourceGroups?: Array<{
            __typename?: "Group";
            resourcesCounts?: {
              __typename?: "ResourcesCounts";
              totalCount: number;
              disconnectedCount: number;
              onlineCount: number;
            } | null;
          }> | null;
          action:
            | { __typename?: "Action"; name: string }
            | { __typename?: "SystemAction"; name: string };
        }> | null;
        planActionBatches?: Array<{
          __typename?: "PlanActionBatch";
          name: string;
          order: number;
          batchActions?: Array<{
            __typename?: "BatchAction";
            id: string;
            order: number;
            name: string;
            resourceGroups?: Array<{
              __typename?: "Group";
              resourcesCounts?: {
                __typename?: "ResourcesCounts";
                totalCount: number;
                disconnectedCount: number;
                onlineCount: number;
              } | null;
            }> | null;
            resources?: Array<{ __typename?: "Resource"; id: string }> | null;
            action:
              | { __typename?: "Action"; name: string }
              | { __typename?: "SystemAction"; name: string };
          }> | null;
        }> | null;
      } | null;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetPresignedUrlQueryVariables = Exact<{
  url: Scalars["String"]["input"];
}>;

export type GetPresignedUrlQuery = {
  __typename?: "Query";
  presignedEventActionOutputUrl?: string | null;
};

export type GetResourceGroupStatusesQueryVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
  eventActionId: Scalars["UUID"]["input"];
  groupIds?: InputMaybe<
    Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"]
  >;
  merged?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetResourceGroupStatusesQuery = {
  __typename?: "Query";
  eventActionResourceGroupStatuses?: Array<{
    __typename?: "EventActionResourceGroupStatus";
    groupId: string;
    status: ResourceGroupStatus;
  }> | null;
};

export type GetGlobalEventActionResourceStateQueryVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
  eventActionId: Scalars["UUID"]["input"];
  sort?: InputMaybe<EventActionResourceStateSortInput>;
  filter?: InputMaybe<EventActionResourceStatesFilterInput>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  excludeGroupStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetGlobalEventActionResourceStateQuery = {
  __typename?: "Query";
  globalEventActionResourceState: {
    __typename?: "EventActionResourceStateSearchPage";
    pageInfo: { __typename?: "PageInfo"; count: number };
    result?: Array<{
      __typename?: "EventActionResourceStateSearchItem";
      resourceGroupId?: string | null;
      resourceGroupStatus?: ResourceGroupStatus | null;
      resourceGroup?: { __typename?: "Group"; id: string; name: string } | null;
      resourceStates?: Array<{
        __typename?: "EventActionResourceStateWithoutGroup";
        id: string;
        resourceId: string;
        order: number;
        status: ResourceExecutionStatus;
        outputUri?: string | null;
        annotation: string;
        errorCode?: ResourceExecutionErrorCode | null;
        resource?: {
          __typename?: "Resource";
          id: string;
          name: string;
          provider: ResourceCloudProvider;
          region: string;
          os?: {
            __typename?: "ResourceOS";
            type: OsType;
            subType?: OsSubType | null;
          } | null;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      }> | null;
    }> | null;
  };
};

export type RerunEventActionMutationVariables = Exact<{
  input: RerunEventActionInput;
}>;

export type RerunEventActionMutation = {
  __typename?: "Mutation";
  rerunEventAction: boolean;
};

export type RevokeIncomingEventMutationVariables = Exact<{
  eventId: Scalars["UUID"]["input"];
}>;

export type RevokeIncomingEventMutation = {
  __typename?: "Mutation";
  revokeIncomingEvent: boolean;
};

export type CreateMappingRuleMutationVariables = Exact<{
  input: CreateMappingRuleInput;
}>;

export type CreateMappingRuleMutation = {
  __typename?: "Mutation";
  createMappingRule: {
    __typename?: "MappingRule";
    id: string;
    tagName: string;
    type: MappingRuleType;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type DeleteMappingRuleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteMappingRuleMutation = {
  __typename?: "Mutation";
  deleteMappingRule: boolean;
};

export type MappingRulesQueryVariables = Exact<{
  sort?: InputMaybe<MappingRulesSortInput>;
  filter?: InputMaybe<MappingRulesFilterInput>;
}>;

export type MappingRulesQuery = {
  __typename?: "Query";
  mappingRules: {
    __typename?: "MappingRulesPage";
    pageInfo: { __typename?: "PageInfo"; count: number; pages: number };
    result?: Array<{
      __typename?: "MappingRule";
      id: string;
      tagName: string;
      type: MappingRuleType;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        updatedAt: string;
        createdBy: string;
        updatedBy: string;
      };
    }> | null;
  };
};

export type CreateNotificationGroupMutationVariables = Exact<{
  input: CreateNotificationGroupInput;
}>;

export type CreateNotificationGroupMutation = {
  __typename?: "Mutation";
  createNotificationGroup: {
    __typename?: "NotificationGroup";
    id: string;
    name: string;
  };
};

export type DeleteNotificationGroupMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteNotificationGroupMutation = {
  __typename?: "Mutation";
  removeNotificationGroup: boolean;
};

export type GetNotificationGroupQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetNotificationGroupQuery = {
  __typename?: "Query";
  notificationGroup?: {
    __typename?: "NotificationGroup";
    id: string;
    name: string;
    description?: string | null;
    channels?: Array<{
      __typename?: "Channel";
      id: string;
      typeProperties:
        | { __typename?: "EmailChannel"; email: string }
        | {
            __typename?: "WebhookChannel";
            url: string;
            payload?: string | null;
            method: string;
            type: WebhookChannelType;
            headers?: Array<{
              __typename?: "KeyValue";
              key: string;
              value: string;
            }> | null;
          };
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      updatedAt: string;
      createdAt: string;
      updatedBy: string;
      createdBy: string;
    };
  } | null;
};

export type GetNotificationGroupPlansQueryVariables = Exact<{
  notificationGroupId: Scalars["UUID"]["input"];
}>;

export type GetNotificationGroupPlansQuery = {
  __typename?: "Query";
  notificationGroup?: {
    __typename?: "NotificationGroup";
    plans?: Array<{ __typename?: "Plan"; id: string; name: string }> | null;
  } | null;
};

export type GetNotificationGroupsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<NotificationGroupSortInput>;
}>;

export type GetNotificationGroupsQuery = {
  __typename?: "Query";
  notificationGroups: {
    __typename?: "NotificationGroupPage";
    result?: Array<{
      __typename?: "NotificationGroup";
      id: string;
      name: string;
      description?: string | null;
      channels?: Array<{
        __typename?: "Channel";
        id: string;
        typeProperties:
          | { __typename?: "EmailChannel"; email: string }
          | {
              __typename?: "WebhookChannel";
              url: string;
              payload?: string | null;
              method: string;
              type: WebhookChannelType;
              headers?: Array<{
                __typename?: "KeyValue";
                key: string;
                value: string;
              }> | null;
            };
      }> | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        updatedAt: string;
        createdAt: string;
        updatedBy: string;
        createdBy: string;
      };
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type UpdateNotificationGroupMutationVariables = Exact<{
  input: UpdateNotificationGroupInput;
}>;

export type UpdateNotificationGroupMutation = {
  __typename?: "Mutation";
  updateNotificationGroup: {
    __typename?: "NotificationGroup";
    id: string;
    name: string;
    description?: string | null;
    channels?: Array<{
      __typename?: "Channel";
      id: string;
      typeProperties:
        | { __typename?: "EmailChannel"; email: string }
        | {
            __typename?: "WebhookChannel";
            url: string;
            payload?: string | null;
            method: string;
            type: WebhookChannelType;
            headers?: Array<{
              __typename?: "KeyValue";
              key: string;
              value: string;
            }> | null;
          };
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      updatedAt: string;
      createdAt: string;
      updatedBy: string;
      createdBy: string;
    };
  };
};

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;

export type CreateApiKeyMutation = {
  __typename?: "Mutation";
  createApiKey: {
    __typename?: "CreateApiKeyResult";
    apiKeySecret: string;
    apiKey: {
      __typename?: "ApiKey";
      id: string;
      name: string;
      owner: string;
      description?: string | null;
      lastUsedAt?: string | null;
      expiresAt?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdBy: string;
        createdAt: string;
        updatedBy: string;
        updatedAt: string;
      };
    };
  };
};

export type DeleteApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars["UUID"]["input"];
}>;

export type DeleteApiKeyMutation = {
  __typename?: "Mutation";
  removeApiKey: boolean;
};

export type GetApiKeysQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ApiKeysSortInput>;
}>;

export type GetApiKeysQuery = {
  __typename?: "Query";
  apiKeys: {
    __typename?: "ApiKeysPage";
    result?: Array<{
      __typename?: "ApiKey";
      id: string;
      name: string;
      owner: string;
      description?: string | null;
      lastUsedAt?: string | null;
      expiresAt?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
      roleBindings?: {
        __typename?: "RoleBindingsPage";
        pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
        result?: Array<{
          __typename?: "RoleBinding";
          id: string;
          role: { __typename?: "Role"; id: string; name: string };
        } | null> | null;
      } | null;
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type UpdateApiKeyMutationVariables = Exact<{
  input: UpdateApiKeyInput;
}>;

export type UpdateApiKeyMutation = {
  __typename?: "Mutation";
  updateApiKey: {
    __typename?: "ApiKey";
    id: string;
    name: string;
    description?: string | null;
    expiresAt?: string | null;
    owner: string;
    roleBindings?: {
      __typename?: "RoleBindingsPage";
      result?: Array<{
        __typename?: "RoleBinding";
        id: string;
        role: { __typename?: "Role"; id: string; name: string };
      } | null> | null;
    } | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type GetRoleQueryVariables = Exact<{
  roleId: Scalars["UUID"]["input"];
}>;

export type GetRoleQuery = {
  __typename?: "Query";
  role?: {
    __typename?: "Role";
    id: string;
    name: string;
    description?: string | null;
    rules: Array<{
      __typename?: "RoleRule";
      resources: Array<RbacResource>;
      actions: Array<RbacAction>;
    }>;
  } | null;
};

export type UpdateRoleMutationVariables = Exact<{
  input: RoleUpdateInput;
}>;

export type UpdateRoleMutation = {
  __typename?: "Mutation";
  updateRole: {
    __typename?: "Role";
    id: string;
    name: string;
    description?: string | null;
    rules: Array<{
      __typename?: "RoleRule";
      resources: Array<RbacResource>;
      actions: Array<RbacAction>;
    }>;
    changeDetails: {
      __typename?: "ChangeDetails";
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type CreateRoleMutationVariables = Exact<{
  input: RoleInput;
}>;

export type CreateRoleMutation = {
  __typename?: "Mutation";
  createRole: { __typename?: "Role"; id: string };
};

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars["UUID"]["input"];
}>;

export type DeleteRoleMutation = {
  __typename?: "Mutation";
  removeRole: boolean;
};

export type GetRolesQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<RolesSortInput>;
}>;

export type GetRolesQuery = {
  __typename?: "Query";
  roles: {
    __typename?: "RolesPage";
    result?: Array<{
      __typename?: "Role";
      id: string;
      name: string;
      description?: string | null;
      rules: Array<{
        __typename?: "RoleRule";
        resources: Array<RbacResource>;
        actions: Array<RbacAction>;
      }>;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type DeleteUserMutation = {
  __typename?: "Mutation";
  removeUser: boolean;
};

export type GetRoleBindingsByUsersQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  sort?: InputMaybe<RoleBindingsByUsersSortInput>;
}>;

export type GetRoleBindingsByUsersQuery = {
  __typename?: "Query";
  roleBindingsByUsers?: {
    __typename?: "RoleBindingsByUsersPage";
    result?: Array<{
      __typename?: "RoleBindingByUser";
      customerId: string;
      type: RbacRoleBindingType;
      subject: string;
      lastLoggedInAt?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
      roles: Array<{
        __typename?: "Role";
        id: string;
        name: string;
        description?: string | null;
        rules: Array<{
          __typename?: "RoleRule";
          resources: Array<RbacResource>;
          actions: Array<RbacAction>;
        }>;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      }>;
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  } | null;
};

export type CreateRoleBindingMutationVariables = Exact<{
  input: CreateRoleBindingInput;
}>;

export type CreateRoleBindingMutation = {
  __typename?: "Mutation";
  createRoleBinding: {
    __typename?: "RoleBinding";
    id: string;
    type: RbacRoleBindingType;
    subject: string;
    role: {
      __typename?: "Role";
      id: string;
      name: string;
      description?: string | null;
    };
  };
};

export type DeleteRoleBindingMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteRoleBindingMutation = {
  __typename?: "Mutation";
  removeRoleBinding: boolean;
};

export type CreatePlanMutationVariables = Exact<{
  input: CreatePlanInput;
}>;

export type CreatePlanMutation = {
  __typename?: "Mutation";
  createPlan: { __typename?: "Plan"; id: string };
};

export type DeletePlanMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeletePlanMutation = {
  __typename?: "Mutation";
  removePlan: boolean;
};

export type GenerateCronFromPhraseMutationVariables = Exact<{
  input: GenerateCronFromPhraseInput;
}>;

export type GenerateCronFromPhraseMutation = {
  __typename?: "Mutation";
  generateCronFromPhrase: {
    __typename?: "GenerateCronFromPhraseResult";
    expression: string;
    error?: string | null;
    fields: Array<{
      __typename?: "CronField";
      name: string;
      value: string;
      description: string;
    }>;
  };
};

export type GenerateDatesFromCronMutationVariables = Exact<{
  input: GenerateDatesFromCronInput;
}>;

export type GenerateDatesFromCronMutation = {
  __typename?: "Mutation";
  generateDatesFromCron: {
    __typename?: "GenerateDatesFromCronResult";
    dates?: Array<string> | null;
    validationMsg?: string | null;
    error?: string | null;
  };
};

export type GetPlanQueryVariables = Exact<{
  planId: Scalars["UUID"]["input"];
}>;

export type GetPlanQuery = {
  __typename?: "Query";
  plan?: {
    __typename?: "Plan";
    id: string;
    name: string;
    description?: string | null;
    enabled: boolean;
    scheduleCron?: string | null;
    scheduleOffset: number;
    scheduleTimezone?: string | null;
    scheduleExecutionDates?: Array<string> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      updatedAt: string;
      updatedBy: string;
      createdAt: string;
      createdBy: string;
    };
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    planActions?: Array<{
      __typename?: "PlanAction";
      id: string;
      order: number;
      name: string;
      windowDuration: number;
      skipWindow: SkipWindowType;
      executionPolicy: ExecutionPolicy;
      runInSequence: boolean;
      resourceGroups?: Array<{
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        resourcesCounts?: {
          __typename?: "ResourcesCounts";
          totalCount: number;
          disconnectedCount: number;
          onlineCount: number;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      }> | null;
      resources?: Array<{
        __typename?: "Resource";
        id: string;
        name: string;
        autoDiscovery: boolean;
        cloudResourceId: string;
        fullCloudResourceId: string;
        enabled: boolean;
        provider: ResourceCloudProvider;
        providerId: string;
        region: string;
        scanned: boolean;
        os?: {
          __typename?: "ResourceOS";
          type: OsType;
          subType?: OsSubType | null;
          architecture: CpuArchitecture;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      }> | null;
      inputParameters?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
      action:
        | {
            __typename?: "Action";
            id: string;
            name: string;
            description?: string | null;
            color: string;
            type: ActionType;
            scope: ActionScope;
            synchronous: boolean;
            typeProperties:
              | { __typename: "ActionPropertyAWSLambda"; lambdaArn: string }
              | {
                  __typename: "ActionPropertyAzureFunction";
                  accessKeyId: string;
                  functionMethod: AzureFunctionMethod;
                  functionUrl: string;
                }
              | { __typename: "ActionPropertySSMDocument"; documentId: string }
              | { __typename: "ActionPropertyScript"; s3FileUrl: string }
              | {
                  __typename: "ActionPropertyWebhook";
                  webhookUrl: string;
                  webhookMethod: WebhookActionMethod;
                  payload: string;
                  headers: Array<{
                    __typename?: "KeyValue";
                    key: string;
                    value: string;
                  }>;
                };
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
            parameterDefinitions: Array<{
              __typename?: "ActionParameterDefinition";
              name: string;
              required: boolean;
              description?: string | null;
              allowedValues?: Array<string> | null;
              defaultValue?: string | null;
              type: ActionParameterType;
            }>;
          }
        | {
            __typename?: "SystemAction";
            id: string;
            name: string;
            scope: ActionScope;
            color: string;
            version: string;
            parameterDefinitions: Array<{
              __typename?: "ActionParameterDefinition";
              name: string;
              required: boolean;
              description?: string | null;
              allowedValues?: Array<string> | null;
              defaultValue?: string | null;
              type: ActionParameterType;
            }>;
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
          };
      notificationGroups?: Array<{
        __typename?: "PlanActionNotificationGroup";
        id: string;
        triggerEvent: PlanActionNotificationTriggerType;
        inAdvance?: number | null;
        scope: PlanActionNotificationGroupScope;
        notificationGroup: {
          __typename?: "NotificationGroup";
          id: string;
          name: string;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        };
      }> | null;
    }> | null;
    planActionBatches?: Array<{
      __typename?: "PlanActionBatch";
      id: string;
      name: string;
      order: number;
      windowDuration: number;
      skipWindow: SkipWindowType;
      executionPolicy: ExecutionPolicy;
      batchActions?: Array<{
        __typename?: "BatchAction";
        id: string;
        name: string;
        order: number;
        resourceGroups?: Array<{
          __typename?: "Group";
          id: string;
          name: string;
          description?: string | null;
          resourcesCounts?: {
            __typename?: "ResourcesCounts";
            totalCount: number;
            disconnectedCount: number;
            onlineCount: number;
          } | null;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        }> | null;
        resources?: Array<{
          __typename?: "Resource";
          id: string;
          name: string;
          autoDiscovery: boolean;
          cloudResourceId: string;
          fullCloudResourceId: string;
          enabled: boolean;
          provider: ResourceCloudProvider;
          providerId: string;
          region: string;
          scanned: boolean;
          os?: {
            __typename?: "ResourceOS";
            type: OsType;
            subType?: OsSubType | null;
            architecture: CpuArchitecture;
          } | null;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        }> | null;
        notificationGroups?: Array<{
          __typename?: "PlanActionNotificationGroup";
          id: string;
          triggerEvent: PlanActionNotificationTriggerType;
          inAdvance?: number | null;
          scope: PlanActionNotificationGroupScope;
          notificationGroup: {
            __typename?: "NotificationGroup";
            id: string;
            name: string;
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
          };
        }> | null;
        action:
          | {
              __typename?: "Action";
              id: string;
              name: string;
              description?: string | null;
              color: string;
              type: ActionType;
              scope: ActionScope;
              synchronous: boolean;
              typeProperties:
                | { __typename: "ActionPropertyAWSLambda"; lambdaArn: string }
                | {
                    __typename: "ActionPropertyAzureFunction";
                    accessKeyId: string;
                    functionMethod: AzureFunctionMethod;
                    functionUrl: string;
                  }
                | {
                    __typename: "ActionPropertySSMDocument";
                    documentId: string;
                  }
                | { __typename: "ActionPropertyScript"; s3FileUrl: string }
                | {
                    __typename: "ActionPropertyWebhook";
                    webhookUrl: string;
                    webhookMethod: WebhookActionMethod;
                    payload: string;
                    headers: Array<{
                      __typename?: "KeyValue";
                      key: string;
                      value: string;
                    }>;
                  };
              changeDetails: {
                __typename?: "ChangeDetails";
                createdAt: string;
                createdBy: string;
                updatedAt: string;
                updatedBy: string;
              };
              parameterDefinitions: Array<{
                __typename?: "ActionParameterDefinition";
                name: string;
                required: boolean;
                description?: string | null;
                allowedValues?: Array<string> | null;
                defaultValue?: string | null;
                type: ActionParameterType;
              }>;
            }
          | {
              __typename?: "SystemAction";
              id: string;
              name: string;
              scope: ActionScope;
              color: string;
              version: string;
              parameterDefinitions: Array<{
                __typename?: "ActionParameterDefinition";
                name: string;
                required: boolean;
                description?: string | null;
                allowedValues?: Array<string> | null;
                defaultValue?: string | null;
                type: ActionParameterType;
              }>;
              changeDetails: {
                __typename?: "ChangeDetails";
                createdAt: string;
                createdBy: string;
                updatedAt: string;
                updatedBy: string;
              };
            };
        inputParameters?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        }> | null;
      }> | null;
    }> | null;
    notificationGroups?: Array<{
      __typename?: "PlanNotificationGroup";
      id: string;
      triggerEvent: PlanNotificationTriggerType;
      inAdvance?: number | null;
      notificationGroup: {
        __typename?: "NotificationGroup";
        id: string;
        name: string;
        description?: string | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      };
    }> | null;
  } | null;
};

export type GetPlanNamesQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<PlanSortInput>;
  filter?: InputMaybe<PlansFilterInput>;
}>;

export type GetPlanNamesQuery = {
  __typename?: "Query";
  plans: {
    __typename?: "PlanPage";
    result?: Array<{ __typename?: "Plan"; id: string; name: string }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetPlansQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<PlanSortInput>;
  filter?: InputMaybe<PlansFilterInput>;
}>;

export type GetPlansQuery = {
  __typename?: "Query";
  plans: {
    __typename?: "PlanPage";
    result?: Array<{
      __typename?: "Plan";
      id: string;
      name: string;
      description?: string | null;
      enabled: boolean;
      scheduleCron?: string | null;
      scheduleTimezone?: string | null;
      scheduleExecutionDates?: Array<string> | null;
      scheduleOffset: number;
      nextExecutionDates?: Array<string> | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        updatedAt: string;
        updatedBy: string;
        createdAt: string;
        createdBy: string;
      };
      metadata?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
      planActions?: Array<{
        __typename?: "PlanAction";
        id: string;
        action:
          | { __typename?: "Action"; id: string }
          | { __typename?: "SystemAction"; id: string };
      }> | null;
      notificationGroups?: Array<{
        __typename?: "PlanNotificationGroup";
        notificationGroup: {
          __typename?: "NotificationGroup";
          id: string;
          name: string;
          description?: string | null;
        };
      }> | null;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetPlansBasicQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<PlanSortInput>;
  filter?: InputMaybe<PlansFilterInput>;
}>;

export type GetPlansBasicQuery = {
  __typename?: "Query";
  plans: {
    __typename?: "PlanPage";
    result?: Array<{ __typename?: "Plan"; id: string; name: string }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetSystemActionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<SystemActionsSortInput>;
}>;

export type GetSystemActionsQuery = {
  __typename?: "Query";
  systemActions: {
    __typename?: "SystemActionPage";
    result?: Array<{
      __typename?: "SystemAction";
      id: string;
      name: string;
      color: string;
      description?: string | null;
      version: string;
      scope: ActionScope;
      parameterDefinitions: Array<{
        __typename?: "ActionParameterDefinition";
        name: string;
        required: boolean;
        description?: string | null;
        allowedValues?: Array<string> | null;
        defaultValue?: string | null;
        type: ActionParameterType;
      }>;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type TriggerPlanMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type TriggerPlanMutation = {
  __typename?: "Mutation";
  triggerPlan: {
    __typename?: "Event";
    id: string;
    plan?: { __typename?: "Plan"; id: string } | null;
  };
};

export type UpdatePlanMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;

export type UpdatePlanMutation = {
  __typename?: "Mutation";
  updatePlan: {
    __typename?: "Plan";
    id: string;
    name: string;
    description?: string | null;
    enabled: boolean;
    scheduleCron?: string | null;
    scheduleOffset: number;
    scheduleTimezone?: string | null;
    scheduleExecutionDates?: Array<string> | null;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    planActions?: Array<{
      __typename?: "PlanAction";
      id: string;
      order: number;
      windowDuration: number;
      skipWindow: SkipWindowType;
      executionPolicy: ExecutionPolicy;
      runInSequence: boolean;
      resourceGroups?: Array<{
        __typename?: "Group";
        id: string;
        name: string;
        description?: string | null;
        resourcesCounts?: {
          __typename?: "ResourcesCounts";
          totalCount: number;
          disconnectedCount: number;
          onlineCount: number;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      }> | null;
      inputParameters?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
      action:
        | {
            __typename?: "Action";
            id: string;
            name: string;
            description?: string | null;
            color: string;
            type: ActionType;
            scope: ActionScope;
            synchronous: boolean;
            typeProperties:
              | { __typename: "ActionPropertyAWSLambda"; lambdaArn: string }
              | {
                  __typename: "ActionPropertyAzureFunction";
                  accessKeyId: string;
                  functionMethod: AzureFunctionMethod;
                  functionUrl: string;
                }
              | { __typename: "ActionPropertySSMDocument"; documentId: string }
              | { __typename: "ActionPropertyScript"; s3FileUrl: string }
              | {
                  __typename: "ActionPropertyWebhook";
                  webhookUrl: string;
                  webhookMethod: WebhookActionMethod;
                  payload: string;
                  headers: Array<{
                    __typename?: "KeyValue";
                    key: string;
                    value: string;
                  }>;
                };
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
            parameterDefinitions: Array<{
              __typename?: "ActionParameterDefinition";
              name: string;
              required: boolean;
              description?: string | null;
              allowedValues?: Array<string> | null;
              defaultValue?: string | null;
              type: ActionParameterType;
            }>;
          }
        | {
            __typename?: "SystemAction";
            id: string;
            name: string;
            scope: ActionScope;
            color: string;
            version: string;
            parameterDefinitions: Array<{
              __typename?: "ActionParameterDefinition";
              name: string;
              required: boolean;
              description?: string | null;
              allowedValues?: Array<string> | null;
              defaultValue?: string | null;
              type: ActionParameterType;
            }>;
            changeDetails: {
              __typename?: "ChangeDetails";
              createdAt: string;
              createdBy: string;
              updatedAt: string;
              updatedBy: string;
            };
          };
      notificationGroups?: Array<{
        __typename?: "PlanActionNotificationGroup";
        id: string;
        triggerEvent: PlanActionNotificationTriggerType;
        scope: PlanActionNotificationGroupScope;
        notificationGroup: {
          __typename?: "NotificationGroup";
          id: string;
          name: string;
          changeDetails: {
            __typename?: "ChangeDetails";
            createdAt: string;
            createdBy: string;
            updatedAt: string;
            updatedBy: string;
          };
        };
      }> | null;
    }> | null;
    planActionBatches?: Array<{
      __typename?: "PlanActionBatch";
      id: string;
      name: string;
      batchActions?: Array<{
        __typename?: "BatchAction";
        id: string;
        name: string;
      }> | null;
    }> | null;
    notificationGroups?: Array<{
      __typename?: "PlanNotificationGroup";
      id: string;
      triggerEvent: PlanNotificationTriggerType;
      inAdvance?: number | null;
      notificationGroup: {
        __typename?: "NotificationGroup";
        id: string;
        name: string;
      };
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;

export type CreateGroupMutation = {
  __typename?: "Mutation";
  createGroup: { __typename?: "Group"; id: string; name: string };
};

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteGroupMutation = {
  __typename?: "Mutation";
  removeGroup: boolean;
};

export type GetGroupPlansQueryVariables = Exact<{
  resourceGroupId: Scalars["UUID"]["input"];
}>;

export type GetGroupPlansQuery = {
  __typename?: "Query";
  group?: {
    __typename?: "Group";
    plans?: Array<{
      __typename?: "Plan";
      id: string;
      name: string;
    } | null> | null;
  } | null;
};

export type GetResourceGroupQueryVariables = Exact<{
  resourceGroupId: Scalars["UUID"]["input"];
}>;

export type GetResourceGroupQuery = {
  __typename?: "Query";
  group?: {
    __typename?: "Group";
    id: string;
    name: string;
    description?: string | null;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    resourceSelectors?: Array<{
      __typename?: "ResourceSelector";
      id: string;
      tagsExpression?: string | null;
      order: number;
      resource?: {
        __typename?: "Resource";
        id: string;
        name: string;
        description?: string | null;
        autoDiscovery: boolean;
        fullCloudResourceId: string;
        cloudResourceId: string;
        enabled: boolean;
        provider: ResourceCloudProvider;
        providerId: string;
        region: string;
        scanned: boolean;
        os?: {
          __typename?: "ResourceOS";
          type: OsType;
          subType?: OsSubType | null;
          architecture: CpuArchitecture;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      } | null;
      dynamicResources?: Array<{
        __typename?: "Resource";
        name: string;
        id: string;
        provider: ResourceCloudProvider;
        autoDiscovery: boolean;
        cloudResourceId: string;
        fullCloudResourceId: string;
        enabled: boolean;
        providerId: string;
        region: string;
        scanned: boolean;
        os?: {
          __typename?: "ResourceOS";
          type: OsType;
          subType?: OsSubType | null;
          architecture: CpuArchitecture;
        } | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      }> | null;
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  } | null;
};

export type GetResourceGroupsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<GroupsSortInput>;
  filter?: InputMaybe<GroupsFilterInput>;
  excludeResourceSelectors?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetResourceGroupsQuery = {
  __typename?: "Query";
  groups: {
    __typename?: "GroupsPage";
    result?: Array<{
      __typename?: "Group";
      id: string;
      name: string;
      type?: GroupTypes | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        updatedAt: string;
        updatedBy: string;
      };
      resourceSelectors?: Array<{
        __typename?: "ResourceSelector";
        id: string;
        tagsExpression?: string | null;
        order: number;
        resource?: { __typename?: "Resource"; id: string; name: string } | null;
      }> | null;
      resourcesCounts?: {
        __typename?: "ResourcesCounts";
        disconnectedCount: number;
        onlineCount: number;
        totalCount: number;
      } | null;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetResourceGroupsBasicQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<GroupsSortInput>;
  filter?: InputMaybe<GroupsFilterInput>;
}>;

export type GetResourceGroupsBasicQuery = {
  __typename?: "Query";
  groups: {
    __typename?: "GroupsPage";
    result?: Array<{ __typename?: "Group"; id: string; name: string }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;

export type UpdateGroupMutation = {
  __typename?: "Mutation";
  updateGroup: {
    __typename?: "Group";
    id: string;
    name: string;
    description?: string | null;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    resourceSelectors?: Array<{
      __typename?: "ResourceSelector";
      id: string;
      tagsExpression?: string | null;
      order: number;
      resource?: {
        __typename?: "Resource";
        id: string;
        name: string;
        description?: string | null;
        os?: {
          __typename?: "ResourceOS";
          type: OsType;
          subType?: OsSubType | null;
        } | null;
      } | null;
      dynamicResources?: Array<{
        __typename?: "Resource";
        name: string;
        id: string;
        provider: ResourceCloudProvider;
        os?: {
          __typename?: "ResourceOS";
          type: OsType;
          subType?: OsSubType | null;
        } | null;
      }> | null;
    }> | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type GetEventActionResourceReportQueryVariables = Exact<{
  eventActionId: Scalars["UUID"]["input"];
  eventId: Scalars["UUID"]["input"];
  resourceId: Scalars["UUID"]["input"];
}>;

export type GetEventActionResourceReportQuery = {
  __typename?: "Query";
  eventActionResourceReport: {
    __typename?: "EventActionResourceReport";
    name: string;
    resourceId: string;
    result: {
      __typename?: "EventActionResourceReportResult";
      installed?: Array<{
        __typename?: "ResourceReportPackage";
        name: string;
        id: string;
        version?: string | null;
      }> | null;
      updated?: Array<{
        __typename?: "ResourceReportPackage";
        name: string;
        id: string;
        version?: string | null;
      }> | null;
      removed?: Array<{
        __typename?: "ResourceReportPackage";
        name: string;
        id: string;
        version?: string | null;
      }> | null;
      available?: Array<{
        __typename?: "ResourceReportPackage";
        name: string;
        id: string;
        version?: string | null;
      }> | null;
      failed?: Array<{
        __typename?: "ResourceReportPackage";
        name: string;
        id: string;
        version?: string | null;
      }> | null;
    };
  };
};

export type GetGroupsForResourceQueryVariables = Exact<{
  resourceId: Scalars["UUID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<GroupsForResourceSortInput>;
  filter?: InputMaybe<GroupsForResourceFilterInput>;
}>;

export type GetGroupsForResourceQuery = {
  __typename?: "Query";
  groupsForResource: {
    __typename?: "GroupsForResourcePage";
    result: Array<{
      __typename?: "GroupForResource";
      id: string;
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      name: string;
      resourceSelector: {
        __typename?: "ResourceSelector";
        id: string;
        order: number;
        tagsExpression?: string | null;
      };
      plans?: Array<{
        __typename?: "Plan";
        id: string;
        name: string;
        description?: string | null;
        status: PlanStatuses;
        enabled: boolean;
        scheduleCron?: string | null;
        scheduleExecutionDates?: Array<string> | null;
        scheduleOffset: number;
        scheduleOption: PlanScheduleOptions;
        scheduleTimezone?: string | null;
        nextExecutionDates?: Array<string> | null;
        changeDetails: {
          __typename?: "ChangeDetails";
          createdAt: string;
          createdBy: string;
          updatedAt: string;
          updatedBy: string;
        };
      }> | null;
    }>;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetGroupUniqueAttributesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetGroupUniqueAttributesQuery = {
  __typename?: "Query";
  groupUniqueAttributes: {
    __typename?: "GroupUniqueAttributes";
    createdBy: Array<string>;
  };
};

export type GetIncomingActionsForResourceQueryVariables = Exact<{
  resourceId: Scalars["UUID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<FutureActionsForResourceSortInput>;
  filter?: InputMaybe<FutureActionsForResourceFilterInput>;
}>;

export type GetIncomingActionsForResourceQuery = {
  __typename?: "Query";
  futureActionsForResource: {
    __typename?: "FutureActionsForResourcePage";
    result: Array<{
      __typename?: "FutureActionForResource";
      actionName: string;
      actionType: PlanActionType;
      eventId: string;
      eventName: string;
      planId: string;
      resourceGroupId?: string | null;
      resourceGroupName?: string | null;
      scheduleTimezone: string;
      startTime: string;
    }>;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetPastActionsForResourceQueryVariables = Exact<{
  resourceId: Scalars["UUID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<PastActionsForResourceSortInput>;
  filter?: InputMaybe<PastActionsForResourceFilterInput>;
}>;

export type GetPastActionsForResourceQuery = {
  __typename?: "Query";
  pastActionsForResource: {
    __typename?: "PastActionsForResourcePage";
    result: Array<{
      __typename?: "PastActionForResource";
      id: string;
      planId: string;
      actionName: string;
      actionType: EventActionType;
      resourceGroupId?: string | null;
      resourceGroupName?: string | null;
      eventId: string;
      eventActionId: string;
      eventName: string;
      scheduleTimezone: string;
      endTime?: string | null;
      status: ResourceExecutionStatus;
      outputUri?: string | null;
      annotation?: string | null;
      updatedBy: string;
      errorCode?: ResourceExecutionErrorCode | null;
    }>;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;

export type CreateReportMutation = {
  __typename?: "Mutation";
  createReport: { __typename?: "Report"; id: string };
};

export type CreateResourceUpdatesReportMutationVariables = Exact<{
  reportType: ReportType;
  resourceId: Scalars["UUID"]["input"];
  startDate: Scalars["String"]["input"];
  endDate: Scalars["String"]["input"];
}>;

export type CreateResourceUpdatesReportMutation = {
  __typename?: "Mutation";
  createReport: { __typename?: "Report"; id: string; status: ReportStatus };
};

export type DeleteResourceMutationVariables = Exact<{
  removeResourceId: Scalars["UUID"]["input"];
}>;

export type DeleteResourceMutation = {
  __typename?: "Mutation";
  removeResource?: boolean | null;
};

export type GetAllResourceDetailsQueryVariables = Exact<{
  input: ResourcesSearchInput;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ResourcesSortInput>;
}>;

export type GetAllResourceDetailsQuery = {
  __typename?: "Query";
  resourcesSearch?: {
    __typename?: "ResourcesPage";
    result?: Array<{
      __typename?: "Resource";
      id: string;
      name: string;
      scanned: boolean;
      os?: { __typename?: "ResourceOS"; type: OsType } | null;
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  } | null;
};

export type GetReportsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ReportsSortInput>;
  filter?: InputMaybe<ReportsFilterInput>;
}>;

export type GetReportsQuery = {
  __typename?: "Query";
  reports: {
    __typename?: "ReportsPage";
    pageInfo: { __typename?: "PageInfo"; count: number; pages: number };
    result?: Array<{
      __typename?: "Report";
      id: string;
      name: string;
      status: ReportStatus;
      type: ReportType;
      dateGenerated?: string | null;
      url?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
    }> | null;
  };
};

export type GetResourceQueryVariables = Exact<{
  resourceId: Scalars["UUID"]["input"];
}>;

export type GetResourceQuery = {
  __typename?: "Query";
  resource?: {
    __typename?: "Resource";
    id: string;
    name: string;
    provider: ResourceCloudProvider;
    providerId: string;
    description?: string | null;
    cloudResourceId: string;
    fullCloudResourceId: string;
    autoDiscovery: boolean;
    enabled: boolean;
    region: string;
    scanned: boolean;
    tags?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    metadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    cloudMetadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
    os?: {
      __typename?: "ResourceOS";
      type: OsType;
      subType?: OsSubType | null;
      version?: string | null;
    } | null;
    access?: { __typename?: "SSMAccess"; instanceId: string } | null;
    state?: {
      __typename?: "ResourceState";
      status: ResourceStatus;
      error?: string | null;
      updatedAt: string;
      ssmMetadata?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
    } | null;
    latestInventory?: {
      __typename?: "ResourceInventory";
      status: InventoryStatus;
      error?: string | null;
      inventoryUri?: string | null;
      availablePackagesUri?: string | null;
      createdAt: string;
    } | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
  } | null;
};

export type GetResourceCloudRegionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetResourceCloudRegionsQuery = {
  __typename?: "Query";
  resourceCloudRegions: {
    __typename?: "ResourceCloudRegions";
    aws: Array<string>;
    azure: Array<string>;
    gc: Array<string>;
    ibm: Array<string>;
  };
};

export type UpdateStatusResourceStatisticsCountsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UpdateStatusResourceStatisticsCountsQuery = {
  __typename?: "Query";
  updateStatusResourceStatisticsCounts?: Array<{
    __typename?: "UpdateStatusResourceStatisticsCounts";
    updateStatus: ResourceUpdateStatus;
    count: number;
  }> | null;
};

export type ResourceFragment = {
  __typename?: "Resource";
  name: string;
  id: string;
  provider: ResourceCloudProvider;
  scanned: boolean;
  region: string;
  providerId: string;
  os?: {
    __typename?: "ResourceOS";
    type: OsType;
    subType?: OsSubType | null;
    version?: string | null;
  } | null;
  access?: { __typename?: "SSMAccess"; instanceId: string } | null;
  state?: {
    __typename?: "ResourceState";
    status: ResourceStatus;
    updatedAt: string;
    ssmMetadata?: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }> | null;
  } | null;
};

export type ResourcePageFragment = {
  __typename?: "ResourcesPage";
  result?: Array<{
    __typename?: "Resource";
    name: string;
    id: string;
    provider: ResourceCloudProvider;
    scanned: boolean;
    region: string;
    providerId: string;
    os?: {
      __typename?: "ResourceOS";
      type: OsType;
      subType?: OsSubType | null;
      version?: string | null;
    } | null;
    access?: { __typename?: "SSMAccess"; instanceId: string } | null;
    state?: {
      __typename?: "ResourceState";
      status: ResourceStatus;
      updatedAt: string;
      ssmMetadata?: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }> | null;
    } | null;
  } | null> | null;
  pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
};

export type GetResourcesQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  sort?: InputMaybe<ResourcesSortInput>;
  filter?: InputMaybe<ResourceFilterInput>;
}>;

export type GetResourcesQuery = {
  __typename?: "Query";
  resources?: {
    __typename?: "ResourcesPage";
    result?: Array<{
      __typename?: "Resource";
      name: string;
      id: string;
      provider: ResourceCloudProvider;
      scanned: boolean;
      region: string;
      providerId: string;
      os?: {
        __typename?: "ResourceOS";
        type: OsType;
        subType?: OsSubType | null;
        version?: string | null;
      } | null;
      access?: { __typename?: "SSMAccess"; instanceId: string } | null;
      state?: {
        __typename?: "ResourceState";
        status: ResourceStatus;
        updatedAt: string;
        ssmMetadata?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        }> | null;
      } | null;
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  } | null;
};

export type GetResourcesByTagsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  tagsExpression: Scalars["String"]["input"];
}>;

export type GetResourcesByTagsQuery = {
  __typename?: "Query";
  resourcesByTags?: {
    __typename?: "ResourcesPage";
    result?: Array<{
      __typename?: "Resource";
      name: string;
      id: string;
      provider: ResourceCloudProvider;
      os?: {
        __typename?: "ResourceOS";
        type: OsType;
        subType?: OsSubType | null;
        version?: string | null;
        architecture: CpuArchitecture;
      } | null;
      state?: {
        __typename?: "ResourceState";
        status: ResourceStatus;
        ssmMetadata?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        }> | null;
      } | null;
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  } | null;
};

export type GetResourceUpdateStatusQueryVariables = Exact<{
  resourceIds: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
}>;

export type GetResourceUpdateStatusQuery = {
  __typename?: "Query";
  updateStatusForResources?: Array<{
    __typename?: "UpdateStatusForResource";
    resourceId: string;
    updateStatus: ResourceUpdateStatus;
    pendingUpdateCount?: number | null;
    basedOn?: {
      __typename?: "ResourceUpdateStatusBasedOn";
      eventId: string;
      eventActionId: string;
      eventActionResourceStateId: string;
    } | null;
  }> | null;
};

export type RemoveReportMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type RemoveReportMutation = {
  __typename?: "Mutation";
  removeReport: boolean;
};

export type ResourceComplianceReportForUiQueryVariables = Exact<{
  input: ResourceComplianceReportForUiInput;
}>;

export type ResourceComplianceReportForUiQuery = {
  __typename?: "Query";
  resourceComplianceReportForUI?: {
    __typename?: "ResourceComplianceReportForUIInfo";
    status: ReportStatus;
    packages?: Array<{
      __typename?: "ResourceComplianceReportPackageInfo";
      eventId: string;
      eventActionId: string;
      updateName: string;
      time: string;
      patchPolicy: string;
      rebootAllowed: string;
      releaseDate: string;
      category: string;
      updateStatus: string;
    }> | null;
    actionsWithMissingData?: Array<{
      __typename?: "ActionWithMissingData";
      eventId: string;
      eventName: string;
      eventActionId: string;
      errCode: ActionWithMissingDataErrorCode;
    }> | null;
  } | null;
};

export type ResourceComplianceStatusForUiQueryVariables = Exact<{
  input: ResourceComplianceStatusForUiInput;
}>;

export type ResourceComplianceStatusForUiQuery = {
  __typename?: "Query";
  resourceComplianceStatusForUI?: {
    __typename?: "ResourceComplianceStatusForUIInfo";
    status: ReportStatus;
    complianceStatuses?: Array<{
      __typename?: "ResourceComplianceStatusInfo";
      resourceId: string;
      status: ResourceComplianceStatus;
    }> | null;
  } | null;
};

export type ResourcesSearchBasicQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  sort?: InputMaybe<ResourcesSortInput>;
  input: ResourcesSearchInput;
}>;

export type ResourcesSearchBasicQuery = {
  __typename?: "Query";
  resourcesSearch?: {
    __typename?: "ResourcesPage";
    result?: Array<{
      __typename?: "Resource";
      id: string;
      name: string;
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  } | null;
};

export type ResourcesSearchQueryVariables = Exact<{
  input: ResourcesSearchInput;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ResourcesSortInput>;
  includeAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeGroupIdentifiers?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeFuturePatchingActions?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ResourcesSearchQuery = {
  __typename?: "Query";
  resourcesSearch?: {
    __typename?: "ResourcesPage";
    result?: Array<{
      __typename?: "Resource";
      name: string;
      id: string;
      provider: ResourceCloudProvider;
      scanned: boolean;
      region: string;
      providerId: string;
      cloudAccount?: {
        __typename?: "CloudAccount";
        id: string;
        name: string;
      } | null;
      groupIdentifiers?: Array<{
        __typename?: "GroupIdentifiers";
        id: string;
        name: string;
      }> | null;
      futurePatchingActions?: Array<{
        __typename?: "NextPatchingActionForResource";
        planId: string;
        planActionId: string;
        eventId: string;
        startTime: string;
        scheduleTimezone: string;
      }> | null;
      os?: {
        __typename?: "ResourceOS";
        type: OsType;
        subType?: OsSubType | null;
        version?: string | null;
      } | null;
      access?: { __typename?: "SSMAccess"; instanceId: string } | null;
      state?: {
        __typename?: "ResourceState";
        status: ResourceStatus;
        updatedAt: string;
        ssmMetadata?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        }> | null;
      } | null;
    } | null> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  } | null;
};

export type UpdateResourceMutationVariables = Exact<{
  input: UpdateResourceInput;
}>;

export type UpdateResourceMutation = {
  __typename?: "Mutation";
  updateResource: {
    __typename?: "Resource";
    id: string;
    name: string;
    description?: string | null;
    changeDetails: {
      __typename?: "ChangeDetails";
      updatedAt: string;
      updatedBy: string;
    };
  };
};

export type DeleteCloudResourceReportMutationVariables = Exact<{
  input: DeleteCloudResourceReportInput;
}>;

export type DeleteCloudResourceReportMutation = {
  __typename?: "Mutation";
  deleteCloudResourceReport: boolean;
};

export type RerunCloudResourceReportMutationVariables = Exact<{
  input: RerunCloudResourceReportInput;
}>;

export type RerunCloudResourceReportMutation = {
  __typename?: "Mutation";
  rerunCloudResourceReport: boolean;
};

export type CreateCloudResourceReportMutationVariables = Exact<{
  input: CreateCloudResourceReportInput;
}>;

export type CreateCloudResourceReportMutation = {
  __typename?: "Mutation";
  createCloudResourceReport: boolean;
};

export type GetCloudAccountsFilterValuesQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
}>;

export type GetCloudAccountsFilterValuesQuery = {
  __typename?: "Query";
  cloudAccounts: {
    __typename?: "CloudAccountsPage";
    result?: Array<{
      __typename?: "CloudAccount";
      id: string;
      name: string;
      provider: CloudAccountCloudProvider;
    } | null> | null;
  };
};

export type GetCloudResourceQueryVariables = Exact<{
  resourceId: Scalars["UUID"]["input"];
}>;

export type GetCloudResourceQuery = {
  __typename?: "Query";
  cloudResource?: {
    __typename?: "CloudResource";
    id: string;
    provider: CloudResourceProvider;
    region: string;
    type: string;
    subtype: string;
    name: string;
    cloudResourceId: string;
    fullCloudResourceId?: string | null;
    providerId: string;
    parentId?: string | null;
    tags: Array<{ __typename?: "KeyValue"; key: string; value: string }>;
    cloudMetadata: Array<{
      __typename?: "KeyValue";
      key: string;
      value: string;
    }>;
    changeDetails: {
      __typename?: "ChangeDetails";
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
    };
    cloudAccount?: {
      __typename?: "CloudAccount";
      id: string;
      name: string;
    } | null;
    lastPatching?: {
      __typename?: "LastPatching";
      status: PatchingStatus;
      date: string;
    } | null;
  } | null;
};

export type GetCloudResourceFilterValuesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCloudResourceFilterValuesQuery = {
  __typename?: "Query";
  cloudResourceFilterValues: {
    __typename?: "CloudResourceFilterValues";
    regions: Array<string>;
    cloudServices: Array<string>;
    resourceTypes: Array<string>;
  };
};

export type CloudResourceReportResultFragment = {
  __typename?: "CloudResourceReport";
  id: string;
  name: string;
  status: CloudResourceReportStatus;
  dateGenerated?: string | null;
  url?: string | null;
  changeDetails: {
    __typename?: "ChangeDetails";
    createdAt: string;
    createdBy: string;
  };
};

export type GetCloudResourceReportsQueryVariables = Exact<{
  page: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  sort?: InputMaybe<CloudResourceReportsSortInput>;
  filter?: InputMaybe<CloudResourceReportsFilterInput>;
}>;

export type GetCloudResourceReportsQuery = {
  __typename?: "Query";
  cloudResourceReports: {
    __typename?: "CloudResourceReportsPage";
    pageInfo: { __typename?: "PageInfo"; count: number; pages: number };
    result?: Array<{
      __typename?: "CloudResourceReport";
      id: string;
      name: string;
      status: CloudResourceReportStatus;
      dateGenerated?: string | null;
      url?: string | null;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
      };
    }> | null;
  };
};

export type CloudResourcePageFragment = {
  __typename?: "CloudResource";
  id: string;
  provider: CloudResourceProvider;
  region: string;
  type: string;
  subtype: string;
  name: string;
  cloudResourceId: string;
  fullCloudResourceId?: string | null;
  providerId: string;
  parentId?: string | null;
  tags: Array<{ __typename?: "KeyValue"; key: string; value: string }>;
  cloudMetadata: Array<{ __typename?: "KeyValue"; key: string; value: string }>;
  cloudAccount?: {
    __typename?: "CloudAccount";
    id: string;
    name: string;
  } | null;
  lastPatching?: {
    __typename?: "LastPatching";
    status: PatchingStatus;
    date: string;
  } | null;
};

export type GetCloudResourcesQueryVariables = Exact<{
  page: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  sort?: InputMaybe<CloudResourcesSortInput>;
  filter?: InputMaybe<CloudResourcesFilterInput>;
}>;

export type GetCloudResourcesQuery = {
  __typename?: "Query";
  cloudResources: {
    __typename?: "CloudResourcesPage";
    pageInfo: { __typename?: "PageInfo"; count: number; pages: number };
    result?: Array<{
      __typename?: "CloudResource";
      id: string;
      name: string;
      provider: CloudResourceProvider;
      region: string;
      type: string;
      subtype: string;
      cloudResourceId: string;
      fullCloudResourceId?: string | null;
      providerId: string;
      parentId?: string | null;
      tags: Array<{ __typename?: "KeyValue"; key: string; value: string }>;
      cloudMetadata: Array<{
        __typename?: "KeyValue";
        key: string;
        value: string;
      }>;
      changeDetails: {
        __typename?: "ChangeDetails";
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
      };
      cloudAccount?: {
        __typename?: "CloudAccount";
        id: string;
        name: string;
      } | null;
      lastPatching?: {
        __typename?: "LastPatching";
        status: PatchingStatus;
        date: string;
      } | null;
    }> | null;
  };
};

export type GetResourceScheduleFutureActionsQueryVariables = Exact<{
  resourceId: Scalars["UUID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetResourceScheduleFutureActionsQuery = {
  __typename?: "Query";
  futureActionsForResource: {
    __typename?: "FutureActionsForResourcePage";
    result: Array<{
      __typename?: "FutureActionForResource";
      planId: string;
      actionName: string;
      actionType: PlanActionType;
      resourceGroupId?: string | null;
      resourceGroupName?: string | null;
      eventId: string;
      eventName: string;
      startTime: string;
      scheduleTimezone: string;
    }>;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetResourceSchedulePastActionsQueryVariables = Exact<{
  resourceId: Scalars["UUID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetResourceSchedulePastActionsQuery = {
  __typename?: "Query";
  pastActionsForResource: {
    __typename?: "PastActionsForResourcePage";
    result: Array<{
      __typename?: "PastActionForResource";
      id: string;
      planId: string;
      actionName: string;
      actionType: EventActionType;
      resourceGroupId?: string | null;
      resourceGroupName?: string | null;
      eventId: string;
      eventName: string;
      scheduleTimezone: string;
      endTime?: string | null;
      status: ResourceExecutionStatus;
    }>;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetPastTimelineEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<EventsSortInput>;
  filter?: InputMaybe<EventsFilterInput>;
}>;

export type GetPastTimelineEventsQuery = {
  __typename?: "Query";
  eventsView: {
    __typename?: "EventsViewPage";
    result?: Array<{
      __typename?: "EventView";
      id: string;
      name: string;
      status: EventStatus;
      scheduleTimezone: string;
      estimatedEndTime: string;
      startTime: string;
      endTime?: string | null;
      plan?: { __typename?: "Plan"; id: string; name: string } | null;
      actions?: Array<{
        __typename?: "EventViewAction";
        id: string;
        name: string;
        actionName: string;
        order: number;
        windowDuration?: number | null;
        inputParameters?: Array<{
          __typename?: "KeyValue";
          key: string;
          value: string;
        }> | null;
        action?:
          | { __typename?: "Action"; id: string; name: string; color: string }
          | {
              __typename?: "SystemAction";
              id: string;
              name: string;
              color: string;
            }
          | null;
        globalState?: {
          __typename?: "GlobalEventActionState";
          status: ExecutionStatus;
        } | null;
        resourceGroups?: Array<{
          __typename?: "Group";
          id: string;
          name: string;
          resourcesCounts?: {
            __typename?: "ResourcesCounts";
            totalCount: number;
          } | null;
        } | null> | null;
        resources?: Array<{ __typename?: "Resource"; id: string }> | null;
      }> | null;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export type GetTimelineEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<IncomingEventsSortInput>;
  filter?: InputMaybe<IncomingEventsFilterInput>;
}>;

export type GetTimelineEventsQuery = {
  __typename?: "Query";
  incomingEvents: {
    __typename?: "IncomingEventPage";
    result?: Array<{
      __typename?: "IncomingEvent";
      id: string;
      name: string;
      status: IncomingEventStatus;
      scheduleTimezone: string;
      estimatedEndTime: string;
      startTime: string;
      plan?: {
        __typename?: "Plan";
        id: string;
        name: string;
        planActions?: Array<{
          __typename?: "PlanAction";
          id: string;
          name: string;
          order: number;
          windowDuration: number;
          action:
            | { __typename?: "Action"; id: string; name: string; color: string }
            | {
                __typename?: "SystemAction";
                id: string;
                name: string;
                color: string;
              };
          inputParameters?: Array<{
            __typename?: "KeyValue";
            key: string;
            value: string;
          }> | null;
          resourceGroups?: Array<{
            __typename?: "Group";
            id: string;
            name: string;
            resourcesCounts?: {
              __typename?: "ResourcesCounts";
              totalCount: number;
            } | null;
          }> | null;
          resources?: Array<{ __typename?: "Resource"; id: string }> | null;
        }> | null;
      } | null;
    }> | null;
    pageInfo: { __typename?: "PageInfo"; pages: number; count: number };
  };
};

export const EventActionAttemptResourceStatesFragmentDoc = gql`
  fragment EventActionAttemptResourceStates on EventActionAttempt {
    resourceStates {
      id
      eventActionId
      resourceId
      resourceGroupId
      resource {
        id
        name
        description
        os {
          type
          subType
        }
        autoDiscovery
        cloudResourceId
        fullCloudResourceId
        enabled
        provider
        providerId
        region
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        scanned
      }
      resourceGroup {
        id
        name
        description
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        resourcesCounts {
          totalCount
          disconnectedCount
          onlineCount
        }
      }
      order
      status
      outputUri
      output {
        key
        value
      }
      annotation
      errorCode
      changeDetails {
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;
export const EventActionResourceStatesFragmentDoc = gql`
  fragment EventActionResourceStates on EventAction {
    resourceStates {
      id
      eventActionId
      resourceId
      resourceGroupId
      resource {
        id
        name
        description
        os {
          type
          subType
        }
        autoDiscovery
        cloudResourceId
        fullCloudResourceId
        enabled
        provider
        providerId
        region
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        scanned
      }
      resourceGroup {
        id
        name
        description
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        resourcesCounts {
          totalCount
          disconnectedCount
          onlineCount
        }
      }
      order
      status
      outputUri
      output {
        key
        value
      }
      annotation
      errorCode
      changeDetails {
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;
export const ActionPropertiesFragmentDoc = gql`
  fragment ActionProperties on Action {
    id
    name
    color
    synchronous
    type
    typeProperties {
      ... on ActionPropertyAWSLambda {
        lambdaArn
      }
      ... on ActionPropertyAzureFunction {
        accessKeyId
        functionMethod
        functionUrl
      }
      ... on ActionPropertyScript {
        s3FileUrl
      }
      ... on ActionPropertySSMDocument {
        documentId
      }
      ... on ActionPropertyWebhook {
        webhookUrl
        webhookMethod
        payload
        headers {
          key
          value
        }
      }
    }
    parameterDefinitions {
      name
      required
      type
    }
    scope
    changeDetails {
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
export const SystemActionPropertiesFragmentDoc = gql`
  fragment SystemActionProperties on SystemAction {
    id
    name
    scope
    color
    version
    parameterDefinitions {
      name
      required
      type
    }
    changeDetails {
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
export const EventDetailsFragmentDoc = gql`
  fragment EventDetails on EventView {
    id
    name
    description
    scheduleTimezone
    estimatedEndTime
    status
    startTime
    endTime
    metadata {
      key
      value
    }
    plan {
      id
      name
      scheduleCron
      scheduleOffset
      scheduleTimezone
      enabled
      planActions {
        id
        runInSequence
        executionPolicy
        order
        skipWindow
        windowDuration
        action {
          ... on Action {
            ...ActionProperties
          }
          ... on SystemAction {
            ...SystemActionProperties
          }
        }
        resourceGroups {
          id
          name
          description
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
    actions {
      id
      actionName
      globalState {
        status
        outputUri
        estimatedStartTime
        startTime
        endTime
      }
      attempts {
        id
        attempt
        state {
          eventId
          eventActionId
          status
          outputUri
          estimatedStartTime
          startTime
          endTime
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
      }
      inputParameters {
        key
        value
      }
      action {
        ... on Action {
          ...ActionProperties
        }
        ... on SystemAction {
          ...SystemActionProperties
        }
      }
      name
      type
      scope
      order
      windowDuration
      skipWindow
      executionPolicy
      runInSequence
      resourcesFailed
      resourcesNotCompleted
      resourcesSucceeded
      errorCodeCounts {
        errorCode
        count
      }
      resourceGroups {
        id
        name
        description
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        resourcesCounts {
          totalCount
          disconnectedCount
          onlineCount
        }
      }
      resources {
        id
      }
    }
    actionBatches {
      id
      name
      order
      windowDuration
      skipWindow
      executionPolicy
      startTime
      status
      actions {
        id
        action {
          ... on Action {
            id
            name
            type
            color
          }
          ... on SystemAction {
            id
            name
            version
            color
          }
        }
        inputParameters {
          key
          value
        }
        name
        actionName
        type
        order
        scope
        executionPolicy
        windowDuration
        skipWindow
        runInSequence
        resourcesFailed
        resourcesNotCompleted
        resourcesSucceeded
        errorCodeCounts {
          errorCode
          count
        }
        resourceGroups {
          id
          name
          description
          resourcesCounts {
            totalCount
            disconnectedCount
            onlineCount
          }
        }
        resources {
          id
        }
        globalState {
          status
          estimatedStartTime
          startTime
          endTime
          outputUri
        }
        attempts {
          id
          attempt
          state {
            eventId
            eventActionId
            status
            outputUri
            estimatedStartTime
            startTime
            endTime
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
          }
        }
      }
    }
    changeDetails {
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
  ${ActionPropertiesFragmentDoc}
  ${SystemActionPropertiesFragmentDoc}
`;
export const BatchActionFragmentDoc = gql`
  fragment BatchAction on BatchedEventAction {
    id
    action {
      ... on Action {
        id
        name
        type
        color
      }
      ... on SystemAction {
        id
        name
        version
        color
      }
    }
    inputParameters {
      key
      value
    }
    name
    actionName
    type
    order
    resourceGroups {
      id
      name
      description
      resourcesCounts {
        totalCount
        disconnectedCount
        onlineCount
      }
    }
    resources {
      id
    }
    globalState {
      status
      estimatedStartTime
      startTime
      endTime
      outputUri
    }
    resourceStates {
      id
      eventActionId
      resourceId
      resourceGroupId
      resource {
        id
        name
        description
        os {
          type
          subType
        }
        autoDiscovery
        cloudResourceId
        fullCloudResourceId
        enabled
        provider
        providerId
        region
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        scanned
      }
      resourceGroup {
        id
        name
        description
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        resourcesCounts {
          totalCount
          disconnectedCount
          onlineCount
        }
      }
      order
      status
      outputUri
      output {
        key
        value
      }
      annotation
      changeDetails {
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;
export const BatchActionsFragmentDoc = gql`
  fragment BatchActions on EventActionBatch {
    actions {
      ...BatchAction
    }
  }
  ${BatchActionFragmentDoc}
`;
export const EventActionBatchFragmentDoc = gql`
  fragment EventActionBatch on EventActionBatch {
    id
    name
    order
    windowDuration
    skipWindow
    executionPolicy
    ...BatchActions
    startTime
    status
  }
  ${BatchActionsFragmentDoc}
`;
export const ActionBatchesFragmentDoc = gql`
  fragment ActionBatches on Event {
    actionBatches {
      ...EventActionBatch
    }
  }
  ${EventActionBatchFragmentDoc}
`;
export const EventActionFragmentDoc = gql`
  fragment EventAction on EventAction {
    id
    action {
      ... on Action {
        id
        name
        type
        color
        description
      }
      ... on SystemAction {
        id
        name
        version
        color
        description
      }
    }
    name
    type
    scope
    order
    windowDuration
    skipWindow
    executionPolicy
    resourceGroups {
      id
      name
      description
      resourcesCounts {
        totalCount
        disconnectedCount
        onlineCount
      }
    }
    resources {
      id
    }
    globalState {
      status
      estimatedStartTime
      startTime
      endTime
      outputUri
    }
    resourceStates {
      id
      resourceGroupId
      resource {
        id
        name
      }
      resourceGroup {
        id
        name
      }
      order
      status
      outputUri
      output {
        key
        value
      }
      changeDetails {
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;
export const EventActionsFragmentDoc = gql`
  fragment EventActions on Event {
    actions {
      ...EventAction
    }
  }
  ${EventActionFragmentDoc}
`;
export const EventDetailResourceGroupFragmentDoc = gql`
  fragment EventDetailResourceGroup on Group {
    id
    name
  }
`;
export const EventActionDefinitionFragmentDoc = gql`
  fragment EventActionDefinition on Action {
    id
    name
    color
    type
    scope
    description
  }
`;
export const EventSystemActionDefinitionFragmentDoc = gql`
  fragment EventSystemActionDefinition on SystemAction {
    id
    name
    color
    scope
    description
    version
  }
`;
export const EventDetailResourceFragmentDoc = gql`
  fragment EventDetailResource on Resource {
    id
    name
    os {
      type
      subType
    }
  }
`;
export const IncomingEventDetailPlanBatchActionFragmentDoc = gql`
  fragment IncomingEventDetailPlanBatchAction on BatchAction {
    __typename
    id
    name
    order
    resourceGroups {
      id
      name
    }
    action {
      ... on Action {
        ...EventActionDefinition
      }
      ... on SystemAction {
        ...EventSystemActionDefinition
      }
    }
    resources {
      ... on Resource {
        ...EventDetailResource
      }
    }
    inputParameters {
      key
      value
    }
  }
  ${EventActionDefinitionFragmentDoc}
  ${EventSystemActionDefinitionFragmentDoc}
  ${EventDetailResourceFragmentDoc}
`;
export const IncomingEventDetailPlanActionBatchFragmentDoc = gql`
  fragment IncomingEventDetailPlanActionBatch on PlanActionBatch {
    __typename
    id
    name
    order
    windowDuration
    skipWindow
    executionPolicy
    batchActions {
      ...IncomingEventDetailPlanBatchAction
    }
  }
  ${IncomingEventDetailPlanBatchActionFragmentDoc}
`;
export const IncomingEventsListPlanActionFragmentDoc = gql`
  fragment IncomingEventsListPlanAction on PlanAction {
    id
    name
    order
    resourceGroups {
      resourcesCounts {
        totalCount
        disconnectedCount
        onlineCount
      }
    }
    action {
      ... on Action {
        name
      }
      ... on SystemAction {
        name
      }
    }
  }
`;
export const IncomingEventsListBatchActionFragmentDoc = gql`
  fragment IncomingEventsListBatchAction on BatchAction {
    id
    order
    name
    resourceGroups {
      resourcesCounts {
        totalCount
        disconnectedCount
        onlineCount
      }
    }
    resources {
      id
    }
    action {
      ... on Action {
        name
      }
      ... on SystemAction {
        name
      }
    }
  }
`;
export const IncomingEventsListPlanActionBatchFragmentDoc = gql`
  fragment IncomingEventsListPlanActionBatch on PlanActionBatch {
    name
    order
    batchActions {
      ...IncomingEventsListBatchAction
    }
  }
  ${IncomingEventsListBatchActionFragmentDoc}
`;
export const ResourceFragmentDoc = gql`
  fragment Resource on Resource {
    name
    id
    provider
    scanned
    region
    providerId
    os {
      type
      subType
      version
    }
    access {
      ... on SSMAccess {
        instanceId
      }
    }
    state {
      status
      ssmMetadata {
        key
        value
      }
      updatedAt
    }
  }
`;
export const ResourcePageFragmentDoc = gql`
  fragment ResourcePage on ResourcesPage {
    result {
      ...Resource
    }
    pageInfo {
      pages
      count
    }
  }
  ${ResourceFragmentDoc}
`;
export const CloudResourceReportResultFragmentDoc = gql`
  fragment CloudResourceReportResult on CloudResourceReport {
    id
    name
    status
    dateGenerated
    url
    changeDetails {
      createdAt
      createdBy
    }
  }
`;
export const CloudResourcePageFragmentDoc = gql`
  fragment CloudResourcePage on CloudResource {
    id
    provider
    region
    type
    subtype
    name
    cloudResourceId
    fullCloudResourceId
    providerId
    parentId
    tags {
      key
      value
    }
    cloudMetadata {
      key
      value
    }
    cloudAccount {
      id
      name
    }
    lastPatching {
      status
      date
    }
  }
`;
export const CustomerDocument = gql`
  query Customer {
    customers {
      id
      name
      organizationName
    }
  }
`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(
    CustomerDocument,
    options
  );
}
export function useCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerQuery,
    CustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(
    CustomerDocument,
    options
  );
}
// @ts-ignore
export function useCustomerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CustomerQuery,
    CustomerQueryVariables
  >
): Apollo.UseSuspenseQueryResult<CustomerQuery, CustomerQueryVariables>;
export function useCustomerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>
): Apollo.UseSuspenseQueryResult<
  CustomerQuery | undefined,
  CustomerQueryVariables
>;
export function useCustomerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CustomerQuery, CustomerQueryVariables>(
    CustomerDocument,
    options
  );
}
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<
  typeof useCustomerLazyQuery
>;
export type CustomerSuspenseQueryHookResult = ReturnType<
  typeof useCustomerSuspenseQuery
>;
export type CustomerQueryResult = Apollo.QueryResult<
  CustomerQuery,
  CustomerQueryVariables
>;
export const GetAvailableEventActionNamesDocument = gql`
  query getAvailableEventActionNames {
    availableEventActionNames
  }
`;

/**
 * __useGetAvailableEventActionNamesQuery__
 *
 * To run a query within a React component, call `useGetAvailableEventActionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableEventActionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableEventActionNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableEventActionNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAvailableEventActionNamesQuery,
    GetAvailableEventActionNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableEventActionNamesQuery,
    GetAvailableEventActionNamesQueryVariables
  >(GetAvailableEventActionNamesDocument, options);
}
export function useGetAvailableEventActionNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableEventActionNamesQuery,
    GetAvailableEventActionNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableEventActionNamesQuery,
    GetAvailableEventActionNamesQueryVariables
  >(GetAvailableEventActionNamesDocument, options);
}
// @ts-ignore
export function useGetAvailableEventActionNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailableEventActionNamesQuery,
    GetAvailableEventActionNamesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAvailableEventActionNamesQuery,
  GetAvailableEventActionNamesQueryVariables
>;
export function useGetAvailableEventActionNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableEventActionNamesQuery,
        GetAvailableEventActionNamesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAvailableEventActionNamesQuery | undefined,
  GetAvailableEventActionNamesQueryVariables
>;
export function useGetAvailableEventActionNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableEventActionNamesQuery,
        GetAvailableEventActionNamesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvailableEventActionNamesQuery,
    GetAvailableEventActionNamesQueryVariables
  >(GetAvailableEventActionNamesDocument, options);
}
export type GetAvailableEventActionNamesQueryHookResult = ReturnType<
  typeof useGetAvailableEventActionNamesQuery
>;
export type GetAvailableEventActionNamesLazyQueryHookResult = ReturnType<
  typeof useGetAvailableEventActionNamesLazyQuery
>;
export type GetAvailableEventActionNamesSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailableEventActionNamesSuspenseQuery
>;
export type GetAvailableEventActionNamesQueryResult = Apollo.QueryResult<
  GetAvailableEventActionNamesQuery,
  GetAvailableEventActionNamesQueryVariables
>;
export const GetAvailablePlanActionNamesDocument = gql`
  query getAvailablePlanActionNames {
    availablePlanActionNames
  }
`;

/**
 * __useGetAvailablePlanActionNamesQuery__
 *
 * To run a query within a React component, call `useGetAvailablePlanActionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePlanActionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailablePlanActionNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailablePlanActionNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAvailablePlanActionNamesQuery,
    GetAvailablePlanActionNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailablePlanActionNamesQuery,
    GetAvailablePlanActionNamesQueryVariables
  >(GetAvailablePlanActionNamesDocument, options);
}
export function useGetAvailablePlanActionNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailablePlanActionNamesQuery,
    GetAvailablePlanActionNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailablePlanActionNamesQuery,
    GetAvailablePlanActionNamesQueryVariables
  >(GetAvailablePlanActionNamesDocument, options);
}
// @ts-ignore
export function useGetAvailablePlanActionNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailablePlanActionNamesQuery,
    GetAvailablePlanActionNamesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAvailablePlanActionNamesQuery,
  GetAvailablePlanActionNamesQueryVariables
>;
export function useGetAvailablePlanActionNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailablePlanActionNamesQuery,
        GetAvailablePlanActionNamesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAvailablePlanActionNamesQuery | undefined,
  GetAvailablePlanActionNamesQueryVariables
>;
export function useGetAvailablePlanActionNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailablePlanActionNamesQuery,
        GetAvailablePlanActionNamesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvailablePlanActionNamesQuery,
    GetAvailablePlanActionNamesQueryVariables
  >(GetAvailablePlanActionNamesDocument, options);
}
export type GetAvailablePlanActionNamesQueryHookResult = ReturnType<
  typeof useGetAvailablePlanActionNamesQuery
>;
export type GetAvailablePlanActionNamesLazyQueryHookResult = ReturnType<
  typeof useGetAvailablePlanActionNamesLazyQuery
>;
export type GetAvailablePlanActionNamesSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailablePlanActionNamesSuspenseQuery
>;
export type GetAvailablePlanActionNamesQueryResult = Apollo.QueryResult<
  GetAvailablePlanActionNamesQuery,
  GetAvailablePlanActionNamesQueryVariables
>;
export const AwsOnboardingTemplateDocument = gql`
  query awsOnboardingTemplate {
    awsOnboardingTemplate
  }
`;

/**
 * __useAwsOnboardingTemplateQuery__
 *
 * To run a query within a React component, call `useAwsOnboardingTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsOnboardingTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsOnboardingTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwsOnboardingTemplateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AwsOnboardingTemplateQuery,
    AwsOnboardingTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AwsOnboardingTemplateQuery,
    AwsOnboardingTemplateQueryVariables
  >(AwsOnboardingTemplateDocument, options);
}
export function useAwsOnboardingTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AwsOnboardingTemplateQuery,
    AwsOnboardingTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AwsOnboardingTemplateQuery,
    AwsOnboardingTemplateQueryVariables
  >(AwsOnboardingTemplateDocument, options);
}
// @ts-ignore
export function useAwsOnboardingTemplateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AwsOnboardingTemplateQuery,
    AwsOnboardingTemplateQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AwsOnboardingTemplateQuery,
  AwsOnboardingTemplateQueryVariables
>;
export function useAwsOnboardingTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AwsOnboardingTemplateQuery,
        AwsOnboardingTemplateQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AwsOnboardingTemplateQuery | undefined,
  AwsOnboardingTemplateQueryVariables
>;
export function useAwsOnboardingTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AwsOnboardingTemplateQuery,
        AwsOnboardingTemplateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AwsOnboardingTemplateQuery,
    AwsOnboardingTemplateQueryVariables
  >(AwsOnboardingTemplateDocument, options);
}
export type AwsOnboardingTemplateQueryHookResult = ReturnType<
  typeof useAwsOnboardingTemplateQuery
>;
export type AwsOnboardingTemplateLazyQueryHookResult = ReturnType<
  typeof useAwsOnboardingTemplateLazyQuery
>;
export type AwsOnboardingTemplateSuspenseQueryHookResult = ReturnType<
  typeof useAwsOnboardingTemplateSuspenseQuery
>;
export type AwsOnboardingTemplateQueryResult = Apollo.QueryResult<
  AwsOnboardingTemplateQuery,
  AwsOnboardingTemplateQueryVariables
>;
export const AzureOnboardingScriptDocument = gql`
  query azureOnboardingScript($subscriptionId: UUID!) {
    azureOnboardingScript(subscriptionId: $subscriptionId)
  }
`;

/**
 * __useAzureOnboardingScriptQuery__
 *
 * To run a query within a React component, call `useAzureOnboardingScriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureOnboardingScriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureOnboardingScriptQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useAzureOnboardingScriptQuery(
  baseOptions: Apollo.QueryHookOptions<
    AzureOnboardingScriptQuery,
    AzureOnboardingScriptQueryVariables
  > &
    (
      | { variables: AzureOnboardingScriptQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AzureOnboardingScriptQuery,
    AzureOnboardingScriptQueryVariables
  >(AzureOnboardingScriptDocument, options);
}
export function useAzureOnboardingScriptLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AzureOnboardingScriptQuery,
    AzureOnboardingScriptQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AzureOnboardingScriptQuery,
    AzureOnboardingScriptQueryVariables
  >(AzureOnboardingScriptDocument, options);
}
// @ts-ignore
export function useAzureOnboardingScriptSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AzureOnboardingScriptQuery,
    AzureOnboardingScriptQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AzureOnboardingScriptQuery,
  AzureOnboardingScriptQueryVariables
>;
export function useAzureOnboardingScriptSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AzureOnboardingScriptQuery,
        AzureOnboardingScriptQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AzureOnboardingScriptQuery | undefined,
  AzureOnboardingScriptQueryVariables
>;
export function useAzureOnboardingScriptSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AzureOnboardingScriptQuery,
        AzureOnboardingScriptQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AzureOnboardingScriptQuery,
    AzureOnboardingScriptQueryVariables
  >(AzureOnboardingScriptDocument, options);
}
export type AzureOnboardingScriptQueryHookResult = ReturnType<
  typeof useAzureOnboardingScriptQuery
>;
export type AzureOnboardingScriptLazyQueryHookResult = ReturnType<
  typeof useAzureOnboardingScriptLazyQuery
>;
export type AzureOnboardingScriptSuspenseQueryHookResult = ReturnType<
  typeof useAzureOnboardingScriptSuspenseQuery
>;
export type AzureOnboardingScriptQueryResult = Apollo.QueryResult<
  AzureOnboardingScriptQuery,
  AzureOnboardingScriptQueryVariables
>;
export const CreateCloudAccountDocument = gql`
  mutation createCloudAccount($input: CreateCloudAccountInput!) {
    createCloudAccount(input: $input) {
      id
    }
  }
`;
export type CreateCloudAccountMutationFn = Apollo.MutationFunction<
  CreateCloudAccountMutation,
  CreateCloudAccountMutationVariables
>;

/**
 * __useCreateCloudAccountMutation__
 *
 * To run a mutation, you first call `useCreateCloudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCloudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCloudAccountMutation, { data, loading, error }] = useCreateCloudAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCloudAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCloudAccountMutation,
    CreateCloudAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCloudAccountMutation,
    CreateCloudAccountMutationVariables
  >(CreateCloudAccountDocument, options);
}
export type CreateCloudAccountMutationHookResult = ReturnType<
  typeof useCreateCloudAccountMutation
>;
export type CreateCloudAccountMutationResult =
  Apollo.MutationResult<CreateCloudAccountMutation>;
export type CreateCloudAccountMutationOptions = Apollo.BaseMutationOptions<
  CreateCloudAccountMutation,
  CreateCloudAccountMutationVariables
>;
export const DeleteCloudAccountDocument = gql`
  mutation deleteCloudAccount($removeCloudAccountId: UUID!) {
    removeCloudAccount(id: $removeCloudAccountId)
  }
`;
export type DeleteCloudAccountMutationFn = Apollo.MutationFunction<
  DeleteCloudAccountMutation,
  DeleteCloudAccountMutationVariables
>;

/**
 * __useDeleteCloudAccountMutation__
 *
 * To run a mutation, you first call `useDeleteCloudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCloudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCloudAccountMutation, { data, loading, error }] = useDeleteCloudAccountMutation({
 *   variables: {
 *      removeCloudAccountId: // value for 'removeCloudAccountId'
 *   },
 * });
 */
export function useDeleteCloudAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCloudAccountMutation,
    DeleteCloudAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCloudAccountMutation,
    DeleteCloudAccountMutationVariables
  >(DeleteCloudAccountDocument, options);
}
export type DeleteCloudAccountMutationHookResult = ReturnType<
  typeof useDeleteCloudAccountMutation
>;
export type DeleteCloudAccountMutationResult =
  Apollo.MutationResult<DeleteCloudAccountMutation>;
export type DeleteCloudAccountMutationOptions = Apollo.BaseMutationOptions<
  DeleteCloudAccountMutation,
  DeleteCloudAccountMutationVariables
>;
export const GetCloudAccountDocument = gql`
  query getCloudAccount($cloudAccountId: UUID!) {
    cloudAccount(id: $cloudAccountId) {
      id
      name
      description
      provider
      providerId
      environment
      status
      lastScanStartDate
      lastScanEndDate
      regions
      resourceDiscoveryEnabled
      resourceCleanerEnabled
      metadata {
        key
        value
      }
      regionsStatuses {
        region
        status
        details
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

/**
 * __useGetCloudAccountQuery__
 *
 * To run a query within a React component, call `useGetCloudAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudAccountQuery({
 *   variables: {
 *      cloudAccountId: // value for 'cloudAccountId'
 *   },
 * });
 */
export function useGetCloudAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCloudAccountQuery,
    GetCloudAccountQueryVariables
  > &
    (
      | { variables: GetCloudAccountQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCloudAccountQuery, GetCloudAccountQueryVariables>(
    GetCloudAccountDocument,
    options
  );
}
export function useGetCloudAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCloudAccountQuery,
    GetCloudAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCloudAccountQuery,
    GetCloudAccountQueryVariables
  >(GetCloudAccountDocument, options);
}
// @ts-ignore
export function useGetCloudAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCloudAccountQuery,
    GetCloudAccountQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCloudAccountQuery,
  GetCloudAccountQueryVariables
>;
export function useGetCloudAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudAccountQuery,
        GetCloudAccountQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCloudAccountQuery | undefined,
  GetCloudAccountQueryVariables
>;
export function useGetCloudAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudAccountQuery,
        GetCloudAccountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCloudAccountQuery,
    GetCloudAccountQueryVariables
  >(GetCloudAccountDocument, options);
}
export type GetCloudAccountQueryHookResult = ReturnType<
  typeof useGetCloudAccountQuery
>;
export type GetCloudAccountLazyQueryHookResult = ReturnType<
  typeof useGetCloudAccountLazyQuery
>;
export type GetCloudAccountSuspenseQueryHookResult = ReturnType<
  typeof useGetCloudAccountSuspenseQuery
>;
export type GetCloudAccountQueryResult = Apollo.QueryResult<
  GetCloudAccountQuery,
  GetCloudAccountQueryVariables
>;
export const GetCloudAccountsDocument = gql`
  query getCloudAccounts(
    $limit: Int!
    $page: Int!
    $sort: CloudAccountsSortInput
    $filter: CloudAccountsSearchInput
  ) {
    cloudAccounts(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        name
        id
        provider
        environment
        status
        providerId
        changeDetails {
          createdAt
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetCloudAccountsQuery__
 *
 * To run a query within a React component, call `useGetCloudAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudAccountsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCloudAccountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCloudAccountsQuery,
    GetCloudAccountsQueryVariables
  > &
    (
      | { variables: GetCloudAccountsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCloudAccountsQuery, GetCloudAccountsQueryVariables>(
    GetCloudAccountsDocument,
    options
  );
}
export function useGetCloudAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCloudAccountsQuery,
    GetCloudAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCloudAccountsQuery,
    GetCloudAccountsQueryVariables
  >(GetCloudAccountsDocument, options);
}
// @ts-ignore
export function useGetCloudAccountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCloudAccountsQuery,
    GetCloudAccountsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCloudAccountsQuery,
  GetCloudAccountsQueryVariables
>;
export function useGetCloudAccountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudAccountsQuery,
        GetCloudAccountsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCloudAccountsQuery | undefined,
  GetCloudAccountsQueryVariables
>;
export function useGetCloudAccountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudAccountsQuery,
        GetCloudAccountsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCloudAccountsQuery,
    GetCloudAccountsQueryVariables
  >(GetCloudAccountsDocument, options);
}
export type GetCloudAccountsQueryHookResult = ReturnType<
  typeof useGetCloudAccountsQuery
>;
export type GetCloudAccountsLazyQueryHookResult = ReturnType<
  typeof useGetCloudAccountsLazyQuery
>;
export type GetCloudAccountsSuspenseQueryHookResult = ReturnType<
  typeof useGetCloudAccountsSuspenseQuery
>;
export type GetCloudAccountsQueryResult = Apollo.QueryResult<
  GetCloudAccountsQuery,
  GetCloudAccountsQueryVariables
>;
export const ScanCloudAccountDocument = gql`
  mutation scanCloudAccount($id: UUID!) {
    scanCloudAccount(id: $id)
  }
`;
export type ScanCloudAccountMutationFn = Apollo.MutationFunction<
  ScanCloudAccountMutation,
  ScanCloudAccountMutationVariables
>;

/**
 * __useScanCloudAccountMutation__
 *
 * To run a mutation, you first call `useScanCloudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScanCloudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scanCloudAccountMutation, { data, loading, error }] = useScanCloudAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScanCloudAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ScanCloudAccountMutation,
    ScanCloudAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ScanCloudAccountMutation,
    ScanCloudAccountMutationVariables
  >(ScanCloudAccountDocument, options);
}
export type ScanCloudAccountMutationHookResult = ReturnType<
  typeof useScanCloudAccountMutation
>;
export type ScanCloudAccountMutationResult =
  Apollo.MutationResult<ScanCloudAccountMutation>;
export type ScanCloudAccountMutationOptions = Apollo.BaseMutationOptions<
  ScanCloudAccountMutation,
  ScanCloudAccountMutationVariables
>;
export const UpdateCloudAccountDocument = gql`
  mutation updateCloudAccount($input: UpdateCloudAccountInput!) {
    updateCloudAccount(input: $input) {
      id
      name
      description
      environment
      regionsStatuses {
        region
        status
        details
      }
      changeDetails {
        updatedAt
        updatedBy
      }
    }
  }
`;
export type UpdateCloudAccountMutationFn = Apollo.MutationFunction<
  UpdateCloudAccountMutation,
  UpdateCloudAccountMutationVariables
>;

/**
 * __useUpdateCloudAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCloudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCloudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCloudAccountMutation, { data, loading, error }] = useUpdateCloudAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCloudAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCloudAccountMutation,
    UpdateCloudAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCloudAccountMutation,
    UpdateCloudAccountMutationVariables
  >(UpdateCloudAccountDocument, options);
}
export type UpdateCloudAccountMutationHookResult = ReturnType<
  typeof useUpdateCloudAccountMutation
>;
export type UpdateCloudAccountMutationResult =
  Apollo.MutationResult<UpdateCloudAccountMutation>;
export type UpdateCloudAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateCloudAccountMutation,
  UpdateCloudAccountMutationVariables
>;
export const CreateApplicationDocument = gql`
  mutation createApplication($input: CreateApplicationInput!) {
    createApplication(input: $input) {
      id
      name
      displayName
      description
      owner
      contacts
      metadata {
        key
        value
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
export type CreateApplicationMutationFn = Apollo.MutationFunction<
  CreateApplicationMutation,
  CreateApplicationMutationVariables
>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateApplicationMutation,
    CreateApplicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateApplicationMutation,
    CreateApplicationMutationVariables
  >(CreateApplicationDocument, options);
}
export type CreateApplicationMutationHookResult = ReturnType<
  typeof useCreateApplicationMutation
>;
export type CreateApplicationMutationResult =
  Apollo.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<
  CreateApplicationMutation,
  CreateApplicationMutationVariables
>;
export const DeleteApplicationDocument = gql`
  mutation deleteApplication($input: DeleteApplicationInput!) {
    deleteApplication(input: $input)
  }
`;
export type DeleteApplicationMutationFn = Apollo.MutationFunction<
  DeleteApplicationMutation,
  DeleteApplicationMutationVariables
>;

/**
 * __useDeleteApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApplicationMutation, { data, loading, error }] = useDeleteApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteApplicationMutation,
    DeleteApplicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteApplicationMutation,
    DeleteApplicationMutationVariables
  >(DeleteApplicationDocument, options);
}
export type DeleteApplicationMutationHookResult = ReturnType<
  typeof useDeleteApplicationMutation
>;
export type DeleteApplicationMutationResult =
  Apollo.MutationResult<DeleteApplicationMutation>;
export type DeleteApplicationMutationOptions = Apollo.BaseMutationOptions<
  DeleteApplicationMutation,
  DeleteApplicationMutationVariables
>;
export const GetApplicationDocument = gql`
  query getApplication($id: UUID!) {
    application(id: $id) {
      id
      name
      displayName
      description
      owner
      contacts
      metadata {
        key
        value
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

/**
 * __useGetApplicationQuery__
 *
 * To run a query within a React component, call `useGetApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetApplicationQuery,
    GetApplicationQueryVariables
  > &
    (
      | { variables: GetApplicationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetApplicationQuery, GetApplicationQueryVariables>(
    GetApplicationDocument,
    options
  );
}
export function useGetApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetApplicationQuery,
    GetApplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetApplicationQuery, GetApplicationQueryVariables>(
    GetApplicationDocument,
    options
  );
}
// @ts-ignore
export function useGetApplicationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetApplicationQuery,
    GetApplicationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetApplicationQuery,
  GetApplicationQueryVariables
>;
export function useGetApplicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetApplicationQuery,
        GetApplicationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetApplicationQuery | undefined,
  GetApplicationQueryVariables
>;
export function useGetApplicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetApplicationQuery,
        GetApplicationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetApplicationQuery,
    GetApplicationQueryVariables
  >(GetApplicationDocument, options);
}
export type GetApplicationQueryHookResult = ReturnType<
  typeof useGetApplicationQuery
>;
export type GetApplicationLazyQueryHookResult = ReturnType<
  typeof useGetApplicationLazyQuery
>;
export type GetApplicationSuspenseQueryHookResult = ReturnType<
  typeof useGetApplicationSuspenseQuery
>;
export type GetApplicationQueryResult = Apollo.QueryResult<
  GetApplicationQuery,
  GetApplicationQueryVariables
>;
export const GetApplicationsDocument = gql`
  query getApplications(
    $page: Int
    $limit: Int
    $sort: ApplicationsSortInput
    $filter: ApplicationsFilterInput
  ) {
    applications(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      pageInfo {
        count
        pages
      }
      result {
        id
        name
        displayName
        description
        owner
        contacts
        metadata {
          key
          value
        }
        environments {
          id
          name
          displayName
          resourceCount
        }
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
    }
  }
`;

/**
 * __useGetApplicationsQuery__
 *
 * To run a query within a React component, call `useGetApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetApplicationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetApplicationsQuery,
    GetApplicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(
    GetApplicationsDocument,
    options
  );
}
export function useGetApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetApplicationsQuery,
    GetApplicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetApplicationsQuery,
    GetApplicationsQueryVariables
  >(GetApplicationsDocument, options);
}
// @ts-ignore
export function useGetApplicationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetApplicationsQuery,
    GetApplicationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetApplicationsQuery,
  GetApplicationsQueryVariables
>;
export function useGetApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetApplicationsQuery,
        GetApplicationsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetApplicationsQuery | undefined,
  GetApplicationsQueryVariables
>;
export function useGetApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetApplicationsQuery,
        GetApplicationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetApplicationsQuery,
    GetApplicationsQueryVariables
  >(GetApplicationsDocument, options);
}
export type GetApplicationsQueryHookResult = ReturnType<
  typeof useGetApplicationsQuery
>;
export type GetApplicationsLazyQueryHookResult = ReturnType<
  typeof useGetApplicationsLazyQuery
>;
export type GetApplicationsSuspenseQueryHookResult = ReturnType<
  typeof useGetApplicationsSuspenseQuery
>;
export type GetApplicationsQueryResult = Apollo.QueryResult<
  GetApplicationsQuery,
  GetApplicationsQueryVariables
>;
export const UpdateApplicationDocument = gql`
  mutation updateApplication($input: UpdateApplicationInput!) {
    updateApplication(input: $input) {
      id
      name
      displayName
      description
      owner
      contacts
      metadata {
        key
        value
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
export type UpdateApplicationMutationFn = Apollo.MutationFunction<
  UpdateApplicationMutation,
  UpdateApplicationMutationVariables
>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateApplicationMutation,
    UpdateApplicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateApplicationMutation,
    UpdateApplicationMutationVariables
  >(UpdateApplicationDocument, options);
}
export type UpdateApplicationMutationHookResult = ReturnType<
  typeof useUpdateApplicationMutation
>;
export type UpdateApplicationMutationResult =
  Apollo.MutationResult<UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = Apollo.BaseMutationOptions<
  UpdateApplicationMutation,
  UpdateApplicationMutationVariables
>;
export const CreateCustomActionDocument = gql`
  mutation createCustomAction($input: CreateActionInput!) {
    createAction(input: $input) {
      id
      name
      description
      color
      type
      scope
    }
  }
`;
export type CreateCustomActionMutationFn = Apollo.MutationFunction<
  CreateCustomActionMutation,
  CreateCustomActionMutationVariables
>;

/**
 * __useCreateCustomActionMutation__
 *
 * To run a mutation, you first call `useCreateCustomActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomActionMutation, { data, loading, error }] = useCreateCustomActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomActionMutation,
    CreateCustomActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomActionMutation,
    CreateCustomActionMutationVariables
  >(CreateCustomActionDocument, options);
}
export type CreateCustomActionMutationHookResult = ReturnType<
  typeof useCreateCustomActionMutation
>;
export type CreateCustomActionMutationResult =
  Apollo.MutationResult<CreateCustomActionMutation>;
export type CreateCustomActionMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomActionMutation,
  CreateCustomActionMutationVariables
>;
export const DeleteCustomActionDocument = gql`
  mutation deleteCustomAction($id: UUID!) {
    removeAction(id: $id)
  }
`;
export type DeleteCustomActionMutationFn = Apollo.MutationFunction<
  DeleteCustomActionMutation,
  DeleteCustomActionMutationVariables
>;

/**
 * __useDeleteCustomActionMutation__
 *
 * To run a mutation, you first call `useDeleteCustomActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomActionMutation, { data, loading, error }] = useDeleteCustomActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomActionMutation,
    DeleteCustomActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomActionMutation,
    DeleteCustomActionMutationVariables
  >(DeleteCustomActionDocument, options);
}
export type DeleteCustomActionMutationHookResult = ReturnType<
  typeof useDeleteCustomActionMutation
>;
export type DeleteCustomActionMutationResult =
  Apollo.MutationResult<DeleteCustomActionMutation>;
export type DeleteCustomActionMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomActionMutation,
  DeleteCustomActionMutationVariables
>;
export const GetCustomActionDocument = gql`
  query getCustomAction($customActionId: UUID!) {
    action(id: $customActionId) {
      id
      name
      description
      color
      type
      scope
      typeProperties {
        __typename
        ... on ActionPropertyAWSLambda {
          lambdaArn
        }
        ... on ActionPropertyAzureFunction {
          accessKeyId
          functionMethod
          functionUrl
        }
        ... on ActionPropertyScript {
          s3FileUrl
        }
        ... on ActionPropertySSMDocument {
          documentId
        }
        ... on ActionPropertyWebhook {
          webhookUrl
          webhookMethod
          payload
          headers {
            key
            value
          }
        }
      }
    }
  }
`;

/**
 * __useGetCustomActionQuery__
 *
 * To run a query within a React component, call `useGetCustomActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomActionQuery({
 *   variables: {
 *      customActionId: // value for 'customActionId'
 *   },
 * });
 */
export function useGetCustomActionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomActionQuery,
    GetCustomActionQueryVariables
  > &
    (
      | { variables: GetCustomActionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomActionQuery, GetCustomActionQueryVariables>(
    GetCustomActionDocument,
    options
  );
}
export function useGetCustomActionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomActionQuery,
    GetCustomActionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomActionQuery,
    GetCustomActionQueryVariables
  >(GetCustomActionDocument, options);
}
// @ts-ignore
export function useGetCustomActionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCustomActionQuery,
    GetCustomActionQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCustomActionQuery,
  GetCustomActionQueryVariables
>;
export function useGetCustomActionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomActionQuery,
        GetCustomActionQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCustomActionQuery | undefined,
  GetCustomActionQueryVariables
>;
export function useGetCustomActionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomActionQuery,
        GetCustomActionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomActionQuery,
    GetCustomActionQueryVariables
  >(GetCustomActionDocument, options);
}
export type GetCustomActionQueryHookResult = ReturnType<
  typeof useGetCustomActionQuery
>;
export type GetCustomActionLazyQueryHookResult = ReturnType<
  typeof useGetCustomActionLazyQuery
>;
export type GetCustomActionSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomActionSuspenseQuery
>;
export type GetCustomActionQueryResult = Apollo.QueryResult<
  GetCustomActionQuery,
  GetCustomActionQueryVariables
>;
export const GetCustomActionsDocument = gql`
  query getCustomActions(
    $page: Int
    $limit: Int
    $sort: ActionSortInput
    $filter: ActionFilterInput
  ) {
    actions(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
        color
        description
        scope
        type
        synchronous
        changeDetails {
          createdAt
          updatedAt
          updatedBy
          createdBy
        }
        parameterDefinitions {
          name
          required
          description
          allowedValues
          defaultValue
          type
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetCustomActionsQuery__
 *
 * To run a query within a React component, call `useGetCustomActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomActionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomActionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomActionsQuery,
    GetCustomActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomActionsQuery, GetCustomActionsQueryVariables>(
    GetCustomActionsDocument,
    options
  );
}
export function useGetCustomActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomActionsQuery,
    GetCustomActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomActionsQuery,
    GetCustomActionsQueryVariables
  >(GetCustomActionsDocument, options);
}
// @ts-ignore
export function useGetCustomActionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCustomActionsQuery,
    GetCustomActionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCustomActionsQuery,
  GetCustomActionsQueryVariables
>;
export function useGetCustomActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomActionsQuery,
        GetCustomActionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCustomActionsQuery | undefined,
  GetCustomActionsQueryVariables
>;
export function useGetCustomActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomActionsQuery,
        GetCustomActionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomActionsQuery,
    GetCustomActionsQueryVariables
  >(GetCustomActionsDocument, options);
}
export type GetCustomActionsQueryHookResult = ReturnType<
  typeof useGetCustomActionsQuery
>;
export type GetCustomActionsLazyQueryHookResult = ReturnType<
  typeof useGetCustomActionsLazyQuery
>;
export type GetCustomActionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomActionsSuspenseQuery
>;
export type GetCustomActionsQueryResult = Apollo.QueryResult<
  GetCustomActionsQuery,
  GetCustomActionsQueryVariables
>;
export const GetCustomActionPlansDocument = gql`
  query getCustomActionPlans($page: Int, $limit: Int, $sort: PlanSortInput) {
    plans(page: $page, limit: $limit, sort: $sort) {
      result {
        name
        planActions {
          action {
            ... on Action {
              name
              id
            }
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetCustomActionPlansQuery__
 *
 * To run a query within a React component, call `useGetCustomActionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomActionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomActionPlansQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCustomActionPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomActionPlansQuery,
    GetCustomActionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomActionPlansQuery,
    GetCustomActionPlansQueryVariables
  >(GetCustomActionPlansDocument, options);
}
export function useGetCustomActionPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomActionPlansQuery,
    GetCustomActionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomActionPlansQuery,
    GetCustomActionPlansQueryVariables
  >(GetCustomActionPlansDocument, options);
}
// @ts-ignore
export function useGetCustomActionPlansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCustomActionPlansQuery,
    GetCustomActionPlansQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCustomActionPlansQuery,
  GetCustomActionPlansQueryVariables
>;
export function useGetCustomActionPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomActionPlansQuery,
        GetCustomActionPlansQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCustomActionPlansQuery | undefined,
  GetCustomActionPlansQueryVariables
>;
export function useGetCustomActionPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomActionPlansQuery,
        GetCustomActionPlansQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomActionPlansQuery,
    GetCustomActionPlansQueryVariables
  >(GetCustomActionPlansDocument, options);
}
export type GetCustomActionPlansQueryHookResult = ReturnType<
  typeof useGetCustomActionPlansQuery
>;
export type GetCustomActionPlansLazyQueryHookResult = ReturnType<
  typeof useGetCustomActionPlansLazyQuery
>;
export type GetCustomActionPlansSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomActionPlansSuspenseQuery
>;
export type GetCustomActionPlansQueryResult = Apollo.QueryResult<
  GetCustomActionPlansQuery,
  GetCustomActionPlansQueryVariables
>;
export const GetScriptContentDocument = gql`
  query getScriptContent($actionId: UUID!) {
    scriptContent(actionId: $actionId)
  }
`;

/**
 * __useGetScriptContentQuery__
 *
 * To run a query within a React component, call `useGetScriptContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScriptContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScriptContentQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useGetScriptContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScriptContentQuery,
    GetScriptContentQueryVariables
  > &
    (
      | { variables: GetScriptContentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetScriptContentQuery, GetScriptContentQueryVariables>(
    GetScriptContentDocument,
    options
  );
}
export function useGetScriptContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScriptContentQuery,
    GetScriptContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScriptContentQuery,
    GetScriptContentQueryVariables
  >(GetScriptContentDocument, options);
}
// @ts-ignore
export function useGetScriptContentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetScriptContentQuery,
    GetScriptContentQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetScriptContentQuery,
  GetScriptContentQueryVariables
>;
export function useGetScriptContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetScriptContentQuery,
        GetScriptContentQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetScriptContentQuery | undefined,
  GetScriptContentQueryVariables
>;
export function useGetScriptContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetScriptContentQuery,
        GetScriptContentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetScriptContentQuery,
    GetScriptContentQueryVariables
  >(GetScriptContentDocument, options);
}
export type GetScriptContentQueryHookResult = ReturnType<
  typeof useGetScriptContentQuery
>;
export type GetScriptContentLazyQueryHookResult = ReturnType<
  typeof useGetScriptContentLazyQuery
>;
export type GetScriptContentSuspenseQueryHookResult = ReturnType<
  typeof useGetScriptContentSuspenseQuery
>;
export type GetScriptContentQueryResult = Apollo.QueryResult<
  GetScriptContentQuery,
  GetScriptContentQueryVariables
>;
export const UpdateCustomActionDocument = gql`
  mutation updateCustomAction($input: UpdateActionInput!) {
    updateAction(input: $input) {
      id
      name
      description
      type
      scope
      typeProperties {
        __typename
        ... on ActionPropertyAWSLambda {
          lambdaArn
        }
        ... on ActionPropertyAzureFunction {
          accessKeyId
          functionUrl
          functionMethod
        }
        ... on ActionPropertyScript {
          s3FileUrl
        }
        ... on ActionPropertySSMDocument {
          documentId
        }
        ... on ActionPropertyWebhook {
          webhookUrl
          webhookMethod
          payload
          headers {
            key
            value
          }
        }
      }
    }
  }
`;
export type UpdateCustomActionMutationFn = Apollo.MutationFunction<
  UpdateCustomActionMutation,
  UpdateCustomActionMutationVariables
>;

/**
 * __useUpdateCustomActionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomActionMutation, { data, loading, error }] = useUpdateCustomActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomActionMutation,
    UpdateCustomActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomActionMutation,
    UpdateCustomActionMutationVariables
  >(UpdateCustomActionDocument, options);
}
export type UpdateCustomActionMutationHookResult = ReturnType<
  typeof useUpdateCustomActionMutation
>;
export type UpdateCustomActionMutationResult =
  Apollo.MutationResult<UpdateCustomActionMutation>;
export type UpdateCustomActionMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomActionMutation,
  UpdateCustomActionMutationVariables
>;
export const GetEventActionReportDocument = gql`
  query getEventActionReport($eventId: UUID!, $eventActionId: UUID!) {
    eventActionReport(eventId: $eventId, eventActionId: $eventActionId) {
      eventId
      eventActionId
      name
      actionName
      status
      startTime
      endTime
      output
      resources {
        resourceId
        name
        status
        result {
          installed {
            name
            id
            version
          }
          updated {
            name
            id
            version
          }
          removed {
            name
            id
            version
          }
          available {
            name
            id
            version
          }
          failed {
            name
            id
            version
          }
          output
          outputUri
        }
      }
    }
  }
`;

/**
 * __useGetEventActionReportQuery__
 *
 * To run a query within a React component, call `useGetEventActionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventActionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventActionReportQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventActionId: // value for 'eventActionId'
 *   },
 * });
 */
export function useGetEventActionReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventActionReportQuery,
    GetEventActionReportQueryVariables
  > &
    (
      | { variables: GetEventActionReportQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventActionReportQuery,
    GetEventActionReportQueryVariables
  >(GetEventActionReportDocument, options);
}
export function useGetEventActionReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventActionReportQuery,
    GetEventActionReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventActionReportQuery,
    GetEventActionReportQueryVariables
  >(GetEventActionReportDocument, options);
}
// @ts-ignore
export function useGetEventActionReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventActionReportQuery,
    GetEventActionReportQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEventActionReportQuery,
  GetEventActionReportQueryVariables
>;
export function useGetEventActionReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionReportQuery,
        GetEventActionReportQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEventActionReportQuery | undefined,
  GetEventActionReportQueryVariables
>;
export function useGetEventActionReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionReportQuery,
        GetEventActionReportQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventActionReportQuery,
    GetEventActionReportQueryVariables
  >(GetEventActionReportDocument, options);
}
export type GetEventActionReportQueryHookResult = ReturnType<
  typeof useGetEventActionReportQuery
>;
export type GetEventActionReportLazyQueryHookResult = ReturnType<
  typeof useGetEventActionReportLazyQuery
>;
export type GetEventActionReportSuspenseQueryHookResult = ReturnType<
  typeof useGetEventActionReportSuspenseQuery
>;
export type GetEventActionReportQueryResult = Apollo.QueryResult<
  GetEventActionReportQuery,
  GetEventActionReportQueryVariables
>;
export const GetEventActionReportsDocument = gql`
  query getEventActionReports($eventId: UUID!, $eventActionId: UUID!) {
    eventActionReports(eventId: $eventId, eventActionId: $eventActionId) {
      attempt
      report {
        eventId
        eventActionId
        name
        actionName
        status
        startTime
        endTime
        output
        resources {
          resourceId
          name
          cloudResourceId
          fullCloudResourceId
          provider
          providerId
          region
          status
          result {
            installed {
              name
              id
              version
            }
            installedPendingReboot {
              name
              id
              version
              previousVersion
            }
            updated {
              name
              id
              version
              previousVersion
            }
            removed {
              name
              id
              version
            }
            available {
              name
              id
              version
            }
            failed {
              name
              id
              version
            }
            output
            outputUri
          }
        }
      }
    }
  }
`;

/**
 * __useGetEventActionReportsQuery__
 *
 * To run a query within a React component, call `useGetEventActionReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventActionReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventActionReportsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventActionId: // value for 'eventActionId'
 *   },
 * });
 */
export function useGetEventActionReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventActionReportsQuery,
    GetEventActionReportsQueryVariables
  > &
    (
      | { variables: GetEventActionReportsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventActionReportsQuery,
    GetEventActionReportsQueryVariables
  >(GetEventActionReportsDocument, options);
}
export function useGetEventActionReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventActionReportsQuery,
    GetEventActionReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventActionReportsQuery,
    GetEventActionReportsQueryVariables
  >(GetEventActionReportsDocument, options);
}
// @ts-ignore
export function useGetEventActionReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventActionReportsQuery,
    GetEventActionReportsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEventActionReportsQuery,
  GetEventActionReportsQueryVariables
>;
export function useGetEventActionReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionReportsQuery,
        GetEventActionReportsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEventActionReportsQuery | undefined,
  GetEventActionReportsQueryVariables
>;
export function useGetEventActionReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionReportsQuery,
        GetEventActionReportsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventActionReportsQuery,
    GetEventActionReportsQueryVariables
  >(GetEventActionReportsDocument, options);
}
export type GetEventActionReportsQueryHookResult = ReturnType<
  typeof useGetEventActionReportsQuery
>;
export type GetEventActionReportsLazyQueryHookResult = ReturnType<
  typeof useGetEventActionReportsLazyQuery
>;
export type GetEventActionReportsSuspenseQueryHookResult = ReturnType<
  typeof useGetEventActionReportsSuspenseQuery
>;
export type GetEventActionReportsQueryResult = Apollo.QueryResult<
  GetEventActionReportsQuery,
  GetEventActionReportsQueryVariables
>;
export const AnyEventResourceStatusChangedDocument = gql`
  subscription AnyEventResourceStatusChanged(
    $input: AnyResourceStatusChangedInput!
  ) {
    anyEventResourceStatusChanged(input: $input)
  }
`;

/**
 * __useAnyEventResourceStatusChangedSubscription__
 *
 * To run a query within a React component, call `useAnyEventResourceStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnyEventResourceStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnyEventResourceStatusChangedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnyEventResourceStatusChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AnyEventResourceStatusChangedSubscription,
    AnyEventResourceStatusChangedSubscriptionVariables
  > &
    (
      | {
          variables: AnyEventResourceStatusChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AnyEventResourceStatusChangedSubscription,
    AnyEventResourceStatusChangedSubscriptionVariables
  >(AnyEventResourceStatusChangedDocument, options);
}
export type AnyEventResourceStatusChangedSubscriptionHookResult = ReturnType<
  typeof useAnyEventResourceStatusChangedSubscription
>;
export type AnyEventResourceStatusChangedSubscriptionResult =
  Apollo.SubscriptionResult<AnyEventResourceStatusChangedSubscription>;
export const EventActionBatchStatusChangedDocument = gql`
  subscription eventActionBatchStatusChanged($input: StatusChangedInput!) {
    eventActionBatchStatusChanged(input: $input)
  }
`;

/**
 * __useEventActionBatchStatusChangedSubscription__
 *
 * To run a query within a React component, call `useEventActionBatchStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventActionBatchStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventActionBatchStatusChangedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventActionBatchStatusChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EventActionBatchStatusChangedSubscription,
    EventActionBatchStatusChangedSubscriptionVariables
  > &
    (
      | {
          variables: EventActionBatchStatusChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EventActionBatchStatusChangedSubscription,
    EventActionBatchStatusChangedSubscriptionVariables
  >(EventActionBatchStatusChangedDocument, options);
}
export type EventActionBatchStatusChangedSubscriptionHookResult = ReturnType<
  typeof useEventActionBatchStatusChangedSubscription
>;
export type EventActionBatchStatusChangedSubscriptionResult =
  Apollo.SubscriptionResult<EventActionBatchStatusChangedSubscription>;
export const EventResourceStatusChangedDocument = gql`
  subscription eventResourceStatusChanged($input: StatusChangedInput!) {
    eventResourceStatusChanged(input: $input)
  }
`;

/**
 * __useEventResourceStatusChangedSubscription__
 *
 * To run a query within a React component, call `useEventResourceStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventResourceStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventResourceStatusChangedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventResourceStatusChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EventResourceStatusChangedSubscription,
    EventResourceStatusChangedSubscriptionVariables
  > &
    (
      | {
          variables: EventResourceStatusChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EventResourceStatusChangedSubscription,
    EventResourceStatusChangedSubscriptionVariables
  >(EventResourceStatusChangedDocument, options);
}
export type EventResourceStatusChangedSubscriptionHookResult = ReturnType<
  typeof useEventResourceStatusChangedSubscription
>;
export type EventResourceStatusChangedSubscriptionResult =
  Apollo.SubscriptionResult<EventResourceStatusChangedSubscription>;
export const EventActionStatusChangedDocument = gql`
  subscription eventActionStatusChanged($input: StatusChangedInput!) {
    eventActionStatusChanged(input: $input)
  }
`;

/**
 * __useEventActionStatusChangedSubscription__
 *
 * To run a query within a React component, call `useEventActionStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventActionStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventActionStatusChangedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventActionStatusChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EventActionStatusChangedSubscription,
    EventActionStatusChangedSubscriptionVariables
  > &
    (
      | {
          variables: EventActionStatusChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EventActionStatusChangedSubscription,
    EventActionStatusChangedSubscriptionVariables
  >(EventActionStatusChangedDocument, options);
}
export type EventActionStatusChangedSubscriptionHookResult = ReturnType<
  typeof useEventActionStatusChangedSubscription
>;
export type EventActionStatusChangedSubscriptionResult =
  Apollo.SubscriptionResult<EventActionStatusChangedSubscription>;
export const EventStatusChangedDocument = gql`
  subscription eventStatusChanged($input: StatusChangedInput!) {
    eventStatusChanged(input: $input)
  }
`;

/**
 * __useEventStatusChangedSubscription__
 *
 * To run a query within a React component, call `useEventStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventStatusChangedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventStatusChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EventStatusChangedSubscription,
    EventStatusChangedSubscriptionVariables
  > &
    (
      | { variables: EventStatusChangedSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EventStatusChangedSubscription,
    EventStatusChangedSubscriptionVariables
  >(EventStatusChangedDocument, options);
}
export type EventStatusChangedSubscriptionHookResult = ReturnType<
  typeof useEventStatusChangedSubscription
>;
export type EventStatusChangedSubscriptionResult =
  Apollo.SubscriptionResult<EventStatusChangedSubscription>;
export const ApproveEventActionDocument = gql`
  mutation approveEventAction($eventId: UUID!, $actionId: UUID!) {
    approveEventAction(eventId: $eventId, eventActionId: $actionId)
  }
`;
export type ApproveEventActionMutationFn = Apollo.MutationFunction<
  ApproveEventActionMutation,
  ApproveEventActionMutationVariables
>;

/**
 * __useApproveEventActionMutation__
 *
 * To run a mutation, you first call `useApproveEventActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveEventActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveEventActionMutation, { data, loading, error }] = useApproveEventActionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useApproveEventActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveEventActionMutation,
    ApproveEventActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveEventActionMutation,
    ApproveEventActionMutationVariables
  >(ApproveEventActionDocument, options);
}
export type ApproveEventActionMutationHookResult = ReturnType<
  typeof useApproveEventActionMutation
>;
export type ApproveEventActionMutationResult =
  Apollo.MutationResult<ApproveEventActionMutation>;
export type ApproveEventActionMutationOptions = Apollo.BaseMutationOptions<
  ApproveEventActionMutation,
  ApproveEventActionMutationVariables
>;
export const ApproveEventActionBatchDocument = gql`
  mutation approveEventActionBatch($eventId: UUID!, $actionBatchId: UUID!) {
    approveEventActionBatch(
      eventId: $eventId
      eventActionBatchId: $actionBatchId
    )
  }
`;
export type ApproveEventActionBatchMutationFn = Apollo.MutationFunction<
  ApproveEventActionBatchMutation,
  ApproveEventActionBatchMutationVariables
>;

/**
 * __useApproveEventActionBatchMutation__
 *
 * To run a mutation, you first call `useApproveEventActionBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveEventActionBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveEventActionBatchMutation, { data, loading, error }] = useApproveEventActionBatchMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      actionBatchId: // value for 'actionBatchId'
 *   },
 * });
 */
export function useApproveEventActionBatchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveEventActionBatchMutation,
    ApproveEventActionBatchMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveEventActionBatchMutation,
    ApproveEventActionBatchMutationVariables
  >(ApproveEventActionBatchDocument, options);
}
export type ApproveEventActionBatchMutationHookResult = ReturnType<
  typeof useApproveEventActionBatchMutation
>;
export type ApproveEventActionBatchMutationResult =
  Apollo.MutationResult<ApproveEventActionBatchMutation>;
export type ApproveEventActionBatchMutationOptions = Apollo.BaseMutationOptions<
  ApproveEventActionBatchMutation,
  ApproveEventActionBatchMutationVariables
>;
export const ChangeResourceExecutionStatusDocument = gql`
  mutation changeResourceExecutionStatus(
    $input: ChangeResourceExecutionStatusInput!
  ) {
    changeResourceExecutionStatus(input: $input)
  }
`;
export type ChangeResourceExecutionStatusMutationFn = Apollo.MutationFunction<
  ChangeResourceExecutionStatusMutation,
  ChangeResourceExecutionStatusMutationVariables
>;

/**
 * __useChangeResourceExecutionStatusMutation__
 *
 * To run a mutation, you first call `useChangeResourceExecutionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeResourceExecutionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeResourceExecutionStatusMutation, { data, loading, error }] = useChangeResourceExecutionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeResourceExecutionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeResourceExecutionStatusMutation,
    ChangeResourceExecutionStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeResourceExecutionStatusMutation,
    ChangeResourceExecutionStatusMutationVariables
  >(ChangeResourceExecutionStatusDocument, options);
}
export type ChangeResourceExecutionStatusMutationHookResult = ReturnType<
  typeof useChangeResourceExecutionStatusMutation
>;
export type ChangeResourceExecutionStatusMutationResult =
  Apollo.MutationResult<ChangeResourceExecutionStatusMutation>;
export type ChangeResourceExecutionStatusMutationOptions =
  Apollo.BaseMutationOptions<
    ChangeResourceExecutionStatusMutation,
    ChangeResourceExecutionStatusMutationVariables
  >;
export const EventActionResourceStateChangedDocument = gql`
  subscription EventActionResourceStateChanged($eventId: UUID!) {
    eventActionResourceStateChanged(input: { eventId: $eventId }) {
      resourceStateId
      eventActionId
      status
    }
  }
`;

/**
 * __useEventActionResourceStateChangedSubscription__
 *
 * To run a query within a React component, call `useEventActionResourceStateChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventActionResourceStateChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventActionResourceStateChangedSubscription({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventActionResourceStateChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EventActionResourceStateChangedSubscription,
    EventActionResourceStateChangedSubscriptionVariables
  > &
    (
      | {
          variables: EventActionResourceStateChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EventActionResourceStateChangedSubscription,
    EventActionResourceStateChangedSubscriptionVariables
  >(EventActionResourceStateChangedDocument, options);
}
export type EventActionResourceStateChangedSubscriptionHookResult = ReturnType<
  typeof useEventActionResourceStateChangedSubscription
>;
export type EventActionResourceStateChangedSubscriptionResult =
  Apollo.SubscriptionResult<EventActionResourceStateChangedSubscription>;
export const GetEventActionResourceStateSearchDocument = gql`
  query getEventActionResourceStateSearch(
    $eventId: UUID!
    $eventActionId: UUID!
    $sort: EventActionResourceStateSortInput
    $filter: EventActionResourceStatesFilterInput
    $page: Int
    $limit: Int
    $excludeGroupStatus: Boolean = false
  ) {
    eventActionResourceStateSearch(
      eventId: $eventId
      eventActionId: $eventActionId
      sort: $sort
      filter: $filter
      page: $page
      limit: $limit
    ) {
      result {
        resourceGroupId
        resourceGroup {
          id
          name
          description
          resourcesCounts {
            totalCount
            disconnectedCount
            onlineCount
          }
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
        resourceGroupStatus @skip(if: $excludeGroupStatus)
        resourceStates {
          id
          resourceId
          resource {
            id
            name
            description
            os {
              type
              subType
            }
            autoDiscovery
            cloudResourceId
            fullCloudResourceId
            enabled
            provider
            providerId
            region
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
            scanned
          }
          order
          status
          outputUri
          output {
            key
            value
          }
          annotation
          errorCode
          changeDetails {
            createdBy
            createdAt
            updatedBy
            updatedAt
          }
        }
      }
      pageInfo {
        count
        pages
      }
    }
  }
`;

/**
 * __useGetEventActionResourceStateSearchQuery__
 *
 * To run a query within a React component, call `useGetEventActionResourceStateSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventActionResourceStateSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventActionResourceStateSearchQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventActionId: // value for 'eventActionId'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      excludeGroupStatus: // value for 'excludeGroupStatus'
 *   },
 * });
 */
export function useGetEventActionResourceStateSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventActionResourceStateSearchQuery,
    GetEventActionResourceStateSearchQueryVariables
  > &
    (
      | {
          variables: GetEventActionResourceStateSearchQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventActionResourceStateSearchQuery,
    GetEventActionResourceStateSearchQueryVariables
  >(GetEventActionResourceStateSearchDocument, options);
}
export function useGetEventActionResourceStateSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventActionResourceStateSearchQuery,
    GetEventActionResourceStateSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventActionResourceStateSearchQuery,
    GetEventActionResourceStateSearchQueryVariables
  >(GetEventActionResourceStateSearchDocument, options);
}
// @ts-ignore
export function useGetEventActionResourceStateSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventActionResourceStateSearchQuery,
    GetEventActionResourceStateSearchQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEventActionResourceStateSearchQuery,
  GetEventActionResourceStateSearchQueryVariables
>;
export function useGetEventActionResourceStateSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionResourceStateSearchQuery,
        GetEventActionResourceStateSearchQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEventActionResourceStateSearchQuery | undefined,
  GetEventActionResourceStateSearchQueryVariables
>;
export function useGetEventActionResourceStateSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionResourceStateSearchQuery,
        GetEventActionResourceStateSearchQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventActionResourceStateSearchQuery,
    GetEventActionResourceStateSearchQueryVariables
  >(GetEventActionResourceStateSearchDocument, options);
}
export type GetEventActionResourceStateSearchQueryHookResult = ReturnType<
  typeof useGetEventActionResourceStateSearchQuery
>;
export type GetEventActionResourceStateSearchLazyQueryHookResult = ReturnType<
  typeof useGetEventActionResourceStateSearchLazyQuery
>;
export type GetEventActionResourceStateSearchSuspenseQueryHookResult =
  ReturnType<typeof useGetEventActionResourceStateSearchSuspenseQuery>;
export type GetEventActionResourceStateSearchQueryResult = Apollo.QueryResult<
  GetEventActionResourceStateSearchQuery,
  GetEventActionResourceStateSearchQueryVariables
>;
export const GetEventViewDocument = gql`
  query getEventView($id: UUID!) {
    eventView(id: $id) {
      ...EventDetails
    }
  }
  ${EventDetailsFragmentDoc}
`;

/**
 * __useGetEventViewQuery__
 *
 * To run a query within a React component, call `useGetEventViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventViewQuery,
    GetEventViewQueryVariables
  > &
    (
      | { variables: GetEventViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventViewQuery, GetEventViewQueryVariables>(
    GetEventViewDocument,
    options
  );
}
export function useGetEventViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventViewQuery,
    GetEventViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventViewQuery, GetEventViewQueryVariables>(
    GetEventViewDocument,
    options
  );
}
// @ts-ignore
export function useGetEventViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventViewQuery,
    GetEventViewQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetEventViewQuery, GetEventViewQueryVariables>;
export function useGetEventViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventViewQuery,
        GetEventViewQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEventViewQuery | undefined,
  GetEventViewQueryVariables
>;
export function useGetEventViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventViewQuery,
        GetEventViewQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventViewQuery, GetEventViewQueryVariables>(
    GetEventViewDocument,
    options
  );
}
export type GetEventViewQueryHookResult = ReturnType<
  typeof useGetEventViewQuery
>;
export type GetEventViewLazyQueryHookResult = ReturnType<
  typeof useGetEventViewLazyQuery
>;
export type GetEventViewSuspenseQueryHookResult = ReturnType<
  typeof useGetEventViewSuspenseQuery
>;
export type GetEventViewQueryResult = Apollo.QueryResult<
  GetEventViewQuery,
  GetEventViewQueryVariables
>;
export const GetEventActionResourceReportsDocument = gql`
  query getEventActionResourceReports(
    $eventId: UUID!
    $eventActionId: UUID!
    $page: Int
    $limit: Int
    $filter: EventActionResourceReportsFilterInput
    $includeAttempts: Boolean
  ) {
    eventActionResourceReports(
      eventId: $eventId
      eventActionId: $eventActionId
      page: $page
      limit: $limit
      filter: $filter
      includeAttempts: $includeAttempts
    ) {
      pageInfo {
        pages
        count
      }
      packagesCount {
        installed
        installedPendingReboot
        updated
        available
        removed
        failed
      }
      result {
        resourceId
        cloudResourceId
        fullCloudResourceId
        provider
        providerId
        name
        region
        status
        errorCode
        result {
          installed {
            id
            name
            version
            previousVersion
            errorMessage
          }
          installedPendingReboot {
            id
            name
            version
            previousVersion
            errorMessage
          }
          updated {
            id
            name
            version
            previousVersion
            errorMessage
          }
          removed {
            id
            name
            version
            previousVersion
            errorMessage
          }
          available {
            id
            name
            version
            previousVersion
            errorMessage
          }
          failed {
            id
            name
            version
            previousVersion
            errorMessage
          }
          output
          outputUri
        }
      }
    }
  }
`;

/**
 * __useGetEventActionResourceReportsQuery__
 *
 * To run a query within a React component, call `useGetEventActionResourceReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventActionResourceReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventActionResourceReportsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventActionId: // value for 'eventActionId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      includeAttempts: // value for 'includeAttempts'
 *   },
 * });
 */
export function useGetEventActionResourceReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventActionResourceReportsQuery,
    GetEventActionResourceReportsQueryVariables
  > &
    (
      | {
          variables: GetEventActionResourceReportsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventActionResourceReportsQuery,
    GetEventActionResourceReportsQueryVariables
  >(GetEventActionResourceReportsDocument, options);
}
export function useGetEventActionResourceReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventActionResourceReportsQuery,
    GetEventActionResourceReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventActionResourceReportsQuery,
    GetEventActionResourceReportsQueryVariables
  >(GetEventActionResourceReportsDocument, options);
}
// @ts-ignore
export function useGetEventActionResourceReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventActionResourceReportsQuery,
    GetEventActionResourceReportsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEventActionResourceReportsQuery,
  GetEventActionResourceReportsQueryVariables
>;
export function useGetEventActionResourceReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionResourceReportsQuery,
        GetEventActionResourceReportsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEventActionResourceReportsQuery | undefined,
  GetEventActionResourceReportsQueryVariables
>;
export function useGetEventActionResourceReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionResourceReportsQuery,
        GetEventActionResourceReportsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventActionResourceReportsQuery,
    GetEventActionResourceReportsQueryVariables
  >(GetEventActionResourceReportsDocument, options);
}
export type GetEventActionResourceReportsQueryHookResult = ReturnType<
  typeof useGetEventActionResourceReportsQuery
>;
export type GetEventActionResourceReportsLazyQueryHookResult = ReturnType<
  typeof useGetEventActionResourceReportsLazyQuery
>;
export type GetEventActionResourceReportsSuspenseQueryHookResult = ReturnType<
  typeof useGetEventActionResourceReportsSuspenseQuery
>;
export type GetEventActionResourceReportsQueryResult = Apollo.QueryResult<
  GetEventActionResourceReportsQuery,
  GetEventActionResourceReportsQueryVariables
>;
export const GetEventsViewDocument = gql`
  query getEventsView(
    $page: Int
    $limit: Int
    $sort: EventsSortInput
    $filter: EventsFilterInput
  ) {
    eventsView(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        startTime
        endTime
        status
        name
        scheduleTimezone
        estimatedEndTime
        actions {
          scope
          id
          name
          order
          globalState {
            status
          }
          resourcesFailed
          resourcesSucceeded
          resourcesNotCompleted
          errorCodeCounts {
            errorCode
            count
          }
        }
        actionBatches {
          id
          name
          order
          status
          actions {
            id
            name
            order
            globalState {
              status
            }
            resourcesFailed
            resourcesSucceeded
            resourcesNotCompleted
            errorCodeCounts {
              errorCode
              count
            }
            scope
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetEventsViewQuery__
 *
 * To run a query within a React component, call `useGetEventsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsViewQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEventsViewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEventsViewQuery,
    GetEventsViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventsViewQuery, GetEventsViewQueryVariables>(
    GetEventsViewDocument,
    options
  );
}
export function useGetEventsViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventsViewQuery,
    GetEventsViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventsViewQuery, GetEventsViewQueryVariables>(
    GetEventsViewDocument,
    options
  );
}
// @ts-ignore
export function useGetEventsViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventsViewQuery,
    GetEventsViewQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEventsViewQuery,
  GetEventsViewQueryVariables
>;
export function useGetEventsViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventsViewQuery,
        GetEventsViewQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEventsViewQuery | undefined,
  GetEventsViewQueryVariables
>;
export function useGetEventsViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventsViewQuery,
        GetEventsViewQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventsViewQuery,
    GetEventsViewQueryVariables
  >(GetEventsViewDocument, options);
}
export type GetEventsViewQueryHookResult = ReturnType<
  typeof useGetEventsViewQuery
>;
export type GetEventsViewLazyQueryHookResult = ReturnType<
  typeof useGetEventsViewLazyQuery
>;
export type GetEventsViewSuspenseQueryHookResult = ReturnType<
  typeof useGetEventsViewSuspenseQuery
>;
export type GetEventsViewQueryResult = Apollo.QueryResult<
  GetEventsViewQuery,
  GetEventsViewQueryVariables
>;
export const GetIncomingEventDocument = gql`
  query getIncomingEvent($id: UUID!) {
    incomingEvent(eventId: $id) {
      id
      name
      scheduleTimezone
      estimatedEndTime
      status
      startTime
      plan {
        id
        name
        description
        scheduleCron
        scheduleOffset
        scheduleTimezone
        enabled
        planActions {
          id
          name
          runInSequence
          executionPolicy
          order
          skipWindow
          windowDuration
          action {
            ... on Action {
              ...EventActionDefinition
            }
            ... on SystemAction {
              ...EventSystemActionDefinition
            }
          }
          resourceGroups {
            id
            name
          }
          resources {
            ... on Resource {
              ...EventDetailResource
            }
          }
          inputParameters {
            key
            value
          }
        }
        planActionBatches {
          ...IncomingEventDetailPlanActionBatch
        }
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      metadata {
        key
        value
      }
    }
  }
  ${EventActionDefinitionFragmentDoc}
  ${EventSystemActionDefinitionFragmentDoc}
  ${EventDetailResourceFragmentDoc}
  ${IncomingEventDetailPlanActionBatchFragmentDoc}
`;

/**
 * __useGetIncomingEventQuery__
 *
 * To run a query within a React component, call `useGetIncomingEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomingEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomingEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIncomingEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIncomingEventQuery,
    GetIncomingEventQueryVariables
  > &
    (
      | { variables: GetIncomingEventQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIncomingEventQuery, GetIncomingEventQueryVariables>(
    GetIncomingEventDocument,
    options
  );
}
export function useGetIncomingEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIncomingEventQuery,
    GetIncomingEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIncomingEventQuery,
    GetIncomingEventQueryVariables
  >(GetIncomingEventDocument, options);
}
// @ts-ignore
export function useGetIncomingEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIncomingEventQuery,
    GetIncomingEventQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetIncomingEventQuery,
  GetIncomingEventQueryVariables
>;
export function useGetIncomingEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIncomingEventQuery,
        GetIncomingEventQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetIncomingEventQuery | undefined,
  GetIncomingEventQueryVariables
>;
export function useGetIncomingEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIncomingEventQuery,
        GetIncomingEventQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIncomingEventQuery,
    GetIncomingEventQueryVariables
  >(GetIncomingEventDocument, options);
}
export type GetIncomingEventQueryHookResult = ReturnType<
  typeof useGetIncomingEventQuery
>;
export type GetIncomingEventLazyQueryHookResult = ReturnType<
  typeof useGetIncomingEventLazyQuery
>;
export type GetIncomingEventSuspenseQueryHookResult = ReturnType<
  typeof useGetIncomingEventSuspenseQuery
>;
export type GetIncomingEventQueryResult = Apollo.QueryResult<
  GetIncomingEventQuery,
  GetIncomingEventQueryVariables
>;
export const GetIncomingEventsDocument = gql`
  query getIncomingEvents(
    $page: Int
    $limit: Int
    $sort: IncomingEventsSortInput
    $filter: IncomingEventsFilterInput
  ) {
    incomingEvents(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
        status
        scheduleTimezone
        estimatedEndTime
        startTime
        changeDetails {
          createdBy
          createdAt
          updatedBy
          updatedAt
        }
        plan {
          id
          planActions {
            ...IncomingEventsListPlanAction
          }
          planActionBatches {
            ...IncomingEventsListPlanActionBatch
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
  ${IncomingEventsListPlanActionFragmentDoc}
  ${IncomingEventsListPlanActionBatchFragmentDoc}
`;

/**
 * __useGetIncomingEventsQuery__
 *
 * To run a query within a React component, call `useGetIncomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomingEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetIncomingEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetIncomingEventsQuery,
    GetIncomingEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIncomingEventsQuery,
    GetIncomingEventsQueryVariables
  >(GetIncomingEventsDocument, options);
}
export function useGetIncomingEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIncomingEventsQuery,
    GetIncomingEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIncomingEventsQuery,
    GetIncomingEventsQueryVariables
  >(GetIncomingEventsDocument, options);
}
// @ts-ignore
export function useGetIncomingEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIncomingEventsQuery,
    GetIncomingEventsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetIncomingEventsQuery,
  GetIncomingEventsQueryVariables
>;
export function useGetIncomingEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIncomingEventsQuery,
        GetIncomingEventsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetIncomingEventsQuery | undefined,
  GetIncomingEventsQueryVariables
>;
export function useGetIncomingEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIncomingEventsQuery,
        GetIncomingEventsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIncomingEventsQuery,
    GetIncomingEventsQueryVariables
  >(GetIncomingEventsDocument, options);
}
export type GetIncomingEventsQueryHookResult = ReturnType<
  typeof useGetIncomingEventsQuery
>;
export type GetIncomingEventsLazyQueryHookResult = ReturnType<
  typeof useGetIncomingEventsLazyQuery
>;
export type GetIncomingEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetIncomingEventsSuspenseQuery
>;
export type GetIncomingEventsQueryResult = Apollo.QueryResult<
  GetIncomingEventsQuery,
  GetIncomingEventsQueryVariables
>;
export const GetPresignedUrlDocument = gql`
  query getPresignedUrl($url: String!) {
    presignedEventActionOutputUrl(url: $url)
  }
`;

/**
 * __useGetPresignedUrlQuery__
 *
 * To run a query within a React component, call `useGetPresignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresignedUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetPresignedUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPresignedUrlQuery,
    GetPresignedUrlQueryVariables
  > &
    (
      | { variables: GetPresignedUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPresignedUrlQuery, GetPresignedUrlQueryVariables>(
    GetPresignedUrlDocument,
    options
  );
}
export function useGetPresignedUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPresignedUrlQuery,
    GetPresignedUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPresignedUrlQuery,
    GetPresignedUrlQueryVariables
  >(GetPresignedUrlDocument, options);
}
// @ts-ignore
export function useGetPresignedUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPresignedUrlQuery,
    GetPresignedUrlQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPresignedUrlQuery,
  GetPresignedUrlQueryVariables
>;
export function useGetPresignedUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPresignedUrlQuery,
        GetPresignedUrlQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPresignedUrlQuery | undefined,
  GetPresignedUrlQueryVariables
>;
export function useGetPresignedUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPresignedUrlQuery,
        GetPresignedUrlQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPresignedUrlQuery,
    GetPresignedUrlQueryVariables
  >(GetPresignedUrlDocument, options);
}
export type GetPresignedUrlQueryHookResult = ReturnType<
  typeof useGetPresignedUrlQuery
>;
export type GetPresignedUrlLazyQueryHookResult = ReturnType<
  typeof useGetPresignedUrlLazyQuery
>;
export type GetPresignedUrlSuspenseQueryHookResult = ReturnType<
  typeof useGetPresignedUrlSuspenseQuery
>;
export type GetPresignedUrlQueryResult = Apollo.QueryResult<
  GetPresignedUrlQuery,
  GetPresignedUrlQueryVariables
>;
export const GetResourceGroupStatusesDocument = gql`
  query getResourceGroupStatuses(
    $eventId: UUID!
    $eventActionId: UUID!
    $groupIds: [UUID!]
    $merged: Boolean = false
  ) {
    eventActionResourceGroupStatuses(
      eventId: $eventId
      eventActionId: $eventActionId
      groupIds: $groupIds
      merged: $merged
    ) {
      groupId
      status
    }
  }
`;

/**
 * __useGetResourceGroupStatusesQuery__
 *
 * To run a query within a React component, call `useGetResourceGroupStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceGroupStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceGroupStatusesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventActionId: // value for 'eventActionId'
 *      groupIds: // value for 'groupIds'
 *      merged: // value for 'merged'
 *   },
 * });
 */
export function useGetResourceGroupStatusesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetResourceGroupStatusesQuery,
    GetResourceGroupStatusesQueryVariables
  > &
    (
      | { variables: GetResourceGroupStatusesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetResourceGroupStatusesQuery,
    GetResourceGroupStatusesQueryVariables
  >(GetResourceGroupStatusesDocument, options);
}
export function useGetResourceGroupStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceGroupStatusesQuery,
    GetResourceGroupStatusesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourceGroupStatusesQuery,
    GetResourceGroupStatusesQueryVariables
  >(GetResourceGroupStatusesDocument, options);
}
// @ts-ignore
export function useGetResourceGroupStatusesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceGroupStatusesQuery,
    GetResourceGroupStatusesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourceGroupStatusesQuery,
  GetResourceGroupStatusesQueryVariables
>;
export function useGetResourceGroupStatusesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceGroupStatusesQuery,
        GetResourceGroupStatusesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceGroupStatusesQuery | undefined,
  GetResourceGroupStatusesQueryVariables
>;
export function useGetResourceGroupStatusesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceGroupStatusesQuery,
        GetResourceGroupStatusesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourceGroupStatusesQuery,
    GetResourceGroupStatusesQueryVariables
  >(GetResourceGroupStatusesDocument, options);
}
export type GetResourceGroupStatusesQueryHookResult = ReturnType<
  typeof useGetResourceGroupStatusesQuery
>;
export type GetResourceGroupStatusesLazyQueryHookResult = ReturnType<
  typeof useGetResourceGroupStatusesLazyQuery
>;
export type GetResourceGroupStatusesSuspenseQueryHookResult = ReturnType<
  typeof useGetResourceGroupStatusesSuspenseQuery
>;
export type GetResourceGroupStatusesQueryResult = Apollo.QueryResult<
  GetResourceGroupStatusesQuery,
  GetResourceGroupStatusesQueryVariables
>;
export const GetGlobalEventActionResourceStateDocument = gql`
  query getGlobalEventActionResourceState(
    $eventId: UUID!
    $eventActionId: UUID!
    $sort: EventActionResourceStateSortInput
    $filter: EventActionResourceStatesFilterInput
    $page: Int
    $limit: Int
    $excludeGroupStatus: Boolean = false
  ) {
    globalEventActionResourceState(
      eventId: $eventId
      eventActionId: $eventActionId
      sort: $sort
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pageInfo {
        count
      }
      result {
        resourceGroupId
        resourceGroup {
          id
          name
        }
        resourceGroupStatus @skip(if: $excludeGroupStatus)
        resourceStates {
          id
          resourceId
          resource {
            id
            name
            os {
              type
              subType
            }
            provider
            region
          }
          order
          status
          outputUri
          annotation
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
          errorCode
        }
      }
    }
  }
`;

/**
 * __useGetGlobalEventActionResourceStateQuery__
 *
 * To run a query within a React component, call `useGetGlobalEventActionResourceStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalEventActionResourceStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalEventActionResourceStateQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventActionId: // value for 'eventActionId'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      excludeGroupStatus: // value for 'excludeGroupStatus'
 *   },
 * });
 */
export function useGetGlobalEventActionResourceStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGlobalEventActionResourceStateQuery,
    GetGlobalEventActionResourceStateQueryVariables
  > &
    (
      | {
          variables: GetGlobalEventActionResourceStateQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGlobalEventActionResourceStateQuery,
    GetGlobalEventActionResourceStateQueryVariables
  >(GetGlobalEventActionResourceStateDocument, options);
}
export function useGetGlobalEventActionResourceStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGlobalEventActionResourceStateQuery,
    GetGlobalEventActionResourceStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGlobalEventActionResourceStateQuery,
    GetGlobalEventActionResourceStateQueryVariables
  >(GetGlobalEventActionResourceStateDocument, options);
}
// @ts-ignore
export function useGetGlobalEventActionResourceStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGlobalEventActionResourceStateQuery,
    GetGlobalEventActionResourceStateQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetGlobalEventActionResourceStateQuery,
  GetGlobalEventActionResourceStateQueryVariables
>;
export function useGetGlobalEventActionResourceStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGlobalEventActionResourceStateQuery,
        GetGlobalEventActionResourceStateQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetGlobalEventActionResourceStateQuery | undefined,
  GetGlobalEventActionResourceStateQueryVariables
>;
export function useGetGlobalEventActionResourceStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGlobalEventActionResourceStateQuery,
        GetGlobalEventActionResourceStateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetGlobalEventActionResourceStateQuery,
    GetGlobalEventActionResourceStateQueryVariables
  >(GetGlobalEventActionResourceStateDocument, options);
}
export type GetGlobalEventActionResourceStateQueryHookResult = ReturnType<
  typeof useGetGlobalEventActionResourceStateQuery
>;
export type GetGlobalEventActionResourceStateLazyQueryHookResult = ReturnType<
  typeof useGetGlobalEventActionResourceStateLazyQuery
>;
export type GetGlobalEventActionResourceStateSuspenseQueryHookResult =
  ReturnType<typeof useGetGlobalEventActionResourceStateSuspenseQuery>;
export type GetGlobalEventActionResourceStateQueryResult = Apollo.QueryResult<
  GetGlobalEventActionResourceStateQuery,
  GetGlobalEventActionResourceStateQueryVariables
>;
export const RerunEventActionDocument = gql`
  mutation rerunEventAction($input: RerunEventActionInput!) {
    rerunEventAction(input: $input)
  }
`;
export type RerunEventActionMutationFn = Apollo.MutationFunction<
  RerunEventActionMutation,
  RerunEventActionMutationVariables
>;

/**
 * __useRerunEventActionMutation__
 *
 * To run a mutation, you first call `useRerunEventActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunEventActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunEventActionMutation, { data, loading, error }] = useRerunEventActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRerunEventActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RerunEventActionMutation,
    RerunEventActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RerunEventActionMutation,
    RerunEventActionMutationVariables
  >(RerunEventActionDocument, options);
}
export type RerunEventActionMutationHookResult = ReturnType<
  typeof useRerunEventActionMutation
>;
export type RerunEventActionMutationResult =
  Apollo.MutationResult<RerunEventActionMutation>;
export type RerunEventActionMutationOptions = Apollo.BaseMutationOptions<
  RerunEventActionMutation,
  RerunEventActionMutationVariables
>;
export const RevokeIncomingEventDocument = gql`
  mutation revokeIncomingEvent($eventId: UUID!) {
    revokeIncomingEvent(eventId: $eventId)
  }
`;
export type RevokeIncomingEventMutationFn = Apollo.MutationFunction<
  RevokeIncomingEventMutation,
  RevokeIncomingEventMutationVariables
>;

/**
 * __useRevokeIncomingEventMutation__
 *
 * To run a mutation, you first call `useRevokeIncomingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeIncomingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeIncomingEventMutation, { data, loading, error }] = useRevokeIncomingEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRevokeIncomingEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeIncomingEventMutation,
    RevokeIncomingEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeIncomingEventMutation,
    RevokeIncomingEventMutationVariables
  >(RevokeIncomingEventDocument, options);
}
export type RevokeIncomingEventMutationHookResult = ReturnType<
  typeof useRevokeIncomingEventMutation
>;
export type RevokeIncomingEventMutationResult =
  Apollo.MutationResult<RevokeIncomingEventMutation>;
export type RevokeIncomingEventMutationOptions = Apollo.BaseMutationOptions<
  RevokeIncomingEventMutation,
  RevokeIncomingEventMutationVariables
>;
export const CreateMappingRuleDocument = gql`
  mutation CreateMappingRule($input: CreateMappingRuleInput!) {
    createMappingRule(input: $input) {
      id
      tagName
      type
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
export type CreateMappingRuleMutationFn = Apollo.MutationFunction<
  CreateMappingRuleMutation,
  CreateMappingRuleMutationVariables
>;

/**
 * __useCreateMappingRuleMutation__
 *
 * To run a mutation, you first call `useCreateMappingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMappingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMappingRuleMutation, { data, loading, error }] = useCreateMappingRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMappingRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMappingRuleMutation,
    CreateMappingRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMappingRuleMutation,
    CreateMappingRuleMutationVariables
  >(CreateMappingRuleDocument, options);
}
export type CreateMappingRuleMutationHookResult = ReturnType<
  typeof useCreateMappingRuleMutation
>;
export type CreateMappingRuleMutationResult =
  Apollo.MutationResult<CreateMappingRuleMutation>;
export type CreateMappingRuleMutationOptions = Apollo.BaseMutationOptions<
  CreateMappingRuleMutation,
  CreateMappingRuleMutationVariables
>;
export const DeleteMappingRuleDocument = gql`
  mutation DeleteMappingRule($id: ID!) {
    deleteMappingRule(input: { id: $id })
  }
`;
export type DeleteMappingRuleMutationFn = Apollo.MutationFunction<
  DeleteMappingRuleMutation,
  DeleteMappingRuleMutationVariables
>;

/**
 * __useDeleteMappingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteMappingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMappingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMappingRuleMutation, { data, loading, error }] = useDeleteMappingRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMappingRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMappingRuleMutation,
    DeleteMappingRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMappingRuleMutation,
    DeleteMappingRuleMutationVariables
  >(DeleteMappingRuleDocument, options);
}
export type DeleteMappingRuleMutationHookResult = ReturnType<
  typeof useDeleteMappingRuleMutation
>;
export type DeleteMappingRuleMutationResult =
  Apollo.MutationResult<DeleteMappingRuleMutation>;
export type DeleteMappingRuleMutationOptions = Apollo.BaseMutationOptions<
  DeleteMappingRuleMutation,
  DeleteMappingRuleMutationVariables
>;
export const MappingRulesDocument = gql`
  query mappingRules(
    $sort: MappingRulesSortInput
    $filter: MappingRulesFilterInput
  ) {
    mappingRules(sort: $sort, filter: $filter) {
      pageInfo {
        count
        pages
      }
      result {
        id
        tagName
        type
        changeDetails {
          createdAt
          updatedAt
          createdBy
          updatedBy
        }
      }
    }
  }
`;

/**
 * __useMappingRulesQuery__
 *
 * To run a query within a React component, call `useMappingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMappingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMappingRulesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMappingRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MappingRulesQuery,
    MappingRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MappingRulesQuery, MappingRulesQueryVariables>(
    MappingRulesDocument,
    options
  );
}
export function useMappingRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MappingRulesQuery,
    MappingRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MappingRulesQuery, MappingRulesQueryVariables>(
    MappingRulesDocument,
    options
  );
}
// @ts-ignore
export function useMappingRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MappingRulesQuery,
    MappingRulesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<MappingRulesQuery, MappingRulesQueryVariables>;
export function useMappingRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MappingRulesQuery,
        MappingRulesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  MappingRulesQuery | undefined,
  MappingRulesQueryVariables
>;
export function useMappingRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MappingRulesQuery,
        MappingRulesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MappingRulesQuery, MappingRulesQueryVariables>(
    MappingRulesDocument,
    options
  );
}
export type MappingRulesQueryHookResult = ReturnType<
  typeof useMappingRulesQuery
>;
export type MappingRulesLazyQueryHookResult = ReturnType<
  typeof useMappingRulesLazyQuery
>;
export type MappingRulesSuspenseQueryHookResult = ReturnType<
  typeof useMappingRulesSuspenseQuery
>;
export type MappingRulesQueryResult = Apollo.QueryResult<
  MappingRulesQuery,
  MappingRulesQueryVariables
>;
export const CreateNotificationGroupDocument = gql`
  mutation createNotificationGroup($input: CreateNotificationGroupInput!) {
    createNotificationGroup(input: $input) {
      id
      name
    }
  }
`;
export type CreateNotificationGroupMutationFn = Apollo.MutationFunction<
  CreateNotificationGroupMutation,
  CreateNotificationGroupMutationVariables
>;

/**
 * __useCreateNotificationGroupMutation__
 *
 * To run a mutation, you first call `useCreateNotificationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationGroupMutation, { data, loading, error }] = useCreateNotificationGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNotificationGroupMutation,
    CreateNotificationGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateNotificationGroupMutation,
    CreateNotificationGroupMutationVariables
  >(CreateNotificationGroupDocument, options);
}
export type CreateNotificationGroupMutationHookResult = ReturnType<
  typeof useCreateNotificationGroupMutation
>;
export type CreateNotificationGroupMutationResult =
  Apollo.MutationResult<CreateNotificationGroupMutation>;
export type CreateNotificationGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateNotificationGroupMutation,
  CreateNotificationGroupMutationVariables
>;
export const DeleteNotificationGroupDocument = gql`
  mutation deleteNotificationGroup($id: UUID!) {
    removeNotificationGroup(id: $id)
  }
`;
export type DeleteNotificationGroupMutationFn = Apollo.MutationFunction<
  DeleteNotificationGroupMutation,
  DeleteNotificationGroupMutationVariables
>;

/**
 * __useDeleteNotificationGroupMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationGroupMutation, { data, loading, error }] = useDeleteNotificationGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteNotificationGroupMutation,
    DeleteNotificationGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteNotificationGroupMutation,
    DeleteNotificationGroupMutationVariables
  >(DeleteNotificationGroupDocument, options);
}
export type DeleteNotificationGroupMutationHookResult = ReturnType<
  typeof useDeleteNotificationGroupMutation
>;
export type DeleteNotificationGroupMutationResult =
  Apollo.MutationResult<DeleteNotificationGroupMutation>;
export type DeleteNotificationGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteNotificationGroupMutation,
  DeleteNotificationGroupMutationVariables
>;
export const GetNotificationGroupDocument = gql`
  query getNotificationGroup($id: UUID!) {
    notificationGroup(id: $id) {
      id
      name
      description
      channels {
        id
        typeProperties {
          ... on EmailChannel {
            email
          }
          ... on WebhookChannel {
            url
            payload
            headers {
              key
              value
            }
            method
            type
          }
        }
      }
      changeDetails {
        updatedAt
        createdAt
        updatedBy
        createdBy
      }
    }
  }
`;

/**
 * __useGetNotificationGroupQuery__
 *
 * To run a query within a React component, call `useGetNotificationGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNotificationGroupQuery,
    GetNotificationGroupQueryVariables
  > &
    (
      | { variables: GetNotificationGroupQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNotificationGroupQuery,
    GetNotificationGroupQueryVariables
  >(GetNotificationGroupDocument, options);
}
export function useGetNotificationGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationGroupQuery,
    GetNotificationGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationGroupQuery,
    GetNotificationGroupQueryVariables
  >(GetNotificationGroupDocument, options);
}
// @ts-ignore
export function useGetNotificationGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNotificationGroupQuery,
    GetNotificationGroupQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetNotificationGroupQuery,
  GetNotificationGroupQueryVariables
>;
export function useGetNotificationGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNotificationGroupQuery,
        GetNotificationGroupQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetNotificationGroupQuery | undefined,
  GetNotificationGroupQueryVariables
>;
export function useGetNotificationGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNotificationGroupQuery,
        GetNotificationGroupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetNotificationGroupQuery,
    GetNotificationGroupQueryVariables
  >(GetNotificationGroupDocument, options);
}
export type GetNotificationGroupQueryHookResult = ReturnType<
  typeof useGetNotificationGroupQuery
>;
export type GetNotificationGroupLazyQueryHookResult = ReturnType<
  typeof useGetNotificationGroupLazyQuery
>;
export type GetNotificationGroupSuspenseQueryHookResult = ReturnType<
  typeof useGetNotificationGroupSuspenseQuery
>;
export type GetNotificationGroupQueryResult = Apollo.QueryResult<
  GetNotificationGroupQuery,
  GetNotificationGroupQueryVariables
>;
export const GetNotificationGroupPlansDocument = gql`
  query getNotificationGroupPlans($notificationGroupId: UUID!) {
    notificationGroup(id: $notificationGroupId) {
      plans {
        id
        name
      }
    }
  }
`;

/**
 * __useGetNotificationGroupPlansQuery__
 *
 * To run a query within a React component, call `useGetNotificationGroupPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationGroupPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationGroupPlansQuery({
 *   variables: {
 *      notificationGroupId: // value for 'notificationGroupId'
 *   },
 * });
 */
export function useGetNotificationGroupPlansQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNotificationGroupPlansQuery,
    GetNotificationGroupPlansQueryVariables
  > &
    (
      | { variables: GetNotificationGroupPlansQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNotificationGroupPlansQuery,
    GetNotificationGroupPlansQueryVariables
  >(GetNotificationGroupPlansDocument, options);
}
export function useGetNotificationGroupPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationGroupPlansQuery,
    GetNotificationGroupPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationGroupPlansQuery,
    GetNotificationGroupPlansQueryVariables
  >(GetNotificationGroupPlansDocument, options);
}
// @ts-ignore
export function useGetNotificationGroupPlansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNotificationGroupPlansQuery,
    GetNotificationGroupPlansQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetNotificationGroupPlansQuery,
  GetNotificationGroupPlansQueryVariables
>;
export function useGetNotificationGroupPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNotificationGroupPlansQuery,
        GetNotificationGroupPlansQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetNotificationGroupPlansQuery | undefined,
  GetNotificationGroupPlansQueryVariables
>;
export function useGetNotificationGroupPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNotificationGroupPlansQuery,
        GetNotificationGroupPlansQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetNotificationGroupPlansQuery,
    GetNotificationGroupPlansQueryVariables
  >(GetNotificationGroupPlansDocument, options);
}
export type GetNotificationGroupPlansQueryHookResult = ReturnType<
  typeof useGetNotificationGroupPlansQuery
>;
export type GetNotificationGroupPlansLazyQueryHookResult = ReturnType<
  typeof useGetNotificationGroupPlansLazyQuery
>;
export type GetNotificationGroupPlansSuspenseQueryHookResult = ReturnType<
  typeof useGetNotificationGroupPlansSuspenseQuery
>;
export type GetNotificationGroupPlansQueryResult = Apollo.QueryResult<
  GetNotificationGroupPlansQuery,
  GetNotificationGroupPlansQueryVariables
>;
export const GetNotificationGroupsDocument = gql`
  query getNotificationGroups(
    $page: Int
    $limit: Int
    $sort: NotificationGroupSortInput
  ) {
    notificationGroups(page: $page, limit: $limit, sort: $sort) {
      result {
        id
        name
        description
        channels {
          id
          typeProperties {
            ... on EmailChannel {
              email
            }
            ... on WebhookChannel {
              url
              payload
              headers {
                key
                value
              }
              method
              type
            }
          }
        }
        changeDetails {
          updatedAt
          createdAt
          updatedBy
          createdBy
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetNotificationGroupsQuery__
 *
 * To run a query within a React component, call `useGetNotificationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetNotificationGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNotificationGroupsQuery,
    GetNotificationGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNotificationGroupsQuery,
    GetNotificationGroupsQueryVariables
  >(GetNotificationGroupsDocument, options);
}
export function useGetNotificationGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationGroupsQuery,
    GetNotificationGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationGroupsQuery,
    GetNotificationGroupsQueryVariables
  >(GetNotificationGroupsDocument, options);
}
// @ts-ignore
export function useGetNotificationGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNotificationGroupsQuery,
    GetNotificationGroupsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetNotificationGroupsQuery,
  GetNotificationGroupsQueryVariables
>;
export function useGetNotificationGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNotificationGroupsQuery,
        GetNotificationGroupsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetNotificationGroupsQuery | undefined,
  GetNotificationGroupsQueryVariables
>;
export function useGetNotificationGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNotificationGroupsQuery,
        GetNotificationGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetNotificationGroupsQuery,
    GetNotificationGroupsQueryVariables
  >(GetNotificationGroupsDocument, options);
}
export type GetNotificationGroupsQueryHookResult = ReturnType<
  typeof useGetNotificationGroupsQuery
>;
export type GetNotificationGroupsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationGroupsLazyQuery
>;
export type GetNotificationGroupsSuspenseQueryHookResult = ReturnType<
  typeof useGetNotificationGroupsSuspenseQuery
>;
export type GetNotificationGroupsQueryResult = Apollo.QueryResult<
  GetNotificationGroupsQuery,
  GetNotificationGroupsQueryVariables
>;
export const UpdateNotificationGroupDocument = gql`
  mutation updateNotificationGroup($input: UpdateNotificationGroupInput!) {
    updateNotificationGroup(input: $input) {
      id
      name
      description
      channels {
        id
        typeProperties {
          ... on EmailChannel {
            email
          }
          ... on WebhookChannel {
            url
            payload
            headers {
              key
              value
            }
            method
            type
          }
        }
      }
      changeDetails {
        updatedAt
        createdAt
        updatedBy
        createdBy
      }
    }
  }
`;
export type UpdateNotificationGroupMutationFn = Apollo.MutationFunction<
  UpdateNotificationGroupMutation,
  UpdateNotificationGroupMutationVariables
>;

/**
 * __useUpdateNotificationGroupMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationGroupMutation, { data, loading, error }] = useUpdateNotificationGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationGroupMutation,
    UpdateNotificationGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateNotificationGroupMutation,
    UpdateNotificationGroupMutationVariables
  >(UpdateNotificationGroupDocument, options);
}
export type UpdateNotificationGroupMutationHookResult = ReturnType<
  typeof useUpdateNotificationGroupMutation
>;
export type UpdateNotificationGroupMutationResult =
  Apollo.MutationResult<UpdateNotificationGroupMutation>;
export type UpdateNotificationGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateNotificationGroupMutation,
  UpdateNotificationGroupMutationVariables
>;
export const CreateApiKeyDocument = gql`
  mutation createApiKey($input: CreateApiKeyInput!) {
    createApiKey(input: $input) {
      apiKey {
        id
        name
        owner
        description
        changeDetails {
          createdBy
          createdAt
          updatedBy
          updatedAt
        }
        lastUsedAt
        expiresAt
      }
      apiKeySecret
    }
  }
`;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<
  CreateApiKeyMutation,
  CreateApiKeyMutationVariables
>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateApiKeyMutation,
    CreateApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateApiKeyMutation,
    CreateApiKeyMutationVariables
  >(CreateApiKeyDocument, options);
}
export type CreateApiKeyMutationHookResult = ReturnType<
  typeof useCreateApiKeyMutation
>;
export type CreateApiKeyMutationResult =
  Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<
  CreateApiKeyMutation,
  CreateApiKeyMutationVariables
>;
export const DeleteApiKeyDocument = gql`
  mutation deleteApiKey($apiKeyId: UUID!) {
    removeApiKey(id: $apiKeyId)
  }
`;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<
  DeleteApiKeyMutation,
  DeleteApiKeyMutationVariables
>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteApiKeyMutation,
    DeleteApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteApiKeyMutation,
    DeleteApiKeyMutationVariables
  >(DeleteApiKeyDocument, options);
}
export type DeleteApiKeyMutationHookResult = ReturnType<
  typeof useDeleteApiKeyMutation
>;
export type DeleteApiKeyMutationResult =
  Apollo.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<
  DeleteApiKeyMutation,
  DeleteApiKeyMutationVariables
>;
export const GetApiKeysDocument = gql`
  query getApiKeys($page: Int, $limit: Int, $sort: ApiKeysSortInput) {
    apiKeys(page: $page, limit: $limit, sort: $sort) {
      result {
        id
        name
        owner
        description
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        lastUsedAt
        expiresAt
        roleBindings(page: 1, limit: 100) {
          pageInfo {
            pages
            count
          }
          result {
            id
            role {
              id
              name
            }
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetApiKeysQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetApiKeysQuery,
    GetApiKeysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(
    GetApiKeysDocument,
    options
  );
}
export function useGetApiKeysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetApiKeysQuery,
    GetApiKeysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(
    GetApiKeysDocument,
    options
  );
}
// @ts-ignore
export function useGetApiKeysSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetApiKeysQuery,
    GetApiKeysQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export function useGetApiKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetApiKeysQuery | undefined,
  GetApiKeysQueryVariables
>;
export function useGetApiKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(
    GetApiKeysDocument,
    options
  );
}
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<
  typeof useGetApiKeysLazyQuery
>;
export type GetApiKeysSuspenseQueryHookResult = ReturnType<
  typeof useGetApiKeysSuspenseQuery
>;
export type GetApiKeysQueryResult = Apollo.QueryResult<
  GetApiKeysQuery,
  GetApiKeysQueryVariables
>;
export const UpdateApiKeyDocument = gql`
  mutation updateApiKey($input: UpdateApiKeyInput!) {
    updateApiKey(input: $input) {
      id
      name
      description
      expiresAt
      owner
      roleBindings(page: 1, limit: 100) {
        result {
          id
          role {
            id
            name
          }
        }
      }
      changeDetails {
        updatedAt
        updatedBy
      }
    }
  }
`;
export type UpdateApiKeyMutationFn = Apollo.MutationFunction<
  UpdateApiKeyMutation,
  UpdateApiKeyMutationVariables
>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateApiKeyMutation,
    UpdateApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateApiKeyMutation,
    UpdateApiKeyMutationVariables
  >(UpdateApiKeyDocument, options);
}
export type UpdateApiKeyMutationHookResult = ReturnType<
  typeof useUpdateApiKeyMutation
>;
export type UpdateApiKeyMutationResult =
  Apollo.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<
  UpdateApiKeyMutation,
  UpdateApiKeyMutationVariables
>;
export const GetRoleDocument = gql`
  query getRole($roleId: UUID!) {
    role(id: $roleId) {
      id
      name
      description
      rules {
        resources
        actions
      }
    }
  }
`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetRoleQuery(
  baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> &
    ({ variables: GetRoleQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(
    GetRoleDocument,
    options
  );
}
export function useGetRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(
    GetRoleDocument,
    options
  );
}
// @ts-ignore
export function useGetRoleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRoleQuery,
    GetRoleQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetRoleQuery, GetRoleQueryVariables>;
export function useGetRoleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetRoleQuery | undefined,
  GetRoleQueryVariables
>;
export function useGetRoleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(
    GetRoleDocument,
    options
  );
}
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<
  typeof useGetRoleSuspenseQuery
>;
export type GetRoleQueryResult = Apollo.QueryResult<
  GetRoleQuery,
  GetRoleQueryVariables
>;
export const UpdateRoleDocument = gql`
  mutation updateRole($input: RoleUpdateInput!) {
    updateRole(input: $input) {
      id
      name
      description
      rules {
        resources
        actions
      }
      changeDetails {
        updatedAt
        updatedBy
      }
    }
  }
`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<
  UpdateRoleMutation,
  UpdateRoleMutationVariables
>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRoleMutation,
    UpdateRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(
    UpdateRoleDocument,
    options
  );
}
export type UpdateRoleMutationHookResult = ReturnType<
  typeof useUpdateRoleMutation
>;
export type UpdateRoleMutationResult =
  Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<
  UpdateRoleMutation,
  UpdateRoleMutationVariables
>;
export const CreateRoleDocument = gql`
  mutation createRole($input: RoleInput!) {
    createRole(input: $input) {
      id
    }
  }
`;
export type CreateRoleMutationFn = Apollo.MutationFunction<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRoleMutation,
    CreateRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(
    CreateRoleDocument,
    options
  );
}
export type CreateRoleMutationHookResult = ReturnType<
  typeof useCreateRoleMutation
>;
export type CreateRoleMutationResult =
  Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;
export const DeleteRoleDocument = gql`
  mutation deleteRole($roleId: UUID!) {
    removeRole(id: $roleId)
  }
`;
export type DeleteRoleMutationFn = Apollo.MutationFunction<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRoleMutation,
    DeleteRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(
    DeleteRoleDocument,
    options
  );
}
export type DeleteRoleMutationHookResult = ReturnType<
  typeof useDeleteRoleMutation
>;
export type DeleteRoleMutationResult =
  Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;
export const GetRolesDocument = gql`
  query getRoles($page: Int, $limit: Int, $sort: RolesSortInput) {
    roles(page: $page, limit: $limit, sort: $sort) {
      result {
        id
        name
        description
        rules {
          resources
          actions
        }
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(
    GetRolesDocument,
    options
  );
}
export function useGetRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRolesQuery,
    GetRolesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(
    GetRolesDocument,
    options
  );
}
// @ts-ignore
export function useGetRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRolesQuery,
    GetRolesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetRolesQuery, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetRolesQuery | undefined,
  GetRolesQueryVariables
>;
export function useGetRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(
    GetRolesDocument,
    options
  );
}
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<
  typeof useGetRolesLazyQuery
>;
export type GetRolesSuspenseQueryHookResult = ReturnType<
  typeof useGetRolesSuspenseQuery
>;
export type GetRolesQueryResult = Apollo.QueryResult<
  GetRolesQuery,
  GetRolesQueryVariables
>;
export const DeleteUserDocument = gql`
  mutation deleteUser($userId: String!) {
    removeUser(id: $userId)
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options
  );
}
export type DeleteUserMutationHookResult = ReturnType<
  typeof useDeleteUserMutation
>;
export type DeleteUserMutationResult =
  Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const GetRoleBindingsByUsersDocument = gql`
  query getRoleBindingsByUsers(
    $limit: Int!
    $page: Int!
    $sort: RoleBindingsByUsersSortInput
  ) {
    roleBindingsByUsers(page: $page, limit: $limit, sort: $sort) {
      result {
        customerId
        type
        subject
        lastLoggedInAt
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        roles {
          id
          name
          description
          rules {
            resources
            actions
          }
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetRoleBindingsByUsersQuery__
 *
 * To run a query within a React component, call `useGetRoleBindingsByUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleBindingsByUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleBindingsByUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetRoleBindingsByUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRoleBindingsByUsersQuery,
    GetRoleBindingsByUsersQueryVariables
  > &
    (
      | { variables: GetRoleBindingsByUsersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRoleBindingsByUsersQuery,
    GetRoleBindingsByUsersQueryVariables
  >(GetRoleBindingsByUsersDocument, options);
}
export function useGetRoleBindingsByUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRoleBindingsByUsersQuery,
    GetRoleBindingsByUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRoleBindingsByUsersQuery,
    GetRoleBindingsByUsersQueryVariables
  >(GetRoleBindingsByUsersDocument, options);
}
// @ts-ignore
export function useGetRoleBindingsByUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRoleBindingsByUsersQuery,
    GetRoleBindingsByUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetRoleBindingsByUsersQuery,
  GetRoleBindingsByUsersQueryVariables
>;
export function useGetRoleBindingsByUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRoleBindingsByUsersQuery,
        GetRoleBindingsByUsersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetRoleBindingsByUsersQuery | undefined,
  GetRoleBindingsByUsersQueryVariables
>;
export function useGetRoleBindingsByUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRoleBindingsByUsersQuery,
        GetRoleBindingsByUsersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRoleBindingsByUsersQuery,
    GetRoleBindingsByUsersQueryVariables
  >(GetRoleBindingsByUsersDocument, options);
}
export type GetRoleBindingsByUsersQueryHookResult = ReturnType<
  typeof useGetRoleBindingsByUsersQuery
>;
export type GetRoleBindingsByUsersLazyQueryHookResult = ReturnType<
  typeof useGetRoleBindingsByUsersLazyQuery
>;
export type GetRoleBindingsByUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetRoleBindingsByUsersSuspenseQuery
>;
export type GetRoleBindingsByUsersQueryResult = Apollo.QueryResult<
  GetRoleBindingsByUsersQuery,
  GetRoleBindingsByUsersQueryVariables
>;
export const CreateRoleBindingDocument = gql`
  mutation createRoleBinding($input: CreateRoleBindingInput!) {
    createRoleBinding(input: $input) {
      id
      type
      subject
      role {
        id
        name
        description
      }
    }
  }
`;
export type CreateRoleBindingMutationFn = Apollo.MutationFunction<
  CreateRoleBindingMutation,
  CreateRoleBindingMutationVariables
>;

/**
 * __useCreateRoleBindingMutation__
 *
 * To run a mutation, you first call `useCreateRoleBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleBindingMutation, { data, loading, error }] = useCreateRoleBindingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRoleBindingMutation,
    CreateRoleBindingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRoleBindingMutation,
    CreateRoleBindingMutationVariables
  >(CreateRoleBindingDocument, options);
}
export type CreateRoleBindingMutationHookResult = ReturnType<
  typeof useCreateRoleBindingMutation
>;
export type CreateRoleBindingMutationResult =
  Apollo.MutationResult<CreateRoleBindingMutation>;
export type CreateRoleBindingMutationOptions = Apollo.BaseMutationOptions<
  CreateRoleBindingMutation,
  CreateRoleBindingMutationVariables
>;
export const DeleteRoleBindingDocument = gql`
  mutation deleteRoleBinding($id: ID!) {
    removeRoleBinding(id: $id)
  }
`;
export type DeleteRoleBindingMutationFn = Apollo.MutationFunction<
  DeleteRoleBindingMutation,
  DeleteRoleBindingMutationVariables
>;

/**
 * __useDeleteRoleBindingMutation__
 *
 * To run a mutation, you first call `useDeleteRoleBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleBindingMutation, { data, loading, error }] = useDeleteRoleBindingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRoleBindingMutation,
    DeleteRoleBindingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteRoleBindingMutation,
    DeleteRoleBindingMutationVariables
  >(DeleteRoleBindingDocument, options);
}
export type DeleteRoleBindingMutationHookResult = ReturnType<
  typeof useDeleteRoleBindingMutation
>;
export type DeleteRoleBindingMutationResult =
  Apollo.MutationResult<DeleteRoleBindingMutation>;
export type DeleteRoleBindingMutationOptions = Apollo.BaseMutationOptions<
  DeleteRoleBindingMutation,
  DeleteRoleBindingMutationVariables
>;
export const CreatePlanDocument = gql`
  mutation createPlan($input: CreatePlanInput!) {
    createPlan(input: $input) {
      id
    }
  }
`;
export type CreatePlanMutationFn = Apollo.MutationFunction<
  CreatePlanMutation,
  CreatePlanMutationVariables
>;

/**
 * __useCreatePlanMutation__
 *
 * To run a mutation, you first call `useCreatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanMutation, { data, loading, error }] = useCreatePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlanMutation,
    CreatePlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePlanMutation, CreatePlanMutationVariables>(
    CreatePlanDocument,
    options
  );
}
export type CreatePlanMutationHookResult = ReturnType<
  typeof useCreatePlanMutation
>;
export type CreatePlanMutationResult =
  Apollo.MutationResult<CreatePlanMutation>;
export type CreatePlanMutationOptions = Apollo.BaseMutationOptions<
  CreatePlanMutation,
  CreatePlanMutationVariables
>;
export const DeletePlanDocument = gql`
  mutation deletePlan($id: UUID!) {
    removePlan(id: $id)
  }
`;
export type DeletePlanMutationFn = Apollo.MutationFunction<
  DeletePlanMutation,
  DeletePlanMutationVariables
>;

/**
 * __useDeletePlanMutation__
 *
 * To run a mutation, you first call `useDeletePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanMutation, { data, loading, error }] = useDeletePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePlanMutation,
    DeletePlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePlanMutation, DeletePlanMutationVariables>(
    DeletePlanDocument,
    options
  );
}
export type DeletePlanMutationHookResult = ReturnType<
  typeof useDeletePlanMutation
>;
export type DeletePlanMutationResult =
  Apollo.MutationResult<DeletePlanMutation>;
export type DeletePlanMutationOptions = Apollo.BaseMutationOptions<
  DeletePlanMutation,
  DeletePlanMutationVariables
>;
export const GenerateCronFromPhraseDocument = gql`
  mutation generateCronFromPhrase($input: GenerateCronFromPhraseInput!) {
    generateCronFromPhrase(input: $input) {
      expression
      fields {
        name
        value
        description
      }
      error
    }
  }
`;
export type GenerateCronFromPhraseMutationFn = Apollo.MutationFunction<
  GenerateCronFromPhraseMutation,
  GenerateCronFromPhraseMutationVariables
>;

/**
 * __useGenerateCronFromPhraseMutation__
 *
 * To run a mutation, you first call `useGenerateCronFromPhraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCronFromPhraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCronFromPhraseMutation, { data, loading, error }] = useGenerateCronFromPhraseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCronFromPhraseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateCronFromPhraseMutation,
    GenerateCronFromPhraseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateCronFromPhraseMutation,
    GenerateCronFromPhraseMutationVariables
  >(GenerateCronFromPhraseDocument, options);
}
export type GenerateCronFromPhraseMutationHookResult = ReturnType<
  typeof useGenerateCronFromPhraseMutation
>;
export type GenerateCronFromPhraseMutationResult =
  Apollo.MutationResult<GenerateCronFromPhraseMutation>;
export type GenerateCronFromPhraseMutationOptions = Apollo.BaseMutationOptions<
  GenerateCronFromPhraseMutation,
  GenerateCronFromPhraseMutationVariables
>;
export const GenerateDatesFromCronDocument = gql`
  mutation generateDatesFromCron($input: GenerateDatesFromCronInput!) {
    generateDatesFromCron(input: $input) {
      dates
      validationMsg
      error
    }
  }
`;
export type GenerateDatesFromCronMutationFn = Apollo.MutationFunction<
  GenerateDatesFromCronMutation,
  GenerateDatesFromCronMutationVariables
>;

/**
 * __useGenerateDatesFromCronMutation__
 *
 * To run a mutation, you first call `useGenerateDatesFromCronMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDatesFromCronMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDatesFromCronMutation, { data, loading, error }] = useGenerateDatesFromCronMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateDatesFromCronMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateDatesFromCronMutation,
    GenerateDatesFromCronMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateDatesFromCronMutation,
    GenerateDatesFromCronMutationVariables
  >(GenerateDatesFromCronDocument, options);
}
export type GenerateDatesFromCronMutationHookResult = ReturnType<
  typeof useGenerateDatesFromCronMutation
>;
export type GenerateDatesFromCronMutationResult =
  Apollo.MutationResult<GenerateDatesFromCronMutation>;
export type GenerateDatesFromCronMutationOptions = Apollo.BaseMutationOptions<
  GenerateDatesFromCronMutation,
  GenerateDatesFromCronMutationVariables
>;
export const GetPlanDocument = gql`
  query getPlan($planId: UUID!) {
    plan(id: $planId) {
      id
      name
      description
      enabled
      scheduleCron
      scheduleOffset
      scheduleTimezone
      scheduleExecutionDates
      changeDetails {
        updatedAt
        updatedBy
        createdAt
        createdBy
      }
      metadata {
        key
        value
      }
      planActions {
        id
        order
        name
        windowDuration
        skipWindow
        executionPolicy
        resourceGroups {
          id
          name
          description
          resourcesCounts {
            totalCount
            disconnectedCount
            onlineCount
          }
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
        resources {
          id
          name
          os {
            type
            subType
            architecture
          }
          autoDiscovery
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
          cloudResourceId
          fullCloudResourceId
          enabled
          provider
          providerId
          region
          scanned
        }
        inputParameters {
          key
          value
        }
        runInSequence
        action {
          ... on Action {
            id
            name
            description
            color
            type
            scope
            synchronous
            typeProperties {
              __typename
              ... on ActionPropertyAWSLambda {
                lambdaArn
              }
              ... on ActionPropertyAzureFunction {
                accessKeyId
                functionMethod
                functionUrl
              }
              ... on ActionPropertyScript {
                s3FileUrl
              }
              ... on ActionPropertySSMDocument {
                documentId
              }
              ... on ActionPropertyWebhook {
                webhookUrl
                webhookMethod
                payload
                headers {
                  key
                  value
                }
              }
            }
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
            parameterDefinitions {
              name
              required
              description
              allowedValues
              defaultValue
              type
            }
          }
          ... on SystemAction {
            id
            name
            scope
            color
            scope
            version
            scope
            parameterDefinitions {
              name
              required
              description
              allowedValues
              defaultValue
              type
            }
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
          }
        }
        notificationGroups {
          id
          notificationGroup {
            id
            name
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
          }
          triggerEvent
          inAdvance
          scope
        }
      }
      planActionBatches {
        id
        name
        order
        windowDuration
        skipWindow
        executionPolicy
        batchActions {
          id
          name
          order
          resourceGroups {
            id
            name
            description
            resourcesCounts {
              totalCount
              disconnectedCount
              onlineCount
            }
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
          }
          resources {
            id
            name
            os {
              type
              subType
              architecture
            }
            autoDiscovery
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
            cloudResourceId
            fullCloudResourceId
            enabled
            provider
            providerId
            region
            scanned
          }
          notificationGroups {
            id
            notificationGroup {
              id
              name
              changeDetails {
                createdAt
                createdBy
                updatedAt
                updatedBy
              }
            }
            triggerEvent
            inAdvance
            scope
          }
          action {
            ... on Action {
              id
              name
              description
              color
              type
              scope
              synchronous
              typeProperties {
                __typename
                ... on ActionPropertyAWSLambda {
                  lambdaArn
                }
                ... on ActionPropertyAzureFunction {
                  accessKeyId
                  functionMethod
                  functionUrl
                }
                ... on ActionPropertyScript {
                  s3FileUrl
                }
                ... on ActionPropertySSMDocument {
                  documentId
                }
                ... on ActionPropertyWebhook {
                  webhookUrl
                  webhookMethod
                  payload
                  headers {
                    key
                    value
                  }
                }
              }
              changeDetails {
                createdAt
                createdBy
                updatedAt
                updatedBy
              }
              parameterDefinitions {
                name
                required
                description
                allowedValues
                defaultValue
                type
              }
            }
            ... on SystemAction {
              id
              name
              scope
              color
              scope
              version
              scope
              parameterDefinitions {
                name
                required
                description
                allowedValues
                defaultValue
                type
              }
              changeDetails {
                createdAt
                createdBy
                updatedAt
                updatedBy
              }
            }
          }
          inputParameters {
            key
            value
          }
        }
      }
      notificationGroups {
        id
        triggerEvent
        inAdvance
        notificationGroup {
          id
          name
          description
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
      }
    }
  }
`;

/**
 * __useGetPlanQuery__
 *
 * To run a query within a React component, call `useGetPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useGetPlanQuery(
  baseOptions: Apollo.QueryHookOptions<GetPlanQuery, GetPlanQueryVariables> &
    ({ variables: GetPlanQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlanQuery, GetPlanQueryVariables>(
    GetPlanDocument,
    options
  );
}
export function useGetPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPlanQuery, GetPlanQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlanQuery, GetPlanQueryVariables>(
    GetPlanDocument,
    options
  );
}
// @ts-ignore
export function useGetPlanSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPlanQuery,
    GetPlanQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetPlanQuery, GetPlanQueryVariables>;
export function useGetPlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPlanQuery, GetPlanQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetPlanQuery | undefined,
  GetPlanQueryVariables
>;
export function useGetPlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPlanQuery, GetPlanQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPlanQuery, GetPlanQueryVariables>(
    GetPlanDocument,
    options
  );
}
export type GetPlanQueryHookResult = ReturnType<typeof useGetPlanQuery>;
export type GetPlanLazyQueryHookResult = ReturnType<typeof useGetPlanLazyQuery>;
export type GetPlanSuspenseQueryHookResult = ReturnType<
  typeof useGetPlanSuspenseQuery
>;
export type GetPlanQueryResult = Apollo.QueryResult<
  GetPlanQuery,
  GetPlanQueryVariables
>;
export const GetPlanNamesDocument = gql`
  query getPlanNames(
    $page: Int
    $limit: Int
    $sort: PlanSortInput
    $filter: PlansFilterInput
  ) {
    plans(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetPlanNamesQuery__
 *
 * To run a query within a React component, call `useGetPlanNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanNamesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPlanNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPlanNamesQuery,
    GetPlanNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlanNamesQuery, GetPlanNamesQueryVariables>(
    GetPlanNamesDocument,
    options
  );
}
export function useGetPlanNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlanNamesQuery,
    GetPlanNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlanNamesQuery, GetPlanNamesQueryVariables>(
    GetPlanNamesDocument,
    options
  );
}
// @ts-ignore
export function useGetPlanNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPlanNamesQuery,
    GetPlanNamesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetPlanNamesQuery, GetPlanNamesQueryVariables>;
export function useGetPlanNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPlanNamesQuery,
        GetPlanNamesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPlanNamesQuery | undefined,
  GetPlanNamesQueryVariables
>;
export function useGetPlanNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPlanNamesQuery,
        GetPlanNamesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPlanNamesQuery, GetPlanNamesQueryVariables>(
    GetPlanNamesDocument,
    options
  );
}
export type GetPlanNamesQueryHookResult = ReturnType<
  typeof useGetPlanNamesQuery
>;
export type GetPlanNamesLazyQueryHookResult = ReturnType<
  typeof useGetPlanNamesLazyQuery
>;
export type GetPlanNamesSuspenseQueryHookResult = ReturnType<
  typeof useGetPlanNamesSuspenseQuery
>;
export type GetPlanNamesQueryResult = Apollo.QueryResult<
  GetPlanNamesQuery,
  GetPlanNamesQueryVariables
>;
export const GetPlansDocument = gql`
  query getPlans(
    $page: Int
    $limit: Int
    $sort: PlanSortInput
    $filter: PlansFilterInput
  ) {
    plans(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
        description
        enabled
        scheduleCron
        scheduleTimezone
        scheduleExecutionDates
        scheduleOffset
        changeDetails {
          updatedAt
          updatedBy
          createdAt
          createdBy
        }
        metadata {
          key
          value
        }
        planActions {
          id
          action {
            ... on Action {
              id
            }
            ... on SystemAction {
              id
            }
          }
        }
        notificationGroups {
          notificationGroup {
            id
            name
            description
          }
        }
        nextExecutionDates
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetPlansQuery__
 *
 * To run a query within a React component, call `useGetPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPlansQuery, GetPlansQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlansQuery, GetPlansQueryVariables>(
    GetPlansDocument,
    options
  );
}
export function useGetPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlansQuery,
    GetPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlansQuery, GetPlansQueryVariables>(
    GetPlansDocument,
    options
  );
}
// @ts-ignore
export function useGetPlansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPlansQuery,
    GetPlansQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetPlansQuery, GetPlansQueryVariables>;
export function useGetPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPlansQuery, GetPlansQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetPlansQuery | undefined,
  GetPlansQueryVariables
>;
export function useGetPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPlansQuery, GetPlansQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPlansQuery, GetPlansQueryVariables>(
    GetPlansDocument,
    options
  );
}
export type GetPlansQueryHookResult = ReturnType<typeof useGetPlansQuery>;
export type GetPlansLazyQueryHookResult = ReturnType<
  typeof useGetPlansLazyQuery
>;
export type GetPlansSuspenseQueryHookResult = ReturnType<
  typeof useGetPlansSuspenseQuery
>;
export type GetPlansQueryResult = Apollo.QueryResult<
  GetPlansQuery,
  GetPlansQueryVariables
>;
export const GetPlansBasicDocument = gql`
  query getPlansBasic(
    $page: Int
    $limit: Int
    $sort: PlanSortInput
    $filter: PlansFilterInput
  ) {
    plans(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetPlansBasicQuery__
 *
 * To run a query within a React component, call `useGetPlansBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansBasicQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPlansBasicQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPlansBasicQuery,
    GetPlansBasicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlansBasicQuery, GetPlansBasicQueryVariables>(
    GetPlansBasicDocument,
    options
  );
}
export function useGetPlansBasicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlansBasicQuery,
    GetPlansBasicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlansBasicQuery, GetPlansBasicQueryVariables>(
    GetPlansBasicDocument,
    options
  );
}
// @ts-ignore
export function useGetPlansBasicSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPlansBasicQuery,
    GetPlansBasicQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPlansBasicQuery,
  GetPlansBasicQueryVariables
>;
export function useGetPlansBasicSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPlansBasicQuery,
        GetPlansBasicQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPlansBasicQuery | undefined,
  GetPlansBasicQueryVariables
>;
export function useGetPlansBasicSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPlansBasicQuery,
        GetPlansBasicQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPlansBasicQuery,
    GetPlansBasicQueryVariables
  >(GetPlansBasicDocument, options);
}
export type GetPlansBasicQueryHookResult = ReturnType<
  typeof useGetPlansBasicQuery
>;
export type GetPlansBasicLazyQueryHookResult = ReturnType<
  typeof useGetPlansBasicLazyQuery
>;
export type GetPlansBasicSuspenseQueryHookResult = ReturnType<
  typeof useGetPlansBasicSuspenseQuery
>;
export type GetPlansBasicQueryResult = Apollo.QueryResult<
  GetPlansBasicQuery,
  GetPlansBasicQueryVariables
>;
export const GetSystemActionsDocument = gql`
  query getSystemActions(
    $page: Int
    $limit: Int
    $sort: SystemActionsSortInput
  ) {
    systemActions(page: $page, limit: $limit, sort: $sort) {
      result {
        id
        name
        color
        description
        version
        scope
        parameterDefinitions {
          name
          required
          description
          allowedValues
          defaultValue
          type
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetSystemActionsQuery__
 *
 * To run a query within a React component, call `useGetSystemActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemActionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSystemActionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSystemActionsQuery,
    GetSystemActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSystemActionsQuery, GetSystemActionsQueryVariables>(
    GetSystemActionsDocument,
    options
  );
}
export function useGetSystemActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSystemActionsQuery,
    GetSystemActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSystemActionsQuery,
    GetSystemActionsQueryVariables
  >(GetSystemActionsDocument, options);
}
// @ts-ignore
export function useGetSystemActionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSystemActionsQuery,
    GetSystemActionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetSystemActionsQuery,
  GetSystemActionsQueryVariables
>;
export function useGetSystemActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSystemActionsQuery,
        GetSystemActionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetSystemActionsQuery | undefined,
  GetSystemActionsQueryVariables
>;
export function useGetSystemActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSystemActionsQuery,
        GetSystemActionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSystemActionsQuery,
    GetSystemActionsQueryVariables
  >(GetSystemActionsDocument, options);
}
export type GetSystemActionsQueryHookResult = ReturnType<
  typeof useGetSystemActionsQuery
>;
export type GetSystemActionsLazyQueryHookResult = ReturnType<
  typeof useGetSystemActionsLazyQuery
>;
export type GetSystemActionsSuspenseQueryHookResult = ReturnType<
  typeof useGetSystemActionsSuspenseQuery
>;
export type GetSystemActionsQueryResult = Apollo.QueryResult<
  GetSystemActionsQuery,
  GetSystemActionsQueryVariables
>;
export const TriggerPlanDocument = gql`
  mutation triggerPlan($id: UUID!) {
    triggerPlan(id: $id) {
      id
      plan {
        id
      }
    }
  }
`;
export type TriggerPlanMutationFn = Apollo.MutationFunction<
  TriggerPlanMutation,
  TriggerPlanMutationVariables
>;

/**
 * __useTriggerPlanMutation__
 *
 * To run a mutation, you first call `useTriggerPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerPlanMutation, { data, loading, error }] = useTriggerPlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerPlanMutation,
    TriggerPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TriggerPlanMutation, TriggerPlanMutationVariables>(
    TriggerPlanDocument,
    options
  );
}
export type TriggerPlanMutationHookResult = ReturnType<
  typeof useTriggerPlanMutation
>;
export type TriggerPlanMutationResult =
  Apollo.MutationResult<TriggerPlanMutation>;
export type TriggerPlanMutationOptions = Apollo.BaseMutationOptions<
  TriggerPlanMutation,
  TriggerPlanMutationVariables
>;
export const UpdatePlanDocument = gql`
  mutation updatePlan($input: UpdatePlanInput!) {
    updatePlan(input: $input) {
      id
      name
      description
      enabled
      scheduleCron
      scheduleOffset
      scheduleTimezone
      scheduleExecutionDates
      metadata {
        key
        value
      }
      planActions {
        id
        order
        windowDuration
        skipWindow
        executionPolicy
        resourceGroups {
          id
          name
          description
          resourcesCounts {
            totalCount
            disconnectedCount
            onlineCount
          }
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
        inputParameters {
          key
          value
        }
        runInSequence
        action {
          ... on Action {
            id
            name
            description
            color
            type
            scope
            synchronous
            typeProperties {
              __typename
              ... on ActionPropertyAWSLambda {
                lambdaArn
              }
              ... on ActionPropertyAzureFunction {
                accessKeyId
                functionMethod
                functionUrl
              }
              ... on ActionPropertyScript {
                s3FileUrl
              }
              ... on ActionPropertySSMDocument {
                documentId
              }
              ... on ActionPropertyWebhook {
                webhookUrl
                webhookMethod
                payload
                headers {
                  key
                  value
                }
              }
            }
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
            parameterDefinitions {
              name
              required
              description
              allowedValues
              defaultValue
              type
            }
          }
          ... on SystemAction {
            id
            name
            scope
            color
            scope
            version
            scope
            parameterDefinitions {
              name
              required
              description
              allowedValues
              defaultValue
              type
            }
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
          }
        }
        notificationGroups {
          id
          notificationGroup {
            id
            name
            changeDetails {
              createdAt
              createdBy
              updatedAt
              updatedBy
            }
          }
          triggerEvent
          scope
        }
      }
      planActionBatches {
        id
        name
        batchActions {
          id
          name
        }
      }
      notificationGroups {
        id
        triggerEvent
        inAdvance
        notificationGroup {
          id
          name
        }
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
export type UpdatePlanMutationFn = Apollo.MutationFunction<
  UpdatePlanMutation,
  UpdatePlanMutationVariables
>;

/**
 * __useUpdatePlanMutation__
 *
 * To run a mutation, you first call `useUpdatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanMutation, { data, loading, error }] = useUpdatePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlanMutation,
    UpdatePlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePlanMutation, UpdatePlanMutationVariables>(
    UpdatePlanDocument,
    options
  );
}
export type UpdatePlanMutationHookResult = ReturnType<
  typeof useUpdatePlanMutation
>;
export type UpdatePlanMutationResult =
  Apollo.MutationResult<UpdatePlanMutation>;
export type UpdatePlanMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlanMutation,
  UpdatePlanMutationVariables
>;
export const CreateGroupDocument = gql`
  mutation createGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      id
      name
    }
  }
`;
export type CreateGroupMutationFn = Apollo.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    options
  );
}
export type CreateGroupMutationHookResult = ReturnType<
  typeof useCreateGroupMutation
>;
export type CreateGroupMutationResult =
  Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;
export const DeleteGroupDocument = gql`
  mutation deleteGroup($id: UUID!) {
    removeGroup(id: $id)
  }
`;
export type DeleteGroupMutationFn = Apollo.MutationFunction<
  DeleteGroupMutation,
  DeleteGroupMutationVariables
>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGroupMutation,
    DeleteGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(
    DeleteGroupDocument,
    options
  );
}
export type DeleteGroupMutationHookResult = ReturnType<
  typeof useDeleteGroupMutation
>;
export type DeleteGroupMutationResult =
  Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteGroupMutation,
  DeleteGroupMutationVariables
>;
export const GetGroupPlansDocument = gql`
  query getGroupPlans($resourceGroupId: UUID!) {
    group(id: $resourceGroupId) {
      plans {
        id
        name
      }
    }
  }
`;

/**
 * __useGetGroupPlansQuery__
 *
 * To run a query within a React component, call `useGetGroupPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupPlansQuery({
 *   variables: {
 *      resourceGroupId: // value for 'resourceGroupId'
 *   },
 * });
 */
export function useGetGroupPlansQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGroupPlansQuery,
    GetGroupPlansQueryVariables
  > &
    (
      | { variables: GetGroupPlansQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupPlansQuery, GetGroupPlansQueryVariables>(
    GetGroupPlansDocument,
    options
  );
}
export function useGetGroupPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupPlansQuery,
    GetGroupPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupPlansQuery, GetGroupPlansQueryVariables>(
    GetGroupPlansDocument,
    options
  );
}
// @ts-ignore
export function useGetGroupPlansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupPlansQuery,
    GetGroupPlansQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetGroupPlansQuery,
  GetGroupPlansQueryVariables
>;
export function useGetGroupPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupPlansQuery,
        GetGroupPlansQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetGroupPlansQuery | undefined,
  GetGroupPlansQueryVariables
>;
export function useGetGroupPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupPlansQuery,
        GetGroupPlansQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetGroupPlansQuery,
    GetGroupPlansQueryVariables
  >(GetGroupPlansDocument, options);
}
export type GetGroupPlansQueryHookResult = ReturnType<
  typeof useGetGroupPlansQuery
>;
export type GetGroupPlansLazyQueryHookResult = ReturnType<
  typeof useGetGroupPlansLazyQuery
>;
export type GetGroupPlansSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupPlansSuspenseQuery
>;
export type GetGroupPlansQueryResult = Apollo.QueryResult<
  GetGroupPlansQuery,
  GetGroupPlansQueryVariables
>;
export const GetResourceGroupDocument = gql`
  query getResourceGroup($resourceGroupId: UUID!) {
    group(id: $resourceGroupId) {
      id
      name
      description
      metadata {
        key
        value
      }
      resourceSelectors {
        id
        resource {
          id
          name
          description
          os {
            type
            subType
            architecture
          }
          autoDiscovery
          fullCloudResourceId
          cloudResourceId
          enabled
          provider
          providerId
          region
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
          scanned
        }
        tagsExpression
        order
        dynamicResources {
          name
          id
          provider
          os {
            type
            subType
            architecture
          }
          autoDiscovery
          cloudResourceId
          fullCloudResourceId
          enabled
          provider
          providerId
          region
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
          scanned
        }
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

/**
 * __useGetResourceGroupQuery__
 *
 * To run a query within a React component, call `useGetResourceGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceGroupQuery({
 *   variables: {
 *      resourceGroupId: // value for 'resourceGroupId'
 *   },
 * });
 */
export function useGetResourceGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetResourceGroupQuery,
    GetResourceGroupQueryVariables
  > &
    (
      | { variables: GetResourceGroupQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetResourceGroupQuery, GetResourceGroupQueryVariables>(
    GetResourceGroupDocument,
    options
  );
}
export function useGetResourceGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceGroupQuery,
    GetResourceGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourceGroupQuery,
    GetResourceGroupQueryVariables
  >(GetResourceGroupDocument, options);
}
// @ts-ignore
export function useGetResourceGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceGroupQuery,
    GetResourceGroupQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourceGroupQuery,
  GetResourceGroupQueryVariables
>;
export function useGetResourceGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceGroupQuery,
        GetResourceGroupQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceGroupQuery | undefined,
  GetResourceGroupQueryVariables
>;
export function useGetResourceGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceGroupQuery,
        GetResourceGroupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourceGroupQuery,
    GetResourceGroupQueryVariables
  >(GetResourceGroupDocument, options);
}
export type GetResourceGroupQueryHookResult = ReturnType<
  typeof useGetResourceGroupQuery
>;
export type GetResourceGroupLazyQueryHookResult = ReturnType<
  typeof useGetResourceGroupLazyQuery
>;
export type GetResourceGroupSuspenseQueryHookResult = ReturnType<
  typeof useGetResourceGroupSuspenseQuery
>;
export type GetResourceGroupQueryResult = Apollo.QueryResult<
  GetResourceGroupQuery,
  GetResourceGroupQueryVariables
>;
export const GetResourceGroupsDocument = gql`
  query getResourceGroups(
    $page: Int
    $limit: Int
    $sort: GroupsSortInput
    $filter: GroupsFilterInput
    $excludeResourceSelectors: Boolean = false
  ) {
    groups(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
        changeDetails {
          createdAt
          updatedAt
          updatedBy
        }
        resourceSelectors @skip(if: $excludeResourceSelectors) {
          id
          resource {
            id
            name
          }
          tagsExpression
          order
        }
        type
        resourcesCounts {
          disconnectedCount
          onlineCount
          totalCount
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetResourceGroupsQuery__
 *
 * To run a query within a React component, call `useGetResourceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      excludeResourceSelectors: // value for 'excludeResourceSelectors'
 *   },
 * });
 */
export function useGetResourceGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetResourceGroupsQuery,
    GetResourceGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetResourceGroupsQuery,
    GetResourceGroupsQueryVariables
  >(GetResourceGroupsDocument, options);
}
export function useGetResourceGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceGroupsQuery,
    GetResourceGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourceGroupsQuery,
    GetResourceGroupsQueryVariables
  >(GetResourceGroupsDocument, options);
}
// @ts-ignore
export function useGetResourceGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceGroupsQuery,
    GetResourceGroupsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourceGroupsQuery,
  GetResourceGroupsQueryVariables
>;
export function useGetResourceGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceGroupsQuery,
        GetResourceGroupsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceGroupsQuery | undefined,
  GetResourceGroupsQueryVariables
>;
export function useGetResourceGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceGroupsQuery,
        GetResourceGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourceGroupsQuery,
    GetResourceGroupsQueryVariables
  >(GetResourceGroupsDocument, options);
}
export type GetResourceGroupsQueryHookResult = ReturnType<
  typeof useGetResourceGroupsQuery
>;
export type GetResourceGroupsLazyQueryHookResult = ReturnType<
  typeof useGetResourceGroupsLazyQuery
>;
export type GetResourceGroupsSuspenseQueryHookResult = ReturnType<
  typeof useGetResourceGroupsSuspenseQuery
>;
export type GetResourceGroupsQueryResult = Apollo.QueryResult<
  GetResourceGroupsQuery,
  GetResourceGroupsQueryVariables
>;
export const GetResourceGroupsBasicDocument = gql`
  query getResourceGroupsBasic(
    $page: Int
    $limit: Int
    $sort: GroupsSortInput
    $filter: GroupsFilterInput
  ) {
    groups(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetResourceGroupsBasicQuery__
 *
 * To run a query within a React component, call `useGetResourceGroupsBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceGroupsBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceGroupsBasicQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetResourceGroupsBasicQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetResourceGroupsBasicQuery,
    GetResourceGroupsBasicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetResourceGroupsBasicQuery,
    GetResourceGroupsBasicQueryVariables
  >(GetResourceGroupsBasicDocument, options);
}
export function useGetResourceGroupsBasicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceGroupsBasicQuery,
    GetResourceGroupsBasicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourceGroupsBasicQuery,
    GetResourceGroupsBasicQueryVariables
  >(GetResourceGroupsBasicDocument, options);
}
// @ts-ignore
export function useGetResourceGroupsBasicSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceGroupsBasicQuery,
    GetResourceGroupsBasicQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourceGroupsBasicQuery,
  GetResourceGroupsBasicQueryVariables
>;
export function useGetResourceGroupsBasicSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceGroupsBasicQuery,
        GetResourceGroupsBasicQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceGroupsBasicQuery | undefined,
  GetResourceGroupsBasicQueryVariables
>;
export function useGetResourceGroupsBasicSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceGroupsBasicQuery,
        GetResourceGroupsBasicQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourceGroupsBasicQuery,
    GetResourceGroupsBasicQueryVariables
  >(GetResourceGroupsBasicDocument, options);
}
export type GetResourceGroupsBasicQueryHookResult = ReturnType<
  typeof useGetResourceGroupsBasicQuery
>;
export type GetResourceGroupsBasicLazyQueryHookResult = ReturnType<
  typeof useGetResourceGroupsBasicLazyQuery
>;
export type GetResourceGroupsBasicSuspenseQueryHookResult = ReturnType<
  typeof useGetResourceGroupsBasicSuspenseQuery
>;
export type GetResourceGroupsBasicQueryResult = Apollo.QueryResult<
  GetResourceGroupsBasicQuery,
  GetResourceGroupsBasicQueryVariables
>;
export const UpdateGroupDocument = gql`
  mutation updateGroup($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      id
      name
      description
      metadata {
        key
        value
      }
      resourceSelectors {
        id
        resource {
          id
          name
          description
          os {
            type
            subType
          }
        }
        tagsExpression
        order
        dynamicResources {
          name
          id
          provider
          os {
            type
            subType
          }
        }
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGroupMutation,
    UpdateGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(
    UpdateGroupDocument,
    options
  );
}
export type UpdateGroupMutationHookResult = ReturnType<
  typeof useUpdateGroupMutation
>;
export type UpdateGroupMutationResult =
  Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;
export const GetEventActionResourceReportDocument = gql`
  query getEventActionResourceReport(
    $eventActionId: UUID!
    $eventId: UUID!
    $resourceId: UUID!
  ) {
    eventActionResourceReport(
      eventActionId: $eventActionId
      eventId: $eventId
      resourceId: $resourceId
    ) {
      name
      resourceId
      result {
        installed {
          name
          id
          version
        }
        updated {
          name
          id
          version
        }
        removed {
          name
          id
          version
        }
        available {
          name
          id
          version
        }
        failed {
          name
          id
          version
        }
      }
    }
  }
`;

/**
 * __useGetEventActionResourceReportQuery__
 *
 * To run a query within a React component, call `useGetEventActionResourceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventActionResourceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventActionResourceReportQuery({
 *   variables: {
 *      eventActionId: // value for 'eventActionId'
 *      eventId: // value for 'eventId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetEventActionResourceReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventActionResourceReportQuery,
    GetEventActionResourceReportQueryVariables
  > &
    (
      | {
          variables: GetEventActionResourceReportQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventActionResourceReportQuery,
    GetEventActionResourceReportQueryVariables
  >(GetEventActionResourceReportDocument, options);
}
export function useGetEventActionResourceReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventActionResourceReportQuery,
    GetEventActionResourceReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventActionResourceReportQuery,
    GetEventActionResourceReportQueryVariables
  >(GetEventActionResourceReportDocument, options);
}
// @ts-ignore
export function useGetEventActionResourceReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventActionResourceReportQuery,
    GetEventActionResourceReportQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEventActionResourceReportQuery,
  GetEventActionResourceReportQueryVariables
>;
export function useGetEventActionResourceReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionResourceReportQuery,
        GetEventActionResourceReportQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEventActionResourceReportQuery | undefined,
  GetEventActionResourceReportQueryVariables
>;
export function useGetEventActionResourceReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventActionResourceReportQuery,
        GetEventActionResourceReportQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventActionResourceReportQuery,
    GetEventActionResourceReportQueryVariables
  >(GetEventActionResourceReportDocument, options);
}
export type GetEventActionResourceReportQueryHookResult = ReturnType<
  typeof useGetEventActionResourceReportQuery
>;
export type GetEventActionResourceReportLazyQueryHookResult = ReturnType<
  typeof useGetEventActionResourceReportLazyQuery
>;
export type GetEventActionResourceReportSuspenseQueryHookResult = ReturnType<
  typeof useGetEventActionResourceReportSuspenseQuery
>;
export type GetEventActionResourceReportQueryResult = Apollo.QueryResult<
  GetEventActionResourceReportQuery,
  GetEventActionResourceReportQueryVariables
>;
export const GetGroupsForResourceDocument = gql`
  query getGroupsForResource(
    $resourceId: UUID!
    $page: Int
    $limit: Int
    $sort: GroupsForResourceSortInput
    $filter: GroupsForResourceFilterInput
  ) {
    groupsForResource(
      resourceId: $resourceId
      page: $page
      limit: $limit
      sort: $sort
      filter: $filter
    ) {
      result {
        id
        createdAt
        createdBy
        updatedAt
        name
        resourceSelector {
          id
          order
          tagsExpression
        }
        plans {
          id
          name
          description
          status
          enabled
          scheduleCron
          scheduleExecutionDates
          scheduleOffset
          scheduleOption
          scheduleTimezone
          nextExecutionDates
          changeDetails {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetGroupsForResourceQuery__
 *
 * To run a query within a React component, call `useGetGroupsForResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsForResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsForResourceQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetGroupsForResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGroupsForResourceQuery,
    GetGroupsForResourceQueryVariables
  > &
    (
      | { variables: GetGroupsForResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupsForResourceQuery,
    GetGroupsForResourceQueryVariables
  >(GetGroupsForResourceDocument, options);
}
export function useGetGroupsForResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupsForResourceQuery,
    GetGroupsForResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupsForResourceQuery,
    GetGroupsForResourceQueryVariables
  >(GetGroupsForResourceDocument, options);
}
// @ts-ignore
export function useGetGroupsForResourceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupsForResourceQuery,
    GetGroupsForResourceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetGroupsForResourceQuery,
  GetGroupsForResourceQueryVariables
>;
export function useGetGroupsForResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupsForResourceQuery,
        GetGroupsForResourceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetGroupsForResourceQuery | undefined,
  GetGroupsForResourceQueryVariables
>;
export function useGetGroupsForResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupsForResourceQuery,
        GetGroupsForResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetGroupsForResourceQuery,
    GetGroupsForResourceQueryVariables
  >(GetGroupsForResourceDocument, options);
}
export type GetGroupsForResourceQueryHookResult = ReturnType<
  typeof useGetGroupsForResourceQuery
>;
export type GetGroupsForResourceLazyQueryHookResult = ReturnType<
  typeof useGetGroupsForResourceLazyQuery
>;
export type GetGroupsForResourceSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupsForResourceSuspenseQuery
>;
export type GetGroupsForResourceQueryResult = Apollo.QueryResult<
  GetGroupsForResourceQuery,
  GetGroupsForResourceQueryVariables
>;
export const GetGroupUniqueAttributesDocument = gql`
  query getGroupUniqueAttributes {
    groupUniqueAttributes {
      createdBy
    }
  }
`;

/**
 * __useGetGroupUniqueAttributesQuery__
 *
 * To run a query within a React component, call `useGetGroupUniqueAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupUniqueAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupUniqueAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupUniqueAttributesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupUniqueAttributesQuery,
    GetGroupUniqueAttributesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupUniqueAttributesQuery,
    GetGroupUniqueAttributesQueryVariables
  >(GetGroupUniqueAttributesDocument, options);
}
export function useGetGroupUniqueAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupUniqueAttributesQuery,
    GetGroupUniqueAttributesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupUniqueAttributesQuery,
    GetGroupUniqueAttributesQueryVariables
  >(GetGroupUniqueAttributesDocument, options);
}
// @ts-ignore
export function useGetGroupUniqueAttributesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupUniqueAttributesQuery,
    GetGroupUniqueAttributesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetGroupUniqueAttributesQuery,
  GetGroupUniqueAttributesQueryVariables
>;
export function useGetGroupUniqueAttributesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupUniqueAttributesQuery,
        GetGroupUniqueAttributesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetGroupUniqueAttributesQuery | undefined,
  GetGroupUniqueAttributesQueryVariables
>;
export function useGetGroupUniqueAttributesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupUniqueAttributesQuery,
        GetGroupUniqueAttributesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetGroupUniqueAttributesQuery,
    GetGroupUniqueAttributesQueryVariables
  >(GetGroupUniqueAttributesDocument, options);
}
export type GetGroupUniqueAttributesQueryHookResult = ReturnType<
  typeof useGetGroupUniqueAttributesQuery
>;
export type GetGroupUniqueAttributesLazyQueryHookResult = ReturnType<
  typeof useGetGroupUniqueAttributesLazyQuery
>;
export type GetGroupUniqueAttributesSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupUniqueAttributesSuspenseQuery
>;
export type GetGroupUniqueAttributesQueryResult = Apollo.QueryResult<
  GetGroupUniqueAttributesQuery,
  GetGroupUniqueAttributesQueryVariables
>;
export const GetIncomingActionsForResourceDocument = gql`
  query getIncomingActionsForResource(
    $resourceId: UUID!
    $page: Int
    $limit: Int
    $sort: FutureActionsForResourceSortInput
    $filter: FutureActionsForResourceFilterInput
  ) {
    futureActionsForResource(
      resourceId: $resourceId
      page: $page
      limit: $limit
      sort: $sort
      filter: $filter
    ) {
      result {
        actionName
        actionType
        eventId
        eventName
        planId
        resourceGroupId
        resourceGroupName
        scheduleTimezone
        startTime
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetIncomingActionsForResourceQuery__
 *
 * To run a query within a React component, call `useGetIncomingActionsForResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomingActionsForResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomingActionsForResourceQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetIncomingActionsForResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIncomingActionsForResourceQuery,
    GetIncomingActionsForResourceQueryVariables
  > &
    (
      | {
          variables: GetIncomingActionsForResourceQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIncomingActionsForResourceQuery,
    GetIncomingActionsForResourceQueryVariables
  >(GetIncomingActionsForResourceDocument, options);
}
export function useGetIncomingActionsForResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIncomingActionsForResourceQuery,
    GetIncomingActionsForResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIncomingActionsForResourceQuery,
    GetIncomingActionsForResourceQueryVariables
  >(GetIncomingActionsForResourceDocument, options);
}
// @ts-ignore
export function useGetIncomingActionsForResourceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIncomingActionsForResourceQuery,
    GetIncomingActionsForResourceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetIncomingActionsForResourceQuery,
  GetIncomingActionsForResourceQueryVariables
>;
export function useGetIncomingActionsForResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIncomingActionsForResourceQuery,
        GetIncomingActionsForResourceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetIncomingActionsForResourceQuery | undefined,
  GetIncomingActionsForResourceQueryVariables
>;
export function useGetIncomingActionsForResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIncomingActionsForResourceQuery,
        GetIncomingActionsForResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIncomingActionsForResourceQuery,
    GetIncomingActionsForResourceQueryVariables
  >(GetIncomingActionsForResourceDocument, options);
}
export type GetIncomingActionsForResourceQueryHookResult = ReturnType<
  typeof useGetIncomingActionsForResourceQuery
>;
export type GetIncomingActionsForResourceLazyQueryHookResult = ReturnType<
  typeof useGetIncomingActionsForResourceLazyQuery
>;
export type GetIncomingActionsForResourceSuspenseQueryHookResult = ReturnType<
  typeof useGetIncomingActionsForResourceSuspenseQuery
>;
export type GetIncomingActionsForResourceQueryResult = Apollo.QueryResult<
  GetIncomingActionsForResourceQuery,
  GetIncomingActionsForResourceQueryVariables
>;
export const GetPastActionsForResourceDocument = gql`
  query getPastActionsForResource(
    $resourceId: UUID!
    $page: Int
    $limit: Int
    $sort: PastActionsForResourceSortInput
    $filter: PastActionsForResourceFilterInput
  ) {
    pastActionsForResource(
      resourceId: $resourceId
      page: $page
      limit: $limit
      sort: $sort
      filter: $filter
    ) {
      result {
        id
        planId
        actionName
        actionType
        resourceGroupId
        resourceGroupName
        eventId
        eventActionId
        eventName
        scheduleTimezone
        endTime
        status
        outputUri
        annotation
        updatedBy
        errorCode
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetPastActionsForResourceQuery__
 *
 * To run a query within a React component, call `useGetPastActionsForResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastActionsForResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastActionsForResourceQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPastActionsForResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPastActionsForResourceQuery,
    GetPastActionsForResourceQueryVariables
  > &
    (
      | { variables: GetPastActionsForResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPastActionsForResourceQuery,
    GetPastActionsForResourceQueryVariables
  >(GetPastActionsForResourceDocument, options);
}
export function useGetPastActionsForResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPastActionsForResourceQuery,
    GetPastActionsForResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPastActionsForResourceQuery,
    GetPastActionsForResourceQueryVariables
  >(GetPastActionsForResourceDocument, options);
}
// @ts-ignore
export function useGetPastActionsForResourceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPastActionsForResourceQuery,
    GetPastActionsForResourceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPastActionsForResourceQuery,
  GetPastActionsForResourceQueryVariables
>;
export function useGetPastActionsForResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPastActionsForResourceQuery,
        GetPastActionsForResourceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPastActionsForResourceQuery | undefined,
  GetPastActionsForResourceQueryVariables
>;
export function useGetPastActionsForResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPastActionsForResourceQuery,
        GetPastActionsForResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPastActionsForResourceQuery,
    GetPastActionsForResourceQueryVariables
  >(GetPastActionsForResourceDocument, options);
}
export type GetPastActionsForResourceQueryHookResult = ReturnType<
  typeof useGetPastActionsForResourceQuery
>;
export type GetPastActionsForResourceLazyQueryHookResult = ReturnType<
  typeof useGetPastActionsForResourceLazyQuery
>;
export type GetPastActionsForResourceSuspenseQueryHookResult = ReturnType<
  typeof useGetPastActionsForResourceSuspenseQuery
>;
export type GetPastActionsForResourceQueryResult = Apollo.QueryResult<
  GetPastActionsForResourceQuery,
  GetPastActionsForResourceQueryVariables
>;
export const CreateReportDocument = gql`
  mutation CreateReport($input: CreateReportInput!) {
    createReport(input: $input) {
      id
    }
  }
`;
export type CreateReportMutationFn = Apollo.MutationFunction<
  CreateReportMutation,
  CreateReportMutationVariables
>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReportMutation,
    CreateReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReportMutation,
    CreateReportMutationVariables
  >(CreateReportDocument, options);
}
export type CreateReportMutationHookResult = ReturnType<
  typeof useCreateReportMutation
>;
export type CreateReportMutationResult =
  Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<
  CreateReportMutation,
  CreateReportMutationVariables
>;
export const CreateResourceUpdatesReportDocument = gql`
  mutation createResourceUpdatesReport(
    $reportType: ReportType!
    $resourceId: UUID!
    $startDate: String!
    $endDate: String!
  ) {
    createReport(
      input: {
        reportType: $reportType
        resourcePackagesComplianceInput: {
          resourceId: $resourceId
          startDate: $startDate
          endDate: $endDate
        }
      }
    ) {
      id
      status
    }
  }
`;
export type CreateResourceUpdatesReportMutationFn = Apollo.MutationFunction<
  CreateResourceUpdatesReportMutation,
  CreateResourceUpdatesReportMutationVariables
>;

/**
 * __useCreateResourceUpdatesReportMutation__
 *
 * To run a mutation, you first call `useCreateResourceUpdatesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceUpdatesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceUpdatesReportMutation, { data, loading, error }] = useCreateResourceUpdatesReportMutation({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      resourceId: // value for 'resourceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreateResourceUpdatesReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateResourceUpdatesReportMutation,
    CreateResourceUpdatesReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateResourceUpdatesReportMutation,
    CreateResourceUpdatesReportMutationVariables
  >(CreateResourceUpdatesReportDocument, options);
}
export type CreateResourceUpdatesReportMutationHookResult = ReturnType<
  typeof useCreateResourceUpdatesReportMutation
>;
export type CreateResourceUpdatesReportMutationResult =
  Apollo.MutationResult<CreateResourceUpdatesReportMutation>;
export type CreateResourceUpdatesReportMutationOptions =
  Apollo.BaseMutationOptions<
    CreateResourceUpdatesReportMutation,
    CreateResourceUpdatesReportMutationVariables
  >;
export const DeleteResourceDocument = gql`
  mutation deleteResource($removeResourceId: UUID!) {
    removeResource(id: $removeResourceId)
  }
`;
export type DeleteResourceMutationFn = Apollo.MutationFunction<
  DeleteResourceMutation,
  DeleteResourceMutationVariables
>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      removeResourceId: // value for 'removeResourceId'
 *   },
 * });
 */
export function useDeleteResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteResourceMutation,
    DeleteResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteResourceMutation,
    DeleteResourceMutationVariables
  >(DeleteResourceDocument, options);
}
export type DeleteResourceMutationHookResult = ReturnType<
  typeof useDeleteResourceMutation
>;
export type DeleteResourceMutationResult =
  Apollo.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<
  DeleteResourceMutation,
  DeleteResourceMutationVariables
>;
export const GetAllResourceDetailsDocument = gql`
  query getAllResourceDetails(
    $input: ResourcesSearchInput!
    $page: Int
    $limit: Int
    $sort: ResourcesSortInput
  ) {
    resourcesSearch(page: $page, limit: $limit, sort: $sort, input: $input) {
      result {
        id
        name
        scanned
        os {
          type
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetAllResourceDetailsQuery__
 *
 * To run a query within a React component, call `useGetAllResourceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllResourceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllResourceDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllResourceDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllResourceDetailsQuery,
    GetAllResourceDetailsQueryVariables
  > &
    (
      | { variables: GetAllResourceDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllResourceDetailsQuery,
    GetAllResourceDetailsQueryVariables
  >(GetAllResourceDetailsDocument, options);
}
export function useGetAllResourceDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllResourceDetailsQuery,
    GetAllResourceDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllResourceDetailsQuery,
    GetAllResourceDetailsQueryVariables
  >(GetAllResourceDetailsDocument, options);
}
// @ts-ignore
export function useGetAllResourceDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAllResourceDetailsQuery,
    GetAllResourceDetailsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAllResourceDetailsQuery,
  GetAllResourceDetailsQueryVariables
>;
export function useGetAllResourceDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAllResourceDetailsQuery,
        GetAllResourceDetailsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAllResourceDetailsQuery | undefined,
  GetAllResourceDetailsQueryVariables
>;
export function useGetAllResourceDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAllResourceDetailsQuery,
        GetAllResourceDetailsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAllResourceDetailsQuery,
    GetAllResourceDetailsQueryVariables
  >(GetAllResourceDetailsDocument, options);
}
export type GetAllResourceDetailsQueryHookResult = ReturnType<
  typeof useGetAllResourceDetailsQuery
>;
export type GetAllResourceDetailsLazyQueryHookResult = ReturnType<
  typeof useGetAllResourceDetailsLazyQuery
>;
export type GetAllResourceDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetAllResourceDetailsSuspenseQuery
>;
export type GetAllResourceDetailsQueryResult = Apollo.QueryResult<
  GetAllResourceDetailsQuery,
  GetAllResourceDetailsQueryVariables
>;
export const GetReportsDocument = gql`
  query getReports(
    $page: Int
    $limit: Int
    $sort: ReportsSortInput
    $filter: ReportsFilterInput
  ) {
    reports(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      pageInfo {
        count
        pages
      }
      result {
        id
        name
        status
        type
        dateGenerated
        url
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
    }
  }
`;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetReportsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportsQuery,
    GetReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportsQuery, GetReportsQueryVariables>(
    GetReportsDocument,
    options
  );
}
export function useGetReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportsQuery,
    GetReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(
    GetReportsDocument,
    options
  );
}
// @ts-ignore
export function useGetReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetReportsQuery,
    GetReportsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetReportsQuery, GetReportsQueryVariables>;
export function useGetReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetReportsQuery | undefined,
  GetReportsQueryVariables
>;
export function useGetReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetReportsQuery, GetReportsQueryVariables>(
    GetReportsDocument,
    options
  );
}
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<
  typeof useGetReportsLazyQuery
>;
export type GetReportsSuspenseQueryHookResult = ReturnType<
  typeof useGetReportsSuspenseQuery
>;
export type GetReportsQueryResult = Apollo.QueryResult<
  GetReportsQuery,
  GetReportsQueryVariables
>;
export const GetResourceDocument = gql`
  query getResource($resourceId: UUID!) {
    resource(id: $resourceId) {
      id
      name
      provider
      providerId
      description
      cloudResourceId
      fullCloudResourceId
      autoDiscovery
      enabled
      region
      scanned
      tags {
        key
        value
      }
      metadata {
        key
        value
      }
      cloudMetadata {
        key
        value
      }
      os {
        type
        subType
        version
      }
      access {
        ... on SSMAccess {
          instanceId
        }
      }
      state {
        status
        error
        updatedAt
        ssmMetadata {
          key
          value
        }
      }
      latestInventory {
        status
        error
        inventoryUri
        availablePackagesUri
        createdAt
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

/**
 * __useGetResourceQuery__
 *
 * To run a query within a React component, call `useGetResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetResourceQuery,
    GetResourceQueryVariables
  > &
    (
      | { variables: GetResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetResourceQuery, GetResourceQueryVariables>(
    GetResourceDocument,
    options
  );
}
export function useGetResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceQuery,
    GetResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetResourceQuery, GetResourceQueryVariables>(
    GetResourceDocument,
    options
  );
}
// @ts-ignore
export function useGetResourceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceQuery,
    GetResourceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetResourceQuery, GetResourceQueryVariables>;
export function useGetResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceQuery,
        GetResourceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceQuery | undefined,
  GetResourceQueryVariables
>;
export function useGetResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceQuery,
        GetResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetResourceQuery, GetResourceQueryVariables>(
    GetResourceDocument,
    options
  );
}
export type GetResourceQueryHookResult = ReturnType<typeof useGetResourceQuery>;
export type GetResourceLazyQueryHookResult = ReturnType<
  typeof useGetResourceLazyQuery
>;
export type GetResourceSuspenseQueryHookResult = ReturnType<
  typeof useGetResourceSuspenseQuery
>;
export type GetResourceQueryResult = Apollo.QueryResult<
  GetResourceQuery,
  GetResourceQueryVariables
>;
export const GetResourceCloudRegionsDocument = gql`
  query getResourceCloudRegions {
    resourceCloudRegions {
      aws
      azure
      gc
      ibm
    }
  }
`;

/**
 * __useGetResourceCloudRegionsQuery__
 *
 * To run a query within a React component, call `useGetResourceCloudRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceCloudRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceCloudRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResourceCloudRegionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetResourceCloudRegionsQuery,
    GetResourceCloudRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetResourceCloudRegionsQuery,
    GetResourceCloudRegionsQueryVariables
  >(GetResourceCloudRegionsDocument, options);
}
export function useGetResourceCloudRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceCloudRegionsQuery,
    GetResourceCloudRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourceCloudRegionsQuery,
    GetResourceCloudRegionsQueryVariables
  >(GetResourceCloudRegionsDocument, options);
}
// @ts-ignore
export function useGetResourceCloudRegionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceCloudRegionsQuery,
    GetResourceCloudRegionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourceCloudRegionsQuery,
  GetResourceCloudRegionsQueryVariables
>;
export function useGetResourceCloudRegionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceCloudRegionsQuery,
        GetResourceCloudRegionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceCloudRegionsQuery | undefined,
  GetResourceCloudRegionsQueryVariables
>;
export function useGetResourceCloudRegionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceCloudRegionsQuery,
        GetResourceCloudRegionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourceCloudRegionsQuery,
    GetResourceCloudRegionsQueryVariables
  >(GetResourceCloudRegionsDocument, options);
}
export type GetResourceCloudRegionsQueryHookResult = ReturnType<
  typeof useGetResourceCloudRegionsQuery
>;
export type GetResourceCloudRegionsLazyQueryHookResult = ReturnType<
  typeof useGetResourceCloudRegionsLazyQuery
>;
export type GetResourceCloudRegionsSuspenseQueryHookResult = ReturnType<
  typeof useGetResourceCloudRegionsSuspenseQuery
>;
export type GetResourceCloudRegionsQueryResult = Apollo.QueryResult<
  GetResourceCloudRegionsQuery,
  GetResourceCloudRegionsQueryVariables
>;
export const UpdateStatusResourceStatisticsCountsDocument = gql`
  query updateStatusResourceStatisticsCounts {
    updateStatusResourceStatisticsCounts {
      updateStatus
      count
    }
  }
`;

/**
 * __useUpdateStatusResourceStatisticsCountsQuery__
 *
 * To run a query within a React component, call `useUpdateStatusResourceStatisticsCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusResourceStatisticsCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateStatusResourceStatisticsCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateStatusResourceStatisticsCountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UpdateStatusResourceStatisticsCountsQuery,
    UpdateStatusResourceStatisticsCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UpdateStatusResourceStatisticsCountsQuery,
    UpdateStatusResourceStatisticsCountsQueryVariables
  >(UpdateStatusResourceStatisticsCountsDocument, options);
}
export function useUpdateStatusResourceStatisticsCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpdateStatusResourceStatisticsCountsQuery,
    UpdateStatusResourceStatisticsCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UpdateStatusResourceStatisticsCountsQuery,
    UpdateStatusResourceStatisticsCountsQueryVariables
  >(UpdateStatusResourceStatisticsCountsDocument, options);
}
// @ts-ignore
export function useUpdateStatusResourceStatisticsCountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UpdateStatusResourceStatisticsCountsQuery,
    UpdateStatusResourceStatisticsCountsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  UpdateStatusResourceStatisticsCountsQuery,
  UpdateStatusResourceStatisticsCountsQueryVariables
>;
export function useUpdateStatusResourceStatisticsCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UpdateStatusResourceStatisticsCountsQuery,
        UpdateStatusResourceStatisticsCountsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  UpdateStatusResourceStatisticsCountsQuery | undefined,
  UpdateStatusResourceStatisticsCountsQueryVariables
>;
export function useUpdateStatusResourceStatisticsCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UpdateStatusResourceStatisticsCountsQuery,
        UpdateStatusResourceStatisticsCountsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UpdateStatusResourceStatisticsCountsQuery,
    UpdateStatusResourceStatisticsCountsQueryVariables
  >(UpdateStatusResourceStatisticsCountsDocument, options);
}
export type UpdateStatusResourceStatisticsCountsQueryHookResult = ReturnType<
  typeof useUpdateStatusResourceStatisticsCountsQuery
>;
export type UpdateStatusResourceStatisticsCountsLazyQueryHookResult =
  ReturnType<typeof useUpdateStatusResourceStatisticsCountsLazyQuery>;
export type UpdateStatusResourceStatisticsCountsSuspenseQueryHookResult =
  ReturnType<typeof useUpdateStatusResourceStatisticsCountsSuspenseQuery>;
export type UpdateStatusResourceStatisticsCountsQueryResult =
  Apollo.QueryResult<
    UpdateStatusResourceStatisticsCountsQuery,
    UpdateStatusResourceStatisticsCountsQueryVariables
  >;
export const GetResourcesDocument = gql`
  query getResources(
    $limit: Int!
    $page: Int!
    $sort: ResourcesSortInput
    $filter: ResourceFilterInput
  ) {
    resources(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        ...Resource
      }
      pageInfo {
        pages
        count
      }
    }
  }
  ${ResourceFragmentDoc}
`;

/**
 * __useGetResourcesQuery__
 *
 * To run a query within a React component, call `useGetResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetResourcesQuery,
    GetResourcesQueryVariables
  > &
    (
      | { variables: GetResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetResourcesQuery, GetResourcesQueryVariables>(
    GetResourcesDocument,
    options
  );
}
export function useGetResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourcesQuery,
    GetResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetResourcesQuery, GetResourcesQueryVariables>(
    GetResourcesDocument,
    options
  );
}
// @ts-ignore
export function useGetResourcesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourcesQuery,
    GetResourcesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetResourcesQuery, GetResourcesQueryVariables>;
export function useGetResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourcesQuery,
        GetResourcesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourcesQuery | undefined,
  GetResourcesQueryVariables
>;
export function useGetResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourcesQuery,
        GetResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetResourcesQuery, GetResourcesQueryVariables>(
    GetResourcesDocument,
    options
  );
}
export type GetResourcesQueryHookResult = ReturnType<
  typeof useGetResourcesQuery
>;
export type GetResourcesLazyQueryHookResult = ReturnType<
  typeof useGetResourcesLazyQuery
>;
export type GetResourcesSuspenseQueryHookResult = ReturnType<
  typeof useGetResourcesSuspenseQuery
>;
export type GetResourcesQueryResult = Apollo.QueryResult<
  GetResourcesQuery,
  GetResourcesQueryVariables
>;
export const GetResourcesByTagsDocument = gql`
  query getResourcesByTags($limit: Int, $page: Int, $tagsExpression: String!) {
    resourcesByTags(
      page: $page
      limit: $limit
      tagsExpression: $tagsExpression
    ) {
      result {
        name
        id
        provider
        os {
          type
          subType
          version
          architecture
        }
        state {
          status
          ssmMetadata {
            key
            value
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetResourcesByTagsQuery__
 *
 * To run a query within a React component, call `useGetResourcesByTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesByTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesByTagsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      tagsExpression: // value for 'tagsExpression'
 *   },
 * });
 */
export function useGetResourcesByTagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetResourcesByTagsQuery,
    GetResourcesByTagsQueryVariables
  > &
    (
      | { variables: GetResourcesByTagsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetResourcesByTagsQuery,
    GetResourcesByTagsQueryVariables
  >(GetResourcesByTagsDocument, options);
}
export function useGetResourcesByTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourcesByTagsQuery,
    GetResourcesByTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourcesByTagsQuery,
    GetResourcesByTagsQueryVariables
  >(GetResourcesByTagsDocument, options);
}
// @ts-ignore
export function useGetResourcesByTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourcesByTagsQuery,
    GetResourcesByTagsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourcesByTagsQuery,
  GetResourcesByTagsQueryVariables
>;
export function useGetResourcesByTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourcesByTagsQuery,
        GetResourcesByTagsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourcesByTagsQuery | undefined,
  GetResourcesByTagsQueryVariables
>;
export function useGetResourcesByTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourcesByTagsQuery,
        GetResourcesByTagsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourcesByTagsQuery,
    GetResourcesByTagsQueryVariables
  >(GetResourcesByTagsDocument, options);
}
export type GetResourcesByTagsQueryHookResult = ReturnType<
  typeof useGetResourcesByTagsQuery
>;
export type GetResourcesByTagsLazyQueryHookResult = ReturnType<
  typeof useGetResourcesByTagsLazyQuery
>;
export type GetResourcesByTagsSuspenseQueryHookResult = ReturnType<
  typeof useGetResourcesByTagsSuspenseQuery
>;
export type GetResourcesByTagsQueryResult = Apollo.QueryResult<
  GetResourcesByTagsQuery,
  GetResourcesByTagsQueryVariables
>;
export const GetResourceUpdateStatusDocument = gql`
  query getResourceUpdateStatus($resourceIds: [UUID!]!) {
    updateStatusForResources(resourceIds: $resourceIds) {
      resourceId
      updateStatus
      pendingUpdateCount
      basedOn {
        eventId
        eventActionId
        eventActionResourceStateId
      }
    }
  }
`;

/**
 * __useGetResourceUpdateStatusQuery__
 *
 * To run a query within a React component, call `useGetResourceUpdateStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceUpdateStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceUpdateStatusQuery({
 *   variables: {
 *      resourceIds: // value for 'resourceIds'
 *   },
 * });
 */
export function useGetResourceUpdateStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetResourceUpdateStatusQuery,
    GetResourceUpdateStatusQueryVariables
  > &
    (
      | { variables: GetResourceUpdateStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetResourceUpdateStatusQuery,
    GetResourceUpdateStatusQueryVariables
  >(GetResourceUpdateStatusDocument, options);
}
export function useGetResourceUpdateStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceUpdateStatusQuery,
    GetResourceUpdateStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourceUpdateStatusQuery,
    GetResourceUpdateStatusQueryVariables
  >(GetResourceUpdateStatusDocument, options);
}
// @ts-ignore
export function useGetResourceUpdateStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceUpdateStatusQuery,
    GetResourceUpdateStatusQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourceUpdateStatusQuery,
  GetResourceUpdateStatusQueryVariables
>;
export function useGetResourceUpdateStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceUpdateStatusQuery,
        GetResourceUpdateStatusQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceUpdateStatusQuery | undefined,
  GetResourceUpdateStatusQueryVariables
>;
export function useGetResourceUpdateStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceUpdateStatusQuery,
        GetResourceUpdateStatusQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourceUpdateStatusQuery,
    GetResourceUpdateStatusQueryVariables
  >(GetResourceUpdateStatusDocument, options);
}
export type GetResourceUpdateStatusQueryHookResult = ReturnType<
  typeof useGetResourceUpdateStatusQuery
>;
export type GetResourceUpdateStatusLazyQueryHookResult = ReturnType<
  typeof useGetResourceUpdateStatusLazyQuery
>;
export type GetResourceUpdateStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetResourceUpdateStatusSuspenseQuery
>;
export type GetResourceUpdateStatusQueryResult = Apollo.QueryResult<
  GetResourceUpdateStatusQuery,
  GetResourceUpdateStatusQueryVariables
>;
export const RemoveReportDocument = gql`
  mutation removeReport($id: UUID!) {
    removeReport(id: $id)
  }
`;
export type RemoveReportMutationFn = Apollo.MutationFunction<
  RemoveReportMutation,
  RemoveReportMutationVariables
>;

/**
 * __useRemoveReportMutation__
 *
 * To run a mutation, you first call `useRemoveReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReportMutation, { data, loading, error }] = useRemoveReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveReportMutation,
    RemoveReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveReportMutation,
    RemoveReportMutationVariables
  >(RemoveReportDocument, options);
}
export type RemoveReportMutationHookResult = ReturnType<
  typeof useRemoveReportMutation
>;
export type RemoveReportMutationResult =
  Apollo.MutationResult<RemoveReportMutation>;
export type RemoveReportMutationOptions = Apollo.BaseMutationOptions<
  RemoveReportMutation,
  RemoveReportMutationVariables
>;
export const ResourceComplianceReportForUiDocument = gql`
  query resourceComplianceReportForUI(
    $input: ResourceComplianceReportForUIInput!
  ) {
    resourceComplianceReportForUI(input: $input) {
      status
      packages {
        eventId
        eventActionId
        updateName
        time
        patchPolicy
        rebootAllowed
        releaseDate
        category
        updateStatus
      }
      actionsWithMissingData {
        eventId
        eventName
        eventActionId
        errCode
      }
    }
  }
`;

/**
 * __useResourceComplianceReportForUiQuery__
 *
 * To run a query within a React component, call `useResourceComplianceReportForUiQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceComplianceReportForUiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceComplianceReportForUiQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResourceComplianceReportForUiQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceComplianceReportForUiQuery,
    ResourceComplianceReportForUiQueryVariables
  > &
    (
      | {
          variables: ResourceComplianceReportForUiQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ResourceComplianceReportForUiQuery,
    ResourceComplianceReportForUiQueryVariables
  >(ResourceComplianceReportForUiDocument, options);
}
export function useResourceComplianceReportForUiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceComplianceReportForUiQuery,
    ResourceComplianceReportForUiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ResourceComplianceReportForUiQuery,
    ResourceComplianceReportForUiQueryVariables
  >(ResourceComplianceReportForUiDocument, options);
}
// @ts-ignore
export function useResourceComplianceReportForUiSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResourceComplianceReportForUiQuery,
    ResourceComplianceReportForUiQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ResourceComplianceReportForUiQuery,
  ResourceComplianceReportForUiQueryVariables
>;
export function useResourceComplianceReportForUiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceComplianceReportForUiQuery,
        ResourceComplianceReportForUiQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ResourceComplianceReportForUiQuery | undefined,
  ResourceComplianceReportForUiQueryVariables
>;
export function useResourceComplianceReportForUiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceComplianceReportForUiQuery,
        ResourceComplianceReportForUiQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ResourceComplianceReportForUiQuery,
    ResourceComplianceReportForUiQueryVariables
  >(ResourceComplianceReportForUiDocument, options);
}
export type ResourceComplianceReportForUiQueryHookResult = ReturnType<
  typeof useResourceComplianceReportForUiQuery
>;
export type ResourceComplianceReportForUiLazyQueryHookResult = ReturnType<
  typeof useResourceComplianceReportForUiLazyQuery
>;
export type ResourceComplianceReportForUiSuspenseQueryHookResult = ReturnType<
  typeof useResourceComplianceReportForUiSuspenseQuery
>;
export type ResourceComplianceReportForUiQueryResult = Apollo.QueryResult<
  ResourceComplianceReportForUiQuery,
  ResourceComplianceReportForUiQueryVariables
>;
export const ResourceComplianceStatusForUiDocument = gql`
  query resourceComplianceStatusForUI(
    $input: ResourceComplianceStatusForUIInput!
  ) {
    resourceComplianceStatusForUI(input: $input) {
      status
      complianceStatuses {
        resourceId
        status
      }
    }
  }
`;

/**
 * __useResourceComplianceStatusForUiQuery__
 *
 * To run a query within a React component, call `useResourceComplianceStatusForUiQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceComplianceStatusForUiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceComplianceStatusForUiQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResourceComplianceStatusForUiQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceComplianceStatusForUiQuery,
    ResourceComplianceStatusForUiQueryVariables
  > &
    (
      | {
          variables: ResourceComplianceStatusForUiQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ResourceComplianceStatusForUiQuery,
    ResourceComplianceStatusForUiQueryVariables
  >(ResourceComplianceStatusForUiDocument, options);
}
export function useResourceComplianceStatusForUiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceComplianceStatusForUiQuery,
    ResourceComplianceStatusForUiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ResourceComplianceStatusForUiQuery,
    ResourceComplianceStatusForUiQueryVariables
  >(ResourceComplianceStatusForUiDocument, options);
}
// @ts-ignore
export function useResourceComplianceStatusForUiSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResourceComplianceStatusForUiQuery,
    ResourceComplianceStatusForUiQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ResourceComplianceStatusForUiQuery,
  ResourceComplianceStatusForUiQueryVariables
>;
export function useResourceComplianceStatusForUiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceComplianceStatusForUiQuery,
        ResourceComplianceStatusForUiQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ResourceComplianceStatusForUiQuery | undefined,
  ResourceComplianceStatusForUiQueryVariables
>;
export function useResourceComplianceStatusForUiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceComplianceStatusForUiQuery,
        ResourceComplianceStatusForUiQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ResourceComplianceStatusForUiQuery,
    ResourceComplianceStatusForUiQueryVariables
  >(ResourceComplianceStatusForUiDocument, options);
}
export type ResourceComplianceStatusForUiQueryHookResult = ReturnType<
  typeof useResourceComplianceStatusForUiQuery
>;
export type ResourceComplianceStatusForUiLazyQueryHookResult = ReturnType<
  typeof useResourceComplianceStatusForUiLazyQuery
>;
export type ResourceComplianceStatusForUiSuspenseQueryHookResult = ReturnType<
  typeof useResourceComplianceStatusForUiSuspenseQuery
>;
export type ResourceComplianceStatusForUiQueryResult = Apollo.QueryResult<
  ResourceComplianceStatusForUiQuery,
  ResourceComplianceStatusForUiQueryVariables
>;
export const ResourcesSearchBasicDocument = gql`
  query resourcesSearchBasic(
    $limit: Int!
    $page: Int!
    $sort: ResourcesSortInput
    $input: ResourcesSearchInput!
  ) {
    resourcesSearch(page: $page, limit: $limit, sort: $sort, input: $input) {
      result {
        id
        name
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useResourcesSearchBasicQuery__
 *
 * To run a query within a React component, call `useResourcesSearchBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesSearchBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesSearchBasicQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResourcesSearchBasicQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourcesSearchBasicQuery,
    ResourcesSearchBasicQueryVariables
  > &
    (
      | { variables: ResourcesSearchBasicQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ResourcesSearchBasicQuery,
    ResourcesSearchBasicQueryVariables
  >(ResourcesSearchBasicDocument, options);
}
export function useResourcesSearchBasicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourcesSearchBasicQuery,
    ResourcesSearchBasicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ResourcesSearchBasicQuery,
    ResourcesSearchBasicQueryVariables
  >(ResourcesSearchBasicDocument, options);
}
// @ts-ignore
export function useResourcesSearchBasicSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResourcesSearchBasicQuery,
    ResourcesSearchBasicQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ResourcesSearchBasicQuery,
  ResourcesSearchBasicQueryVariables
>;
export function useResourcesSearchBasicSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourcesSearchBasicQuery,
        ResourcesSearchBasicQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ResourcesSearchBasicQuery | undefined,
  ResourcesSearchBasicQueryVariables
>;
export function useResourcesSearchBasicSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourcesSearchBasicQuery,
        ResourcesSearchBasicQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ResourcesSearchBasicQuery,
    ResourcesSearchBasicQueryVariables
  >(ResourcesSearchBasicDocument, options);
}
export type ResourcesSearchBasicQueryHookResult = ReturnType<
  typeof useResourcesSearchBasicQuery
>;
export type ResourcesSearchBasicLazyQueryHookResult = ReturnType<
  typeof useResourcesSearchBasicLazyQuery
>;
export type ResourcesSearchBasicSuspenseQueryHookResult = ReturnType<
  typeof useResourcesSearchBasicSuspenseQuery
>;
export type ResourcesSearchBasicQueryResult = Apollo.QueryResult<
  ResourcesSearchBasicQuery,
  ResourcesSearchBasicQueryVariables
>;
export const ResourcesSearchDocument = gql`
  query resourcesSearch(
    $input: ResourcesSearchInput!
    $page: Int
    $limit: Int
    $sort: ResourcesSortInput
    $includeAccount: Boolean = false
    $includeGroupIdentifiers: Boolean = false
    $includeFuturePatchingActions: Boolean = false
  ) {
    resourcesSearch(input: $input, page: $page, limit: $limit, sort: $sort) {
      result {
        ...Resource
        cloudAccount @include(if: $includeAccount) {
          id
          name
        }
        groupIdentifiers @include(if: $includeGroupIdentifiers) {
          id
          name
        }
        futurePatchingActions @include(if: $includeFuturePatchingActions) {
          planId
          planActionId
          eventId
          startTime
          scheduleTimezone
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
  ${ResourceFragmentDoc}
`;

/**
 * __useResourcesSearchQuery__
 *
 * To run a query within a React component, call `useResourcesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      includeAccount: // value for 'includeAccount'
 *      includeGroupIdentifiers: // value for 'includeGroupIdentifiers'
 *      includeFuturePatchingActions: // value for 'includeFuturePatchingActions'
 *   },
 * });
 */
export function useResourcesSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourcesSearchQuery,
    ResourcesSearchQueryVariables
  > &
    (
      | { variables: ResourcesSearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ResourcesSearchQuery, ResourcesSearchQueryVariables>(
    ResourcesSearchDocument,
    options
  );
}
export function useResourcesSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourcesSearchQuery,
    ResourcesSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ResourcesSearchQuery,
    ResourcesSearchQueryVariables
  >(ResourcesSearchDocument, options);
}
// @ts-ignore
export function useResourcesSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResourcesSearchQuery,
    ResourcesSearchQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ResourcesSearchQuery,
  ResourcesSearchQueryVariables
>;
export function useResourcesSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourcesSearchQuery,
        ResourcesSearchQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ResourcesSearchQuery | undefined,
  ResourcesSearchQueryVariables
>;
export function useResourcesSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourcesSearchQuery,
        ResourcesSearchQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ResourcesSearchQuery,
    ResourcesSearchQueryVariables
  >(ResourcesSearchDocument, options);
}
export type ResourcesSearchQueryHookResult = ReturnType<
  typeof useResourcesSearchQuery
>;
export type ResourcesSearchLazyQueryHookResult = ReturnType<
  typeof useResourcesSearchLazyQuery
>;
export type ResourcesSearchSuspenseQueryHookResult = ReturnType<
  typeof useResourcesSearchSuspenseQuery
>;
export type ResourcesSearchQueryResult = Apollo.QueryResult<
  ResourcesSearchQuery,
  ResourcesSearchQueryVariables
>;
export const UpdateResourceDocument = gql`
  mutation updateResource($input: UpdateResourceInput!) {
    updateResource(input: $input) {
      id
      name
      description
      changeDetails {
        updatedAt
        updatedBy
      }
    }
  }
`;
export type UpdateResourceMutationFn = Apollo.MutationFunction<
  UpdateResourceMutation,
  UpdateResourceMutationVariables
>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceMutation,
    UpdateResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateResourceMutation,
    UpdateResourceMutationVariables
  >(UpdateResourceDocument, options);
}
export type UpdateResourceMutationHookResult = ReturnType<
  typeof useUpdateResourceMutation
>;
export type UpdateResourceMutationResult =
  Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceMutation,
  UpdateResourceMutationVariables
>;
export const DeleteCloudResourceReportDocument = gql`
  mutation deleteCloudResourceReport($input: DeleteCloudResourceReportInput!) {
    deleteCloudResourceReport(input: $input)
  }
`;
export type DeleteCloudResourceReportMutationFn = Apollo.MutationFunction<
  DeleteCloudResourceReportMutation,
  DeleteCloudResourceReportMutationVariables
>;

/**
 * __useDeleteCloudResourceReportMutation__
 *
 * To run a mutation, you first call `useDeleteCloudResourceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCloudResourceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCloudResourceReportMutation, { data, loading, error }] = useDeleteCloudResourceReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCloudResourceReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCloudResourceReportMutation,
    DeleteCloudResourceReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCloudResourceReportMutation,
    DeleteCloudResourceReportMutationVariables
  >(DeleteCloudResourceReportDocument, options);
}
export type DeleteCloudResourceReportMutationHookResult = ReturnType<
  typeof useDeleteCloudResourceReportMutation
>;
export type DeleteCloudResourceReportMutationResult =
  Apollo.MutationResult<DeleteCloudResourceReportMutation>;
export type DeleteCloudResourceReportMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteCloudResourceReportMutation,
    DeleteCloudResourceReportMutationVariables
  >;
export const RerunCloudResourceReportDocument = gql`
  mutation rerunCloudResourceReport($input: RerunCloudResourceReportInput!) {
    rerunCloudResourceReport(input: $input)
  }
`;
export type RerunCloudResourceReportMutationFn = Apollo.MutationFunction<
  RerunCloudResourceReportMutation,
  RerunCloudResourceReportMutationVariables
>;

/**
 * __useRerunCloudResourceReportMutation__
 *
 * To run a mutation, you first call `useRerunCloudResourceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunCloudResourceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunCloudResourceReportMutation, { data, loading, error }] = useRerunCloudResourceReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRerunCloudResourceReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RerunCloudResourceReportMutation,
    RerunCloudResourceReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RerunCloudResourceReportMutation,
    RerunCloudResourceReportMutationVariables
  >(RerunCloudResourceReportDocument, options);
}
export type RerunCloudResourceReportMutationHookResult = ReturnType<
  typeof useRerunCloudResourceReportMutation
>;
export type RerunCloudResourceReportMutationResult =
  Apollo.MutationResult<RerunCloudResourceReportMutation>;
export type RerunCloudResourceReportMutationOptions =
  Apollo.BaseMutationOptions<
    RerunCloudResourceReportMutation,
    RerunCloudResourceReportMutationVariables
  >;
export const CreateCloudResourceReportDocument = gql`
  mutation CreateCloudResourceReport($input: CreateCloudResourceReportInput!) {
    createCloudResourceReport(input: $input)
  }
`;
export type CreateCloudResourceReportMutationFn = Apollo.MutationFunction<
  CreateCloudResourceReportMutation,
  CreateCloudResourceReportMutationVariables
>;

/**
 * __useCreateCloudResourceReportMutation__
 *
 * To run a mutation, you first call `useCreateCloudResourceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCloudResourceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCloudResourceReportMutation, { data, loading, error }] = useCreateCloudResourceReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCloudResourceReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCloudResourceReportMutation,
    CreateCloudResourceReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCloudResourceReportMutation,
    CreateCloudResourceReportMutationVariables
  >(CreateCloudResourceReportDocument, options);
}
export type CreateCloudResourceReportMutationHookResult = ReturnType<
  typeof useCreateCloudResourceReportMutation
>;
export type CreateCloudResourceReportMutationResult =
  Apollo.MutationResult<CreateCloudResourceReportMutation>;
export type CreateCloudResourceReportMutationOptions =
  Apollo.BaseMutationOptions<
    CreateCloudResourceReportMutation,
    CreateCloudResourceReportMutationVariables
  >;
export const GetCloudAccountsFilterValuesDocument = gql`
  query getCloudAccountsFilterValues($limit: Int!) {
    cloudAccounts(limit: $limit) {
      result {
        id
        name
        provider
      }
    }
  }
`;

/**
 * __useGetCloudAccountsFilterValuesQuery__
 *
 * To run a query within a React component, call `useGetCloudAccountsFilterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudAccountsFilterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudAccountsFilterValuesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCloudAccountsFilterValuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCloudAccountsFilterValuesQuery,
    GetCloudAccountsFilterValuesQueryVariables
  > &
    (
      | {
          variables: GetCloudAccountsFilterValuesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCloudAccountsFilterValuesQuery,
    GetCloudAccountsFilterValuesQueryVariables
  >(GetCloudAccountsFilterValuesDocument, options);
}
export function useGetCloudAccountsFilterValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCloudAccountsFilterValuesQuery,
    GetCloudAccountsFilterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCloudAccountsFilterValuesQuery,
    GetCloudAccountsFilterValuesQueryVariables
  >(GetCloudAccountsFilterValuesDocument, options);
}
// @ts-ignore
export function useGetCloudAccountsFilterValuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCloudAccountsFilterValuesQuery,
    GetCloudAccountsFilterValuesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCloudAccountsFilterValuesQuery,
  GetCloudAccountsFilterValuesQueryVariables
>;
export function useGetCloudAccountsFilterValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudAccountsFilterValuesQuery,
        GetCloudAccountsFilterValuesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCloudAccountsFilterValuesQuery | undefined,
  GetCloudAccountsFilterValuesQueryVariables
>;
export function useGetCloudAccountsFilterValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudAccountsFilterValuesQuery,
        GetCloudAccountsFilterValuesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCloudAccountsFilterValuesQuery,
    GetCloudAccountsFilterValuesQueryVariables
  >(GetCloudAccountsFilterValuesDocument, options);
}
export type GetCloudAccountsFilterValuesQueryHookResult = ReturnType<
  typeof useGetCloudAccountsFilterValuesQuery
>;
export type GetCloudAccountsFilterValuesLazyQueryHookResult = ReturnType<
  typeof useGetCloudAccountsFilterValuesLazyQuery
>;
export type GetCloudAccountsFilterValuesSuspenseQueryHookResult = ReturnType<
  typeof useGetCloudAccountsFilterValuesSuspenseQuery
>;
export type GetCloudAccountsFilterValuesQueryResult = Apollo.QueryResult<
  GetCloudAccountsFilterValuesQuery,
  GetCloudAccountsFilterValuesQueryVariables
>;
export const GetCloudResourceDocument = gql`
  query getCloudResource($resourceId: UUID!) {
    cloudResource(id: $resourceId) {
      id
      provider
      region
      type
      subtype
      name
      cloudResourceId
      fullCloudResourceId
      providerId
      parentId
      tags {
        key
        value
      }
      cloudMetadata {
        key
        value
      }
      changeDetails {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      cloudAccount {
        id
        name
      }
      lastPatching {
        status
        date
      }
    }
  }
`;

/**
 * __useGetCloudResourceQuery__
 *
 * To run a query within a React component, call `useGetCloudResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudResourceQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetCloudResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCloudResourceQuery,
    GetCloudResourceQueryVariables
  > &
    (
      | { variables: GetCloudResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCloudResourceQuery, GetCloudResourceQueryVariables>(
    GetCloudResourceDocument,
    options
  );
}
export function useGetCloudResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCloudResourceQuery,
    GetCloudResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCloudResourceQuery,
    GetCloudResourceQueryVariables
  >(GetCloudResourceDocument, options);
}
// @ts-ignore
export function useGetCloudResourceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCloudResourceQuery,
    GetCloudResourceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCloudResourceQuery,
  GetCloudResourceQueryVariables
>;
export function useGetCloudResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudResourceQuery,
        GetCloudResourceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCloudResourceQuery | undefined,
  GetCloudResourceQueryVariables
>;
export function useGetCloudResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudResourceQuery,
        GetCloudResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCloudResourceQuery,
    GetCloudResourceQueryVariables
  >(GetCloudResourceDocument, options);
}
export type GetCloudResourceQueryHookResult = ReturnType<
  typeof useGetCloudResourceQuery
>;
export type GetCloudResourceLazyQueryHookResult = ReturnType<
  typeof useGetCloudResourceLazyQuery
>;
export type GetCloudResourceSuspenseQueryHookResult = ReturnType<
  typeof useGetCloudResourceSuspenseQuery
>;
export type GetCloudResourceQueryResult = Apollo.QueryResult<
  GetCloudResourceQuery,
  GetCloudResourceQueryVariables
>;
export const GetCloudResourceFilterValuesDocument = gql`
  query getCloudResourceFilterValues {
    cloudResourceFilterValues {
      regions
      cloudServices
      resourceTypes
    }
  }
`;

/**
 * __useGetCloudResourceFilterValuesQuery__
 *
 * To run a query within a React component, call `useGetCloudResourceFilterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudResourceFilterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudResourceFilterValuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCloudResourceFilterValuesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCloudResourceFilterValuesQuery,
    GetCloudResourceFilterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCloudResourceFilterValuesQuery,
    GetCloudResourceFilterValuesQueryVariables
  >(GetCloudResourceFilterValuesDocument, options);
}
export function useGetCloudResourceFilterValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCloudResourceFilterValuesQuery,
    GetCloudResourceFilterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCloudResourceFilterValuesQuery,
    GetCloudResourceFilterValuesQueryVariables
  >(GetCloudResourceFilterValuesDocument, options);
}
// @ts-ignore
export function useGetCloudResourceFilterValuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCloudResourceFilterValuesQuery,
    GetCloudResourceFilterValuesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCloudResourceFilterValuesQuery,
  GetCloudResourceFilterValuesQueryVariables
>;
export function useGetCloudResourceFilterValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudResourceFilterValuesQuery,
        GetCloudResourceFilterValuesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCloudResourceFilterValuesQuery | undefined,
  GetCloudResourceFilterValuesQueryVariables
>;
export function useGetCloudResourceFilterValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudResourceFilterValuesQuery,
        GetCloudResourceFilterValuesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCloudResourceFilterValuesQuery,
    GetCloudResourceFilterValuesQueryVariables
  >(GetCloudResourceFilterValuesDocument, options);
}
export type GetCloudResourceFilterValuesQueryHookResult = ReturnType<
  typeof useGetCloudResourceFilterValuesQuery
>;
export type GetCloudResourceFilterValuesLazyQueryHookResult = ReturnType<
  typeof useGetCloudResourceFilterValuesLazyQuery
>;
export type GetCloudResourceFilterValuesSuspenseQueryHookResult = ReturnType<
  typeof useGetCloudResourceFilterValuesSuspenseQuery
>;
export type GetCloudResourceFilterValuesQueryResult = Apollo.QueryResult<
  GetCloudResourceFilterValuesQuery,
  GetCloudResourceFilterValuesQueryVariables
>;
export const GetCloudResourceReportsDocument = gql`
  query getCloudResourceReports(
    $page: Int!
    $limit: Int!
    $sort: CloudResourceReportsSortInput
    $filter: CloudResourceReportsFilterInput
  ) {
    cloudResourceReports(
      page: $page
      limit: $limit
      sort: $sort
      filter: $filter
    ) {
      pageInfo {
        count
        pages
      }
      result {
        id
        name
        status
        dateGenerated
        url
        changeDetails {
          createdAt
          createdBy
        }
      }
    }
  }
`;

/**
 * __useGetCloudResourceReportsQuery__
 *
 * To run a query within a React component, call `useGetCloudResourceReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudResourceReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudResourceReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCloudResourceReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCloudResourceReportsQuery,
    GetCloudResourceReportsQueryVariables
  > &
    (
      | { variables: GetCloudResourceReportsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCloudResourceReportsQuery,
    GetCloudResourceReportsQueryVariables
  >(GetCloudResourceReportsDocument, options);
}
export function useGetCloudResourceReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCloudResourceReportsQuery,
    GetCloudResourceReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCloudResourceReportsQuery,
    GetCloudResourceReportsQueryVariables
  >(GetCloudResourceReportsDocument, options);
}
// @ts-ignore
export function useGetCloudResourceReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCloudResourceReportsQuery,
    GetCloudResourceReportsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCloudResourceReportsQuery,
  GetCloudResourceReportsQueryVariables
>;
export function useGetCloudResourceReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudResourceReportsQuery,
        GetCloudResourceReportsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCloudResourceReportsQuery | undefined,
  GetCloudResourceReportsQueryVariables
>;
export function useGetCloudResourceReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudResourceReportsQuery,
        GetCloudResourceReportsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCloudResourceReportsQuery,
    GetCloudResourceReportsQueryVariables
  >(GetCloudResourceReportsDocument, options);
}
export type GetCloudResourceReportsQueryHookResult = ReturnType<
  typeof useGetCloudResourceReportsQuery
>;
export type GetCloudResourceReportsLazyQueryHookResult = ReturnType<
  typeof useGetCloudResourceReportsLazyQuery
>;
export type GetCloudResourceReportsSuspenseQueryHookResult = ReturnType<
  typeof useGetCloudResourceReportsSuspenseQuery
>;
export type GetCloudResourceReportsQueryResult = Apollo.QueryResult<
  GetCloudResourceReportsQuery,
  GetCloudResourceReportsQueryVariables
>;
export const GetCloudResourcesDocument = gql`
  query getCloudResources(
    $page: Int!
    $limit: Int!
    $sort: CloudResourcesSortInput
    $filter: CloudResourcesFilterInput
  ) {
    cloudResources(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      pageInfo {
        count
        pages
      }
      result {
        id
        name
        provider
        region
        type
        subtype
        name
        cloudResourceId
        fullCloudResourceId
        providerId
        parentId
        tags {
          key
          value
        }
        cloudMetadata {
          key
          value
        }
        changeDetails {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        cloudAccount {
          id
          name
        }
        lastPatching {
          status
          date
        }
      }
    }
  }
`;

/**
 * __useGetCloudResourcesQuery__
 *
 * To run a query within a React component, call `useGetCloudResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudResourcesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCloudResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCloudResourcesQuery,
    GetCloudResourcesQueryVariables
  > &
    (
      | { variables: GetCloudResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCloudResourcesQuery,
    GetCloudResourcesQueryVariables
  >(GetCloudResourcesDocument, options);
}
export function useGetCloudResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCloudResourcesQuery,
    GetCloudResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCloudResourcesQuery,
    GetCloudResourcesQueryVariables
  >(GetCloudResourcesDocument, options);
}
// @ts-ignore
export function useGetCloudResourcesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCloudResourcesQuery,
    GetCloudResourcesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCloudResourcesQuery,
  GetCloudResourcesQueryVariables
>;
export function useGetCloudResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudResourcesQuery,
        GetCloudResourcesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCloudResourcesQuery | undefined,
  GetCloudResourcesQueryVariables
>;
export function useGetCloudResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCloudResourcesQuery,
        GetCloudResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCloudResourcesQuery,
    GetCloudResourcesQueryVariables
  >(GetCloudResourcesDocument, options);
}
export type GetCloudResourcesQueryHookResult = ReturnType<
  typeof useGetCloudResourcesQuery
>;
export type GetCloudResourcesLazyQueryHookResult = ReturnType<
  typeof useGetCloudResourcesLazyQuery
>;
export type GetCloudResourcesSuspenseQueryHookResult = ReturnType<
  typeof useGetCloudResourcesSuspenseQuery
>;
export type GetCloudResourcesQueryResult = Apollo.QueryResult<
  GetCloudResourcesQuery,
  GetCloudResourcesQueryVariables
>;
export const GetResourceScheduleFutureActionsDocument = gql`
  query getResourceScheduleFutureActions(
    $resourceId: UUID!
    $page: Int
    $limit: Int
  ) {
    futureActionsForResource(
      resourceId: $resourceId
      page: $page
      limit: $limit
    ) {
      result {
        planId
        actionName
        actionType
        resourceGroupId
        resourceGroupName
        eventId
        eventName
        startTime
        scheduleTimezone
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetResourceScheduleFutureActionsQuery__
 *
 * To run a query within a React component, call `useGetResourceScheduleFutureActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceScheduleFutureActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceScheduleFutureActionsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetResourceScheduleFutureActionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetResourceScheduleFutureActionsQuery,
    GetResourceScheduleFutureActionsQueryVariables
  > &
    (
      | {
          variables: GetResourceScheduleFutureActionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetResourceScheduleFutureActionsQuery,
    GetResourceScheduleFutureActionsQueryVariables
  >(GetResourceScheduleFutureActionsDocument, options);
}
export function useGetResourceScheduleFutureActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceScheduleFutureActionsQuery,
    GetResourceScheduleFutureActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourceScheduleFutureActionsQuery,
    GetResourceScheduleFutureActionsQueryVariables
  >(GetResourceScheduleFutureActionsDocument, options);
}
// @ts-ignore
export function useGetResourceScheduleFutureActionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceScheduleFutureActionsQuery,
    GetResourceScheduleFutureActionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourceScheduleFutureActionsQuery,
  GetResourceScheduleFutureActionsQueryVariables
>;
export function useGetResourceScheduleFutureActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceScheduleFutureActionsQuery,
        GetResourceScheduleFutureActionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceScheduleFutureActionsQuery | undefined,
  GetResourceScheduleFutureActionsQueryVariables
>;
export function useGetResourceScheduleFutureActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceScheduleFutureActionsQuery,
        GetResourceScheduleFutureActionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourceScheduleFutureActionsQuery,
    GetResourceScheduleFutureActionsQueryVariables
  >(GetResourceScheduleFutureActionsDocument, options);
}
export type GetResourceScheduleFutureActionsQueryHookResult = ReturnType<
  typeof useGetResourceScheduleFutureActionsQuery
>;
export type GetResourceScheduleFutureActionsLazyQueryHookResult = ReturnType<
  typeof useGetResourceScheduleFutureActionsLazyQuery
>;
export type GetResourceScheduleFutureActionsSuspenseQueryHookResult =
  ReturnType<typeof useGetResourceScheduleFutureActionsSuspenseQuery>;
export type GetResourceScheduleFutureActionsQueryResult = Apollo.QueryResult<
  GetResourceScheduleFutureActionsQuery,
  GetResourceScheduleFutureActionsQueryVariables
>;
export const GetResourceSchedulePastActionsDocument = gql`
  query getResourceSchedulePastActions(
    $resourceId: UUID!
    $page: Int
    $limit: Int
  ) {
    pastActionsForResource(
      resourceId: $resourceId
      page: $page
      limit: $limit
    ) {
      result {
        id
        planId
        actionName
        actionType
        resourceGroupId
        resourceGroupName
        eventId
        eventName
        scheduleTimezone
        endTime
        status
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetResourceSchedulePastActionsQuery__
 *
 * To run a query within a React component, call `useGetResourceSchedulePastActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceSchedulePastActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceSchedulePastActionsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetResourceSchedulePastActionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetResourceSchedulePastActionsQuery,
    GetResourceSchedulePastActionsQueryVariables
  > &
    (
      | {
          variables: GetResourceSchedulePastActionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetResourceSchedulePastActionsQuery,
    GetResourceSchedulePastActionsQueryVariables
  >(GetResourceSchedulePastActionsDocument, options);
}
export function useGetResourceSchedulePastActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetResourceSchedulePastActionsQuery,
    GetResourceSchedulePastActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetResourceSchedulePastActionsQuery,
    GetResourceSchedulePastActionsQueryVariables
  >(GetResourceSchedulePastActionsDocument, options);
}
// @ts-ignore
export function useGetResourceSchedulePastActionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetResourceSchedulePastActionsQuery,
    GetResourceSchedulePastActionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetResourceSchedulePastActionsQuery,
  GetResourceSchedulePastActionsQueryVariables
>;
export function useGetResourceSchedulePastActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceSchedulePastActionsQuery,
        GetResourceSchedulePastActionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetResourceSchedulePastActionsQuery | undefined,
  GetResourceSchedulePastActionsQueryVariables
>;
export function useGetResourceSchedulePastActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetResourceSchedulePastActionsQuery,
        GetResourceSchedulePastActionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetResourceSchedulePastActionsQuery,
    GetResourceSchedulePastActionsQueryVariables
  >(GetResourceSchedulePastActionsDocument, options);
}
export type GetResourceSchedulePastActionsQueryHookResult = ReturnType<
  typeof useGetResourceSchedulePastActionsQuery
>;
export type GetResourceSchedulePastActionsLazyQueryHookResult = ReturnType<
  typeof useGetResourceSchedulePastActionsLazyQuery
>;
export type GetResourceSchedulePastActionsSuspenseQueryHookResult = ReturnType<
  typeof useGetResourceSchedulePastActionsSuspenseQuery
>;
export type GetResourceSchedulePastActionsQueryResult = Apollo.QueryResult<
  GetResourceSchedulePastActionsQuery,
  GetResourceSchedulePastActionsQueryVariables
>;
export const GetPastTimelineEventsDocument = gql`
  query getPastTimelineEvents(
    $page: Int
    $limit: Int
    $sort: EventsSortInput
    $filter: EventsFilterInput
  ) {
    eventsView(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
        status
        scheduleTimezone
        estimatedEndTime
        startTime
        endTime
        plan {
          id
          name
        }
        actions {
          id
          name
          actionName
          order
          windowDuration
          inputParameters {
            key
            value
          }
          action {
            ... on Action {
              id
              name
              color
            }
            ... on SystemAction {
              id
              name
              color
            }
          }
          globalState {
            status
          }
          resourceGroups {
            id
            name
            resourcesCounts {
              totalCount
            }
          }
          resources {
            id
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetPastTimelineEventsQuery__
 *
 * To run a query within a React component, call `useGetPastTimelineEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastTimelineEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastTimelineEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPastTimelineEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPastTimelineEventsQuery,
    GetPastTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPastTimelineEventsQuery,
    GetPastTimelineEventsQueryVariables
  >(GetPastTimelineEventsDocument, options);
}
export function useGetPastTimelineEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPastTimelineEventsQuery,
    GetPastTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPastTimelineEventsQuery,
    GetPastTimelineEventsQueryVariables
  >(GetPastTimelineEventsDocument, options);
}
// @ts-ignore
export function useGetPastTimelineEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPastTimelineEventsQuery,
    GetPastTimelineEventsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPastTimelineEventsQuery,
  GetPastTimelineEventsQueryVariables
>;
export function useGetPastTimelineEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPastTimelineEventsQuery,
        GetPastTimelineEventsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPastTimelineEventsQuery | undefined,
  GetPastTimelineEventsQueryVariables
>;
export function useGetPastTimelineEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPastTimelineEventsQuery,
        GetPastTimelineEventsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPastTimelineEventsQuery,
    GetPastTimelineEventsQueryVariables
  >(GetPastTimelineEventsDocument, options);
}
export type GetPastTimelineEventsQueryHookResult = ReturnType<
  typeof useGetPastTimelineEventsQuery
>;
export type GetPastTimelineEventsLazyQueryHookResult = ReturnType<
  typeof useGetPastTimelineEventsLazyQuery
>;
export type GetPastTimelineEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetPastTimelineEventsSuspenseQuery
>;
export type GetPastTimelineEventsQueryResult = Apollo.QueryResult<
  GetPastTimelineEventsQuery,
  GetPastTimelineEventsQueryVariables
>;
export const GetTimelineEventsDocument = gql`
  query getTimelineEvents(
    $page: Int
    $limit: Int
    $sort: IncomingEventsSortInput
    $filter: IncomingEventsFilterInput
  ) {
    incomingEvents(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      result {
        id
        name
        status
        scheduleTimezone
        estimatedEndTime
        startTime
        plan {
          id
          name
          planActions {
            id
            name
            order
            windowDuration
            action {
              ... on Action {
                id
                name
                color
              }
              ... on SystemAction {
                id
                name
                color
              }
            }
            inputParameters {
              key
              value
            }
            resourceGroups {
              id
              name
              resourcesCounts {
                totalCount
              }
            }
            resources {
              id
            }
          }
        }
      }
      pageInfo {
        pages
        count
      }
    }
  }
`;

/**
 * __useGetTimelineEventsQuery__
 *
 * To run a query within a React component, call `useGetTimelineEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimelineEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimelineEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTimelineEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTimelineEventsQuery,
    GetTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTimelineEventsQuery,
    GetTimelineEventsQueryVariables
  >(GetTimelineEventsDocument, options);
}
export function useGetTimelineEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTimelineEventsQuery,
    GetTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTimelineEventsQuery,
    GetTimelineEventsQueryVariables
  >(GetTimelineEventsDocument, options);
}
// @ts-ignore
export function useGetTimelineEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTimelineEventsQuery,
    GetTimelineEventsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetTimelineEventsQuery,
  GetTimelineEventsQueryVariables
>;
export function useGetTimelineEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTimelineEventsQuery,
        GetTimelineEventsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTimelineEventsQuery | undefined,
  GetTimelineEventsQueryVariables
>;
export function useGetTimelineEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTimelineEventsQuery,
        GetTimelineEventsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTimelineEventsQuery,
    GetTimelineEventsQueryVariables
  >(GetTimelineEventsDocument, options);
}
export type GetTimelineEventsQueryHookResult = ReturnType<
  typeof useGetTimelineEventsQuery
>;
export type GetTimelineEventsLazyQueryHookResult = ReturnType<
  typeof useGetTimelineEventsLazyQuery
>;
export type GetTimelineEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetTimelineEventsSuspenseQuery
>;
export type GetTimelineEventsQueryResult = Apollo.QueryResult<
  GetTimelineEventsQuery,
  GetTimelineEventsQueryVariables
>;
